var nv = Object.defineProperty;
var rv = (t, e, n) => e in t ? nv(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var fe = (t, e, n) => (rv(t, typeof e != "symbol" ? e + "" : e, n), n);
import * as C from "react";
import I, { useCallback as pe, forwardRef as de, Children as _r, isValidElement as Ci, createElement as L, cloneElement as Qi, Fragment as gf, createContext as Nt, useMemo as Rn, useContext as Yt, useEffect as ue, useRef as ae, useState as ye, useLayoutEffect as Ji, useReducer as mf, Component as ov } from "react";
import * as iv from "react-dom";
import vf, { flushSync as Ua } from "react-dom";
function sv(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var sa = { exports: {} }, Vr = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wc;
function av() {
  if (wc)
    return Vr;
  wc = 1;
  var t = I, e = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(a, l, c) {
    var u, d = {}, f = null, h = null;
    c !== void 0 && (f = "" + c), l.key !== void 0 && (f = "" + l.key), l.ref !== void 0 && (h = l.ref);
    for (u in l)
      r.call(l, u) && !i.hasOwnProperty(u) && (d[u] = l[u]);
    if (a && a.defaultProps)
      for (u in l = a.defaultProps, l)
        d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: e, type: a, key: f, ref: h, props: d, _owner: o.current };
  }
  return Vr.Fragment = n, Vr.jsx = s, Vr.jsxs = s, Vr;
}
var Wr = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xc;
function lv() {
  return xc || (xc = 1, process.env.NODE_ENV !== "production" && function() {
    var t = I, e = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), a = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), p = Symbol.iterator, g = "@@iterator";
    function m(E) {
      if (E === null || typeof E != "object")
        return null;
      var K = p && E[p] || E[g];
      return typeof K == "function" ? K : null;
    }
    var b = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(E) {
      {
        for (var K = arguments.length, ie = new Array(K > 1 ? K - 1 : 0), me = 1; me < K; me++)
          ie[me - 1] = arguments[me];
        _("error", E, ie);
      }
    }
    function _(E, K, ie) {
      {
        var me = b.ReactDebugCurrentFrame, Ie = me.getStackAddendum();
        Ie !== "" && (K += "%s", ie = ie.concat([Ie]));
        var Be = ie.map(function(Me) {
          return String(Me);
        });
        Be.unshift("Warning: " + K), Function.prototype.apply.call(console[E], console, Be);
      }
    }
    var x = !1, y = !1, M = !1, k = !1, O = !1, S;
    S = Symbol.for("react.module.reference");
    function D(E) {
      return !!(typeof E == "string" || typeof E == "function" || E === r || E === i || O || E === o || E === c || E === u || k || E === h || x || y || M || typeof E == "object" && E !== null && (E.$$typeof === f || E.$$typeof === d || E.$$typeof === s || E.$$typeof === a || E.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      E.$$typeof === S || E.getModuleId !== void 0));
    }
    function P(E, K, ie) {
      var me = E.displayName;
      if (me)
        return me;
      var Ie = K.displayName || K.name || "";
      return Ie !== "" ? ie + "(" + Ie + ")" : ie;
    }
    function N(E) {
      return E.displayName || "Context";
    }
    function T(E) {
      if (E == null)
        return null;
      if (typeof E.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof E == "function")
        return E.displayName || E.name || null;
      if (typeof E == "string")
        return E;
      switch (E) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case c:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof E == "object")
        switch (E.$$typeof) {
          case a:
            var K = E;
            return N(K) + ".Consumer";
          case s:
            var ie = E;
            return N(ie._context) + ".Provider";
          case l:
            return P(E, E.render, "ForwardRef");
          case d:
            var me = E.displayName || null;
            return me !== null ? me : T(E.type) || "Memo";
          case f: {
            var Ie = E, Be = Ie._payload, Me = Ie._init;
            try {
              return T(Me(Be));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var U = Object.assign, R = 0, Y, V, z, ee, $, F, te;
    function J() {
    }
    J.__reactDisabledLog = !0;
    function re() {
      {
        if (R === 0) {
          Y = console.log, V = console.info, z = console.warn, ee = console.error, $ = console.group, F = console.groupCollapsed, te = console.groupEnd;
          var E = {
            configurable: !0,
            enumerable: !0,
            value: J,
            writable: !0
          };
          Object.defineProperties(console, {
            info: E,
            log: E,
            warn: E,
            error: E,
            group: E,
            groupCollapsed: E,
            groupEnd: E
          });
        }
        R++;
      }
    }
    function j() {
      {
        if (R--, R === 0) {
          var E = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: U({}, E, {
              value: Y
            }),
            info: U({}, E, {
              value: V
            }),
            warn: U({}, E, {
              value: z
            }),
            error: U({}, E, {
              value: ee
            }),
            group: U({}, E, {
              value: $
            }),
            groupCollapsed: U({}, E, {
              value: F
            }),
            groupEnd: U({}, E, {
              value: te
            })
          });
        }
        R < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var A = b.ReactCurrentDispatcher, W;
    function H(E, K, ie) {
      {
        if (W === void 0)
          try {
            throw Error();
          } catch (Ie) {
            var me = Ie.stack.trim().match(/\n( *(at )?)/);
            W = me && me[1] || "";
          }
        return `
` + W + E;
      }
    }
    var q = !1, oe;
    {
      var Z = typeof WeakMap == "function" ? WeakMap : Map;
      oe = new Z();
    }
    function G(E, K) {
      if (!E || q)
        return "";
      {
        var ie = oe.get(E);
        if (ie !== void 0)
          return ie;
      }
      var me;
      q = !0;
      var Ie = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Be;
      Be = A.current, A.current = null, re();
      try {
        if (K) {
          var Me = function() {
            throw Error();
          };
          if (Object.defineProperty(Me.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Me, []);
            } catch (cn) {
              me = cn;
            }
            Reflect.construct(E, [], Me);
          } else {
            try {
              Me.call();
            } catch (cn) {
              me = cn;
            }
            E.call(Me.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (cn) {
            me = cn;
          }
          E();
        }
      } catch (cn) {
        if (cn && me && typeof cn.stack == "string") {
          for (var xe = cn.stack.split(`
`), ft = me.stack.split(`
`), Xe = xe.length - 1, tt = ft.length - 1; Xe >= 1 && tt >= 0 && xe[Xe] !== ft[tt]; )
            tt--;
          for (; Xe >= 1 && tt >= 0; Xe--, tt--)
            if (xe[Xe] !== ft[tt]) {
              if (Xe !== 1 || tt !== 1)
                do
                  if (Xe--, tt--, tt < 0 || xe[Xe] !== ft[tt]) {
                    var St = `
` + xe[Xe].replace(" at new ", " at ");
                    return E.displayName && St.includes("<anonymous>") && (St = St.replace("<anonymous>", E.displayName)), typeof E == "function" && oe.set(E, St), St;
                  }
                while (Xe >= 1 && tt >= 0);
              break;
            }
        }
      } finally {
        q = !1, A.current = Be, j(), Error.prepareStackTrace = Ie;
      }
      var pr = E ? E.displayName || E.name : "", yc = pr ? H(pr) : "";
      return typeof E == "function" && oe.set(E, yc), yc;
    }
    function we(E, K, ie) {
      return G(E, !1);
    }
    function Pe(E) {
      var K = E.prototype;
      return !!(K && K.isReactComponent);
    }
    function Re(E, K, ie) {
      if (E == null)
        return "";
      if (typeof E == "function")
        return G(E, Pe(E));
      if (typeof E == "string")
        return H(E);
      switch (E) {
        case c:
          return H("Suspense");
        case u:
          return H("SuspenseList");
      }
      if (typeof E == "object")
        switch (E.$$typeof) {
          case l:
            return we(E.render);
          case d:
            return Re(E.type, K, ie);
          case f: {
            var me = E, Ie = me._payload, Be = me._init;
            try {
              return Re(Be(Ie), K, ie);
            } catch {
            }
          }
        }
      return "";
    }
    var ct = Object.prototype.hasOwnProperty, ut = {}, Gt = b.ReactDebugCurrentFrame;
    function gt(E) {
      if (E) {
        var K = E._owner, ie = Re(E.type, E._source, K ? K.type : null);
        Gt.setExtraStackFrame(ie);
      } else
        Gt.setExtraStackFrame(null);
    }
    function xt(E, K, ie, me, Ie) {
      {
        var Be = Function.call.bind(ct);
        for (var Me in E)
          if (Be(E, Me)) {
            var xe = void 0;
            try {
              if (typeof E[Me] != "function") {
                var ft = Error((me || "React class") + ": " + ie + " type `" + Me + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof E[Me] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ft.name = "Invariant Violation", ft;
              }
              xe = E[Me](K, Me, me, ie, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Xe) {
              xe = Xe;
            }
            xe && !(xe instanceof Error) && (gt(Ie), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", me || "React class", ie, Me, typeof xe), gt(null)), xe instanceof Error && !(xe.message in ut) && (ut[xe.message] = !0, gt(Ie), v("Failed %s type: %s", ie, xe.message), gt(null));
          }
      }
    }
    var at = Array.isArray;
    function xn(E) {
      return at(E);
    }
    function Fr(E) {
      {
        var K = typeof Symbol == "function" && Symbol.toStringTag, ie = K && E[Symbol.toStringTag] || E.constructor.name || "Object";
        return ie;
      }
    }
    function Wt(E) {
      try {
        return _n(E), !1;
      } catch {
        return !0;
      }
    }
    function _n(E) {
      return "" + E;
    }
    function fr(E) {
      if (Wt(E))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Fr(E)), _n(E);
    }
    var qt = b.ReactCurrentOwner, Xt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Zt, Ht, dt;
    dt = {};
    function ys(E) {
      if (ct.call(E, "ref")) {
        var K = Object.getOwnPropertyDescriptor(E, "ref").get;
        if (K && K.isReactWarning)
          return !1;
      }
      return E.ref !== void 0;
    }
    function Bm(E) {
      if (ct.call(E, "key")) {
        var K = Object.getOwnPropertyDescriptor(E, "key").get;
        if (K && K.isReactWarning)
          return !1;
      }
      return E.key !== void 0;
    }
    function jm(E, K) {
      if (typeof E.ref == "string" && qt.current && K && qt.current.stateNode !== K) {
        var ie = T(qt.current.type);
        dt[ie] || (v('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', T(qt.current.type), E.ref), dt[ie] = !0);
      }
    }
    function zm(E, K) {
      {
        var ie = function() {
          Zt || (Zt = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", K));
        };
        ie.isReactWarning = !0, Object.defineProperty(E, "key", {
          get: ie,
          configurable: !0
        });
      }
    }
    function Um(E, K) {
      {
        var ie = function() {
          Ht || (Ht = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", K));
        };
        ie.isReactWarning = !0, Object.defineProperty(E, "ref", {
          get: ie,
          configurable: !0
        });
      }
    }
    var Ym = function(E, K, ie, me, Ie, Be, Me) {
      var xe = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: E,
        key: K,
        ref: ie,
        props: Me,
        // Record the component responsible for creating this element.
        _owner: Be
      };
      return xe._store = {}, Object.defineProperty(xe._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(xe, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: me
      }), Object.defineProperty(xe, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ie
      }), Object.freeze && (Object.freeze(xe.props), Object.freeze(xe)), xe;
    };
    function Km(E, K, ie, me, Ie) {
      {
        var Be, Me = {}, xe = null, ft = null;
        ie !== void 0 && (fr(ie), xe = "" + ie), Bm(K) && (fr(K.key), xe = "" + K.key), ys(K) && (ft = K.ref, jm(K, Ie));
        for (Be in K)
          ct.call(K, Be) && !Xt.hasOwnProperty(Be) && (Me[Be] = K[Be]);
        if (E && E.defaultProps) {
          var Xe = E.defaultProps;
          for (Be in Xe)
            Me[Be] === void 0 && (Me[Be] = Xe[Be]);
        }
        if (xe || ft) {
          var tt = typeof E == "function" ? E.displayName || E.name || "Unknown" : E;
          xe && zm(Me, tt), ft && Um(Me, tt);
        }
        return Ym(E, xe, ft, Ie, me, qt.current, Me);
      }
    }
    var ws = b.ReactCurrentOwner, hc = b.ReactDebugCurrentFrame;
    function hr(E) {
      if (E) {
        var K = E._owner, ie = Re(E.type, E._source, K ? K.type : null);
        hc.setExtraStackFrame(ie);
      } else
        hc.setExtraStackFrame(null);
    }
    var xs;
    xs = !1;
    function _s(E) {
      return typeof E == "object" && E !== null && E.$$typeof === e;
    }
    function pc() {
      {
        if (ws.current) {
          var E = T(ws.current.type);
          if (E)
            return `

Check the render method of \`` + E + "`.";
        }
        return "";
      }
    }
    function Gm(E) {
      {
        if (E !== void 0) {
          var K = E.fileName.replace(/^.*[\\\/]/, ""), ie = E.lineNumber;
          return `

Check your code at ` + K + ":" + ie + ".";
        }
        return "";
      }
    }
    var gc = {};
    function qm(E) {
      {
        var K = pc();
        if (!K) {
          var ie = typeof E == "string" ? E : E.displayName || E.name;
          ie && (K = `

Check the top-level render call using <` + ie + ">.");
        }
        return K;
      }
    }
    function mc(E, K) {
      {
        if (!E._store || E._store.validated || E.key != null)
          return;
        E._store.validated = !0;
        var ie = qm(K);
        if (gc[ie])
          return;
        gc[ie] = !0;
        var me = "";
        E && E._owner && E._owner !== ws.current && (me = " It was passed a child from " + T(E._owner.type) + "."), hr(E), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ie, me), hr(null);
      }
    }
    function vc(E, K) {
      {
        if (typeof E != "object")
          return;
        if (xn(E))
          for (var ie = 0; ie < E.length; ie++) {
            var me = E[ie];
            _s(me) && mc(me, K);
          }
        else if (_s(E))
          E._store && (E._store.validated = !0);
        else if (E) {
          var Ie = m(E);
          if (typeof Ie == "function" && Ie !== E.entries)
            for (var Be = Ie.call(E), Me; !(Me = Be.next()).done; )
              _s(Me.value) && mc(Me.value, K);
        }
      }
    }
    function Xm(E) {
      {
        var K = E.type;
        if (K == null || typeof K == "string")
          return;
        var ie;
        if (typeof K == "function")
          ie = K.propTypes;
        else if (typeof K == "object" && (K.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        K.$$typeof === d))
          ie = K.propTypes;
        else
          return;
        if (ie) {
          var me = T(K);
          xt(ie, E.props, "prop", me, E);
        } else if (K.PropTypes !== void 0 && !xs) {
          xs = !0;
          var Ie = T(K);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Ie || "Unknown");
        }
        typeof K.getDefaultProps == "function" && !K.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Zm(E) {
      {
        for (var K = Object.keys(E.props), ie = 0; ie < K.length; ie++) {
          var me = K[ie];
          if (me !== "children" && me !== "key") {
            hr(E), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", me), hr(null);
            break;
          }
        }
        E.ref !== null && (hr(E), v("Invalid attribute `ref` supplied to `React.Fragment`."), hr(null));
      }
    }
    function bc(E, K, ie, me, Ie, Be) {
      {
        var Me = D(E);
        if (!Me) {
          var xe = "";
          (E === void 0 || typeof E == "object" && E !== null && Object.keys(E).length === 0) && (xe += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ft = Gm(Ie);
          ft ? xe += ft : xe += pc();
          var Xe;
          E === null ? Xe = "null" : xn(E) ? Xe = "array" : E !== void 0 && E.$$typeof === e ? (Xe = "<" + (T(E.type) || "Unknown") + " />", xe = " Did you accidentally export a JSX literal instead of a component?") : Xe = typeof E, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Xe, xe);
        }
        var tt = Km(E, K, ie, Ie, Be);
        if (tt == null)
          return tt;
        if (Me) {
          var St = K.children;
          if (St !== void 0)
            if (me)
              if (xn(St)) {
                for (var pr = 0; pr < St.length; pr++)
                  vc(St[pr], E);
                Object.freeze && Object.freeze(St);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              vc(St, E);
        }
        return E === r ? Zm(tt) : Xm(tt), tt;
      }
    }
    function Qm(E, K, ie) {
      return bc(E, K, ie, !0);
    }
    function Jm(E, K, ie) {
      return bc(E, K, ie, !1);
    }
    var ev = Jm, tv = Qm;
    Wr.Fragment = r, Wr.jsx = ev, Wr.jsxs = tv;
  }()), Wr;
}
process.env.NODE_ENV === "production" ? sa.exports = av() : sa.exports = lv();
var Ya = sa.exports;
const nt = Ya.Fragment, w = Ya.jsx, B = Ya.jsxs;
function ne() {
  return ne = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, ne.apply(this, arguments);
}
function cv(t, e) {
  typeof t == "function" ? t(e) : t != null && (t.current = e);
}
function Ka(...t) {
  return (e) => t.forEach(
    (n) => cv(n, e)
  );
}
function et(...t) {
  return pe(Ka(...t), t);
}
const Rt = /* @__PURE__ */ de((t, e) => {
  const { children: n, ...r } = t, o = _r.toArray(n), i = o.find(uv);
  if (i) {
    const s = i.props.children, a = o.map((l) => l === i ? _r.count(s) > 1 ? _r.only(null) : /* @__PURE__ */ Ci(s) ? s.props.children : null : l);
    return /* @__PURE__ */ L(aa, ne({}, r, {
      ref: e
    }), /* @__PURE__ */ Ci(s) ? /* @__PURE__ */ Qi(s, void 0, a) : null);
  }
  return /* @__PURE__ */ L(aa, ne({}, r, {
    ref: e
  }), n);
});
Rt.displayName = "Slot";
const aa = /* @__PURE__ */ de((t, e) => {
  const { children: n, ...r } = t;
  return /* @__PURE__ */ Ci(n) ? /* @__PURE__ */ Qi(n, {
    ...dv(r, n.props),
    ref: e ? Ka(e, n.ref) : n.ref
  }) : _r.count(n) > 1 ? _r.only(null) : null;
});
aa.displayName = "SlotClone";
const bf = ({ children: t }) => /* @__PURE__ */ L(gf, null, t);
function uv(t) {
  return /* @__PURE__ */ Ci(t) && t.type === bf;
}
function dv(t, e) {
  const n = {
    ...e
  };
  for (const r in e) {
    const o = t[r], i = e[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...a) => {
      i(...a), o(...a);
    } : o && (n[r] = o) : r === "style" ? n[r] = {
      ...o,
      ...i
    } : r === "className" && (n[r] = [
      o,
      i
    ].filter(Boolean).join(" "));
  }
  return {
    ...t,
    ...n
  };
}
function yf(t) {
  var e, n, r = "";
  if (typeof t == "string" || typeof t == "number")
    r += t;
  else if (typeof t == "object")
    if (Array.isArray(t))
      for (e = 0; e < t.length; e++)
        t[e] && (n = yf(t[e])) && (r && (r += " "), r += n);
    else
      for (e in t)
        t[e] && (r && (r += " "), r += e);
  return r;
}
function wf() {
  for (var t, e, n = 0, r = ""; n < arguments.length; )
    (t = arguments[n++]) && (e = yf(t)) && (r && (r += " "), r += e);
  return r;
}
const _c = (t) => typeof t == "boolean" ? "".concat(t) : t === 0 ? "0" : t, Cc = wf, Kt = (t, e) => (n) => {
  var r;
  if ((e == null ? void 0 : e.variants) == null)
    return Cc(t, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: o, defaultVariants: i } = e, s = Object.keys(o).map((c) => {
    const u = n == null ? void 0 : n[c], d = i == null ? void 0 : i[c];
    if (u === null)
      return null;
    const f = _c(u) || _c(d);
    return o[c][f];
  }), a = n && Object.entries(n).reduce((c, u) => {
    let [d, f] = u;
    return f === void 0 || (c[d] = f), c;
  }, {}), l = e == null || (r = e.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((c, u) => {
    let { class: d, className: f, ...h } = u;
    return Object.entries(h).every((p) => {
      let [g, m] = p;
      return Array.isArray(m) ? m.includes({
        ...i,
        ...a
      }[g]) : {
        ...i,
        ...a
      }[g] === m;
    }) ? [
      ...c,
      d,
      f
    ] : c;
  }, []);
  return Cc(t, s, l, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
};
function fv() {
  for (var t = 0, e, n, r = ""; t < arguments.length; )
    (e = arguments[t++]) && (n = xf(e)) && (r && (r += " "), r += n);
  return r;
}
function xf(t) {
  if (typeof t == "string")
    return t;
  for (var e, n = "", r = 0; r < t.length; r++)
    t[r] && (e = xf(t[r])) && (n && (n += " "), n += e);
  return n;
}
var Ga = "-";
function hv(t) {
  var e = gv(t), n = t.conflictingClassGroups, r = t.conflictingClassGroupModifiers, o = r === void 0 ? {} : r;
  function i(a) {
    var l = a.split(Ga);
    return l[0] === "" && l.length !== 1 && l.shift(), _f(l, e) || pv(a);
  }
  function s(a, l) {
    var c = n[a] || [];
    return l && o[a] ? [].concat(c, o[a]) : c;
  }
  return {
    getClassGroupId: i,
    getConflictingClassGroupIds: s
  };
}
function _f(t, e) {
  var s;
  if (t.length === 0)
    return e.classGroupId;
  var n = t[0], r = e.nextPart.get(n), o = r ? _f(t.slice(1), r) : void 0;
  if (o)
    return o;
  if (e.validators.length !== 0) {
    var i = t.join(Ga);
    return (s = e.validators.find(function(a) {
      var l = a.validator;
      return l(i);
    })) == null ? void 0 : s.classGroupId;
  }
}
var Ec = /^\[(.+)\]$/;
function pv(t) {
  if (Ec.test(t)) {
    var e = Ec.exec(t)[1], n = e == null ? void 0 : e.substring(0, e.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}
function gv(t) {
  var e = t.theme, n = t.prefix, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, o = vv(Object.entries(t.classGroups), n);
  return o.forEach(function(i) {
    var s = i[0], a = i[1];
    la(a, r, s, e);
  }), r;
}
function la(t, e, n, r) {
  t.forEach(function(o) {
    if (typeof o == "string") {
      var i = o === "" ? e : Mc(e, o);
      i.classGroupId = n;
      return;
    }
    if (typeof o == "function") {
      if (mv(o)) {
        la(o(r), e, n, r);
        return;
      }
      e.validators.push({
        validator: o,
        classGroupId: n
      });
      return;
    }
    Object.entries(o).forEach(function(s) {
      var a = s[0], l = s[1];
      la(l, Mc(e, a), n, r);
    });
  });
}
function Mc(t, e) {
  var n = t;
  return e.split(Ga).forEach(function(r) {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}
function mv(t) {
  return t.isThemeGetter;
}
function vv(t, e) {
  return e ? t.map(function(n) {
    var r = n[0], o = n[1], i = o.map(function(s) {
      return typeof s == "string" ? e + s : typeof s == "object" ? Object.fromEntries(Object.entries(s).map(function(a) {
        var l = a[0], c = a[1];
        return [e + l, c];
      })) : s;
    });
    return [r, i];
  }) : t;
}
function bv(t) {
  if (t < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var e = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  function o(i, s) {
    n.set(i, s), e++, e > t && (e = 0, r = n, n = /* @__PURE__ */ new Map());
  }
  return {
    get: function(s) {
      var a = n.get(s);
      if (a !== void 0)
        return a;
      if ((a = r.get(s)) !== void 0)
        return o(s, a), a;
    },
    set: function(s, a) {
      n.has(s) ? n.set(s, a) : o(s, a);
    }
  };
}
var Cf = "!";
function yv(t) {
  var e = t.separator || ":", n = e.length === 1, r = e[0], o = e.length;
  return function(s) {
    for (var a = [], l = 0, c = 0, u, d = 0; d < s.length; d++) {
      var f = s[d];
      if (l === 0) {
        if (f === r && (n || s.slice(d, d + o) === e)) {
          a.push(s.slice(c, d)), c = d + o;
          continue;
        }
        if (f === "/") {
          u = d;
          continue;
        }
      }
      f === "[" ? l++ : f === "]" && l--;
    }
    var h = a.length === 0 ? s : s.substring(c), p = h.startsWith(Cf), g = p ? h.substring(1) : h, m = u && u > c ? u - c : void 0;
    return {
      modifiers: a,
      hasImportantModifier: p,
      baseClassName: g,
      maybePostfixModifierPosition: m
    };
  };
}
function wv(t) {
  if (t.length <= 1)
    return t;
  var e = [], n = [];
  return t.forEach(function(r) {
    var o = r[0] === "[";
    o ? (e.push.apply(e, n.sort().concat([r])), n = []) : n.push(r);
  }), e.push.apply(e, n.sort()), e;
}
function xv(t) {
  return {
    cache: bv(t.cacheSize),
    splitModifiers: yv(t),
    ...hv(t)
  };
}
var _v = /\s+/;
function Cv(t, e) {
  var n = e.splitModifiers, r = e.getClassGroupId, o = e.getConflictingClassGroupIds, i = /* @__PURE__ */ new Set();
  return t.trim().split(_v).map(function(s) {
    var a = n(s), l = a.modifiers, c = a.hasImportantModifier, u = a.baseClassName, d = a.maybePostfixModifierPosition, f = r(d ? u.substring(0, d) : u), h = !!d;
    if (!f) {
      if (!d)
        return {
          isTailwindClass: !1,
          originalClassName: s
        };
      if (f = r(u), !f)
        return {
          isTailwindClass: !1,
          originalClassName: s
        };
      h = !1;
    }
    var p = wv(l).join(":"), g = c ? p + Cf : p;
    return {
      isTailwindClass: !0,
      modifierId: g,
      classGroupId: f,
      originalClassName: s,
      hasPostfixModifier: h
    };
  }).reverse().filter(function(s) {
    if (!s.isTailwindClass)
      return !0;
    var a = s.modifierId, l = s.classGroupId, c = s.hasPostfixModifier, u = a + l;
    return i.has(u) ? !1 : (i.add(u), o(l, c).forEach(function(d) {
      return i.add(a + d);
    }), !0);
  }).reverse().map(function(s) {
    return s.originalClassName;
  }).join(" ");
}
function Ev() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  var r, o, i, s = a;
  function a(c) {
    var u = e[0], d = e.slice(1), f = d.reduce(function(h, p) {
      return p(h);
    }, u());
    return r = xv(f), o = r.cache.get, i = r.cache.set, s = l, l(c);
  }
  function l(c) {
    var u = o(c);
    if (u)
      return u;
    var d = Cv(c, r);
    return i(c, d), d;
  }
  return function() {
    return s(fv.apply(null, arguments));
  };
}
function ze(t) {
  var e = function(r) {
    return r[t] || [];
  };
  return e.isThemeGetter = !0, e;
}
var Ef = /^\[(?:([a-z-]+):)?(.+)\]$/i, Mv = /^\d+\/\d+$/, kv = /* @__PURE__ */ new Set(["px", "full", "screen"]), Ov = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Sv = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Pv = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function Bt(t) {
  return Qn(t) || kv.has(t) || Mv.test(t) || ca(t);
}
function ca(t) {
  return lr(t, "length", Rv);
}
function Iv(t) {
  return lr(t, "size", Mf);
}
function Tv(t) {
  return lr(t, "position", Mf);
}
function Dv(t) {
  return lr(t, "url", Av);
}
function Ro(t) {
  return lr(t, "number", Qn);
}
function Qn(t) {
  return !Number.isNaN(Number(t));
}
function $v(t) {
  return t.endsWith("%") && Qn(t.slice(0, -1));
}
function Hr(t) {
  return kc(t) || lr(t, "number", kc);
}
function _e(t) {
  return Ef.test(t);
}
function Br() {
  return !0;
}
function Cn(t) {
  return Ov.test(t);
}
function Nv(t) {
  return lr(t, "", Lv);
}
function lr(t, e, n) {
  var r = Ef.exec(t);
  return r ? r[1] ? r[1] === e : n(r[2]) : !1;
}
function Rv(t) {
  return Sv.test(t);
}
function Mf() {
  return !1;
}
function Av(t) {
  return t.startsWith("url(");
}
function kc(t) {
  return Number.isInteger(Number(t));
}
function Lv(t) {
  return Pv.test(t);
}
function Fv() {
  var t = ze("colors"), e = ze("spacing"), n = ze("blur"), r = ze("brightness"), o = ze("borderColor"), i = ze("borderRadius"), s = ze("borderSpacing"), a = ze("borderWidth"), l = ze("contrast"), c = ze("grayscale"), u = ze("hueRotate"), d = ze("invert"), f = ze("gap"), h = ze("gradientColorStops"), p = ze("gradientColorStopPositions"), g = ze("inset"), m = ze("margin"), b = ze("opacity"), v = ze("padding"), _ = ze("saturate"), x = ze("scale"), y = ze("sepia"), M = ze("skew"), k = ze("space"), O = ze("translate"), S = function() {
    return ["auto", "contain", "none"];
  }, D = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, P = function() {
    return ["auto", _e, e];
  }, N = function() {
    return [_e, e];
  }, T = function() {
    return ["", Bt];
  }, U = function() {
    return ["auto", Qn, _e];
  }, R = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, Y = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, V = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, z = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, ee = function() {
    return ["", "0", _e];
  }, $ = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, F = function() {
    return [Qn, Ro];
  }, te = function() {
    return [Qn, _e];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [Br],
      spacing: [Bt],
      blur: ["none", "", Cn, _e],
      brightness: F(),
      borderColor: [t],
      borderRadius: ["none", "", "full", Cn, _e],
      borderSpacing: N(),
      borderWidth: T(),
      contrast: F(),
      grayscale: ee(),
      hueRotate: te(),
      invert: ee(),
      gap: N(),
      gradientColorStops: [t],
      gradientColorStopPositions: [$v, ca],
      inset: P(),
      margin: P(),
      opacity: F(),
      padding: N(),
      saturate: F(),
      scale: F(),
      sepia: ee(),
      skew: te(),
      space: N(),
      translate: N()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", _e]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Cn]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": $()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": $()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(R(), [_e])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: D()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": D()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": D()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: S()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": S()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": S()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [g]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [g]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [g]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [g]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [g]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [g]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [g]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [g]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [g]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Hr]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: P()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", _e]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ee()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ee()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Hr]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Br]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Hr]
        }, _e]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": U()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": U()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Br]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Hr]
        }, _e]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": U()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": U()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", _e]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", _e]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [f]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [f]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [f]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(z())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(z(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(z(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [v]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [v]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [v]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [v]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [v]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [v]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [v]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [v]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [v]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [m]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [m]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [m]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [m]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [m]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [m]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [m]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [m]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [m]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [k]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [k]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", _e, e]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", _e, Bt]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [Cn]
        }, Cn, _e]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [_e, e, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", _e, Bt]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [_e, e, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Cn, ca]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Ro]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Br]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", _e]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Qn, Ro]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", _e, Bt]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", _e]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", _e]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [t]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [b]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [t]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [b]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(Y(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Bt]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", _e, Bt]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [t]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: N()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", _e]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", _e]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [b]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(R(), [Tv])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", Iv]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, Dv]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [t]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [p]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [h]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [a]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [a]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [a]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [a]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [a]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [a]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [a]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [a]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [a]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [b]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(Y(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [a]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [a]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [b]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: Y()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(Y())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [_e, Bt]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Bt]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [t]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: T()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [t]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [b]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Bt]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [t]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Cn, Nv]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Br]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [b]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": V()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": V()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Cn, _e]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [c]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [_]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [y]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [c]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [b]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [_]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [y]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [s]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [s]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [s]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", _e]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: te()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", _e]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: te()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", _e]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [x]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [x]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [x]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Hr, _e]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [O]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [O]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [M]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [M]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", _e]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", t]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", _e]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [t]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": N()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": N()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": N()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": N()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": N()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": N()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": N()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": N()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": N()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": N()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": N()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": N()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": N()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": N()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": N()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": N()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": N()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": N()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", _e]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [t, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Bt, Ro]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [t, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
var Vv = /* @__PURE__ */ Ev(Fv);
function he(...t) {
  return Vv(wf(t));
}
const Ei = Kt(
  "relative select-none overflow-hidden inline-flex items-center justify-center gap-2 rounded-md font-medium transition-colors duration-75 focus-visible:outline-none focus-visible:ring-1 border border-transparent disabled:cursor-not-allowed disabled:pointer-events-none",
  {
    variants: {
      variant: {
        primary: "bg-info-bold text-foundations-inverse border-info-bolder hover:bg-info-bolder hover:border-info-boldest hover:shadow-sm focus-visible:border-info-boldest focus-visible:ring-info-boldest focus-visible::shadow-sm active:bg-info-boldest [&_.spinner-container]:bg-foundations-subtlest [&_.spinner-icon]:border-info-boldest [&_.spinner-icon]:border-r-info-subtle",
        secondary: "bg-foundations-default text-foundations-subtle border-foundations-bold hover:bg-foundations-subtlest hover:text-foundations-bold hover:shadow-sm focus-visible:border-info-bold focus-visible:ring-info-bold focus-visible:shadow-sm active:bg-foundations-subtler active:text-foundations-bold [&_.spinner-container]:bg-foundations-default [&_.spinner-icon]:border-info-boldest [&_.spinner-icon]:border-r-info-subtle",
        tertiary: "text-foundations-subtle hover:bg-foundations-subtlest hover:text-foundations-bold hover:shadow-sm focus-visible:border-info-bold focus-visible:ring-info-bold focus-visible:shadow-sm active:bg-foundations-subtler active:text-foundations-bold  [&_.spinner-container]:bg-foundations-default [&_.spinner-icon]:border-info-boldest [&_.spinner-icon]:border-r-info-subtle"
      },
      size: {
        xs: "text-xs px-4 py-1.5 [&_svg]:h-5 [&_svg]:w-5 [&_.spinner-icon]:h-5 [&_.spinner-icon]:w-5",
        sm: "text-sm px-6 py-2.5 [&_svg]:h-5 [&_svg]:w-5 [&_.spinner-icon]:h-5 [&_.spinner-icon]:w-5",
        md: "text-base px-6 py-3 [&_svg]:h-6 [&_svg]:w-6 [&_.spinner-icon]:h-6 [&_.spinner-icon]:w-6",
        lg: "text-base px-8 py-4 [&_svg]:h-6 [&_svg]:w-6 [&_.spinner-icon]:h-6 [&_.spinner-icon]:w-6"
      },
      disabled: {
        true: ""
      },
      colorScheme: {
        danger: "",
        success: "",
        inverse: ""
      }
    },
    compoundVariants: [
      {
        variant: "primary",
        colorScheme: "danger",
        className: "bg-danger-bold border-danger-bolder hover:bg-danger-bolder hover:border-danger-boldest focus-visible:border-danger-boldest focus-visible:ring-danger-boldest active:bg-danger-boldest [&_.spinner-icon]:border-red-700 [&_.spinner-icon]:border-r-red-300"
      },
      {
        variant: "primary",
        colorScheme: "success",
        className: "bg-success-bold border-success-bolder hover:bg-success-bolder hover:border-success-boldest focus-visible:border-success-boldest focus-visible:ring-success-boldest active:bg-success-boldest [&_.spinner-icon]:border-green-700 [&_.spinner-icon]:border-r-green-300"
      },
      {
        variant: "primary",
        colorScheme: "inverse",
        className: "bg-foundations-default text-info border-info-bold hover:bg-info-subtler hover:border-info-bold focus-visible:border-info-bold focus-visible:ring-info-bold active:bg-info-subtler active:text-info disabled:text-foundations-subtler "
      },
      {
        variant: "secondary",
        colorScheme: "danger",
        className: "text-danger border border-danger-subtle hover:text-danger active:border-danger-subtler active:text-danger hover:bg-danger-subtler focus-visible:border-danger-subtle focus-visible:ring-danger-subtle active:bg-danger-subtler"
      },
      {
        variant: "secondary",
        colorScheme: "success",
        className: "text-success border border-success-subtle hover:text-success active:border-success-subtler active:text-success hover:bg-success-subtler focus-visible:border-success-subtle focus-visible:ring-success-subtle active:bg-success-subtler"
      },
      {
        variant: "primary",
        disabled: !0,
        className: "disabled:bg-foundations-subtler disabled:text-foundations-subtler disabled:border-foundations-subtle"
      },
      {
        variant: "secondary",
        disabled: !0,
        className: "disabled:bg-foundations-subtlest disabled:border-foundations-subtle disabled:text-foundations-subtler"
      },
      {
        variant: "tertiary",
        disabled: !0,
        className: "disabled:text-foundations-subtler"
      },
      {
        colorScheme: "inverse",
        disabled: !0,
        className: "disabled:border-foundations-bold disabled:bg-foundations-subtler disabled:!text-foundations-subtler"
      }
    ],
    defaultVariants: {
      variant: "primary",
      size: "sm"
    }
  }
), Mi = C.forwardRef(
  ({
    className: t,
    variant: e,
    size: n,
    isLoading: r,
    colorScheme: o,
    asChild: i = !1,
    children: s,
    ...a
  }, l) => i ? /* @__PURE__ */ w(
    Rt,
    {
      className: he(
        Ei({
          variant: e,
          size: n,
          colorScheme: o,
          disabled: a.disabled || r,
          className: t
        })
      ),
      ref: l,
      ...a,
      children: s
    }
  ) : /* @__PURE__ */ B(
    "button",
    {
      type: "button",
      className: he(
        Ei({
          variant: e,
          size: n,
          colorScheme: o,
          disabled: a.disabled || r,
          className: t
        })
      ),
      ref: l,
      disabled: a.disabled || r,
      ...a,
      children: [
        s,
        r && /* @__PURE__ */ w("div", { className: "spinner-container absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ w("div", { className: "spinner-icon animate-spin rounded-full border-4" }) })
      ]
    }
  )
);
Mi.displayName = "Button";
const Wv = I.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ w(
  "div",
  {
    role: "group",
    ref: n,
    className: he(
      "flex [&>button:focus]:z-10 [&>button:not(:first-child)]:rounded-l-none [&>button:not(:focus-visible):not(:last-child)]:border-r-transparent [&>button:not(:last-child)]:rounded-r-none",
      t
    ),
    ...e
  }
));
Wv.displayName = "ButtonGroup";
const Oc = Kt("", {
  variants: {
    size: {
      xs: "[&_svg]:h-4 [&_svg]:w-4 p-1",
      sm: "[&_svg]:h-5 [&_svg]:w-5 p-2.5",
      md: "[&_svg]:h-6 [&_svg]:w-6 p-3",
      lg: "[&_svg]:h-6 [&_svg]:w-6 p-4"
    },
    shape: {
      circle: "rounded-full"
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), ua = C.forwardRef(
  ({
    className: t,
    variant: e,
    size: n,
    isLoading: r,
    colorScheme: o,
    shape: i,
    asChild: s = !1,
    children: a,
    ...l
  }, c) => s ? /* @__PURE__ */ w(
    Rt,
    {
      className: he(
        Ei({
          variant: e,
          size: n,
          colorScheme: o,
          disabled: l.disabled || r
        }),
        Oc({
          size: n,
          shape: i,
          className: t
        })
      ),
      ref: c,
      ...l,
      children: a
    }
  ) : /* @__PURE__ */ B(
    "button",
    {
      type: "button",
      className: he(
        Ei({
          variant: e,
          size: n,
          colorScheme: o,
          disabled: l.disabled || r
        }),
        Oc({
          size: n,
          shape: i,
          className: t
        })
      ),
      ref: c,
      disabled: l.disabled || r,
      ...l,
      children: [
        a,
        r && /* @__PURE__ */ w("div", { className: "spinner-container absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ w("div", { className: "spinner-icon animate-spin rounded-full border-4" }) })
      ]
    }
  )
);
ua.displayName = "IconButton";
function be(t, e, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (t == null || t(o), n === !1 || !o.defaultPrevented)
      return e == null ? void 0 : e(o);
  };
}
function an(t, e = []) {
  let n = [];
  function r(i, s) {
    const a = /* @__PURE__ */ Nt(s), l = n.length;
    n = [
      ...n,
      s
    ];
    function c(d) {
      const { scope: f, children: h, ...p } = d, g = (f == null ? void 0 : f[t][l]) || a, m = Rn(
        () => p,
        Object.values(p)
      );
      return /* @__PURE__ */ L(g.Provider, {
        value: m
      }, h);
    }
    function u(d, f) {
      const h = (f == null ? void 0 : f[t][l]) || a, p = Yt(h);
      if (p)
        return p;
      if (s !== void 0)
        return s;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return c.displayName = i + "Provider", [
      c,
      u
    ];
  }
  const o = () => {
    const i = n.map((s) => /* @__PURE__ */ Nt(s));
    return function(a) {
      const l = (a == null ? void 0 : a[t]) || i;
      return Rn(
        () => ({
          [`__scope${t}`]: {
            ...a,
            [t]: l
          }
        }),
        [
          a,
          l
        ]
      );
    };
  };
  return o.scopeName = t, [
    r,
    Hv(o, ...e)
  ];
}
function Hv(...t) {
  const e = t[0];
  if (t.length === 1)
    return e;
  const n = () => {
    const r = t.map(
      (o) => ({
        useScope: o(),
        scopeName: o.scopeName
      })
    );
    return function(i) {
      const s = r.reduce((a, { useScope: l, scopeName: c }) => {
        const d = l(i)[`__scope${c}`];
        return {
          ...a,
          ...d
        };
      }, {});
      return Rn(
        () => ({
          [`__scope${e.scopeName}`]: s
        }),
        [
          s
        ]
      );
    };
  };
  return n.scopeName = e.scopeName, n;
}
const Bv = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], je = Bv.reduce((t, e) => {
  const n = /* @__PURE__ */ de((r, o) => {
    const { asChild: i, ...s } = r, a = i ? Rt : e;
    return ue(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ L(a, ne({}, s, {
      ref: o
    }));
  });
  return n.displayName = `Primitive.${e}`, {
    ...t,
    [e]: n
  };
}, {});
function qa(t, e) {
  t && Ua(
    () => t.dispatchEvent(e)
  );
}
function pt(t) {
  const e = ae(t);
  return ue(() => {
    e.current = t;
  }), Rn(
    () => (...n) => {
      var r;
      return (r = e.current) === null || r === void 0 ? void 0 : r.call(e, ...n);
    },
    []
  );
}
function kf(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = pt(t);
  ue(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return e.addEventListener("keydown", r), () => e.removeEventListener("keydown", r);
  }, [
    n,
    e
  ]);
}
const da = "dismissableLayer.update", jv = "dismissableLayer.pointerDownOutside", zv = "dismissableLayer.focusOutside";
let Sc;
const Uv = /* @__PURE__ */ Nt({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Of = /* @__PURE__ */ de((t, e) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: o, onPointerDownOutside: i, onFocusOutside: s, onInteractOutside: a, onDismiss: l, ...c } = t, u = Yt(Uv), [d, f] = ye(null), h = (n = d == null ? void 0 : d.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, p] = ye({}), g = et(
    e,
    (O) => f(O)
  ), m = Array.from(u.layers), [b] = [
    ...u.layersWithOutsidePointerEventsDisabled
  ].slice(-1), v = m.indexOf(b), _ = d ? m.indexOf(d) : -1, x = u.layersWithOutsidePointerEventsDisabled.size > 0, y = _ >= v, M = Yv((O) => {
    const S = O.target, D = [
      ...u.branches
    ].some(
      (P) => P.contains(S)
    );
    !y || D || (i == null || i(O), a == null || a(O), O.defaultPrevented || l == null || l());
  }, h), k = Kv((O) => {
    const S = O.target;
    [
      ...u.branches
    ].some(
      (P) => P.contains(S)
    ) || (s == null || s(O), a == null || a(O), O.defaultPrevented || l == null || l());
  }, h);
  return kf((O) => {
    _ === u.layers.size - 1 && (o == null || o(O), !O.defaultPrevented && l && (O.preventDefault(), l()));
  }, h), ue(() => {
    if (d)
      return r && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (Sc = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), Pc(), () => {
        r && u.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = Sc);
      };
  }, [
    d,
    h,
    r,
    u
  ]), ue(() => () => {
    d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), Pc());
  }, [
    d,
    u
  ]), ue(() => {
    const O = () => p({});
    return document.addEventListener(da, O), () => document.removeEventListener(da, O);
  }, []), /* @__PURE__ */ L(je.div, ne({}, c, {
    ref: g,
    style: {
      pointerEvents: x ? y ? "auto" : "none" : void 0,
      ...t.style
    },
    onFocusCapture: be(t.onFocusCapture, k.onFocusCapture),
    onBlurCapture: be(t.onBlurCapture, k.onBlurCapture),
    onPointerDownCapture: be(t.onPointerDownCapture, M.onPointerDownCapture)
  }));
});
function Yv(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = pt(t), r = ae(!1), o = ae(() => {
  });
  return ue(() => {
    const i = (a) => {
      if (a.target && !r.current) {
        let c = function() {
          Sf(jv, n, l, {
            discrete: !0
          });
        };
        const l = {
          originalEvent: a
        };
        a.pointerType === "touch" ? (e.removeEventListener("click", o.current), o.current = c, e.addEventListener("click", o.current, {
          once: !0
        })) : c();
      }
      r.current = !1;
    }, s = window.setTimeout(() => {
      e.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(s), e.removeEventListener("pointerdown", i), e.removeEventListener("click", o.current);
    };
  }, [
    e,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Kv(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = pt(t), r = ae(!1);
  return ue(() => {
    const o = (i) => {
      i.target && !r.current && Sf(zv, n, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", o), () => e.removeEventListener("focusin", o);
  }, [
    e,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function Pc() {
  const t = new CustomEvent(da);
  document.dispatchEvent(t);
}
function Sf(t, e, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(t, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  e && o.addEventListener(t, e, {
    once: !0
  }), r ? qa(o, i) : o.dispatchEvent(i);
}
const An = globalThis != null && globalThis.document ? Ji : () => {
}, Gv = C["useId".toString()] || (() => {
});
let qv = 0;
function fo(t) {
  const [e, n] = C.useState(Gv());
  return An(() => {
    t || n(
      (r) => r ?? String(qv++)
    );
  }, [
    t
  ]), t || (e ? `radix-${e}` : "");
}
const Xv = ["top", "right", "bottom", "left"], Ln = Math.min, Ct = Math.max, ki = Math.round, Ao = Math.floor, Fn = (t) => ({
  x: t,
  y: t
}), Zv = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Qv = {
  start: "end",
  end: "start"
};
function fa(t, e, n) {
  return Ct(t, Ln(e, n));
}
function mn(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function vn(t) {
  return t.split("-")[0];
}
function Nr(t) {
  return t.split("-")[1];
}
function Xa(t) {
  return t === "x" ? "y" : "x";
}
function Za(t) {
  return t === "y" ? "height" : "width";
}
function Rr(t) {
  return ["top", "bottom"].includes(vn(t)) ? "y" : "x";
}
function Qa(t) {
  return Xa(Rr(t));
}
function Jv(t, e, n) {
  n === void 0 && (n = !1);
  const r = Nr(t), o = Qa(t), i = Za(o);
  let s = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return e.reference[i] > e.floating[i] && (s = Oi(s)), [s, Oi(s)];
}
function e0(t) {
  const e = Oi(t);
  return [ha(t), e, ha(e)];
}
function ha(t) {
  return t.replace(/start|end/g, (e) => Qv[e]);
}
function t0(t, e, n) {
  const r = ["left", "right"], o = ["right", "left"], i = ["top", "bottom"], s = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? o : r : e ? r : o;
    case "left":
    case "right":
      return e ? i : s;
    default:
      return [];
  }
}
function n0(t, e, n, r) {
  const o = Nr(t);
  let i = t0(vn(t), n === "start", r);
  return o && (i = i.map((s) => s + "-" + o), e && (i = i.concat(i.map(ha)))), i;
}
function Oi(t) {
  return t.replace(/left|right|bottom|top/g, (e) => Zv[e]);
}
function r0(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function Pf(t) {
  return typeof t != "number" ? r0(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function Si(t) {
  return {
    ...t,
    top: t.y,
    left: t.x,
    right: t.x + t.width,
    bottom: t.y + t.height
  };
}
function Ic(t, e, n) {
  let {
    reference: r,
    floating: o
  } = t;
  const i = Rr(e), s = Qa(e), a = Za(s), l = vn(e), c = i === "y", u = r.x + r.width / 2 - o.width / 2, d = r.y + r.height / 2 - o.height / 2, f = r[a] / 2 - o[a] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: u,
        y: r.y - o.height
      };
      break;
    case "bottom":
      h = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      h = {
        x: r.x - o.width,
        y: d
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (Nr(e)) {
    case "start":
      h[s] -= f * (n && c ? -1 : 1);
      break;
    case "end":
      h[s] += f * (n && c ? -1 : 1);
      break;
  }
  return h;
}
const o0 = async (t, e, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: s
  } = n, a = i.filter(Boolean), l = await (s.isRTL == null ? void 0 : s.isRTL(e));
  let c = await s.getElementRects({
    reference: t,
    floating: e,
    strategy: o
  }), {
    x: u,
    y: d
  } = Ic(c, r, l), f = r, h = {}, p = 0;
  for (let g = 0; g < a.length; g++) {
    const {
      name: m,
      fn: b
    } = a[g], {
      x: v,
      y: _,
      data: x,
      reset: y
    } = await b({
      x: u,
      y: d,
      initialPlacement: r,
      placement: f,
      strategy: o,
      middlewareData: h,
      rects: c,
      platform: s,
      elements: {
        reference: t,
        floating: e
      }
    });
    if (u = v ?? u, d = _ ?? d, h = {
      ...h,
      [m]: {
        ...h[m],
        ...x
      }
    }, y && p <= 50) {
      p++, typeof y == "object" && (y.placement && (f = y.placement), y.rects && (c = y.rects === !0 ? await s.getElementRects({
        reference: t,
        floating: e,
        strategy: o
      }) : y.rects), {
        x: u,
        y: d
      } = Ic(c, f, l)), g = -1;
      continue;
    }
  }
  return {
    x: u,
    y: d,
    placement: f,
    strategy: o,
    middlewareData: h
  };
};
async function ho(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: r,
    y: o,
    platform: i,
    rects: s,
    elements: a,
    strategy: l
  } = t, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: h = 0
  } = mn(e, t), p = Pf(h), m = a[f ? d === "floating" ? "reference" : "floating" : d], b = Si(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(m))) == null || n ? m : m.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(a.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), v = d === "floating" ? {
    ...s.floating,
    x: r,
    y: o
  } : s.reference, _ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(a.floating)), x = await (i.isElement == null ? void 0 : i.isElement(_)) ? await (i.getScale == null ? void 0 : i.getScale(_)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, y = Si(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: v,
    offsetParent: _,
    strategy: l
  }) : v);
  return {
    top: (b.top - y.top + p.top) / x.y,
    bottom: (y.bottom - b.bottom + p.bottom) / x.y,
    left: (b.left - y.left + p.left) / x.x,
    right: (y.right - b.right + p.right) / x.x
  };
}
const Tc = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: i,
      platform: s,
      elements: a
    } = e, {
      element: l,
      padding: c = 0
    } = mn(t, e) || {};
    if (l == null)
      return {};
    const u = Pf(c), d = {
      x: n,
      y: r
    }, f = Qa(o), h = Za(f), p = await s.getDimensions(l), g = f === "y", m = g ? "top" : "left", b = g ? "bottom" : "right", v = g ? "clientHeight" : "clientWidth", _ = i.reference[h] + i.reference[f] - d[f] - i.floating[h], x = d[f] - i.reference[f], y = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(l));
    let M = y ? y[v] : 0;
    (!M || !await (s.isElement == null ? void 0 : s.isElement(y))) && (M = a.floating[v] || i.floating[h]);
    const k = _ / 2 - x / 2, O = M / 2 - p[h] / 2 - 1, S = Ln(u[m], O), D = Ln(u[b], O), P = S, N = M - p[h] - D, T = M / 2 - p[h] / 2 + k, U = fa(P, T, N), Y = Nr(o) != null && T != U && i.reference[h] / 2 - (T < P ? S : D) - p[h] / 2 < 0 ? T < P ? P - T : N - T : 0;
    return {
      [f]: d[f] - Y,
      data: {
        [f]: U,
        centerOffset: T - U + Y
      }
    };
  }
}), Ja = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n;
      const {
        placement: r,
        middlewareData: o,
        rects: i,
        initialPlacement: s,
        platform: a,
        elements: l
      } = e, {
        mainAxis: c = !0,
        crossAxis: u = !0,
        fallbackPlacements: d,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: h = "none",
        flipAlignment: p = !0,
        ...g
      } = mn(t, e), m = vn(r), b = vn(s) === s, v = await (a.isRTL == null ? void 0 : a.isRTL(l.floating)), _ = d || (b || !p ? [Oi(s)] : e0(s));
      !d && h !== "none" && _.push(...n0(s, p, h, v));
      const x = [s, ..._], y = await ho(e, g), M = [];
      let k = ((n = o.flip) == null ? void 0 : n.overflows) || [];
      if (c && M.push(y[m]), u) {
        const P = Jv(r, i, v);
        M.push(y[P[0]], y[P[1]]);
      }
      if (k = [...k, {
        placement: r,
        overflows: M
      }], !M.every((P) => P <= 0)) {
        var O, S;
        const P = (((O = o.flip) == null ? void 0 : O.index) || 0) + 1, N = x[P];
        if (N)
          return {
            data: {
              index: P,
              overflows: k
            },
            reset: {
              placement: N
            }
          };
        let T = (S = k.filter((U) => U.overflows[0] <= 0).sort((U, R) => U.overflows[1] - R.overflows[1])[0]) == null ? void 0 : S.placement;
        if (!T)
          switch (f) {
            case "bestFit": {
              var D;
              const U = (D = k.map((R) => [R.placement, R.overflows.filter((Y) => Y > 0).reduce((Y, V) => Y + V, 0)]).sort((R, Y) => R[1] - Y[1])[0]) == null ? void 0 : D[0];
              U && (T = U);
              break;
            }
            case "initialPlacement":
              T = s;
              break;
          }
        if (r !== T)
          return {
            reset: {
              placement: T
            }
          };
      }
      return {};
    }
  };
};
function Dc(t, e) {
  return {
    top: t.top - e.height,
    right: t.right - e.width,
    bottom: t.bottom - e.height,
    left: t.left - e.width
  };
}
function $c(t) {
  return Xv.some((e) => t[e] >= 0);
}
const If = function(t) {
  return t === void 0 && (t = {}), {
    name: "hide",
    options: t,
    async fn(e) {
      const {
        rects: n
      } = e, {
        strategy: r = "referenceHidden",
        ...o
      } = mn(t, e);
      switch (r) {
        case "referenceHidden": {
          const i = await ho(e, {
            ...o,
            elementContext: "reference"
          }), s = Dc(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: $c(s)
            }
          };
        }
        case "escaped": {
          const i = await ho(e, {
            ...o,
            altBoundary: !0
          }), s = Dc(i, n.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: $c(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function i0(t, e) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = t, i = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), s = vn(n), a = Nr(n), l = Rr(n) === "y", c = ["left", "top"].includes(s) ? -1 : 1, u = i && l ? -1 : 1, d = mn(e, t);
  let {
    mainAxis: f,
    crossAxis: h,
    alignmentAxis: p
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...d
  };
  return a && typeof p == "number" && (h = a === "end" ? p * -1 : p), l ? {
    x: h * u,
    y: f * c
  } : {
    x: f * c,
    y: h * u
  };
}
const el = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: r
      } = e, o = await i0(e, t);
      return {
        x: n + o.x,
        y: r + o.y,
        data: o
      };
    }
  };
}, tl = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: r,
        placement: o
      } = e, {
        mainAxis: i = !0,
        crossAxis: s = !1,
        limiter: a = {
          fn: (m) => {
            let {
              x: b,
              y: v
            } = m;
            return {
              x: b,
              y: v
            };
          }
        },
        ...l
      } = mn(t, e), c = {
        x: n,
        y: r
      }, u = await ho(e, l), d = Rr(vn(o)), f = Xa(d);
      let h = c[f], p = c[d];
      if (i) {
        const m = f === "y" ? "top" : "left", b = f === "y" ? "bottom" : "right", v = h + u[m], _ = h - u[b];
        h = fa(v, h, _);
      }
      if (s) {
        const m = d === "y" ? "top" : "left", b = d === "y" ? "bottom" : "right", v = p + u[m], _ = p - u[b];
        p = fa(v, p, _);
      }
      const g = a.fn({
        ...e,
        [f]: h,
        [d]: p
      });
      return {
        ...g,
        data: {
          x: g.x - n,
          y: g.y - r
        }
      };
    }
  };
}, Tf = function(t) {
  return t === void 0 && (t = {}), {
    options: t,
    fn(e) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: i,
        middlewareData: s
      } = e, {
        offset: a = 0,
        mainAxis: l = !0,
        crossAxis: c = !0
      } = mn(t, e), u = {
        x: n,
        y: r
      }, d = Rr(o), f = Xa(d);
      let h = u[f], p = u[d];
      const g = mn(a, e), m = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (l) {
        const _ = f === "y" ? "height" : "width", x = i.reference[f] - i.floating[_] + m.mainAxis, y = i.reference[f] + i.reference[_] - m.mainAxis;
        h < x ? h = x : h > y && (h = y);
      }
      if (c) {
        var b, v;
        const _ = f === "y" ? "width" : "height", x = ["top", "left"].includes(vn(o)), y = i.reference[d] - i.floating[_] + (x && ((b = s.offset) == null ? void 0 : b[d]) || 0) + (x ? 0 : m.crossAxis), M = i.reference[d] + i.reference[_] + (x ? 0 : ((v = s.offset) == null ? void 0 : v[d]) || 0) - (x ? m.crossAxis : 0);
        p < y ? p = y : p > M && (p = M);
      }
      return {
        [f]: h,
        [d]: p
      };
    }
  };
}, nl = function(t) {
  return t === void 0 && (t = {}), {
    name: "size",
    options: t,
    async fn(e) {
      const {
        placement: n,
        rects: r,
        platform: o,
        elements: i
      } = e, {
        apply: s = () => {
        },
        ...a
      } = mn(t, e), l = await ho(e, a), c = vn(n), u = Nr(n), d = Rr(n) === "y", {
        width: f,
        height: h
      } = r.floating;
      let p, g;
      c === "top" || c === "bottom" ? (p = c, g = u === (await (o.isRTL == null ? void 0 : o.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (g = c, p = u === "end" ? "top" : "bottom");
      const m = h - l[p], b = f - l[g], v = !e.middlewareData.shift;
      let _ = m, x = b;
      if (d) {
        const M = f - l.left - l.right;
        x = u || v ? Ln(b, M) : M;
      } else {
        const M = h - l.top - l.bottom;
        _ = u || v ? Ln(m, M) : M;
      }
      if (v && !u) {
        const M = Ct(l.left, 0), k = Ct(l.right, 0), O = Ct(l.top, 0), S = Ct(l.bottom, 0);
        d ? x = f - 2 * (M !== 0 || k !== 0 ? M + k : Ct(l.left, l.right)) : _ = h - 2 * (O !== 0 || S !== 0 ? O + S : Ct(l.top, l.bottom));
      }
      await s({
        ...e,
        availableWidth: x,
        availableHeight: _
      });
      const y = await o.getDimensions(i.floating);
      return f !== y.width || h !== y.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Vn(t) {
  return Df(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function Ot(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function yn(t) {
  var e;
  return (e = (Df(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function Df(t) {
  return t instanceof Node || t instanceof Ot(t).Node;
}
function bn(t) {
  return t instanceof Element || t instanceof Ot(t).Element;
}
function sn(t) {
  return t instanceof HTMLElement || t instanceof Ot(t).HTMLElement;
}
function Nc(t) {
  return typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof Ot(t).ShadowRoot;
}
function Co(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: r,
    display: o
  } = At(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + r + n) && !["inline", "contents"].includes(o);
}
function s0(t) {
  return ["table", "td", "th"].includes(Vn(t));
}
function rl(t) {
  const e = ol(), n = At(t);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !e && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function a0(t) {
  let e = kr(t);
  for (; sn(e) && !es(e); ) {
    if (rl(e))
      return e;
    e = kr(e);
  }
  return null;
}
function ol() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function es(t) {
  return ["html", "body", "#document"].includes(Vn(t));
}
function At(t) {
  return Ot(t).getComputedStyle(t);
}
function ts(t) {
  return bn(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.pageXOffset,
    scrollTop: t.pageYOffset
  };
}
function kr(t) {
  if (Vn(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    Nc(t) && t.host || // Fallback.
    yn(t)
  );
  return Nc(e) ? e.host : e;
}
function $f(t) {
  const e = kr(t);
  return es(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : sn(e) && Co(e) ? e : $f(e);
}
function Pi(t, e) {
  var n;
  e === void 0 && (e = []);
  const r = $f(t), o = r === ((n = t.ownerDocument) == null ? void 0 : n.body), i = Ot(r);
  return o ? e.concat(i, i.visualViewport || [], Co(r) ? r : []) : e.concat(r, Pi(r));
}
function Nf(t) {
  const e = At(t);
  let n = parseFloat(e.width) || 0, r = parseFloat(e.height) || 0;
  const o = sn(t), i = o ? t.offsetWidth : n, s = o ? t.offsetHeight : r, a = ki(n) !== i || ki(r) !== s;
  return a && (n = i, r = s), {
    width: n,
    height: r,
    $: a
  };
}
function il(t) {
  return bn(t) ? t : t.contextElement;
}
function Cr(t) {
  const e = il(t);
  if (!sn(e))
    return Fn(1);
  const n = e.getBoundingClientRect(), {
    width: r,
    height: o,
    $: i
  } = Nf(e);
  let s = (i ? ki(n.width) : n.width) / r, a = (i ? ki(n.height) : n.height) / o;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
const l0 = /* @__PURE__ */ Fn(0);
function Rf(t) {
  const e = Ot(t);
  return !ol() || !e.visualViewport ? l0 : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function c0(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== Ot(t) ? !1 : e;
}
function nr(t, e, n, r) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const o = t.getBoundingClientRect(), i = il(t);
  let s = Fn(1);
  e && (r ? bn(r) && (s = Cr(r)) : s = Cr(t));
  const a = c0(i, n, r) ? Rf(i) : Fn(0);
  let l = (o.left + a.x) / s.x, c = (o.top + a.y) / s.y, u = o.width / s.x, d = o.height / s.y;
  if (i) {
    const f = Ot(i), h = r && bn(r) ? Ot(r) : r;
    let p = f.frameElement;
    for (; p && r && h !== f; ) {
      const g = Cr(p), m = p.getBoundingClientRect(), b = At(p), v = m.left + (p.clientLeft + parseFloat(b.paddingLeft)) * g.x, _ = m.top + (p.clientTop + parseFloat(b.paddingTop)) * g.y;
      l *= g.x, c *= g.y, u *= g.x, d *= g.y, l += v, c += _, p = Ot(p).frameElement;
    }
  }
  return Si({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
function u0(t) {
  let {
    rect: e,
    offsetParent: n,
    strategy: r
  } = t;
  const o = sn(n), i = yn(n);
  if (n === i)
    return e;
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  }, a = Fn(1);
  const l = Fn(0);
  if ((o || !o && r !== "fixed") && ((Vn(n) !== "body" || Co(i)) && (s = ts(n)), sn(n))) {
    const c = nr(n);
    a = Cr(n), l.x = c.x + n.clientLeft, l.y = c.y + n.clientTop;
  }
  return {
    width: e.width * a.x,
    height: e.height * a.y,
    x: e.x * a.x - s.scrollLeft * a.x + l.x,
    y: e.y * a.y - s.scrollTop * a.y + l.y
  };
}
function d0(t) {
  return Array.from(t.getClientRects());
}
function Af(t) {
  return nr(yn(t)).left + ts(t).scrollLeft;
}
function f0(t) {
  const e = yn(t), n = ts(t), r = t.ownerDocument.body, o = Ct(e.scrollWidth, e.clientWidth, r.scrollWidth, r.clientWidth), i = Ct(e.scrollHeight, e.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + Af(t);
  const a = -n.scrollTop;
  return At(r).direction === "rtl" && (s += Ct(e.clientWidth, r.clientWidth) - o), {
    width: o,
    height: i,
    x: s,
    y: a
  };
}
function h0(t, e) {
  const n = Ot(t), r = yn(t), o = n.visualViewport;
  let i = r.clientWidth, s = r.clientHeight, a = 0, l = 0;
  if (o) {
    i = o.width, s = o.height;
    const c = ol();
    (!c || c && e === "fixed") && (a = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: i,
    height: s,
    x: a,
    y: l
  };
}
function p0(t, e) {
  const n = nr(t, !0, e === "fixed"), r = n.top + t.clientTop, o = n.left + t.clientLeft, i = sn(t) ? Cr(t) : Fn(1), s = t.clientWidth * i.x, a = t.clientHeight * i.y, l = o * i.x, c = r * i.y;
  return {
    width: s,
    height: a,
    x: l,
    y: c
  };
}
function Rc(t, e, n) {
  let r;
  if (e === "viewport")
    r = h0(t, n);
  else if (e === "document")
    r = f0(yn(t));
  else if (bn(e))
    r = p0(e, n);
  else {
    const o = Rf(t);
    r = {
      ...e,
      x: e.x - o.x,
      y: e.y - o.y
    };
  }
  return Si(r);
}
function Lf(t, e) {
  const n = kr(t);
  return n === e || !bn(n) || es(n) ? !1 : At(n).position === "fixed" || Lf(n, e);
}
function g0(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let r = Pi(t).filter((a) => bn(a) && Vn(a) !== "body"), o = null;
  const i = At(t).position === "fixed";
  let s = i ? kr(t) : t;
  for (; bn(s) && !es(s); ) {
    const a = At(s), l = rl(s);
    !l && a.position === "fixed" && (o = null), (i ? !l && !o : !l && a.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || Co(s) && !l && Lf(t, s)) ? r = r.filter((u) => u !== s) : o = a, s = kr(s);
  }
  return e.set(t, r), r;
}
function m0(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = t;
  const s = [...n === "clippingAncestors" ? g0(e, this._c) : [].concat(n), r], a = s[0], l = s.reduce((c, u) => {
    const d = Rc(e, u, o);
    return c.top = Ct(d.top, c.top), c.right = Ln(d.right, c.right), c.bottom = Ln(d.bottom, c.bottom), c.left = Ct(d.left, c.left), c;
  }, Rc(e, a, o));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function v0(t) {
  return Nf(t);
}
function b0(t, e, n) {
  const r = sn(e), o = yn(e), i = n === "fixed", s = nr(t, !0, i, e);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Fn(0);
  if (r || !r && !i)
    if ((Vn(e) !== "body" || Co(o)) && (a = ts(e)), r) {
      const c = nr(e, !0, i, e);
      l.x = c.x + e.clientLeft, l.y = c.y + e.clientTop;
    } else
      o && (l.x = Af(o));
  return {
    x: s.left + a.scrollLeft - l.x,
    y: s.top + a.scrollTop - l.y,
    width: s.width,
    height: s.height
  };
}
function Ac(t, e) {
  return !sn(t) || At(t).position === "fixed" ? null : e ? e(t) : t.offsetParent;
}
function Ff(t, e) {
  const n = Ot(t);
  if (!sn(t))
    return n;
  let r = Ac(t, e);
  for (; r && s0(r) && At(r).position === "static"; )
    r = Ac(r, e);
  return r && (Vn(r) === "html" || Vn(r) === "body" && At(r).position === "static" && !rl(r)) ? n : r || a0(t) || n;
}
const y0 = async function(t) {
  let {
    reference: e,
    floating: n,
    strategy: r
  } = t;
  const o = this.getOffsetParent || Ff, i = this.getDimensions;
  return {
    reference: b0(e, await o(n), r),
    floating: {
      x: 0,
      y: 0,
      ...await i(n)
    }
  };
};
function w0(t) {
  return At(t).direction === "rtl";
}
const x0 = {
  convertOffsetParentRelativeRectToViewportRelativeRect: u0,
  getDocumentElement: yn,
  getClippingRect: m0,
  getOffsetParent: Ff,
  getElementRects: y0,
  getClientRects: d0,
  getDimensions: v0,
  getScale: Cr,
  isElement: bn,
  isRTL: w0
};
function _0(t, e) {
  let n = null, r;
  const o = yn(t);
  function i() {
    clearTimeout(r), n && n.disconnect(), n = null;
  }
  function s(a, l) {
    a === void 0 && (a = !1), l === void 0 && (l = 1), i();
    const {
      left: c,
      top: u,
      width: d,
      height: f
    } = t.getBoundingClientRect();
    if (a || e(), !d || !f)
      return;
    const h = Ao(u), p = Ao(o.clientWidth - (c + d)), g = Ao(o.clientHeight - (u + f)), m = Ao(c), v = {
      rootMargin: -h + "px " + -p + "px " + -g + "px " + -m + "px",
      threshold: Ct(0, Ln(1, l)) || 1
    };
    let _ = !0;
    function x(y) {
      const M = y[0].intersectionRatio;
      if (M !== l) {
        if (!_)
          return s();
        M ? s(!1, M) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 100);
      }
      _ = !1;
    }
    try {
      n = new IntersectionObserver(x, {
        ...v,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(x, v);
    }
    n.observe(t);
  }
  return s(!0), i;
}
function sl(t, e, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, c = il(t), u = o || i ? [...c ? Pi(c) : [], ...Pi(e)] : [];
  u.forEach((b) => {
    o && b.addEventListener("scroll", n, {
      passive: !0
    }), i && b.addEventListener("resize", n);
  });
  const d = c && a ? _0(c, n) : null;
  let f = -1, h = null;
  s && (h = new ResizeObserver((b) => {
    let [v] = b;
    v && v.target === c && h && (h.unobserve(e), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      h && h.observe(e);
    })), n();
  }), c && !l && h.observe(c), h.observe(e));
  let p, g = l ? nr(t) : null;
  l && m();
  function m() {
    const b = nr(t);
    g && (b.x !== g.x || b.y !== g.y || b.width !== g.width || b.height !== g.height) && n(), g = b, p = requestAnimationFrame(m);
  }
  return n(), () => {
    u.forEach((b) => {
      o && b.removeEventListener("scroll", n), i && b.removeEventListener("resize", n);
    }), d && d(), h && h.disconnect(), h = null, l && cancelAnimationFrame(p);
  };
}
const C0 = (t, e, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: x0,
    ...n
  }, i = {
    ...o.platform,
    _c: r
  };
  return o0(t, e, {
    ...o,
    platform: i
  });
}, Vf = (t) => {
  function e(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: t,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof t == "function" ? t(n) : t;
      return r && e(r) ? r.current != null ? Tc({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? Tc({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
};
var di = typeof document < "u" ? Ji : ue;
function Ii(t, e) {
  if (t === e)
    return !0;
  if (typeof t != typeof e)
    return !1;
  if (typeof t == "function" && t.toString() === e.toString())
    return !0;
  let n, r, o;
  if (t && e && typeof t == "object") {
    if (Array.isArray(t)) {
      if (n = t.length, n != e.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!Ii(t[r], e[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(t), n = o.length, n !== Object.keys(e).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(e, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = o[r];
      if (!(i === "_owner" && t.$$typeof) && !Ii(t[i], e[i]))
        return !1;
    }
    return !0;
  }
  return t !== t && e !== e;
}
function Wf(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Lc(t, e) {
  const n = Wf(t);
  return Math.round(e * n) / n;
}
function Fc(t) {
  const e = C.useRef(t);
  return di(() => {
    e.current = t;
  }), e;
}
function al(t) {
  t === void 0 && (t = {});
  const {
    placement: e = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: i,
      floating: s
    } = {},
    transform: a = !0,
    whileElementsMounted: l,
    open: c
  } = t, [u, d] = C.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: e,
    middlewareData: {},
    isPositioned: !1
  }), [f, h] = C.useState(r);
  Ii(f, r) || h(r);
  const [p, g] = C.useState(null), [m, b] = C.useState(null), v = C.useCallback((Y) => {
    Y != M.current && (M.current = Y, g(Y));
  }, [g]), _ = C.useCallback((Y) => {
    Y !== k.current && (k.current = Y, b(Y));
  }, [b]), x = i || p, y = s || m, M = C.useRef(null), k = C.useRef(null), O = C.useRef(u), S = Fc(l), D = Fc(o), P = C.useCallback(() => {
    if (!M.current || !k.current)
      return;
    const Y = {
      placement: e,
      strategy: n,
      middleware: f
    };
    D.current && (Y.platform = D.current), C0(M.current, k.current, Y).then((V) => {
      const z = {
        ...V,
        isPositioned: !0
      };
      N.current && !Ii(O.current, z) && (O.current = z, iv.flushSync(() => {
        d(z);
      }));
    });
  }, [f, e, n, D]);
  di(() => {
    c === !1 && O.current.isPositioned && (O.current.isPositioned = !1, d((Y) => ({
      ...Y,
      isPositioned: !1
    })));
  }, [c]);
  const N = C.useRef(!1);
  di(() => (N.current = !0, () => {
    N.current = !1;
  }), []), di(() => {
    if (x && (M.current = x), y && (k.current = y), x && y) {
      if (S.current)
        return S.current(x, y, P);
      P();
    }
  }, [x, y, P, S]);
  const T = C.useMemo(() => ({
    reference: M,
    floating: k,
    setReference: v,
    setFloating: _
  }), [v, _]), U = C.useMemo(() => ({
    reference: x,
    floating: y
  }), [x, y]), R = C.useMemo(() => {
    const Y = {
      position: n,
      left: 0,
      top: 0
    };
    if (!U.floating)
      return Y;
    const V = Lc(U.floating, u.x), z = Lc(U.floating, u.y);
    return a ? {
      ...Y,
      transform: "translate(" + V + "px, " + z + "px)",
      ...Wf(U.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: V,
      top: z
    };
  }, [n, a, U.floating, u.x, u.y]);
  return C.useMemo(() => ({
    ...u,
    update: P,
    refs: T,
    elements: U,
    floatingStyles: R
  }), [u, P, T, U, R]);
}
const E0 = /* @__PURE__ */ de((t, e) => {
  const { children: n, width: r = 10, height: o = 5, ...i } = t;
  return /* @__PURE__ */ L(je.svg, ne({}, i, {
    ref: e,
    width: r,
    height: o,
    viewBox: "0 0 30 10",
    preserveAspectRatio: "none"
  }), t.asChild ? n : /* @__PURE__ */ L("polygon", {
    points: "0,0 30,0 15,10"
  }));
}), M0 = E0;
function ll(t) {
  const [e, n] = ye(void 0);
  return An(() => {
    if (t) {
      n({
        width: t.offsetWidth,
        height: t.offsetHeight
      });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let s, a;
        if ("borderBoxSize" in i) {
          const l = i.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          s = c.inlineSize, a = c.blockSize;
        } else
          s = t.offsetWidth, a = t.offsetHeight;
        n({
          width: s,
          height: a
        });
      });
      return r.observe(t, {
        box: "border-box"
      }), () => r.unobserve(t);
    } else
      n(void 0);
  }, [
    t
  ]), e;
}
const Hf = "Popper", [Bf, ns] = an(Hf), [k0, jf] = Bf(Hf), O0 = (t) => {
  const { __scopePopper: e, children: n } = t, [r, o] = ye(null);
  return /* @__PURE__ */ L(k0, {
    scope: e,
    anchor: r,
    onAnchorChange: o
  }, n);
}, S0 = "PopperAnchor", P0 = /* @__PURE__ */ de((t, e) => {
  const { __scopePopper: n, virtualRef: r, ...o } = t, i = jf(S0, n), s = ae(null), a = et(e, s);
  return ue(() => {
    i.onAnchorChange((r == null ? void 0 : r.current) || s.current);
  }), r ? null : /* @__PURE__ */ L(je.div, ne({}, o, {
    ref: a
  }));
}), zf = "PopperContent", [I0, T0] = Bf(zf), D0 = /* @__PURE__ */ de((t, e) => {
  var n, r, o, i, s, a, l, c;
  const { __scopePopper: u, side: d = "bottom", sideOffset: f = 0, align: h = "center", alignOffset: p = 0, arrowPadding: g = 0, collisionBoundary: m = [], collisionPadding: b = 0, sticky: v = "partial", hideWhenDetached: _ = !1, avoidCollisions: x = !0, onPlaced: y, ...M } = t, k = jf(zf, u), [O, S] = ye(null), D = et(
    e,
    (Pe) => S(Pe)
  ), [P, N] = ye(null), T = ll(P), U = (n = T == null ? void 0 : T.width) !== null && n !== void 0 ? n : 0, R = (r = T == null ? void 0 : T.height) !== null && r !== void 0 ? r : 0, Y = d + (h !== "center" ? "-" + h : ""), V = typeof b == "number" ? b : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...b
  }, z = Array.isArray(m) ? m : [
    m
  ], ee = z.length > 0, $ = {
    padding: V,
    boundary: z.filter(A0),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: ee
  }, { refs: F, floatingStyles: te, placement: J, isPositioned: re, middlewareData: j } = al({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: Y,
    whileElementsMounted: sl,
    elements: {
      reference: k.anchor
    },
    middleware: [
      el({
        mainAxis: f + R,
        alignmentAxis: p
      }),
      x && tl({
        mainAxis: !0,
        crossAxis: !1,
        limiter: v === "partial" ? Tf() : void 0,
        ...$
      }),
      x && Ja({
        ...$
      }),
      nl({
        ...$,
        apply: ({ elements: Pe, rects: Re, availableWidth: ct, availableHeight: ut }) => {
          const { width: Gt, height: gt } = Re.reference, xt = Pe.floating.style;
          xt.setProperty("--radix-popper-available-width", `${ct}px`), xt.setProperty("--radix-popper-available-height", `${ut}px`), xt.setProperty("--radix-popper-anchor-width", `${Gt}px`), xt.setProperty("--radix-popper-anchor-height", `${gt}px`);
        }
      }),
      P && Vf({
        element: P,
        padding: g
      }),
      L0({
        arrowWidth: U,
        arrowHeight: R
      }),
      _ && If({
        strategy: "referenceHidden"
      })
    ]
  }), [A, W] = Uf(J), H = pt(y);
  An(() => {
    re && (H == null || H());
  }, [
    re,
    H
  ]);
  const q = (o = j.arrow) === null || o === void 0 ? void 0 : o.x, oe = (i = j.arrow) === null || i === void 0 ? void 0 : i.y, Z = ((s = j.arrow) === null || s === void 0 ? void 0 : s.centerOffset) !== 0, [G, we] = ye();
  return An(() => {
    O && we(window.getComputedStyle(O).zIndex);
  }, [
    O
  ]), /* @__PURE__ */ L("div", {
    ref: F.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...te,
      transform: re ? te.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: G,
      "--radix-popper-transform-origin": [
        (a = j.transformOrigin) === null || a === void 0 ? void 0 : a.x,
        (l = j.transformOrigin) === null || l === void 0 ? void 0 : l.y
      ].join(" ")
    },
    dir: t.dir
  }, /* @__PURE__ */ L(I0, {
    scope: u,
    placedSide: A,
    onArrowChange: N,
    arrowX: q,
    arrowY: oe,
    shouldHideArrow: Z
  }, /* @__PURE__ */ L(je.div, ne({
    "data-side": A,
    "data-align": W
  }, M, {
    ref: D,
    style: {
      ...M.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: re ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (c = j.hide) !== null && c !== void 0 && c.referenceHidden ? 0 : void 0
    }
  }))));
}), $0 = "PopperArrow", N0 = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, R0 = /* @__PURE__ */ de(function(e, n) {
  const { __scopePopper: r, ...o } = e, i = T0($0, r), s = N0[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ L("span", {
      ref: i.onArrowChange,
      style: {
        position: "absolute",
        left: i.arrowX,
        top: i.arrowY,
        [s]: 0,
        transformOrigin: {
          top: "",
          right: "0 0",
          bottom: "center 0",
          left: "100% 0"
        }[i.placedSide],
        transform: {
          top: "translateY(100%)",
          right: "translateY(50%) rotate(90deg) translateX(-50%)",
          bottom: "rotate(180deg)",
          left: "translateY(50%) rotate(-90deg) translateX(50%)"
        }[i.placedSide],
        visibility: i.shouldHideArrow ? "hidden" : void 0
      }
    }, /* @__PURE__ */ L(M0, ne({}, o, {
      ref: n,
      style: {
        ...o.style,
        // ensures the element can be measured correctly (mostly for if SVG)
        display: "block"
      }
    })))
  );
});
function A0(t) {
  return t !== null;
}
const L0 = (t) => ({
  name: "transformOrigin",
  options: t,
  fn(e) {
    var n, r, o, i, s;
    const { placement: a, rects: l, middlewareData: c } = e, d = ((n = c.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, f = d ? 0 : t.arrowWidth, h = d ? 0 : t.arrowHeight, [p, g] = Uf(a), m = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[g], b = ((r = (o = c.arrow) === null || o === void 0 ? void 0 : o.x) !== null && r !== void 0 ? r : 0) + f / 2, v = ((i = (s = c.arrow) === null || s === void 0 ? void 0 : s.y) !== null && i !== void 0 ? i : 0) + h / 2;
    let _ = "", x = "";
    return p === "bottom" ? (_ = d ? m : `${b}px`, x = `${-h}px`) : p === "top" ? (_ = d ? m : `${b}px`, x = `${l.floating.height + h}px`) : p === "right" ? (_ = `${-h}px`, x = d ? m : `${v}px`) : p === "left" && (_ = `${l.floating.width + h}px`, x = d ? m : `${v}px`), {
      data: {
        x: _,
        y: x
      }
    };
  }
});
function Uf(t) {
  const [e, n = "center"] = t.split("-");
  return [
    e,
    n
  ];
}
const Yf = O0, cl = P0, Kf = D0, Gf = R0, ul = /* @__PURE__ */ de((t, e) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...o } = t;
  return r ? /* @__PURE__ */ vf.createPortal(/* @__PURE__ */ L(je.div, ne({}, o, {
    ref: e
  })), r) : null;
}), F0 = ul;
function V0(t, e) {
  return mf((n, r) => {
    const o = e[n][r];
    return o ?? n;
  }, t);
}
const cr = (t) => {
  const { present: e, children: n } = t, r = W0(e), o = typeof n == "function" ? n({
    present: r.isPresent
  }) : _r.only(n), i = et(r.ref, o.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ Qi(o, {
    ref: i
  }) : null;
};
cr.displayName = "Presence";
function W0(t) {
  const [e, n] = ye(), r = ae({}), o = ae(t), i = ae("none"), s = t ? "mounted" : "unmounted", [a, l] = V0(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return ue(() => {
    const c = Lo(r.current);
    i.current = a === "mounted" ? c : "none";
  }, [
    a
  ]), An(() => {
    const c = r.current, u = o.current;
    if (u !== t) {
      const f = i.current, h = Lo(c);
      t ? l("MOUNT") : h === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(u && f !== h ? "ANIMATION_OUT" : "UNMOUNT"), o.current = t;
    }
  }, [
    t,
    l
  ]), An(() => {
    if (e) {
      const c = (d) => {
        const h = Lo(r.current).includes(d.animationName);
        d.target === e && h && Ua(
          () => l("ANIMATION_END")
        );
      }, u = (d) => {
        d.target === e && (i.current = Lo(r.current));
      };
      return e.addEventListener("animationstart", u), e.addEventListener("animationcancel", c), e.addEventListener("animationend", c), () => {
        e.removeEventListener("animationstart", u), e.removeEventListener("animationcancel", c), e.removeEventListener("animationend", c);
      };
    } else
      l("ANIMATION_END");
  }, [
    e,
    l
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(a),
    ref: pe((c) => {
      c && (r.current = getComputedStyle(c)), n(c);
    }, [])
  };
}
function Lo(t) {
  return (t == null ? void 0 : t.animationName) || "none";
}
function Hn({ prop: t, defaultProp: e, onChange: n = () => {
} }) {
  const [r, o] = H0({
    defaultProp: e,
    onChange: n
  }), i = t !== void 0, s = i ? t : r, a = pt(n), l = pe((c) => {
    if (i) {
      const d = typeof c == "function" ? c(t) : c;
      d !== t && a(d);
    } else
      o(c);
  }, [
    i,
    t,
    o,
    a
  ]);
  return [
    s,
    l
  ];
}
function H0({ defaultProp: t, onChange: e }) {
  const n = ye(t), [r] = n, o = ae(r), i = pt(e);
  return ue(() => {
    o.current !== r && (i(r), o.current = r);
  }, [
    r,
    o,
    i
  ]), n;
}
const B0 = /* @__PURE__ */ de((t, e) => /* @__PURE__ */ L(je.span, ne({}, t, {
  ref: e,
  style: {
    // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal",
    ...t.style
  }
}))), j0 = B0, [rs, Hk] = an("Tooltip", [
  ns
]), os = ns(), z0 = "TooltipProvider", U0 = 700, pa = "tooltip.open", [Y0, dl] = rs(z0), K0 = (t) => {
  const { __scopeTooltip: e, delayDuration: n = U0, skipDelayDuration: r = 300, disableHoverableContent: o = !1, children: i } = t, [s, a] = ye(!0), l = ae(!1), c = ae(0);
  return ue(() => {
    const u = c.current;
    return () => window.clearTimeout(u);
  }, []), /* @__PURE__ */ L(Y0, {
    scope: e,
    isOpenDelayed: s,
    delayDuration: n,
    onOpen: pe(() => {
      window.clearTimeout(c.current), a(!1);
    }, []),
    onClose: pe(() => {
      window.clearTimeout(c.current), c.current = window.setTimeout(
        () => a(!0),
        r
      );
    }, [
      r
    ]),
    isPointerInTransitRef: l,
    onPointerInTransitChange: pe((u) => {
      l.current = u;
    }, []),
    disableHoverableContent: o
  }, i);
}, fl = "Tooltip", [G0, Eo] = rs(fl), q0 = (t) => {
  const { __scopeTooltip: e, children: n, open: r, defaultOpen: o = !1, onOpenChange: i, disableHoverableContent: s, delayDuration: a } = t, l = dl(fl, t.__scopeTooltip), c = os(e), [u, d] = ye(null), f = fo(), h = ae(0), p = s ?? l.disableHoverableContent, g = a ?? l.delayDuration, m = ae(!1), [b = !1, v] = Hn({
    prop: r,
    defaultProp: o,
    onChange: (k) => {
      k ? (l.onOpen(), document.dispatchEvent(new CustomEvent(pa))) : l.onClose(), i == null || i(k);
    }
  }), _ = Rn(() => b ? m.current ? "delayed-open" : "instant-open" : "closed", [
    b
  ]), x = pe(() => {
    window.clearTimeout(h.current), m.current = !1, v(!0);
  }, [
    v
  ]), y = pe(() => {
    window.clearTimeout(h.current), v(!1);
  }, [
    v
  ]), M = pe(() => {
    window.clearTimeout(h.current), h.current = window.setTimeout(() => {
      m.current = !0, v(!0);
    }, g);
  }, [
    g,
    v
  ]);
  return ue(() => () => window.clearTimeout(h.current), []), /* @__PURE__ */ L(Yf, c, /* @__PURE__ */ L(G0, {
    scope: e,
    contentId: f,
    open: b,
    stateAttribute: _,
    trigger: u,
    onTriggerChange: d,
    onTriggerEnter: pe(() => {
      l.isOpenDelayed ? M() : x();
    }, [
      l.isOpenDelayed,
      M,
      x
    ]),
    onTriggerLeave: pe(() => {
      p ? y() : window.clearTimeout(h.current);
    }, [
      y,
      p
    ]),
    onOpen: x,
    onClose: y,
    disableHoverableContent: p
  }, n));
}, Vc = "TooltipTrigger", X0 = /* @__PURE__ */ de((t, e) => {
  const { __scopeTooltip: n, ...r } = t, o = Eo(Vc, n), i = dl(Vc, n), s = os(n), a = ae(null), l = et(e, a, o.onTriggerChange), c = ae(!1), u = ae(!1), d = pe(
    () => c.current = !1,
    []
  );
  return ue(() => () => document.removeEventListener("pointerup", d), [
    d
  ]), /* @__PURE__ */ L(cl, ne({
    asChild: !0
  }, s), /* @__PURE__ */ L(je.button, ne({
    // We purposefully avoid adding `type=button` here because tooltip triggers are also
    // commonly anchors and the anchor `type` attribute signifies MIME type.
    "aria-describedby": o.open ? o.contentId : void 0,
    "data-state": o.stateAttribute
  }, r, {
    ref: l,
    onPointerMove: be(t.onPointerMove, (f) => {
      f.pointerType !== "touch" && !u.current && !i.isPointerInTransitRef.current && (o.onTriggerEnter(), u.current = !0);
    }),
    onPointerLeave: be(t.onPointerLeave, () => {
      o.onTriggerLeave(), u.current = !1;
    }),
    onPointerDown: be(t.onPointerDown, () => {
      c.current = !0, document.addEventListener("pointerup", d, {
        once: !0
      });
    }),
    onFocus: be(t.onFocus, () => {
      c.current || o.onOpen();
    }),
    onBlur: be(t.onBlur, o.onClose),
    onClick: be(t.onClick, o.onClose)
  })));
}), qf = "TooltipPortal", [Z0, Q0] = rs(qf, {
  forceMount: void 0
}), J0 = (t) => {
  const { __scopeTooltip: e, forceMount: n, children: r, container: o } = t, i = Eo(qf, e);
  return /* @__PURE__ */ L(Z0, {
    scope: e,
    forceMount: n
  }, /* @__PURE__ */ L(cr, {
    present: n || i.open
  }, /* @__PURE__ */ L(ul, {
    asChild: !0,
    container: o
  }, r)));
}, po = "TooltipContent", eb = /* @__PURE__ */ de((t, e) => {
  const n = Q0(po, t.__scopeTooltip), { forceMount: r = n.forceMount, side: o = "top", ...i } = t, s = Eo(po, t.__scopeTooltip);
  return /* @__PURE__ */ L(cr, {
    present: r || s.open
  }, s.disableHoverableContent ? /* @__PURE__ */ L(Xf, ne({
    side: o
  }, i, {
    ref: e
  })) : /* @__PURE__ */ L(tb, ne({
    side: o
  }, i, {
    ref: e
  })));
}), tb = /* @__PURE__ */ de((t, e) => {
  const n = Eo(po, t.__scopeTooltip), r = dl(po, t.__scopeTooltip), o = ae(null), i = et(e, o), [s, a] = ye(null), { trigger: l, onClose: c } = n, u = o.current, { onPointerInTransitChange: d } = r, f = pe(() => {
    a(null), d(!1);
  }, [
    d
  ]), h = pe((p, g) => {
    const m = p.currentTarget, b = {
      x: p.clientX,
      y: p.clientY
    }, v = sb(b, m.getBoundingClientRect()), _ = ab(b, v), x = lb(g.getBoundingClientRect()), y = ub([
      ..._,
      ...x
    ]);
    a(y), d(!0);
  }, [
    d
  ]);
  return ue(() => () => f(), [
    f
  ]), ue(() => {
    if (l && u) {
      const p = (m) => h(m, u), g = (m) => h(m, l);
      return l.addEventListener("pointerleave", p), u.addEventListener("pointerleave", g), () => {
        l.removeEventListener("pointerleave", p), u.removeEventListener("pointerleave", g);
      };
    }
  }, [
    l,
    u,
    h,
    f
  ]), ue(() => {
    if (s) {
      const p = (g) => {
        const m = g.target, b = {
          x: g.clientX,
          y: g.clientY
        }, v = (l == null ? void 0 : l.contains(m)) || (u == null ? void 0 : u.contains(m)), _ = !cb(b, s);
        v ? f() : _ && (f(), c());
      };
      return document.addEventListener("pointermove", p), () => document.removeEventListener("pointermove", p);
    }
  }, [
    l,
    u,
    s,
    c,
    f
  ]), /* @__PURE__ */ L(Xf, ne({}, t, {
    ref: i
  }));
}), [nb, rb] = rs(fl, {
  isInside: !1
}), Xf = /* @__PURE__ */ de((t, e) => {
  const { __scopeTooltip: n, children: r, "aria-label": o, onEscapeKeyDown: i, onPointerDownOutside: s, ...a } = t, l = Eo(po, n), c = os(n), { onClose: u } = l;
  return ue(() => (document.addEventListener(pa, u), () => document.removeEventListener(pa, u)), [
    u
  ]), ue(() => {
    if (l.trigger) {
      const d = (f) => {
        const h = f.target;
        h != null && h.contains(l.trigger) && u();
      };
      return window.addEventListener("scroll", d, {
        capture: !0
      }), () => window.removeEventListener("scroll", d, {
        capture: !0
      });
    }
  }, [
    l.trigger,
    u
  ]), /* @__PURE__ */ L(Of, {
    asChild: !0,
    disableOutsidePointerEvents: !1,
    onEscapeKeyDown: i,
    onPointerDownOutside: s,
    onFocusOutside: (d) => d.preventDefault(),
    onDismiss: u
  }, /* @__PURE__ */ L(Kf, ne({
    "data-state": l.stateAttribute
  }, c, a, {
    ref: e,
    style: {
      ...a.style,
      "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
      "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
      "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }), /* @__PURE__ */ L(bf, null, r), /* @__PURE__ */ L(nb, {
    scope: n,
    isInside: !0
  }, /* @__PURE__ */ L(j0, {
    id: l.contentId,
    role: "tooltip"
  }, o || r))));
}), ob = "TooltipArrow", ib = /* @__PURE__ */ de((t, e) => {
  const { __scopeTooltip: n, ...r } = t, o = os(n);
  return rb(ob, n).isInside ? null : /* @__PURE__ */ L(Gf, ne({}, o, r, {
    ref: e
  }));
});
function sb(t, e) {
  const n = Math.abs(e.top - t.y), r = Math.abs(e.bottom - t.y), o = Math.abs(e.right - t.x), i = Math.abs(e.left - t.x);
  switch (Math.min(n, r, o, i)) {
    case i:
      return "left";
    case o:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function ab(t, e, n = 5) {
  const r = [];
  switch (e) {
    case "top":
      r.push({
        x: t.x - n,
        y: t.y + n
      }, {
        x: t.x + n,
        y: t.y + n
      });
      break;
    case "bottom":
      r.push({
        x: t.x - n,
        y: t.y - n
      }, {
        x: t.x + n,
        y: t.y - n
      });
      break;
    case "left":
      r.push({
        x: t.x + n,
        y: t.y - n
      }, {
        x: t.x + n,
        y: t.y + n
      });
      break;
    case "right":
      r.push({
        x: t.x - n,
        y: t.y - n
      }, {
        x: t.x - n,
        y: t.y + n
      });
      break;
  }
  return r;
}
function lb(t) {
  const { top: e, right: n, bottom: r, left: o } = t;
  return [
    {
      x: o,
      y: e
    },
    {
      x: n,
      y: e
    },
    {
      x: n,
      y: r
    },
    {
      x: o,
      y: r
    }
  ];
}
function cb(t, e) {
  const { x: n, y: r } = t;
  let o = !1;
  for (let i = 0, s = e.length - 1; i < e.length; s = i++) {
    const a = e[i].x, l = e[i].y, c = e[s].x, u = e[s].y;
    l > r != u > r && n < (c - a) * (r - l) / (u - l) + a && (o = !o);
  }
  return o;
}
function ub(t) {
  const e = t.slice();
  return e.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), db(e);
}
function db(t) {
  if (t.length <= 1)
    return t.slice();
  const e = [];
  for (let r = 0; r < t.length; r++) {
    const o = t[r];
    for (; e.length >= 2; ) {
      const i = e[e.length - 1], s = e[e.length - 2];
      if ((i.x - s.x) * (o.y - s.y) >= (i.y - s.y) * (o.x - s.x))
        e.pop();
      else
        break;
    }
    e.push(o);
  }
  e.pop();
  const n = [];
  for (let r = t.length - 1; r >= 0; r--) {
    const o = t[r];
    for (; n.length >= 2; ) {
      const i = n[n.length - 1], s = n[n.length - 2];
      if ((i.x - s.x) * (o.y - s.y) >= (i.y - s.y) * (o.x - s.x))
        n.pop();
      else
        break;
    }
    n.push(o);
  }
  return n.pop(), e.length === 1 && n.length === 1 && e[0].x === n[0].x && e[0].y === n[0].y ? e : e.concat(n);
}
const fb = K0, hb = q0, pb = X0, gb = J0, mb = eb, vb = ib, bb = Kt(
  "z-50 border rounded-lg max-w-lg data-[state=delayed-open]:animate-fadeIn",
  {
    variants: {
      variant: {
        dark: "bg-foundations-inverse border-transparent text-foundations-inverse [&_.tooltip-arrow]:fill-[theme(backgroundColor.foundations-inverse)]",
        light: "bg-foundations-default border-foundations-subtle text-foundations-boldest [&_.tooltip-arrow]:fill-[theme(backgroundColor.foundations-default)] [&_.tooltip-arrow]:stroke [&_.tooltip-arrow]:stroke-[theme(borderColor.foundations-subtle)]"
      },
      size: {
        default: "text-sm p-2 lg:p-3 lg:[&_.tooltip-arrow]:w-8 lg:[&_.tooltip-arrow]:h-4",
        sm: "text-xs py-1.5 px-2.5"
      }
    },
    defaultVariants: {
      variant: "dark",
      size: "default"
    }
  }
), ga = (t) => /* @__PURE__ */ w(fb, { delayDuration: 350, ...t }), rr = ({
  children: t,
  content: e,
  size: n,
  side: r = "top",
  sideOffset: o = 4,
  collisionPadding: i = 4,
  disableHoverableContent: s,
  defaultOpen: a,
  open: l,
  onOpenChange: c,
  variant: u,
  className: d,
  hideArrow: f = !1,
  disabled: h = !1,
  delayDuration: p,
  onClick: g
}) => /* @__PURE__ */ B(
  hb,
  {
    defaultOpen: a,
    open: l,
    onOpenChange: c,
    disableHoverableContent: s,
    delayDuration: p,
    children: [
      /* @__PURE__ */ w(pb, { asChild: !0, children: t }),
      /* @__PURE__ */ w(gb, { children: /* @__PURE__ */ B(
        mb,
        {
          hidden: h,
          className: he(bb({ variant: u, size: n }), d),
          side: r,
          sideOffset: o,
          collisionPadding: i,
          onClick: g,
          children: [
            e,
            !f && /* @__PURE__ */ w(vb, { className: "tooltip-arrow" })
          ]
        }
      ) })
    ]
  }
);
rr.displayName = "Tooltip";
const yb = ({
  children: t,
  content: e,
  ...n
}) => {
  const [r, o] = C.useState(null), [i, s] = C.useState(!1);
  return C.useEffect(() => {
    if (!r)
      return;
    const a = () => {
      s(r.scrollWidth > r.clientWidth);
    }, l = new ResizeObserver((c) => {
      for (const u of c)
        u.contentBoxSize && a();
    });
    return l.observe(r), () => l.unobserve(r);
  }, [r]), C.Children.only(t) && C.isValidElement(t) ? /* @__PURE__ */ w(
    rr,
    {
      disabled: !i,
      content: e ?? (r == null ? void 0 : r.textContent),
      ...n,
      children: /* @__PURE__ */ w(Rt, { className: "truncate", ref: o, children: t })
    }
  ) : null;
};
yb.displayName = "OverflowText";
const wb = C.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ w(
  "div",
  {
    ref: n,
    className: he(
      "h-4 animate-pulse rounded-sm bg-foundations-subtlest",
      t
    ),
    ...e
  }
));
wb.displayName = "Skeleton";
/*!
 * @kurkle/color v0.3.2
 * https://github.com/kurkle/color#readme
 * (c) 2023 Jukka Kurkela
 * Released under the MIT License
 */
function Mo(t) {
  return t + 0.5 | 0;
}
const Sn = (t, e, n) => Math.max(Math.min(t, n), e);
function Qr(t) {
  return Sn(Mo(t * 2.55), 0, 255);
}
function $n(t) {
  return Sn(Mo(t * 255), 0, 255);
}
function pn(t) {
  return Sn(Mo(t / 2.55) / 100, 0, 1);
}
function Wc(t) {
  return Sn(Mo(t * 100), 0, 100);
}
const Pt = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, ma = [..."0123456789ABCDEF"], xb = (t) => ma[t & 15], _b = (t) => ma[(t & 240) >> 4] + ma[t & 15], Fo = (t) => (t & 240) >> 4 === (t & 15), Cb = (t) => Fo(t.r) && Fo(t.g) && Fo(t.b) && Fo(t.a);
function Eb(t) {
  var e = t.length, n;
  return t[0] === "#" && (e === 4 || e === 5 ? n = {
    r: 255 & Pt[t[1]] * 17,
    g: 255 & Pt[t[2]] * 17,
    b: 255 & Pt[t[3]] * 17,
    a: e === 5 ? Pt[t[4]] * 17 : 255
  } : (e === 7 || e === 9) && (n = {
    r: Pt[t[1]] << 4 | Pt[t[2]],
    g: Pt[t[3]] << 4 | Pt[t[4]],
    b: Pt[t[5]] << 4 | Pt[t[6]],
    a: e === 9 ? Pt[t[7]] << 4 | Pt[t[8]] : 255
  })), n;
}
const Mb = (t, e) => t < 255 ? e(t) : "";
function kb(t) {
  var e = Cb(t) ? xb : _b;
  return t ? "#" + e(t.r) + e(t.g) + e(t.b) + Mb(t.a, e) : void 0;
}
const Ob = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function Zf(t, e, n) {
  const r = e * Math.min(n, 1 - n), o = (i, s = (i + t / 30) % 12) => n - r * Math.max(Math.min(s - 3, 9 - s, 1), -1);
  return [o(0), o(8), o(4)];
}
function Sb(t, e, n) {
  const r = (o, i = (o + t / 60) % 6) => n - n * e * Math.max(Math.min(i, 4 - i, 1), 0);
  return [r(5), r(3), r(1)];
}
function Pb(t, e, n) {
  const r = Zf(t, 1, 0.5);
  let o;
  for (e + n > 1 && (o = 1 / (e + n), e *= o, n *= o), o = 0; o < 3; o++)
    r[o] *= 1 - e - n, r[o] += e;
  return r;
}
function Ib(t, e, n, r, o) {
  return t === o ? (e - n) / r + (e < n ? 6 : 0) : e === o ? (n - t) / r + 2 : (t - e) / r + 4;
}
function hl(t) {
  const n = t.r / 255, r = t.g / 255, o = t.b / 255, i = Math.max(n, r, o), s = Math.min(n, r, o), a = (i + s) / 2;
  let l, c, u;
  return i !== s && (u = i - s, c = a > 0.5 ? u / (2 - i - s) : u / (i + s), l = Ib(n, r, o, u, i), l = l * 60 + 0.5), [l | 0, c || 0, a];
}
function pl(t, e, n, r) {
  return (Array.isArray(e) ? t(e[0], e[1], e[2]) : t(e, n, r)).map($n);
}
function gl(t, e, n) {
  return pl(Zf, t, e, n);
}
function Tb(t, e, n) {
  return pl(Pb, t, e, n);
}
function Db(t, e, n) {
  return pl(Sb, t, e, n);
}
function Qf(t) {
  return (t % 360 + 360) % 360;
}
function $b(t) {
  const e = Ob.exec(t);
  let n = 255, r;
  if (!e)
    return;
  e[5] !== r && (n = e[6] ? Qr(+e[5]) : $n(+e[5]));
  const o = Qf(+e[2]), i = +e[3] / 100, s = +e[4] / 100;
  return e[1] === "hwb" ? r = Tb(o, i, s) : e[1] === "hsv" ? r = Db(o, i, s) : r = gl(o, i, s), {
    r: r[0],
    g: r[1],
    b: r[2],
    a: n
  };
}
function Nb(t, e) {
  var n = hl(t);
  n[0] = Qf(n[0] + e), n = gl(n), t.r = n[0], t.g = n[1], t.b = n[2];
}
function Rb(t) {
  if (!t)
    return;
  const e = hl(t), n = e[0], r = Wc(e[1]), o = Wc(e[2]);
  return t.a < 255 ? `hsla(${n}, ${r}%, ${o}%, ${pn(t.a)})` : `hsl(${n}, ${r}%, ${o}%)`;
}
const Hc = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, Bc = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function Ab() {
  const t = {}, e = Object.keys(Bc), n = Object.keys(Hc);
  let r, o, i, s, a;
  for (r = 0; r < e.length; r++) {
    for (s = a = e[r], o = 0; o < n.length; o++)
      i = n[o], a = a.replace(i, Hc[i]);
    i = parseInt(Bc[s], 16), t[a] = [i >> 16 & 255, i >> 8 & 255, i & 255];
  }
  return t;
}
let Vo;
function Lb(t) {
  Vo || (Vo = Ab(), Vo.transparent = [0, 0, 0, 0]);
  const e = Vo[t.toLowerCase()];
  return e && {
    r: e[0],
    g: e[1],
    b: e[2],
    a: e.length === 4 ? e[3] : 255
  };
}
const Fb = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function Vb(t) {
  const e = Fb.exec(t);
  let n = 255, r, o, i;
  if (e) {
    if (e[7] !== r) {
      const s = +e[7];
      n = e[8] ? Qr(s) : Sn(s * 255, 0, 255);
    }
    return r = +e[1], o = +e[3], i = +e[5], r = 255 & (e[2] ? Qr(r) : Sn(r, 0, 255)), o = 255 & (e[4] ? Qr(o) : Sn(o, 0, 255)), i = 255 & (e[6] ? Qr(i) : Sn(i, 0, 255)), {
      r,
      g: o,
      b: i,
      a: n
    };
  }
}
function Wb(t) {
  return t && (t.a < 255 ? `rgba(${t.r}, ${t.g}, ${t.b}, ${pn(t.a)})` : `rgb(${t.r}, ${t.g}, ${t.b})`);
}
const Cs = (t) => t <= 31308e-7 ? t * 12.92 : Math.pow(t, 1 / 2.4) * 1.055 - 0.055, gr = (t) => t <= 0.04045 ? t / 12.92 : Math.pow((t + 0.055) / 1.055, 2.4);
function Hb(t, e, n) {
  const r = gr(pn(t.r)), o = gr(pn(t.g)), i = gr(pn(t.b));
  return {
    r: $n(Cs(r + n * (gr(pn(e.r)) - r))),
    g: $n(Cs(o + n * (gr(pn(e.g)) - o))),
    b: $n(Cs(i + n * (gr(pn(e.b)) - i))),
    a: t.a + n * (e.a - t.a)
  };
}
function Wo(t, e, n) {
  if (t) {
    let r = hl(t);
    r[e] = Math.max(0, Math.min(r[e] + r[e] * n, e === 0 ? 360 : 1)), r = gl(r), t.r = r[0], t.g = r[1], t.b = r[2];
  }
}
function Jf(t, e) {
  return t && Object.assign(e || {}, t);
}
function jc(t) {
  var e = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(t) ? t.length >= 3 && (e = { r: t[0], g: t[1], b: t[2], a: 255 }, t.length > 3 && (e.a = $n(t[3]))) : (e = Jf(t, { r: 0, g: 0, b: 0, a: 1 }), e.a = $n(e.a)), e;
}
function Bb(t) {
  return t.charAt(0) === "r" ? Vb(t) : $b(t);
}
class go {
  constructor(e) {
    if (e instanceof go)
      return e;
    const n = typeof e;
    let r;
    n === "object" ? r = jc(e) : n === "string" && (r = Eb(e) || Lb(e) || Bb(e)), this._rgb = r, this._valid = !!r;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var e = Jf(this._rgb);
    return e && (e.a = pn(e.a)), e;
  }
  set rgb(e) {
    this._rgb = jc(e);
  }
  rgbString() {
    return this._valid ? Wb(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? kb(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? Rb(this._rgb) : void 0;
  }
  mix(e, n) {
    if (e) {
      const r = this.rgb, o = e.rgb;
      let i;
      const s = n === i ? 0.5 : n, a = 2 * s - 1, l = r.a - o.a, c = ((a * l === -1 ? a : (a + l) / (1 + a * l)) + 1) / 2;
      i = 1 - c, r.r = 255 & c * r.r + i * o.r + 0.5, r.g = 255 & c * r.g + i * o.g + 0.5, r.b = 255 & c * r.b + i * o.b + 0.5, r.a = s * r.a + (1 - s) * o.a, this.rgb = r;
    }
    return this;
  }
  interpolate(e, n) {
    return e && (this._rgb = Hb(this._rgb, e._rgb, n)), this;
  }
  clone() {
    return new go(this.rgb);
  }
  alpha(e) {
    return this._rgb.a = $n(e), this;
  }
  clearer(e) {
    const n = this._rgb;
    return n.a *= 1 - e, this;
  }
  greyscale() {
    const e = this._rgb, n = Mo(e.r * 0.3 + e.g * 0.59 + e.b * 0.11);
    return e.r = e.g = e.b = n, this;
  }
  opaquer(e) {
    const n = this._rgb;
    return n.a *= 1 + e, this;
  }
  negate() {
    const e = this._rgb;
    return e.r = 255 - e.r, e.g = 255 - e.g, e.b = 255 - e.b, this;
  }
  lighten(e) {
    return Wo(this._rgb, 2, e), this;
  }
  darken(e) {
    return Wo(this._rgb, 2, -e), this;
  }
  saturate(e) {
    return Wo(this._rgb, 1, e), this;
  }
  desaturate(e) {
    return Wo(this._rgb, 1, -e), this;
  }
  rotate(e) {
    return Nb(this._rgb, e), this;
  }
}
/*!
 * Chart.js v4.3.3
 * https://www.chartjs.org
 * (c) 2023 Chart.js Contributors
 * Released under the MIT License
 */
function un() {
}
const jb = (() => {
  let t = 0;
  return () => t++;
})();
function Ve(t) {
  return t === null || typeof t > "u";
}
function Ye(t) {
  if (Array.isArray && Array.isArray(t))
    return !0;
  const e = Object.prototype.toString.call(t);
  return e.slice(0, 7) === "[object" && e.slice(-6) === "Array]";
}
function Se(t) {
  return t !== null && Object.prototype.toString.call(t) === "[object Object]";
}
function it(t) {
  return (typeof t == "number" || t instanceof Number) && isFinite(+t);
}
function _t(t, e) {
  return it(t) ? t : e;
}
function Fe(t, e) {
  return typeof t > "u" ? e : t;
}
const zb = (t, e) => typeof t == "string" && t.endsWith("%") ? parseFloat(t) / 100 * e : +t;
function Ge(t, e, n) {
  if (t && typeof t.call == "function")
    return t.apply(n, e);
}
function Le(t, e, n, r) {
  let o, i, s;
  if (Ye(t))
    if (i = t.length, r)
      for (o = i - 1; o >= 0; o--)
        e.call(n, t[o], o);
    else
      for (o = 0; o < i; o++)
        e.call(n, t[o], o);
  else if (Se(t))
    for (s = Object.keys(t), i = s.length, o = 0; o < i; o++)
      e.call(n, t[s[o]], s[o]);
}
function Ti(t, e) {
  let n, r, o, i;
  if (!t || !e || t.length !== e.length)
    return !1;
  for (n = 0, r = t.length; n < r; ++n)
    if (o = t[n], i = e[n], o.datasetIndex !== i.datasetIndex || o.index !== i.index)
      return !1;
  return !0;
}
function Di(t) {
  if (Ye(t))
    return t.map(Di);
  if (Se(t)) {
    const e = /* @__PURE__ */ Object.create(null), n = Object.keys(t), r = n.length;
    let o = 0;
    for (; o < r; ++o)
      e[n[o]] = Di(t[n[o]]);
    return e;
  }
  return t;
}
function eh(t) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(t) === -1;
}
function Ub(t, e, n, r) {
  if (!eh(t))
    return;
  const o = e[t], i = n[t];
  Se(o) && Se(i) ? mo(o, i, r) : e[t] = Di(i);
}
function mo(t, e, n) {
  const r = Ye(e) ? e : [
    e
  ], o = r.length;
  if (!Se(t))
    return t;
  n = n || {};
  const i = n.merger || Ub;
  let s;
  for (let a = 0; a < o; ++a) {
    if (s = r[a], !Se(s))
      continue;
    const l = Object.keys(s);
    for (let c = 0, u = l.length; c < u; ++c)
      i(l[c], t, s, n);
  }
  return t;
}
function ro(t, e) {
  return mo(t, e, {
    merger: Yb
  });
}
function Yb(t, e, n) {
  if (!eh(t))
    return;
  const r = e[t], o = n[t];
  Se(r) && Se(o) ? ro(r, o) : Object.prototype.hasOwnProperty.call(e, t) || (e[t] = Di(o));
}
const zc = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (t) => t,
  // default resolvers
  x: (t) => t.x,
  y: (t) => t.y
};
function Kb(t) {
  const e = t.split("."), n = [];
  let r = "";
  for (const o of e)
    r += o, r.endsWith("\\") ? r = r.slice(0, -1) + "." : (n.push(r), r = "");
  return n;
}
function Gb(t) {
  const e = Kb(t);
  return (n) => {
    for (const r of e) {
      if (r === "")
        break;
      n = n && n[r];
    }
    return n;
  };
}
function Or(t, e) {
  return (zc[e] || (zc[e] = Gb(e)))(t);
}
function ml(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
}
const vo = (t) => typeof t < "u", Wn = (t) => typeof t == "function", Uc = (t, e) => {
  if (t.size !== e.size)
    return !1;
  for (const n of t)
    if (!e.has(n))
      return !1;
  return !0;
};
function qb(t) {
  return t.type === "mouseup" || t.type === "click" || t.type === "contextmenu";
}
const st = Math.PI, $t = 2 * st, Xb = $t + st, $i = Number.POSITIVE_INFINITY, Zb = st / 180, wt = st / 2, Un = st / 4, Yc = st * 2 / 3, Pn = Math.log10, on = Math.sign;
function oo(t, e, n) {
  return Math.abs(t - e) < n;
}
function Kc(t) {
  const e = Math.round(t);
  t = oo(t, e, t / 1e3) ? e : t;
  const n = Math.pow(10, Math.floor(Pn(t))), r = t / n;
  return (r <= 1 ? 1 : r <= 2 ? 2 : r <= 5 ? 5 : 10) * n;
}
function Qb(t) {
  const e = [], n = Math.sqrt(t);
  let r;
  for (r = 1; r < n; r++)
    t % r === 0 && (e.push(r), e.push(t / r));
  return n === (n | 0) && e.push(n), e.sort((o, i) => o - i).pop(), e;
}
function bo(t) {
  return !isNaN(parseFloat(t)) && isFinite(t);
}
function Jb(t, e) {
  const n = Math.round(t);
  return n - e <= t && n + e >= t;
}
function th(t, e, n) {
  let r, o, i;
  for (r = 0, o = t.length; r < o; r++)
    i = t[r][n], isNaN(i) || (e.min = Math.min(e.min, i), e.max = Math.max(e.max, i));
}
function In(t) {
  return t * (st / 180);
}
function vl(t) {
  return t * (180 / st);
}
function Gc(t) {
  if (!it(t))
    return;
  let e = 1, n = 0;
  for (; Math.round(t * e) / e !== t; )
    e *= 10, n++;
  return n;
}
function e1(t, e) {
  const n = e.x - t.x, r = e.y - t.y, o = Math.sqrt(n * n + r * r);
  let i = Math.atan2(r, n);
  return i < -0.5 * st && (i += $t), {
    angle: i,
    distance: o
  };
}
function va(t, e) {
  return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
}
function t1(t, e) {
  return (t - e + Xb) % $t - st;
}
function jt(t) {
  return (t % $t + $t) % $t;
}
function nh(t, e, n, r) {
  const o = jt(t), i = jt(e), s = jt(n), a = jt(i - o), l = jt(s - o), c = jt(o - i), u = jt(o - s);
  return o === i || o === s || r && i === s || a > l && c < u;
}
function Mt(t, e, n) {
  return Math.max(e, Math.min(n, t));
}
function n1(t) {
  return Mt(t, -32768, 32767);
}
function ba(t, e, n, r = 1e-6) {
  return t >= Math.min(e, n) - r && t <= Math.max(e, n) + r;
}
function bl(t, e, n) {
  n = n || ((s) => t[s] < e);
  let r = t.length - 1, o = 0, i;
  for (; r - o > 1; )
    i = o + r >> 1, n(i) ? o = i : r = i;
  return {
    lo: o,
    hi: r
  };
}
const Jn = (t, e, n, r) => bl(t, n, r ? (o) => {
  const i = t[o][e];
  return i < n || i === n && t[o + 1][e] === n;
} : (o) => t[o][e] < n), r1 = (t, e, n) => bl(t, n, (r) => t[r][e] >= n);
function o1(t, e, n) {
  let r = 0, o = t.length;
  for (; r < o && t[r] < e; )
    r++;
  for (; o > r && t[o - 1] > n; )
    o--;
  return r > 0 || o < t.length ? t.slice(r, o) : t;
}
const rh = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function i1(t, e) {
  if (t._chartjs) {
    t._chartjs.listeners.push(e);
    return;
  }
  Object.defineProperty(t, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [
        e
      ]
    }
  }), rh.forEach((n) => {
    const r = "_onData" + ml(n), o = t[n];
    Object.defineProperty(t, n, {
      configurable: !0,
      enumerable: !1,
      value(...i) {
        const s = o.apply(this, i);
        return t._chartjs.listeners.forEach((a) => {
          typeof a[r] == "function" && a[r](...i);
        }), s;
      }
    });
  });
}
function qc(t, e) {
  const n = t._chartjs;
  if (!n)
    return;
  const r = n.listeners, o = r.indexOf(e);
  o !== -1 && r.splice(o, 1), !(r.length > 0) && (rh.forEach((i) => {
    delete t[i];
  }), delete t._chartjs);
}
function oh(t) {
  const e = new Set(t);
  return e.size === t.length ? t : Array.from(e);
}
const ih = function() {
  return typeof window > "u" ? function(t) {
    return t();
  } : window.requestAnimationFrame;
}();
function sh(t, e) {
  let n = [], r = !1;
  return function(...o) {
    n = o, r || (r = !0, ih.call(window, () => {
      r = !1, t.apply(e, n);
    }));
  };
}
function s1(t, e) {
  let n;
  return function(...r) {
    return e ? (clearTimeout(n), n = setTimeout(t, e, r)) : t.apply(this, r), e;
  };
}
const a1 = (t) => t === "start" ? "left" : t === "end" ? "right" : "center", Xc = (t, e, n) => t === "start" ? e : t === "end" ? n : (e + n) / 2;
function l1(t, e, n) {
  const r = e.length;
  let o = 0, i = r;
  if (t._sorted) {
    const { iScale: s, _parsed: a } = t, l = s.axis, { min: c, max: u, minDefined: d, maxDefined: f } = s.getUserBounds();
    d && (o = Mt(Math.min(
      // @ts-expect-error Need to type _parsed
      Jn(a, l, c).lo,
      // @ts-expect-error Need to fix types on _lookupByKey
      n ? r : Jn(e, l, s.getPixelForValue(c)).lo
    ), 0, r - 1)), f ? i = Mt(Math.max(
      // @ts-expect-error Need to type _parsed
      Jn(a, s.axis, u, !0).hi + 1,
      // @ts-expect-error Need to fix types on _lookupByKey
      n ? 0 : Jn(e, l, s.getPixelForValue(u), !0).hi + 1
    ), o, r) - o : i = r - o;
  }
  return {
    start: o,
    count: i
  };
}
function c1(t) {
  const { xScale: e, yScale: n, _scaleRanges: r } = t, o = {
    xmin: e.min,
    xmax: e.max,
    ymin: n.min,
    ymax: n.max
  };
  if (!r)
    return t._scaleRanges = o, !0;
  const i = r.xmin !== e.min || r.xmax !== e.max || r.ymin !== n.min || r.ymax !== n.max;
  return Object.assign(r, o), i;
}
const Ho = (t) => t === 0 || t === 1, Zc = (t, e, n) => -(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - e) * $t / n)), Qc = (t, e, n) => Math.pow(2, -10 * t) * Math.sin((t - e) * $t / n) + 1, io = {
  linear: (t) => t,
  easeInQuad: (t) => t * t,
  easeOutQuad: (t) => -t * (t - 2),
  easeInOutQuad: (t) => (t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
  easeInCubic: (t) => t * t * t,
  easeOutCubic: (t) => (t -= 1) * t * t + 1,
  easeInOutCubic: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
  easeInQuart: (t) => t * t * t * t,
  easeOutQuart: (t) => -((t -= 1) * t * t * t - 1),
  easeInOutQuart: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
  easeInQuint: (t) => t * t * t * t * t,
  easeOutQuint: (t) => (t -= 1) * t * t * t * t + 1,
  easeInOutQuint: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
  easeInSine: (t) => -Math.cos(t * wt) + 1,
  easeOutSine: (t) => Math.sin(t * wt),
  easeInOutSine: (t) => -0.5 * (Math.cos(st * t) - 1),
  easeInExpo: (t) => t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
  easeOutExpo: (t) => t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
  easeInOutExpo: (t) => Ho(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
  easeInCirc: (t) => t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
  easeOutCirc: (t) => Math.sqrt(1 - (t -= 1) * t),
  easeInOutCirc: (t) => (t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
  easeInElastic: (t) => Ho(t) ? t : Zc(t, 0.075, 0.3),
  easeOutElastic: (t) => Ho(t) ? t : Qc(t, 0.075, 0.3),
  easeInOutElastic(t) {
    return Ho(t) ? t : t < 0.5 ? 0.5 * Zc(t * 2, 0.1125, 0.45) : 0.5 + 0.5 * Qc(t * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(t) {
    return t * t * ((1.70158 + 1) * t - 1.70158);
  },
  easeOutBack(t) {
    return (t -= 1) * t * ((1.70158 + 1) * t + 1.70158) + 1;
  },
  easeInOutBack(t) {
    let e = 1.70158;
    return (t /= 0.5) < 1 ? 0.5 * (t * t * (((e *= 1.525) + 1) * t - e)) : 0.5 * ((t -= 2) * t * (((e *= 1.525) + 1) * t + e) + 2);
  },
  easeInBounce: (t) => 1 - io.easeOutBounce(1 - t),
  easeOutBounce(t) {
    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + 0.75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375 : 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
  },
  easeInOutBounce: (t) => t < 0.5 ? io.easeInBounce(t * 2) * 0.5 : io.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function yl(t) {
  if (t && typeof t == "object") {
    const e = t.toString();
    return e === "[object CanvasPattern]" || e === "[object CanvasGradient]";
  }
  return !1;
}
function Jc(t) {
  return yl(t) ? t : new go(t);
}
function Es(t) {
  return yl(t) ? t : new go(t).saturate(0.5).darken(0.1).hexString();
}
const u1 = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
], d1 = [
  "color",
  "borderColor",
  "backgroundColor"
];
function f1(t) {
  t.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  }), t.describe("animation", {
    _fallback: !1,
    _indexable: !1,
    _scriptable: (e) => e !== "onProgress" && e !== "onComplete" && e !== "fn"
  }), t.set("animations", {
    colors: {
      type: "color",
      properties: d1
    },
    numbers: {
      type: "number",
      properties: u1
    }
  }), t.describe("animations", {
    _fallback: "animation"
  }), t.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: (e) => e | 0
        }
      }
    }
  });
}
function h1(t) {
  t.set("layout", {
    autoPadding: !0,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
const eu = /* @__PURE__ */ new Map();
function p1(t, e) {
  e = e || {};
  const n = t + JSON.stringify(e);
  let r = eu.get(n);
  return r || (r = new Intl.NumberFormat(t, e), eu.set(n, r)), r;
}
function wl(t, e, n) {
  return p1(e, n).format(t);
}
const ah = {
  values(t) {
    return Ye(t) ? t : "" + t;
  },
  numeric(t, e, n) {
    if (t === 0)
      return "0";
    const r = this.chart.options.locale;
    let o, i = t;
    if (n.length > 1) {
      const c = Math.max(Math.abs(n[0].value), Math.abs(n[n.length - 1].value));
      (c < 1e-4 || c > 1e15) && (o = "scientific"), i = g1(t, n);
    }
    const s = Pn(Math.abs(i)), a = isNaN(s) ? 1 : Math.max(Math.min(-1 * Math.floor(s), 20), 0), l = {
      notation: o,
      minimumFractionDigits: a,
      maximumFractionDigits: a
    };
    return Object.assign(l, this.options.ticks.format), wl(t, r, l);
  },
  logarithmic(t, e, n) {
    if (t === 0)
      return "0";
    const r = n[e].significand || t / Math.pow(10, Math.floor(Pn(t)));
    return [
      1,
      2,
      3,
      5,
      10,
      15
    ].includes(r) || e > 0.8 * n.length ? ah.numeric.call(this, t, e, n) : "";
  }
};
function g1(t, e) {
  let n = e.length > 3 ? e[2].value - e[1].value : e[1].value - e[0].value;
  return Math.abs(n) >= 1 && t !== Math.floor(t) && (n = t - Math.floor(t)), n;
}
var is = {
  formatters: ah
};
function m1(t) {
  t.set("scale", {
    display: !0,
    offset: !1,
    reverse: !1,
    beginAtZero: !1,
    bounds: "ticks",
    grace: 0,
    grid: {
      display: !0,
      lineWidth: 1,
      drawOnChartArea: !0,
      drawTicks: !0,
      tickLength: 8,
      tickWidth: (e, n) => n.lineWidth,
      tickColor: (e, n) => n.color,
      offset: !1
    },
    border: {
      display: !0,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: !1,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: !1,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: !0,
      autoSkip: !0,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: is.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: !1,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  }), t.route("scale.ticks", "color", "", "color"), t.route("scale.grid", "color", "", "borderColor"), t.route("scale.border", "color", "", "borderColor"), t.route("scale.title", "color", "", "color"), t.describe("scale", {
    _fallback: !1,
    _scriptable: (e) => !e.startsWith("before") && !e.startsWith("after") && e !== "callback" && e !== "parser",
    _indexable: (e) => e !== "borderDash" && e !== "tickBorderDash" && e !== "dash"
  }), t.describe("scales", {
    _fallback: "scale"
  }), t.describe("scale.ticks", {
    _scriptable: (e) => e !== "backdropPadding" && e !== "callback",
    _indexable: (e) => e !== "backdropPadding"
  });
}
const or = /* @__PURE__ */ Object.create(null), ya = /* @__PURE__ */ Object.create(null);
function so(t, e) {
  if (!e)
    return t;
  const n = e.split(".");
  for (let r = 0, o = n.length; r < o; ++r) {
    const i = n[r];
    t = t[i] || (t[i] = /* @__PURE__ */ Object.create(null));
  }
  return t;
}
function Ms(t, e, n) {
  return typeof e == "string" ? mo(so(t, e), n) : mo(so(t, ""), e);
}
class v1 {
  constructor(e, n) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (r) => r.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (r, o) => Es(o.backgroundColor), this.hoverBorderColor = (r, o) => Es(o.borderColor), this.hoverColor = (r, o) => Es(o.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(e), this.apply(n);
  }
  set(e, n) {
    return Ms(this, e, n);
  }
  get(e) {
    return so(this, e);
  }
  describe(e, n) {
    return Ms(ya, e, n);
  }
  override(e, n) {
    return Ms(or, e, n);
  }
  route(e, n, r, o) {
    const i = so(this, e), s = so(this, r), a = "_" + n;
    Object.defineProperties(i, {
      [a]: {
        value: i[n],
        writable: !0
      },
      [n]: {
        enumerable: !0,
        get() {
          const l = this[a], c = s[o];
          return Se(l) ? Object.assign({}, c, l) : Fe(l, c);
        },
        set(l) {
          this[a] = l;
        }
      }
    });
  }
  apply(e) {
    e.forEach((n) => n(this));
  }
}
var Ze = /* @__PURE__ */ new v1({
  _scriptable: (t) => !t.startsWith("on"),
  _indexable: (t) => t !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
}, [
  f1,
  h1,
  m1
]);
function b1(t) {
  return !t || Ve(t.size) || Ve(t.family) ? null : (t.style ? t.style + " " : "") + (t.weight ? t.weight + " " : "") + t.size + "px " + t.family;
}
function Ni(t, e, n, r, o) {
  let i = e[o];
  return i || (i = e[o] = t.measureText(o).width, n.push(o)), i > r && (r = i), r;
}
function y1(t, e, n, r) {
  r = r || {};
  let o = r.data = r.data || {}, i = r.garbageCollect = r.garbageCollect || [];
  r.font !== e && (o = r.data = {}, i = r.garbageCollect = [], r.font = e), t.save(), t.font = e;
  let s = 0;
  const a = n.length;
  let l, c, u, d, f;
  for (l = 0; l < a; l++)
    if (d = n[l], d != null && !Ye(d))
      s = Ni(t, o, i, s, d);
    else if (Ye(d))
      for (c = 0, u = d.length; c < u; c++)
        f = d[c], f != null && !Ye(f) && (s = Ni(t, o, i, s, f));
  t.restore();
  const h = i.length / 2;
  if (h > n.length) {
    for (l = 0; l < h; l++)
      delete o[i[l]];
    i.splice(0, h);
  }
  return s;
}
function Yn(t, e, n) {
  const r = t.currentDevicePixelRatio, o = n !== 0 ? Math.max(n / 2, 0.5) : 0;
  return Math.round((e - o) * r) / r + o;
}
function tu(t, e) {
  e = e || t.getContext("2d"), e.save(), e.resetTransform(), e.clearRect(0, 0, t.width, t.height), e.restore();
}
function wa(t, e, n, r) {
  w1(t, e, n, r, null);
}
function w1(t, e, n, r, o) {
  let i, s, a, l, c, u, d, f;
  const h = e.pointStyle, p = e.rotation, g = e.radius;
  let m = (p || 0) * Zb;
  if (h && typeof h == "object" && (i = h.toString(), i === "[object HTMLImageElement]" || i === "[object HTMLCanvasElement]")) {
    t.save(), t.translate(n, r), t.rotate(m), t.drawImage(h, -h.width / 2, -h.height / 2, h.width, h.height), t.restore();
    return;
  }
  if (!(isNaN(g) || g <= 0)) {
    switch (t.beginPath(), h) {
      default:
        o ? t.ellipse(n, r, o / 2, g, 0, 0, $t) : t.arc(n, r, g, 0, $t), t.closePath();
        break;
      case "triangle":
        u = o ? o / 2 : g, t.moveTo(n + Math.sin(m) * u, r - Math.cos(m) * g), m += Yc, t.lineTo(n + Math.sin(m) * u, r - Math.cos(m) * g), m += Yc, t.lineTo(n + Math.sin(m) * u, r - Math.cos(m) * g), t.closePath();
        break;
      case "rectRounded":
        c = g * 0.516, l = g - c, s = Math.cos(m + Un) * l, d = Math.cos(m + Un) * (o ? o / 2 - c : l), a = Math.sin(m + Un) * l, f = Math.sin(m + Un) * (o ? o / 2 - c : l), t.arc(n - d, r - a, c, m - st, m - wt), t.arc(n + f, r - s, c, m - wt, m), t.arc(n + d, r + a, c, m, m + wt), t.arc(n - f, r + s, c, m + wt, m + st), t.closePath();
        break;
      case "rect":
        if (!p) {
          l = Math.SQRT1_2 * g, u = o ? o / 2 : l, t.rect(n - u, r - l, 2 * u, 2 * l);
          break;
        }
        m += Un;
      case "rectRot":
        d = Math.cos(m) * (o ? o / 2 : g), s = Math.cos(m) * g, a = Math.sin(m) * g, f = Math.sin(m) * (o ? o / 2 : g), t.moveTo(n - d, r - a), t.lineTo(n + f, r - s), t.lineTo(n + d, r + a), t.lineTo(n - f, r + s), t.closePath();
        break;
      case "crossRot":
        m += Un;
      case "cross":
        d = Math.cos(m) * (o ? o / 2 : g), s = Math.cos(m) * g, a = Math.sin(m) * g, f = Math.sin(m) * (o ? o / 2 : g), t.moveTo(n - d, r - a), t.lineTo(n + d, r + a), t.moveTo(n + f, r - s), t.lineTo(n - f, r + s);
        break;
      case "star":
        d = Math.cos(m) * (o ? o / 2 : g), s = Math.cos(m) * g, a = Math.sin(m) * g, f = Math.sin(m) * (o ? o / 2 : g), t.moveTo(n - d, r - a), t.lineTo(n + d, r + a), t.moveTo(n + f, r - s), t.lineTo(n - f, r + s), m += Un, d = Math.cos(m) * (o ? o / 2 : g), s = Math.cos(m) * g, a = Math.sin(m) * g, f = Math.sin(m) * (o ? o / 2 : g), t.moveTo(n - d, r - a), t.lineTo(n + d, r + a), t.moveTo(n + f, r - s), t.lineTo(n - f, r + s);
        break;
      case "line":
        s = o ? o / 2 : Math.cos(m) * g, a = Math.sin(m) * g, t.moveTo(n - s, r - a), t.lineTo(n + s, r + a);
        break;
      case "dash":
        t.moveTo(n, r), t.lineTo(n + Math.cos(m) * (o ? o / 2 : g), r + Math.sin(m) * g);
        break;
      case !1:
        t.closePath();
        break;
    }
    t.fill(), e.borderWidth > 0 && t.stroke();
  }
}
function gn(t, e, n) {
  return n = n || 0.5, !e || t && t.x > e.left - n && t.x < e.right + n && t.y > e.top - n && t.y < e.bottom + n;
}
function lh(t, e) {
  t.save(), t.beginPath(), t.rect(e.left, e.top, e.right - e.left, e.bottom - e.top), t.clip();
}
function ch(t) {
  t.restore();
}
function x1(t, e, n, r, o) {
  if (!e)
    return t.lineTo(n.x, n.y);
  if (o === "middle") {
    const i = (e.x + n.x) / 2;
    t.lineTo(i, e.y), t.lineTo(i, n.y);
  } else
    o === "after" != !!r ? t.lineTo(e.x, n.y) : t.lineTo(n.x, e.y);
  t.lineTo(n.x, n.y);
}
function _1(t, e, n, r) {
  if (!e)
    return t.lineTo(n.x, n.y);
  t.bezierCurveTo(r ? e.cp1x : e.cp2x, r ? e.cp1y : e.cp2y, r ? n.cp2x : n.cp1x, r ? n.cp2y : n.cp1y, n.x, n.y);
}
function C1(t, e) {
  e.translation && t.translate(e.translation[0], e.translation[1]), Ve(e.rotation) || t.rotate(e.rotation), e.color && (t.fillStyle = e.color), e.textAlign && (t.textAlign = e.textAlign), e.textBaseline && (t.textBaseline = e.textBaseline);
}
function E1(t, e, n, r, o) {
  if (o.strikethrough || o.underline) {
    const i = t.measureText(r), s = e - i.actualBoundingBoxLeft, a = e + i.actualBoundingBoxRight, l = n - i.actualBoundingBoxAscent, c = n + i.actualBoundingBoxDescent, u = o.strikethrough ? (l + c) / 2 : c;
    t.strokeStyle = t.fillStyle, t.beginPath(), t.lineWidth = o.decorationWidth || 2, t.moveTo(s, u), t.lineTo(a, u), t.stroke();
  }
}
function M1(t, e) {
  const n = t.fillStyle;
  t.fillStyle = e.color, t.fillRect(e.left, e.top, e.width, e.height), t.fillStyle = n;
}
function Ri(t, e, n, r, o, i = {}) {
  const s = Ye(e) ? e : [
    e
  ], a = i.strokeWidth > 0 && i.strokeColor !== "";
  let l, c;
  for (t.save(), t.font = o.string, C1(t, i), l = 0; l < s.length; ++l)
    c = s[l], i.backdrop && M1(t, i.backdrop), a && (i.strokeColor && (t.strokeStyle = i.strokeColor), Ve(i.strokeWidth) || (t.lineWidth = i.strokeWidth), t.strokeText(c, n, r, i.maxWidth)), t.fillText(c, n, r, i.maxWidth), E1(t, n, r, c, i), r += Number(o.lineHeight);
  t.restore();
}
function Ai(t, e) {
  const { x: n, y: r, w: o, h: i, radius: s } = e;
  t.arc(n + s.topLeft, r + s.topLeft, s.topLeft, -wt, st, !0), t.lineTo(n, r + i - s.bottomLeft), t.arc(n + s.bottomLeft, r + i - s.bottomLeft, s.bottomLeft, st, wt, !0), t.lineTo(n + o - s.bottomRight, r + i), t.arc(n + o - s.bottomRight, r + i - s.bottomRight, s.bottomRight, wt, 0, !0), t.lineTo(n + o, r + s.topRight), t.arc(n + o - s.topRight, r + s.topRight, s.topRight, 0, -wt, !0), t.lineTo(n + s.topLeft, r);
}
const k1 = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/, O1 = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function S1(t, e) {
  const n = ("" + t).match(k1);
  if (!n || n[1] === "normal")
    return e * 1.2;
  switch (t = +n[2], n[3]) {
    case "px":
      return t;
    case "%":
      t /= 100;
      break;
  }
  return e * t;
}
const P1 = (t) => +t || 0;
function uh(t, e) {
  const n = {}, r = Se(e), o = r ? Object.keys(e) : e, i = Se(t) ? r ? (s) => Fe(t[s], t[e[s]]) : (s) => t[s] : () => t;
  for (const s of o)
    n[s] = P1(i(s));
  return n;
}
function dh(t) {
  return uh(t, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
function Er(t) {
  return uh(t, [
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight"
  ]);
}
function Lt(t) {
  const e = dh(t);
  return e.width = e.left + e.right, e.height = e.top + e.bottom, e;
}
function kt(t, e) {
  t = t || {}, e = e || Ze.font;
  let n = Fe(t.size, e.size);
  typeof n == "string" && (n = parseInt(n, 10));
  let r = Fe(t.style, e.style);
  r && !("" + r).match(O1) && (console.warn('Invalid font style specified: "' + r + '"'), r = void 0);
  const o = {
    family: Fe(t.family, e.family),
    lineHeight: S1(Fe(t.lineHeight, e.lineHeight), n),
    size: n,
    style: r,
    weight: Fe(t.weight, e.weight),
    string: ""
  };
  return o.string = b1(o), o;
}
function Bo(t, e, n, r) {
  let o = !0, i, s, a;
  for (i = 0, s = t.length; i < s; ++i)
    if (a = t[i], a !== void 0 && (e !== void 0 && typeof a == "function" && (a = a(e), o = !1), n !== void 0 && Ye(a) && (a = a[n % a.length], o = !1), a !== void 0))
      return r && !o && (r.cacheable = !1), a;
}
function I1(t, e, n) {
  const { min: r, max: o } = t, i = zb(e, (o - r) / 2), s = (a, l) => n && a === 0 ? 0 : a + l;
  return {
    min: s(r, -Math.abs(i)),
    max: s(o, i)
  };
}
function Bn(t, e) {
  return Object.assign(Object.create(t), e);
}
function xl(t, e = [
  ""
], n, r, o = () => t[0]) {
  const i = n || t;
  typeof r > "u" && (r = gh("_fallback", t));
  const s = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: t,
    _rootScopes: i,
    _fallback: r,
    _getTarget: o,
    override: (a) => xl([
      a,
      ...t
    ], e, i, r)
  };
  return new Proxy(s, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(a, l) {
      return delete a[l], delete a._keys, delete t[0][l], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(a, l) {
      return hh(a, l, () => F1(l, e, t, a));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(a, l) {
      return Reflect.getOwnPropertyDescriptor(a._scopes[0], l);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(t[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(a, l) {
      return ru(a).includes(l);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(a) {
      return ru(a);
    },
    /**
    * A trap for setting property values.
    */
    set(a, l, c) {
      const u = a._storage || (a._storage = o());
      return a[l] = u[l] = c, delete a._keys, !0;
    }
  });
}
function Sr(t, e, n, r) {
  const o = {
    _cacheable: !1,
    _proxy: t,
    _context: e,
    _subProxy: n,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: fh(t, r),
    setContext: (i) => Sr(t, i, n, r),
    override: (i) => Sr(t.override(i), e, n, r)
  };
  return new Proxy(o, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(i, s) {
      return delete i[s], delete t[s], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(i, s, a) {
      return hh(i, s, () => D1(i, s, a));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(i, s) {
      return i._descriptors.allKeys ? Reflect.has(t, s) ? {
        enumerable: !0,
        configurable: !0
      } : void 0 : Reflect.getOwnPropertyDescriptor(t, s);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(t);
    },
    /**
    * A trap for the in operator.
    */
    has(i, s) {
      return Reflect.has(t, s);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(t);
    },
    /**
    * A trap for setting property values.
    */
    set(i, s, a) {
      return t[s] = a, delete i[s], !0;
    }
  });
}
function fh(t, e = {
  scriptable: !0,
  indexable: !0
}) {
  const { _scriptable: n = e.scriptable, _indexable: r = e.indexable, _allKeys: o = e.allKeys } = t;
  return {
    allKeys: o,
    scriptable: n,
    indexable: r,
    isScriptable: Wn(n) ? n : () => n,
    isIndexable: Wn(r) ? r : () => r
  };
}
const T1 = (t, e) => t ? t + ml(e) : e, _l = (t, e) => Se(e) && t !== "adapters" && (Object.getPrototypeOf(e) === null || e.constructor === Object);
function hh(t, e, n) {
  if (Object.prototype.hasOwnProperty.call(t, e))
    return t[e];
  const r = n();
  return t[e] = r, r;
}
function D1(t, e, n) {
  const { _proxy: r, _context: o, _subProxy: i, _descriptors: s } = t;
  let a = r[e];
  return Wn(a) && s.isScriptable(e) && (a = $1(e, a, t, n)), Ye(a) && a.length && (a = N1(e, a, t, s.isIndexable)), _l(e, a) && (a = Sr(a, o, i && i[e], s)), a;
}
function $1(t, e, n, r) {
  const { _proxy: o, _context: i, _subProxy: s, _stack: a } = n;
  if (a.has(t))
    throw new Error("Recursion detected: " + Array.from(a).join("->") + "->" + t);
  a.add(t);
  let l = e(i, s || r);
  return a.delete(t), _l(t, l) && (l = Cl(o._scopes, o, t, l)), l;
}
function N1(t, e, n, r) {
  const { _proxy: o, _context: i, _subProxy: s, _descriptors: a } = n;
  if (typeof i.index < "u" && r(t))
    return e[i.index % e.length];
  if (Se(e[0])) {
    const l = e, c = o._scopes.filter((u) => u !== l);
    e = [];
    for (const u of l) {
      const d = Cl(c, o, t, u);
      e.push(Sr(d, i, s && s[t], a));
    }
  }
  return e;
}
function ph(t, e, n) {
  return Wn(t) ? t(e, n) : t;
}
const R1 = (t, e) => t === !0 ? e : typeof t == "string" ? Or(e, t) : void 0;
function A1(t, e, n, r, o) {
  for (const i of e) {
    const s = R1(n, i);
    if (s) {
      t.add(s);
      const a = ph(s._fallback, n, o);
      if (typeof a < "u" && a !== n && a !== r)
        return a;
    } else if (s === !1 && typeof r < "u" && n !== r)
      return null;
  }
  return !1;
}
function Cl(t, e, n, r) {
  const o = e._rootScopes, i = ph(e._fallback, n, r), s = [
    ...t,
    ...o
  ], a = /* @__PURE__ */ new Set();
  a.add(r);
  let l = nu(a, s, n, i || n, r);
  return l === null || typeof i < "u" && i !== n && (l = nu(a, s, i, l, r), l === null) ? !1 : xl(Array.from(a), [
    ""
  ], o, i, () => L1(e, n, r));
}
function nu(t, e, n, r, o) {
  for (; n; )
    n = A1(t, e, n, r, o);
  return n;
}
function L1(t, e, n) {
  const r = t._getTarget();
  e in r || (r[e] = {});
  const o = r[e];
  return Ye(o) && Se(n) ? n : o || {};
}
function F1(t, e, n, r) {
  let o;
  for (const i of e)
    if (o = gh(T1(i, t), n), typeof o < "u")
      return _l(t, o) ? Cl(n, r, t, o) : o;
}
function gh(t, e) {
  for (const n of e) {
    if (!n)
      continue;
    const r = n[t];
    if (typeof r < "u")
      return r;
  }
}
function ru(t) {
  let e = t._keys;
  return e || (e = t._keys = V1(t._scopes)), e;
}
function V1(t) {
  const e = /* @__PURE__ */ new Set();
  for (const n of t)
    for (const r of Object.keys(n).filter((o) => !o.startsWith("_")))
      e.add(r);
  return Array.from(e);
}
const W1 = Number.EPSILON || 1e-14, Pr = (t, e) => e < t.length && !t[e].skip && t[e], mh = (t) => t === "x" ? "y" : "x";
function H1(t, e, n, r) {
  const o = t.skip ? e : t, i = e, s = n.skip ? e : n, a = va(i, o), l = va(s, i);
  let c = a / (a + l), u = l / (a + l);
  c = isNaN(c) ? 0 : c, u = isNaN(u) ? 0 : u;
  const d = r * c, f = r * u;
  return {
    previous: {
      x: i.x - d * (s.x - o.x),
      y: i.y - d * (s.y - o.y)
    },
    next: {
      x: i.x + f * (s.x - o.x),
      y: i.y + f * (s.y - o.y)
    }
  };
}
function B1(t, e, n) {
  const r = t.length;
  let o, i, s, a, l, c = Pr(t, 0);
  for (let u = 0; u < r - 1; ++u)
    if (l = c, c = Pr(t, u + 1), !(!l || !c)) {
      if (oo(e[u], 0, W1)) {
        n[u] = n[u + 1] = 0;
        continue;
      }
      o = n[u] / e[u], i = n[u + 1] / e[u], a = Math.pow(o, 2) + Math.pow(i, 2), !(a <= 9) && (s = 3 / Math.sqrt(a), n[u] = o * s * e[u], n[u + 1] = i * s * e[u]);
    }
}
function j1(t, e, n = "x") {
  const r = mh(n), o = t.length;
  let i, s, a, l = Pr(t, 0);
  for (let c = 0; c < o; ++c) {
    if (s = a, a = l, l = Pr(t, c + 1), !a)
      continue;
    const u = a[n], d = a[r];
    s && (i = (u - s[n]) / 3, a[`cp1${n}`] = u - i, a[`cp1${r}`] = d - i * e[c]), l && (i = (l[n] - u) / 3, a[`cp2${n}`] = u + i, a[`cp2${r}`] = d + i * e[c]);
  }
}
function z1(t, e = "x") {
  const n = mh(e), r = t.length, o = Array(r).fill(0), i = Array(r);
  let s, a, l, c = Pr(t, 0);
  for (s = 0; s < r; ++s)
    if (a = l, l = c, c = Pr(t, s + 1), !!l) {
      if (c) {
        const u = c[e] - l[e];
        o[s] = u !== 0 ? (c[n] - l[n]) / u : 0;
      }
      i[s] = a ? c ? on(o[s - 1]) !== on(o[s]) ? 0 : (o[s - 1] + o[s]) / 2 : o[s - 1] : o[s];
    }
  B1(t, o, i), j1(t, i, e);
}
function jo(t, e, n) {
  return Math.max(Math.min(t, n), e);
}
function U1(t, e) {
  let n, r, o, i, s, a = gn(t[0], e);
  for (n = 0, r = t.length; n < r; ++n)
    s = i, i = a, a = n < r - 1 && gn(t[n + 1], e), i && (o = t[n], s && (o.cp1x = jo(o.cp1x, e.left, e.right), o.cp1y = jo(o.cp1y, e.top, e.bottom)), a && (o.cp2x = jo(o.cp2x, e.left, e.right), o.cp2y = jo(o.cp2y, e.top, e.bottom)));
}
function Y1(t, e, n, r, o) {
  let i, s, a, l;
  if (e.spanGaps && (t = t.filter((c) => !c.skip)), e.cubicInterpolationMode === "monotone")
    z1(t, o);
  else {
    let c = r ? t[t.length - 1] : t[0];
    for (i = 0, s = t.length; i < s; ++i)
      a = t[i], l = H1(c, a, t[Math.min(i + 1, s - (r ? 0 : 1)) % s], e.tension), a.cp1x = l.previous.x, a.cp1y = l.previous.y, a.cp2x = l.next.x, a.cp2y = l.next.y, c = a;
  }
  e.capBezierPoints && U1(t, n);
}
function vh() {
  return typeof window < "u" && typeof document < "u";
}
function El(t) {
  let e = t.parentNode;
  return e && e.toString() === "[object ShadowRoot]" && (e = e.host), e;
}
function Li(t, e, n) {
  let r;
  return typeof t == "string" ? (r = parseInt(t, 10), t.indexOf("%") !== -1 && (r = r / 100 * e.parentNode[n])) : r = t, r;
}
const ss = (t) => t.ownerDocument.defaultView.getComputedStyle(t, null);
function K1(t, e) {
  return ss(t).getPropertyValue(e);
}
const G1 = [
  "top",
  "right",
  "bottom",
  "left"
];
function tr(t, e, n) {
  const r = {};
  n = n ? "-" + n : "";
  for (let o = 0; o < 4; o++) {
    const i = G1[o];
    r[i] = parseFloat(t[e + "-" + i + n]) || 0;
  }
  return r.width = r.left + r.right, r.height = r.top + r.bottom, r;
}
const q1 = (t, e, n) => (t > 0 || e > 0) && (!n || !n.shadowRoot);
function X1(t, e) {
  const n = t.touches, r = n && n.length ? n[0] : t, { offsetX: o, offsetY: i } = r;
  let s = !1, a, l;
  if (q1(o, i, t.target))
    a = o, l = i;
  else {
    const c = e.getBoundingClientRect();
    a = r.clientX - c.left, l = r.clientY - c.top, s = !0;
  }
  return {
    x: a,
    y: l,
    box: s
  };
}
function qn(t, e) {
  if ("native" in t)
    return t;
  const { canvas: n, currentDevicePixelRatio: r } = e, o = ss(n), i = o.boxSizing === "border-box", s = tr(o, "padding"), a = tr(o, "border", "width"), { x: l, y: c, box: u } = X1(t, n), d = s.left + (u && a.left), f = s.top + (u && a.top);
  let { width: h, height: p } = e;
  return i && (h -= s.width + a.width, p -= s.height + a.height), {
    x: Math.round((l - d) / h * n.width / r),
    y: Math.round((c - f) / p * n.height / r)
  };
}
function Z1(t, e, n) {
  let r, o;
  if (e === void 0 || n === void 0) {
    const i = El(t);
    if (!i)
      e = t.clientWidth, n = t.clientHeight;
    else {
      const s = i.getBoundingClientRect(), a = ss(i), l = tr(a, "border", "width"), c = tr(a, "padding");
      e = s.width - c.width - l.width, n = s.height - c.height - l.height, r = Li(a.maxWidth, i, "clientWidth"), o = Li(a.maxHeight, i, "clientHeight");
    }
  }
  return {
    width: e,
    height: n,
    maxWidth: r || $i,
    maxHeight: o || $i
  };
}
const zo = (t) => Math.round(t * 10) / 10;
function Q1(t, e, n, r) {
  const o = ss(t), i = tr(o, "margin"), s = Li(o.maxWidth, t, "clientWidth") || $i, a = Li(o.maxHeight, t, "clientHeight") || $i, l = Z1(t, e, n);
  let { width: c, height: u } = l;
  if (o.boxSizing === "content-box") {
    const f = tr(o, "border", "width"), h = tr(o, "padding");
    c -= h.width + f.width, u -= h.height + f.height;
  }
  return c = Math.max(0, c - i.width), u = Math.max(0, r ? c / r : u - i.height), c = zo(Math.min(c, s, l.maxWidth)), u = zo(Math.min(u, a, l.maxHeight)), c && !u && (u = zo(c / 2)), (e !== void 0 || n !== void 0) && r && l.height && u > l.height && (u = l.height, c = zo(Math.floor(u * r))), {
    width: c,
    height: u
  };
}
function ou(t, e, n) {
  const r = e || 1, o = Math.floor(t.height * r), i = Math.floor(t.width * r);
  t.height = Math.floor(t.height), t.width = Math.floor(t.width);
  const s = t.canvas;
  return s.style && (n || !s.style.height && !s.style.width) && (s.style.height = `${t.height}px`, s.style.width = `${t.width}px`), t.currentDevicePixelRatio !== r || s.height !== o || s.width !== i ? (t.currentDevicePixelRatio = r, s.height = o, s.width = i, t.ctx.setTransform(r, 0, 0, r, 0, 0), !0) : !1;
}
const J1 = function() {
  let t = !1;
  try {
    const e = {
      get passive() {
        return t = !0, !1;
      }
    };
    window.addEventListener("test", null, e), window.removeEventListener("test", null, e);
  } catch {
  }
  return t;
}();
function iu(t, e) {
  const n = K1(t, e), r = n && n.match(/^(\d+)(\.\d+)?px$/);
  return r ? +r[1] : void 0;
}
function Xn(t, e, n, r) {
  return {
    x: t.x + n * (e.x - t.x),
    y: t.y + n * (e.y - t.y)
  };
}
function ey(t, e, n, r) {
  return {
    x: t.x + n * (e.x - t.x),
    y: r === "middle" ? n < 0.5 ? t.y : e.y : r === "after" ? n < 1 ? t.y : e.y : n > 0 ? e.y : t.y
  };
}
function ty(t, e, n, r) {
  const o = {
    x: t.cp2x,
    y: t.cp2y
  }, i = {
    x: e.cp1x,
    y: e.cp1y
  }, s = Xn(t, o, n), a = Xn(o, i, n), l = Xn(i, e, n), c = Xn(s, a, n), u = Xn(a, l, n);
  return Xn(c, u, n);
}
const ny = function(t, e) {
  return {
    x(n) {
      return t + t + e - n;
    },
    setWidth(n) {
      e = n;
    },
    textAlign(n) {
      return n === "center" ? n : n === "right" ? "left" : "right";
    },
    xPlus(n, r) {
      return n - r;
    },
    leftForLtr(n, r) {
      return n - r;
    }
  };
}, ry = function() {
  return {
    x(t) {
      return t;
    },
    setWidth(t) {
    },
    textAlign(t) {
      return t;
    },
    xPlus(t, e) {
      return t + e;
    },
    leftForLtr(t, e) {
      return t;
    }
  };
};
function ks(t, e, n) {
  return t ? ny(e, n) : ry();
}
function oy(t, e) {
  let n, r;
  (e === "ltr" || e === "rtl") && (n = t.canvas.style, r = [
    n.getPropertyValue("direction"),
    n.getPropertyPriority("direction")
  ], n.setProperty("direction", e, "important"), t.prevTextDirection = r);
}
function iy(t, e) {
  e !== void 0 && (delete t.prevTextDirection, t.canvas.style.setProperty("direction", e[0], e[1]));
}
function bh(t) {
  return t === "angle" ? {
    between: nh,
    compare: t1,
    normalize: jt
  } : {
    between: ba,
    compare: (e, n) => e - n,
    normalize: (e) => e
  };
}
function su({ start: t, end: e, count: n, loop: r, style: o }) {
  return {
    start: t % n,
    end: e % n,
    loop: r && (e - t + 1) % n === 0,
    style: o
  };
}
function sy(t, e, n) {
  const { property: r, start: o, end: i } = n, { between: s, normalize: a } = bh(r), l = e.length;
  let { start: c, end: u, loop: d } = t, f, h;
  if (d) {
    for (c += l, u += l, f = 0, h = l; f < h && s(a(e[c % l][r]), o, i); ++f)
      c--, u--;
    c %= l, u %= l;
  }
  return u < c && (u += l), {
    start: c,
    end: u,
    loop: d,
    style: t.style
  };
}
function ay(t, e, n) {
  if (!n)
    return [
      t
    ];
  const { property: r, start: o, end: i } = n, s = e.length, { compare: a, between: l, normalize: c } = bh(r), { start: u, end: d, loop: f, style: h } = sy(t, e, n), p = [];
  let g = !1, m = null, b, v, _;
  const x = () => l(o, _, b) && a(o, _) !== 0, y = () => a(i, b) === 0 || l(i, _, b), M = () => g || x(), k = () => !g || y();
  for (let O = u, S = u; O <= d; ++O)
    v = e[O % s], !v.skip && (b = c(v[r]), b !== _ && (g = l(b, o, i), m === null && M() && (m = a(b, o) === 0 ? O : S), m !== null && k() && (p.push(su({
      start: m,
      end: O,
      loop: f,
      count: s,
      style: h
    })), m = null), S = O, _ = b));
  return m !== null && p.push(su({
    start: m,
    end: d,
    loop: f,
    count: s,
    style: h
  })), p;
}
function ly(t, e) {
  const n = [], r = t.segments;
  for (let o = 0; o < r.length; o++) {
    const i = ay(r[o], t.points, e);
    i.length && n.push(...i);
  }
  return n;
}
function cy(t, e, n, r) {
  let o = 0, i = e - 1;
  if (n && !r)
    for (; o < e && !t[o].skip; )
      o++;
  for (; o < e && t[o].skip; )
    o++;
  for (o %= e, n && (i += o); i > o && t[i % e].skip; )
    i--;
  return i %= e, {
    start: o,
    end: i
  };
}
function uy(t, e, n, r) {
  const o = t.length, i = [];
  let s = e, a = t[e], l;
  for (l = e + 1; l <= n; ++l) {
    const c = t[l % o];
    c.skip || c.stop ? a.skip || (r = !1, i.push({
      start: e % o,
      end: (l - 1) % o,
      loop: r
    }), e = s = c.stop ? l : null) : (s = l, a.skip && (e = l)), a = c;
  }
  return s !== null && i.push({
    start: e % o,
    end: s % o,
    loop: r
  }), i;
}
function dy(t, e) {
  const n = t.points, r = t.options.spanGaps, o = n.length;
  if (!o)
    return [];
  const i = !!t._loop, { start: s, end: a } = cy(n, o, i, r);
  if (r === !0)
    return au(t, [
      {
        start: s,
        end: a,
        loop: i
      }
    ], n, e);
  const l = a < s ? a + o : a, c = !!t._fullLoop && s === 0 && a === o - 1;
  return au(t, uy(n, s, l, c), n, e);
}
function au(t, e, n, r) {
  return !r || !r.setContext || !n ? e : fy(t, e, n, r);
}
function fy(t, e, n, r) {
  const o = t._chart.getContext(), i = lu(t.options), { _datasetIndex: s, options: { spanGaps: a } } = t, l = n.length, c = [];
  let u = i, d = e[0].start, f = d;
  function h(p, g, m, b) {
    const v = a ? -1 : 1;
    if (p !== g) {
      for (p += l; n[p % l].skip; )
        p -= v;
      for (; n[g % l].skip; )
        g += v;
      p % l !== g % l && (c.push({
        start: p % l,
        end: g % l,
        loop: m,
        style: b
      }), u = b, d = g % l);
    }
  }
  for (const p of e) {
    d = a ? d : p.start;
    let g = n[d % l], m;
    for (f = d + 1; f <= p.end; f++) {
      const b = n[f % l];
      m = lu(r.setContext(Bn(o, {
        type: "segment",
        p0: g,
        p1: b,
        p0DataIndex: (f - 1) % l,
        p1DataIndex: f % l,
        datasetIndex: s
      }))), hy(m, u) && h(d, f - 1, p.loop, u), g = b, u = m;
    }
    d < f - 1 && h(d, f - 1, p.loop, u);
  }
  return c;
}
function lu(t) {
  return {
    backgroundColor: t.backgroundColor,
    borderCapStyle: t.borderCapStyle,
    borderDash: t.borderDash,
    borderDashOffset: t.borderDashOffset,
    borderJoinStyle: t.borderJoinStyle,
    borderWidth: t.borderWidth,
    borderColor: t.borderColor
  };
}
function hy(t, e) {
  if (!e)
    return !1;
  const n = [], r = function(o, i) {
    return yl(i) ? (n.includes(i) || n.push(i), n.indexOf(i)) : i;
  };
  return JSON.stringify(t, r) !== JSON.stringify(e, r);
}
/*!
 * Chart.js v4.3.3
 * https://www.chartjs.org
 * (c) 2023 Chart.js Contributors
 * Released under the MIT License
 */
class py {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(e, n, r, o) {
    const i = n.listeners[o], s = n.duration;
    i.forEach((a) => a({
      chart: e,
      initial: n.initial,
      numSteps: s,
      currentStep: Math.min(r - n.start, s)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = ih.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(e = Date.now()) {
    let n = 0;
    this._charts.forEach((r, o) => {
      if (!r.running || !r.items.length)
        return;
      const i = r.items;
      let s = i.length - 1, a = !1, l;
      for (; s >= 0; --s)
        l = i[s], l._active ? (l._total > r.duration && (r.duration = l._total), l.tick(e), a = !0) : (i[s] = i[i.length - 1], i.pop());
      a && (o.draw(), this._notify(o, r, e, "progress")), i.length || (r.running = !1, this._notify(o, r, e, "complete"), r.initial = !1), n += i.length;
    }), this._lastDate = e, n === 0 && (this._running = !1);
  }
  _getAnims(e) {
    const n = this._charts;
    let r = n.get(e);
    return r || (r = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, n.set(e, r)), r;
  }
  listen(e, n, r) {
    this._getAnims(e).listeners[n].push(r);
  }
  add(e, n) {
    !n || !n.length || this._getAnims(e).items.push(...n);
  }
  has(e) {
    return this._getAnims(e).items.length > 0;
  }
  start(e) {
    const n = this._charts.get(e);
    n && (n.running = !0, n.start = Date.now(), n.duration = n.items.reduce((r, o) => Math.max(r, o._duration), 0), this._refresh());
  }
  running(e) {
    if (!this._running)
      return !1;
    const n = this._charts.get(e);
    return !(!n || !n.running || !n.items.length);
  }
  stop(e) {
    const n = this._charts.get(e);
    if (!n || !n.items.length)
      return;
    const r = n.items;
    let o = r.length - 1;
    for (; o >= 0; --o)
      r[o].cancel();
    n.items = [], this._notify(e, n, Date.now(), "complete");
  }
  remove(e) {
    return this._charts.delete(e);
  }
}
var fn = /* @__PURE__ */ new py();
const cu = "transparent", gy = {
  boolean(t, e, n) {
    return n > 0.5 ? e : t;
  },
  color(t, e, n) {
    const r = Jc(t || cu), o = r.valid && Jc(e || cu);
    return o && o.valid ? o.mix(r, n).hexString() : e;
  },
  number(t, e, n) {
    return t + (e - t) * n;
  }
};
class my {
  constructor(e, n, r, o) {
    const i = n[r];
    o = Bo([
      e.to,
      o,
      i,
      e.from
    ]);
    const s = Bo([
      e.from,
      i,
      o
    ]);
    this._active = !0, this._fn = e.fn || gy[e.type || typeof s], this._easing = io[e.easing] || io.linear, this._start = Math.floor(Date.now() + (e.delay || 0)), this._duration = this._total = Math.floor(e.duration), this._loop = !!e.loop, this._target = n, this._prop = r, this._from = s, this._to = o, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(e, n, r) {
    if (this._active) {
      this._notify(!1);
      const o = this._target[this._prop], i = r - this._start, s = this._duration - i;
      this._start = r, this._duration = Math.floor(Math.max(s, e.duration)), this._total += i, this._loop = !!e.loop, this._to = Bo([
        e.to,
        n,
        o,
        e.from
      ]), this._from = Bo([
        e.from,
        o,
        n
      ]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(e) {
    const n = e - this._start, r = this._duration, o = this._prop, i = this._from, s = this._loop, a = this._to;
    let l;
    if (this._active = i !== a && (s || n < r), !this._active) {
      this._target[o] = a, this._notify(!0);
      return;
    }
    if (n < 0) {
      this._target[o] = i;
      return;
    }
    l = n / r % 2, l = s && l > 1 ? 2 - l : l, l = this._easing(Math.min(1, Math.max(0, l))), this._target[o] = this._fn(i, a, l);
  }
  wait() {
    const e = this._promises || (this._promises = []);
    return new Promise((n, r) => {
      e.push({
        res: n,
        rej: r
      });
    });
  }
  _notify(e) {
    const n = e ? "res" : "rej", r = this._promises || [];
    for (let o = 0; o < r.length; o++)
      r[o][n]();
  }
}
class yh {
  constructor(e, n) {
    this._chart = e, this._properties = /* @__PURE__ */ new Map(), this.configure(n);
  }
  configure(e) {
    if (!Se(e))
      return;
    const n = Object.keys(Ze.animation), r = this._properties;
    Object.getOwnPropertyNames(e).forEach((o) => {
      const i = e[o];
      if (!Se(i))
        return;
      const s = {};
      for (const a of n)
        s[a] = i[a];
      (Ye(i.properties) && i.properties || [
        o
      ]).forEach((a) => {
        (a === o || !r.has(a)) && r.set(a, s);
      });
    });
  }
  _animateOptions(e, n) {
    const r = n.options, o = by(e, r);
    if (!o)
      return [];
    const i = this._createAnimations(o, r);
    return r.$shared && vy(e.options.$animations, r).then(() => {
      e.options = r;
    }, () => {
    }), i;
  }
  _createAnimations(e, n) {
    const r = this._properties, o = [], i = e.$animations || (e.$animations = {}), s = Object.keys(n), a = Date.now();
    let l;
    for (l = s.length - 1; l >= 0; --l) {
      const c = s[l];
      if (c.charAt(0) === "$")
        continue;
      if (c === "options") {
        o.push(...this._animateOptions(e, n));
        continue;
      }
      const u = n[c];
      let d = i[c];
      const f = r.get(c);
      if (d)
        if (f && d.active()) {
          d.update(f, u, a);
          continue;
        } else
          d.cancel();
      if (!f || !f.duration) {
        e[c] = u;
        continue;
      }
      i[c] = d = new my(f, e, c, u), o.push(d);
    }
    return o;
  }
  update(e, n) {
    if (this._properties.size === 0) {
      Object.assign(e, n);
      return;
    }
    const r = this._createAnimations(e, n);
    if (r.length)
      return fn.add(this._chart, r), !0;
  }
}
function vy(t, e) {
  const n = [], r = Object.keys(e);
  for (let o = 0; o < r.length; o++) {
    const i = t[r[o]];
    i && i.active() && n.push(i.wait());
  }
  return Promise.all(n);
}
function by(t, e) {
  if (!e)
    return;
  let n = t.options;
  if (!n) {
    t.options = e;
    return;
  }
  return n.$shared && (t.options = n = Object.assign({}, n, {
    $shared: !1,
    $animations: {}
  })), n;
}
function uu(t, e) {
  const n = t && t.options || {}, r = n.reverse, o = n.min === void 0 ? e : 0, i = n.max === void 0 ? e : 0;
  return {
    start: r ? i : o,
    end: r ? o : i
  };
}
function yy(t, e, n) {
  if (n === !1)
    return !1;
  const r = uu(t, n), o = uu(e, n);
  return {
    top: o.end,
    right: r.end,
    bottom: o.start,
    left: r.start
  };
}
function wy(t) {
  let e, n, r, o;
  return Se(t) ? (e = t.top, n = t.right, r = t.bottom, o = t.left) : e = n = r = o = t, {
    top: e,
    right: n,
    bottom: r,
    left: o,
    disabled: t === !1
  };
}
function wh(t, e) {
  const n = [], r = t._getSortedDatasetMetas(e);
  let o, i;
  for (o = 0, i = r.length; o < i; ++o)
    n.push(r[o].index);
  return n;
}
function du(t, e, n, r = {}) {
  const o = t.keys, i = r.mode === "single";
  let s, a, l, c;
  if (e !== null) {
    for (s = 0, a = o.length; s < a; ++s) {
      if (l = +o[s], l === n) {
        if (r.all)
          continue;
        break;
      }
      c = t.values[l], it(c) && (i || e === 0 || on(e) === on(c)) && (e += c);
    }
    return e;
  }
}
function xy(t) {
  const e = Object.keys(t), n = new Array(e.length);
  let r, o, i;
  for (r = 0, o = e.length; r < o; ++r)
    i = e[r], n[r] = {
      x: i,
      y: t[i]
    };
  return n;
}
function fu(t, e) {
  const n = t && t.options.stacked;
  return n || n === void 0 && e.stack !== void 0;
}
function _y(t, e, n) {
  return `${t.id}.${e.id}.${n.stack || n.type}`;
}
function Cy(t) {
  const { min: e, max: n, minDefined: r, maxDefined: o } = t.getUserBounds();
  return {
    min: r ? e : Number.NEGATIVE_INFINITY,
    max: o ? n : Number.POSITIVE_INFINITY
  };
}
function Ey(t, e, n) {
  const r = t[e] || (t[e] = {});
  return r[n] || (r[n] = {});
}
function hu(t, e, n, r) {
  for (const o of e.getMatchingVisibleMetas(r).reverse()) {
    const i = t[o.index];
    if (n && i > 0 || !n && i < 0)
      return o.index;
  }
  return null;
}
function pu(t, e) {
  const { chart: n, _cachedMeta: r } = t, o = n._stacks || (n._stacks = {}), { iScale: i, vScale: s, index: a } = r, l = i.axis, c = s.axis, u = _y(i, s, r), d = e.length;
  let f;
  for (let h = 0; h < d; ++h) {
    const p = e[h], { [l]: g, [c]: m } = p, b = p._stacks || (p._stacks = {});
    f = b[c] = Ey(o, u, g), f[a] = m, f._top = hu(f, s, !0, r.type), f._bottom = hu(f, s, !1, r.type);
    const v = f._visualValues || (f._visualValues = {});
    v[a] = m;
  }
}
function Os(t, e) {
  const n = t.scales;
  return Object.keys(n).filter((r) => n[r].axis === e).shift();
}
function My(t, e) {
  return Bn(t, {
    active: !1,
    dataset: void 0,
    datasetIndex: e,
    index: e,
    mode: "default",
    type: "dataset"
  });
}
function ky(t, e, n) {
  return Bn(t, {
    active: !1,
    dataIndex: e,
    parsed: void 0,
    raw: void 0,
    element: n,
    index: e,
    mode: "default",
    type: "data"
  });
}
function jr(t, e) {
  const n = t.controller.index, r = t.vScale && t.vScale.axis;
  if (r) {
    e = e || t._parsed;
    for (const o of e) {
      const i = o._stacks;
      if (!i || i[r] === void 0 || i[r][n] === void 0)
        return;
      delete i[r][n], i[r]._visualValues !== void 0 && i[r]._visualValues[n] !== void 0 && delete i[r]._visualValues[n];
    }
  }
}
const Ss = (t) => t === "reset" || t === "none", gu = (t, e) => e ? t : Object.assign({}, t), Oy = (t, e, n) => t && !e.hidden && e._stacked && {
  keys: wh(n, !0),
  values: null
};
class Mr {
  constructor(e, n) {
    this.chart = e, this._ctx = e.ctx, this.index = n, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.datasetElementType = new.target.datasetElementType, this.dataElementType = new.target.dataElementType, this.initialize();
  }
  initialize() {
    const e = this._cachedMeta;
    this.configure(), this.linkScales(), e._stacked = fu(e.vScale, e), this.addElements(), this.options.fill && !this.chart.isPluginEnabled("filler") && console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
  }
  updateIndex(e) {
    this.index !== e && jr(this._cachedMeta), this.index = e;
  }
  linkScales() {
    const e = this.chart, n = this._cachedMeta, r = this.getDataset(), o = (d, f, h, p) => d === "x" ? f : d === "r" ? p : h, i = n.xAxisID = Fe(r.xAxisID, Os(e, "x")), s = n.yAxisID = Fe(r.yAxisID, Os(e, "y")), a = n.rAxisID = Fe(r.rAxisID, Os(e, "r")), l = n.indexAxis, c = n.iAxisID = o(l, i, s, a), u = n.vAxisID = o(l, s, i, a);
    n.xScale = this.getScaleForId(i), n.yScale = this.getScaleForId(s), n.rScale = this.getScaleForId(a), n.iScale = this.getScaleForId(c), n.vScale = this.getScaleForId(u);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(e) {
    return this.chart.scales[e];
  }
  _getOtherScale(e) {
    const n = this._cachedMeta;
    return e === n.iScale ? n.vScale : n.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const e = this._cachedMeta;
    this._data && qc(this._data, this), e._stacked && jr(e);
  }
  _dataCheck() {
    const e = this.getDataset(), n = e.data || (e.data = []), r = this._data;
    if (Se(n))
      this._data = xy(n);
    else if (r !== n) {
      if (r) {
        qc(r, this);
        const o = this._cachedMeta;
        jr(o), o._parsed = [];
      }
      n && Object.isExtensible(n) && i1(n, this), this._syncList = [], this._data = n;
    }
  }
  addElements() {
    const e = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (e.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(e) {
    const n = this._cachedMeta, r = this.getDataset();
    let o = !1;
    this._dataCheck();
    const i = n._stacked;
    n._stacked = fu(n.vScale, n), n.stack !== r.stack && (o = !0, jr(n), n.stack = r.stack), this._resyncElements(e), (o || i !== n._stacked) && pu(this, n._parsed);
  }
  configure() {
    const e = this.chart.config, n = e.datasetScopeKeys(this._type), r = e.getOptionScopes(this.getDataset(), n, !0);
    this.options = e.createResolver(r, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(e, n) {
    const { _cachedMeta: r, _data: o } = this, { iScale: i, _stacked: s } = r, a = i.axis;
    let l = e === 0 && n === o.length ? !0 : r._sorted, c = e > 0 && r._parsed[e - 1], u, d, f;
    if (this._parsing === !1)
      r._parsed = o, r._sorted = !0, f = o;
    else {
      Ye(o[e]) ? f = this.parseArrayData(r, o, e, n) : Se(o[e]) ? f = this.parseObjectData(r, o, e, n) : f = this.parsePrimitiveData(r, o, e, n);
      const h = () => d[a] === null || c && d[a] < c[a];
      for (u = 0; u < n; ++u)
        r._parsed[u + e] = d = f[u], l && (h() && (l = !1), c = d);
      r._sorted = l;
    }
    s && pu(this, f);
  }
  parsePrimitiveData(e, n, r, o) {
    const { iScale: i, vScale: s } = e, a = i.axis, l = s.axis, c = i.getLabels(), u = i === s, d = new Array(o);
    let f, h, p;
    for (f = 0, h = o; f < h; ++f)
      p = f + r, d[f] = {
        [a]: u || i.parse(c[p], p),
        [l]: s.parse(n[p], p)
      };
    return d;
  }
  parseArrayData(e, n, r, o) {
    const { xScale: i, yScale: s } = e, a = new Array(o);
    let l, c, u, d;
    for (l = 0, c = o; l < c; ++l)
      u = l + r, d = n[u], a[l] = {
        x: i.parse(d[0], u),
        y: s.parse(d[1], u)
      };
    return a;
  }
  parseObjectData(e, n, r, o) {
    const { xScale: i, yScale: s } = e, { xAxisKey: a = "x", yAxisKey: l = "y" } = this._parsing, c = new Array(o);
    let u, d, f, h;
    for (u = 0, d = o; u < d; ++u)
      f = u + r, h = n[f], c[u] = {
        x: i.parse(Or(h, a), f),
        y: s.parse(Or(h, l), f)
      };
    return c;
  }
  getParsed(e) {
    return this._cachedMeta._parsed[e];
  }
  getDataElement(e) {
    return this._cachedMeta.data[e];
  }
  applyStack(e, n, r) {
    const o = this.chart, i = this._cachedMeta, s = n[e.axis], a = {
      keys: wh(o, !0),
      values: n._stacks[e.axis]._visualValues
    };
    return du(a, s, i.index, {
      mode: r
    });
  }
  updateRangeFromParsed(e, n, r, o) {
    const i = r[n.axis];
    let s = i === null ? NaN : i;
    const a = o && r._stacks[n.axis];
    o && a && (o.values = a, s = du(o, i, this._cachedMeta.index)), e.min = Math.min(e.min, s), e.max = Math.max(e.max, s);
  }
  getMinMax(e, n) {
    const r = this._cachedMeta, o = r._parsed, i = r._sorted && e === r.iScale, s = o.length, a = this._getOtherScale(e), l = Oy(n, r, this.chart), c = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    }, { min: u, max: d } = Cy(a);
    let f, h;
    function p() {
      h = o[f];
      const g = h[a.axis];
      return !it(h[e.axis]) || u > g || d < g;
    }
    for (f = 0; f < s && !(!p() && (this.updateRangeFromParsed(c, e, h, l), i)); ++f)
      ;
    if (i) {
      for (f = s - 1; f >= 0; --f)
        if (!p()) {
          this.updateRangeFromParsed(c, e, h, l);
          break;
        }
    }
    return c;
  }
  getAllParsedValues(e) {
    const n = this._cachedMeta._parsed, r = [];
    let o, i, s;
    for (o = 0, i = n.length; o < i; ++o)
      s = n[o][e.axis], it(s) && r.push(s);
    return r;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(e) {
    const n = this._cachedMeta, r = n.iScale, o = n.vScale, i = this.getParsed(e);
    return {
      label: r ? "" + r.getLabelForValue(i[r.axis]) : "",
      value: o ? "" + o.getLabelForValue(i[o.axis]) : ""
    };
  }
  _update(e) {
    const n = this._cachedMeta;
    this.update(e || "default"), n._clip = wy(Fe(this.options.clip, yy(n.xScale, n.yScale, this.getMaxOverflow())));
  }
  update(e) {
  }
  draw() {
    const e = this._ctx, n = this.chart, r = this._cachedMeta, o = r.data || [], i = n.chartArea, s = [], a = this._drawStart || 0, l = this._drawCount || o.length - a, c = this.options.drawActiveElementsOnTop;
    let u;
    for (r.dataset && r.dataset.draw(e, i, a, l), u = a; u < a + l; ++u) {
      const d = o[u];
      d.hidden || (d.active && c ? s.push(d) : d.draw(e, i));
    }
    for (u = 0; u < s.length; ++u)
      s[u].draw(e, i);
  }
  getStyle(e, n) {
    const r = n ? "active" : "default";
    return e === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(r) : this.resolveDataElementOptions(e || 0, r);
  }
  getContext(e, n, r) {
    const o = this.getDataset();
    let i;
    if (e >= 0 && e < this._cachedMeta.data.length) {
      const s = this._cachedMeta.data[e];
      i = s.$context || (s.$context = ky(this.getContext(), e, s)), i.parsed = this.getParsed(e), i.raw = o.data[e], i.index = i.dataIndex = e;
    } else
      i = this.$context || (this.$context = My(this.chart.getContext(), this.index)), i.dataset = o, i.index = i.datasetIndex = this.index;
    return i.active = !!n, i.mode = r, i;
  }
  resolveDatasetElementOptions(e) {
    return this._resolveElementOptions(this.datasetElementType.id, e);
  }
  resolveDataElementOptions(e, n) {
    return this._resolveElementOptions(this.dataElementType.id, n, e);
  }
  _resolveElementOptions(e, n = "default", r) {
    const o = n === "active", i = this._cachedDataOpts, s = e + "-" + n, a = i[s], l = this.enableOptionSharing && vo(r);
    if (a)
      return gu(a, l);
    const c = this.chart.config, u = c.datasetElementScopeKeys(this._type, e), d = o ? [
      `${e}Hover`,
      "hover",
      e,
      ""
    ] : [
      e,
      ""
    ], f = c.getOptionScopes(this.getDataset(), u), h = Object.keys(Ze.elements[e]), p = () => this.getContext(r, o, n), g = c.resolveNamedOptions(f, h, p, d);
    return g.$shared && (g.$shared = l, i[s] = Object.freeze(gu(g, l))), g;
  }
  _resolveAnimations(e, n, r) {
    const o = this.chart, i = this._cachedDataOpts, s = `animation-${n}`, a = i[s];
    if (a)
      return a;
    let l;
    if (o.options.animation !== !1) {
      const u = this.chart.config, d = u.datasetAnimationScopeKeys(this._type, n), f = u.getOptionScopes(this.getDataset(), d);
      l = u.createResolver(f, this.getContext(e, r, n));
    }
    const c = new yh(o, l && l.animations);
    return l && l._cacheable && (i[s] = Object.freeze(c)), c;
  }
  getSharedOptions(e) {
    if (e.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, e));
  }
  includeOptions(e, n) {
    return !n || Ss(e) || this.chart._animationsDisabled;
  }
  _getSharedOptions(e, n) {
    const r = this.resolveDataElementOptions(e, n), o = this._sharedOptions, i = this.getSharedOptions(r), s = this.includeOptions(n, i) || i !== o;
    return this.updateSharedOptions(i, n, r), {
      sharedOptions: i,
      includeOptions: s
    };
  }
  updateElement(e, n, r, o) {
    Ss(o) ? Object.assign(e, r) : this._resolveAnimations(n, o).update(e, r);
  }
  updateSharedOptions(e, n, r) {
    e && !Ss(n) && this._resolveAnimations(void 0, n).update(e, r);
  }
  _setStyle(e, n, r, o) {
    e.active = o;
    const i = this.getStyle(n, o);
    this._resolveAnimations(n, r, o).update(e, {
      options: !o && this.getSharedOptions(i) || i
    });
  }
  removeHoverStyle(e, n, r) {
    this._setStyle(e, r, "active", !1);
  }
  setHoverStyle(e, n, r) {
    this._setStyle(e, r, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const e = this._cachedMeta.dataset;
    e && this._setStyle(e, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const e = this._cachedMeta.dataset;
    e && this._setStyle(e, void 0, "active", !0);
  }
  _resyncElements(e) {
    const n = this._data, r = this._cachedMeta.data;
    for (const [a, l, c] of this._syncList)
      this[a](l, c);
    this._syncList = [];
    const o = r.length, i = n.length, s = Math.min(i, o);
    s && this.parse(0, s), i > o ? this._insertElements(o, i - o, e) : i < o && this._removeElements(i, o - i);
  }
  _insertElements(e, n, r = !0) {
    const o = this._cachedMeta, i = o.data, s = e + n;
    let a;
    const l = (c) => {
      for (c.length += n, a = c.length - 1; a >= s; a--)
        c[a] = c[a - n];
    };
    for (l(i), a = e; a < s; ++a)
      i[a] = new this.dataElementType();
    this._parsing && l(o._parsed), this.parse(e, n), r && this.updateElements(i, e, n, "reset");
  }
  updateElements(e, n, r, o) {
  }
  _removeElements(e, n) {
    const r = this._cachedMeta;
    if (this._parsing) {
      const o = r._parsed.splice(e, n);
      r._stacked && jr(r, o);
    }
    r.data.splice(e, n);
  }
  _sync(e) {
    if (this._parsing)
      this._syncList.push(e);
    else {
      const [n, r, o] = e;
      this[n](r, o);
    }
    this.chart._dataChanges.push([
      this.index,
      ...e
    ]);
  }
  _onDataPush() {
    const e = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - e,
      e
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(e, n) {
    n && this._sync([
      "_removeElements",
      e,
      n
    ]);
    const r = arguments.length - 2;
    r && this._sync([
      "_insertElements",
      e,
      r
    ]);
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
}
fe(Mr, "defaults", {}), fe(Mr, "datasetElementType", null), fe(Mr, "dataElementType", null);
function Sy(t, e) {
  if (!t._cache.$bar) {
    const n = t.getMatchingVisibleMetas(e);
    let r = [];
    for (let o = 0, i = n.length; o < i; o++)
      r = r.concat(n[o].controller.getAllParsedValues(t));
    t._cache.$bar = oh(r.sort((o, i) => o - i));
  }
  return t._cache.$bar;
}
function Py(t) {
  const e = t.iScale, n = Sy(e, t.type);
  let r = e._length, o, i, s, a;
  const l = () => {
    s === 32767 || s === -32768 || (vo(a) && (r = Math.min(r, Math.abs(s - a) || r)), a = s);
  };
  for (o = 0, i = n.length; o < i; ++o)
    s = e.getPixelForValue(n[o]), l();
  for (a = void 0, o = 0, i = e.ticks.length; o < i; ++o)
    s = e.getPixelForTick(o), l();
  return r;
}
function Iy(t, e, n, r) {
  const o = n.barThickness;
  let i, s;
  return Ve(o) ? (i = e.min * n.categoryPercentage, s = n.barPercentage) : (i = o * r, s = 1), {
    chunk: i / r,
    ratio: s,
    start: e.pixels[t] - i / 2
  };
}
function Ty(t, e, n, r) {
  const o = e.pixels, i = o[t];
  let s = t > 0 ? o[t - 1] : null, a = t < o.length - 1 ? o[t + 1] : null;
  const l = n.categoryPercentage;
  s === null && (s = i - (a === null ? e.end - e.start : a - i)), a === null && (a = i + i - s);
  const c = i - (i - Math.min(s, a)) / 2 * l;
  return {
    chunk: Math.abs(a - s) / 2 * l / r,
    ratio: n.barPercentage,
    start: c
  };
}
function Dy(t, e, n, r) {
  const o = n.parse(t[0], r), i = n.parse(t[1], r), s = Math.min(o, i), a = Math.max(o, i);
  let l = s, c = a;
  Math.abs(s) > Math.abs(a) && (l = a, c = s), e[n.axis] = c, e._custom = {
    barStart: l,
    barEnd: c,
    start: o,
    end: i,
    min: s,
    max: a
  };
}
function xh(t, e, n, r) {
  return Ye(t) ? Dy(t, e, n, r) : e[n.axis] = n.parse(t, r), e;
}
function mu(t, e, n, r) {
  const o = t.iScale, i = t.vScale, s = o.getLabels(), a = o === i, l = [];
  let c, u, d, f;
  for (c = n, u = n + r; c < u; ++c)
    f = e[c], d = {}, d[o.axis] = a || o.parse(s[c], c), l.push(xh(f, d, i, c));
  return l;
}
function Ps(t) {
  return t && t.barStart !== void 0 && t.barEnd !== void 0;
}
function $y(t, e, n) {
  return t !== 0 ? on(t) : (e.isHorizontal() ? 1 : -1) * (e.min >= n ? 1 : -1);
}
function Ny(t) {
  let e, n, r, o, i;
  return t.horizontal ? (e = t.base > t.x, n = "left", r = "right") : (e = t.base < t.y, n = "bottom", r = "top"), e ? (o = "end", i = "start") : (o = "start", i = "end"), {
    start: n,
    end: r,
    reverse: e,
    top: o,
    bottom: i
  };
}
function Ry(t, e, n, r) {
  let o = e.borderSkipped;
  const i = {};
  if (!o) {
    t.borderSkipped = i;
    return;
  }
  if (o === !0) {
    t.borderSkipped = {
      top: !0,
      right: !0,
      bottom: !0,
      left: !0
    };
    return;
  }
  const { start: s, end: a, reverse: l, top: c, bottom: u } = Ny(t);
  o === "middle" && n && (t.enableBorderRadius = !0, (n._top || 0) === r ? o = c : (n._bottom || 0) === r ? o = u : (i[vu(u, s, a, l)] = !0, o = c)), i[vu(o, s, a, l)] = !0, t.borderSkipped = i;
}
function vu(t, e, n, r) {
  return r ? (t = Ay(t, e, n), t = bu(t, n, e)) : t = bu(t, e, n), t;
}
function Ay(t, e, n) {
  return t === e ? n : t === n ? e : t;
}
function bu(t, e, n) {
  return t === "start" ? e : t === "end" ? n : t;
}
function Ly(t, { inflateAmount: e }, n) {
  t.inflateAmount = e === "auto" ? n === 1 ? 0.33 : 0 : e;
}
class fi extends Mr {
  parsePrimitiveData(e, n, r, o) {
    return mu(e, n, r, o);
  }
  parseArrayData(e, n, r, o) {
    return mu(e, n, r, o);
  }
  parseObjectData(e, n, r, o) {
    const { iScale: i, vScale: s } = e, { xAxisKey: a = "x", yAxisKey: l = "y" } = this._parsing, c = i.axis === "x" ? a : l, u = s.axis === "x" ? a : l, d = [];
    let f, h, p, g;
    for (f = r, h = r + o; f < h; ++f)
      g = n[f], p = {}, p[i.axis] = i.parse(Or(g, c), f), d.push(xh(Or(g, u), p, s, f));
    return d;
  }
  updateRangeFromParsed(e, n, r, o) {
    super.updateRangeFromParsed(e, n, r, o);
    const i = r._custom;
    i && n === this._cachedMeta.vScale && (e.min = Math.min(e.min, i.min), e.max = Math.max(e.max, i.max));
  }
  getMaxOverflow() {
    return 0;
  }
  getLabelAndValue(e) {
    const n = this._cachedMeta, { iScale: r, vScale: o } = n, i = this.getParsed(e), s = i._custom, a = Ps(s) ? "[" + s.start + ", " + s.end + "]" : "" + o.getLabelForValue(i[o.axis]);
    return {
      label: "" + r.getLabelForValue(i[r.axis]),
      value: a
    };
  }
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
    const e = this._cachedMeta;
    e.stack = this.getDataset().stack;
  }
  update(e) {
    const n = this._cachedMeta;
    this.updateElements(n.data, 0, n.data.length, e);
  }
  updateElements(e, n, r, o) {
    const i = o === "reset", { index: s, _cachedMeta: { vScale: a } } = this, l = a.getBasePixel(), c = a.isHorizontal(), u = this._getRuler(), { sharedOptions: d, includeOptions: f } = this._getSharedOptions(n, o);
    for (let h = n; h < n + r; h++) {
      const p = this.getParsed(h), g = i || Ve(p[a.axis]) ? {
        base: l,
        head: l
      } : this._calculateBarValuePixels(h), m = this._calculateBarIndexPixels(h, u), b = (p._stacks || {})[a.axis], v = {
        horizontal: c,
        base: g.base,
        enableBorderRadius: !b || Ps(p._custom) || s === b._top || s === b._bottom,
        x: c ? g.head : m.center,
        y: c ? m.center : g.head,
        height: c ? m.size : Math.abs(g.size),
        width: c ? Math.abs(g.size) : m.size
      };
      f && (v.options = d || this.resolveDataElementOptions(h, e[h].active ? "active" : o));
      const _ = v.options || e[h].options;
      Ry(v, _, b, s), Ly(v, _, u.ratio), this.updateElement(e[h], h, v, o);
    }
  }
  _getStacks(e, n) {
    const { iScale: r } = this._cachedMeta, o = r.getMatchingVisibleMetas(this._type).filter((l) => l.controller.options.grouped), i = r.options.stacked, s = [], a = (l) => {
      const c = l.controller.getParsed(n), u = c && c[l.vScale.axis];
      if (Ve(u) || isNaN(u))
        return !0;
    };
    for (const l of o)
      if (!(n !== void 0 && a(l)) && ((i === !1 || s.indexOf(l.stack) === -1 || i === void 0 && l.stack === void 0) && s.push(l.stack), l.index === e))
        break;
    return s.length || s.push(void 0), s;
  }
  _getStackCount(e) {
    return this._getStacks(void 0, e).length;
  }
  _getStackIndex(e, n, r) {
    const o = this._getStacks(e, r), i = n !== void 0 ? o.indexOf(n) : -1;
    return i === -1 ? o.length - 1 : i;
  }
  _getRuler() {
    const e = this.options, n = this._cachedMeta, r = n.iScale, o = [];
    let i, s;
    for (i = 0, s = n.data.length; i < s; ++i)
      o.push(r.getPixelForValue(this.getParsed(i)[r.axis], i));
    const a = e.barThickness;
    return {
      min: a || Py(n),
      pixels: o,
      start: r._startPixel,
      end: r._endPixel,
      stackCount: this._getStackCount(),
      scale: r,
      grouped: e.grouped,
      ratio: a ? 1 : e.categoryPercentage * e.barPercentage
    };
  }
  _calculateBarValuePixels(e) {
    const { _cachedMeta: { vScale: n, _stacked: r, index: o }, options: { base: i, minBarLength: s } } = this, a = i || 0, l = this.getParsed(e), c = l._custom, u = Ps(c);
    let d = l[n.axis], f = 0, h = r ? this.applyStack(n, l, r) : d, p, g;
    h !== d && (f = h - d, h = d), u && (d = c.barStart, h = c.barEnd - c.barStart, d !== 0 && on(d) !== on(c.barEnd) && (f = 0), f += d);
    const m = !Ve(i) && !u ? i : f;
    let b = n.getPixelForValue(m);
    if (this.chart.getDataVisibility(e) ? p = n.getPixelForValue(f + h) : p = b, g = p - b, Math.abs(g) < s) {
      g = $y(g, n, a) * s, d === a && (b -= g / 2);
      const v = n.getPixelForDecimal(0), _ = n.getPixelForDecimal(1), x = Math.min(v, _), y = Math.max(v, _);
      b = Math.max(Math.min(b, y), x), p = b + g, r && !u && (l._stacks[n.axis]._visualValues[o] = n.getValueForPixel(p) - n.getValueForPixel(b));
    }
    if (b === n.getPixelForValue(a)) {
      const v = on(g) * n.getLineWidthForValue(a) / 2;
      b += v, g -= v;
    }
    return {
      size: g,
      base: b,
      head: p,
      center: p + g / 2
    };
  }
  _calculateBarIndexPixels(e, n) {
    const r = n.scale, o = this.options, i = o.skipNull, s = Fe(o.maxBarThickness, 1 / 0);
    let a, l;
    if (n.grouped) {
      const c = i ? this._getStackCount(e) : n.stackCount, u = o.barThickness === "flex" ? Ty(e, n, o, c) : Iy(e, n, o, c), d = this._getStackIndex(this.index, this._cachedMeta.stack, i ? e : void 0);
      a = u.start + u.chunk * d + u.chunk / 2, l = Math.min(s, u.chunk * u.ratio);
    } else
      a = r.getPixelForValue(this.getParsed(e)[r.axis], e), l = Math.min(s, n.min * n.ratio);
    return {
      base: a - l / 2,
      head: a + l / 2,
      center: a,
      size: l
    };
  }
  draw() {
    const e = this._cachedMeta, n = e.vScale, r = e.data, o = r.length;
    let i = 0;
    for (; i < o; ++i)
      this.getParsed(i)[n.axis] !== null && r[i].draw(this._ctx);
  }
}
fe(fi, "id", "bar"), fe(fi, "defaults", {
  datasetElementType: !1,
  dataElementType: "bar",
  categoryPercentage: 0.8,
  barPercentage: 0.9,
  grouped: !0,
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "base",
        "width",
        "height"
      ]
    }
  }
}), fe(fi, "overrides", {
  scales: {
    _index_: {
      type: "category",
      offset: !0,
      grid: {
        offset: !0
      }
    },
    _value_: {
      type: "linear",
      beginAtZero: !0
    }
  }
});
class hi extends Mr {
  initialize() {
    this.enableOptionSharing = !0, this.supportsDecimation = !0, super.initialize();
  }
  update(e) {
    const n = this._cachedMeta, { dataset: r, data: o = [], _dataset: i } = n, s = this.chart._animationsDisabled;
    let { start: a, count: l } = l1(n, o, s);
    this._drawStart = a, this._drawCount = l, c1(n) && (a = 0, l = o.length), r._chart = this.chart, r._datasetIndex = this.index, r._decimated = !!i._decimated, r.points = o;
    const c = this.resolveDatasetElementOptions(e);
    this.options.showLine || (c.borderWidth = 0), c.segment = this.options.segment, this.updateElement(r, void 0, {
      animated: !s,
      options: c
    }, e), this.updateElements(o, a, l, e);
  }
  updateElements(e, n, r, o) {
    const i = o === "reset", { iScale: s, vScale: a, _stacked: l, _dataset: c } = this._cachedMeta, { sharedOptions: u, includeOptions: d } = this._getSharedOptions(n, o), f = s.axis, h = a.axis, { spanGaps: p, segment: g } = this.options, m = bo(p) ? p : Number.POSITIVE_INFINITY, b = this.chart._animationsDisabled || i || o === "none", v = n + r, _ = e.length;
    let x = n > 0 && this.getParsed(n - 1);
    for (let y = 0; y < _; ++y) {
      const M = e[y], k = b ? M : {};
      if (y < n || y >= v) {
        k.skip = !0;
        continue;
      }
      const O = this.getParsed(y), S = Ve(O[h]), D = k[f] = s.getPixelForValue(O[f], y), P = k[h] = i || S ? a.getBasePixel() : a.getPixelForValue(l ? this.applyStack(a, O, l) : O[h], y);
      k.skip = isNaN(D) || isNaN(P) || S, k.stop = y > 0 && Math.abs(O[f] - x[f]) > m, g && (k.parsed = O, k.raw = c.data[y]), d && (k.options = u || this.resolveDataElementOptions(y, M.active ? "active" : o)), b || this.updateElement(M, y, k, o), x = O;
    }
  }
  getMaxOverflow() {
    const e = this._cachedMeta, n = e.dataset, r = n.options && n.options.borderWidth || 0, o = e.data || [];
    if (!o.length)
      return r;
    const i = o[0].size(this.resolveDataElementOptions(0)), s = o[o.length - 1].size(this.resolveDataElementOptions(o.length - 1));
    return Math.max(r, i, s) / 2;
  }
  draw() {
    const e = this._cachedMeta;
    e.dataset.updateControlPoints(this.chart.chartArea, e.iScale.axis), super.draw();
  }
}
fe(hi, "id", "line"), fe(hi, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  showLine: !0,
  spanGaps: !1
}), fe(hi, "overrides", {
  scales: {
    _index_: {
      type: "category"
    },
    _value_: {
      type: "linear"
    }
  }
});
function Kn() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class Ml {
  constructor(e) {
    fe(this, "options");
    this.options = e || {};
  }
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(e) {
    Object.assign(Ml.prototype, e);
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  formats() {
    return Kn();
  }
  parse() {
    return Kn();
  }
  format() {
    return Kn();
  }
  add() {
    return Kn();
  }
  diff() {
    return Kn();
  }
  startOf() {
    return Kn();
  }
  endOf() {
    return Kn();
  }
}
var _h = {
  _date: Ml
};
function Fy(t, e, n, r) {
  const { controller: o, data: i, _sorted: s } = t, a = o._cachedMeta.iScale;
  if (a && e === a.axis && e !== "r" && s && i.length) {
    const l = a._reversePixels ? r1 : Jn;
    if (r) {
      if (o._sharedOptions) {
        const c = i[0], u = typeof c.getRange == "function" && c.getRange(e);
        if (u) {
          const d = l(i, e, n - u), f = l(i, e, n + u);
          return {
            lo: d.lo,
            hi: f.hi
          };
        }
      }
    } else
      return l(i, e, n);
  }
  return {
    lo: 0,
    hi: i.length - 1
  };
}
function ko(t, e, n, r, o) {
  const i = t.getSortedVisibleDatasetMetas(), s = n[e];
  for (let a = 0, l = i.length; a < l; ++a) {
    const { index: c, data: u } = i[a], { lo: d, hi: f } = Fy(i[a], e, s, o);
    for (let h = d; h <= f; ++h) {
      const p = u[h];
      p.skip || r(p, c, h);
    }
  }
}
function Vy(t) {
  const e = t.indexOf("x") !== -1, n = t.indexOf("y") !== -1;
  return function(r, o) {
    const i = e ? Math.abs(r.x - o.x) : 0, s = n ? Math.abs(r.y - o.y) : 0;
    return Math.sqrt(Math.pow(i, 2) + Math.pow(s, 2));
  };
}
function Is(t, e, n, r, o) {
  const i = [];
  return !o && !t.isPointInArea(e) || ko(t, n, e, function(a, l, c) {
    !o && !gn(a, t.chartArea, 0) || a.inRange(e.x, e.y, r) && i.push({
      element: a,
      datasetIndex: l,
      index: c
    });
  }, !0), i;
}
function Wy(t, e, n, r) {
  let o = [];
  function i(s, a, l) {
    const { startAngle: c, endAngle: u } = s.getProps([
      "startAngle",
      "endAngle"
    ], r), { angle: d } = e1(s, {
      x: e.x,
      y: e.y
    });
    nh(d, c, u) && o.push({
      element: s,
      datasetIndex: a,
      index: l
    });
  }
  return ko(t, n, e, i), o;
}
function Hy(t, e, n, r, o, i) {
  let s = [];
  const a = Vy(n);
  let l = Number.POSITIVE_INFINITY;
  function c(u, d, f) {
    const h = u.inRange(e.x, e.y, o);
    if (r && !h)
      return;
    const p = u.getCenterPoint(o);
    if (!(!!i || t.isPointInArea(p)) && !h)
      return;
    const m = a(e, p);
    m < l ? (s = [
      {
        element: u,
        datasetIndex: d,
        index: f
      }
    ], l = m) : m === l && s.push({
      element: u,
      datasetIndex: d,
      index: f
    });
  }
  return ko(t, n, e, c), s;
}
function Ts(t, e, n, r, o, i) {
  return !i && !t.isPointInArea(e) ? [] : n === "r" && !r ? Wy(t, e, n, o) : Hy(t, e, n, r, o, i);
}
function yu(t, e, n, r, o) {
  const i = [], s = n === "x" ? "inXRange" : "inYRange";
  let a = !1;
  return ko(t, n, e, (l, c, u) => {
    l[s](e[n], o) && (i.push({
      element: l,
      datasetIndex: c,
      index: u
    }), a = a || l.inRange(e.x, e.y, o));
  }), r && !a ? [] : i;
}
var By = {
  evaluateInteractionItems: ko,
  modes: {
    index(t, e, n, r) {
      const o = qn(e, t), i = n.axis || "x", s = n.includeInvisible || !1, a = n.intersect ? Is(t, o, i, r, s) : Ts(t, o, i, !1, r, s), l = [];
      return a.length ? (t.getSortedVisibleDatasetMetas().forEach((c) => {
        const u = a[0].index, d = c.data[u];
        d && !d.skip && l.push({
          element: d,
          datasetIndex: c.index,
          index: u
        });
      }), l) : [];
    },
    dataset(t, e, n, r) {
      const o = qn(e, t), i = n.axis || "xy", s = n.includeInvisible || !1;
      let a = n.intersect ? Is(t, o, i, r, s) : Ts(t, o, i, !1, r, s);
      if (a.length > 0) {
        const l = a[0].datasetIndex, c = t.getDatasetMeta(l).data;
        a = [];
        for (let u = 0; u < c.length; ++u)
          a.push({
            element: c[u],
            datasetIndex: l,
            index: u
          });
      }
      return a;
    },
    point(t, e, n, r) {
      const o = qn(e, t), i = n.axis || "xy", s = n.includeInvisible || !1;
      return Is(t, o, i, r, s);
    },
    nearest(t, e, n, r) {
      const o = qn(e, t), i = n.axis || "xy", s = n.includeInvisible || !1;
      return Ts(t, o, i, n.intersect, r, s);
    },
    x(t, e, n, r) {
      const o = qn(e, t);
      return yu(t, o, "x", n.intersect, r);
    },
    y(t, e, n, r) {
      const o = qn(e, t);
      return yu(t, o, "y", n.intersect, r);
    }
  }
};
const Ch = [
  "left",
  "top",
  "right",
  "bottom"
];
function zr(t, e) {
  return t.filter((n) => n.pos === e);
}
function wu(t, e) {
  return t.filter((n) => Ch.indexOf(n.pos) === -1 && n.box.axis === e);
}
function Ur(t, e) {
  return t.sort((n, r) => {
    const o = e ? r : n, i = e ? n : r;
    return o.weight === i.weight ? o.index - i.index : o.weight - i.weight;
  });
}
function jy(t) {
  const e = [];
  let n, r, o, i, s, a;
  for (n = 0, r = (t || []).length; n < r; ++n)
    o = t[n], { position: i, options: { stack: s, stackWeight: a = 1 } } = o, e.push({
      index: n,
      box: o,
      pos: i,
      horizontal: o.isHorizontal(),
      weight: o.weight,
      stack: s && i + s,
      stackWeight: a
    });
  return e;
}
function zy(t) {
  const e = {};
  for (const n of t) {
    const { stack: r, pos: o, stackWeight: i } = n;
    if (!r || !Ch.includes(o))
      continue;
    const s = e[r] || (e[r] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    s.count++, s.weight += i;
  }
  return e;
}
function Uy(t, e) {
  const n = zy(t), { vBoxMaxWidth: r, hBoxMaxHeight: o } = e;
  let i, s, a;
  for (i = 0, s = t.length; i < s; ++i) {
    a = t[i];
    const { fullSize: l } = a.box, c = n[a.stack], u = c && a.stackWeight / c.weight;
    a.horizontal ? (a.width = u ? u * r : l && e.availableWidth, a.height = o) : (a.width = r, a.height = u ? u * o : l && e.availableHeight);
  }
  return n;
}
function Yy(t) {
  const e = jy(t), n = Ur(e.filter((c) => c.box.fullSize), !0), r = Ur(zr(e, "left"), !0), o = Ur(zr(e, "right")), i = Ur(zr(e, "top"), !0), s = Ur(zr(e, "bottom")), a = wu(e, "x"), l = wu(e, "y");
  return {
    fullSize: n,
    leftAndTop: r.concat(i),
    rightAndBottom: o.concat(l).concat(s).concat(a),
    chartArea: zr(e, "chartArea"),
    vertical: r.concat(o).concat(l),
    horizontal: i.concat(s).concat(a)
  };
}
function xu(t, e, n, r) {
  return Math.max(t[n], e[n]) + Math.max(t[r], e[r]);
}
function Eh(t, e) {
  t.top = Math.max(t.top, e.top), t.left = Math.max(t.left, e.left), t.bottom = Math.max(t.bottom, e.bottom), t.right = Math.max(t.right, e.right);
}
function Ky(t, e, n, r) {
  const { pos: o, box: i } = n, s = t.maxPadding;
  if (!Se(o)) {
    n.size && (t[o] -= n.size);
    const d = r[n.stack] || {
      size: 0,
      count: 1
    };
    d.size = Math.max(d.size, n.horizontal ? i.height : i.width), n.size = d.size / d.count, t[o] += n.size;
  }
  i.getPadding && Eh(s, i.getPadding());
  const a = Math.max(0, e.outerWidth - xu(s, t, "left", "right")), l = Math.max(0, e.outerHeight - xu(s, t, "top", "bottom")), c = a !== t.w, u = l !== t.h;
  return t.w = a, t.h = l, n.horizontal ? {
    same: c,
    other: u
  } : {
    same: u,
    other: c
  };
}
function Gy(t) {
  const e = t.maxPadding;
  function n(r) {
    const o = Math.max(e[r] - t[r], 0);
    return t[r] += o, o;
  }
  t.y += n("top"), t.x += n("left"), n("right"), n("bottom");
}
function qy(t, e) {
  const n = e.maxPadding;
  function r(o) {
    const i = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    return o.forEach((s) => {
      i[s] = Math.max(e[s], n[s]);
    }), i;
  }
  return r(t ? [
    "left",
    "right"
  ] : [
    "top",
    "bottom"
  ]);
}
function Jr(t, e, n, r) {
  const o = [];
  let i, s, a, l, c, u;
  for (i = 0, s = t.length, c = 0; i < s; ++i) {
    a = t[i], l = a.box, l.update(a.width || e.w, a.height || e.h, qy(a.horizontal, e));
    const { same: d, other: f } = Ky(e, n, a, r);
    c |= d && o.length, u = u || f, l.fullSize || o.push(a);
  }
  return c && Jr(o, e, n, r) || u;
}
function Uo(t, e, n, r, o) {
  t.top = n, t.left = e, t.right = e + r, t.bottom = n + o, t.width = r, t.height = o;
}
function _u(t, e, n, r) {
  const o = n.padding;
  let { x: i, y: s } = e;
  for (const a of t) {
    const l = a.box, c = r[a.stack] || {
      count: 1,
      placed: 0,
      weight: 1
    }, u = a.stackWeight / c.weight || 1;
    if (a.horizontal) {
      const d = e.w * u, f = c.size || l.height;
      vo(c.start) && (s = c.start), l.fullSize ? Uo(l, o.left, s, n.outerWidth - o.right - o.left, f) : Uo(l, e.left + c.placed, s, d, f), c.start = s, c.placed += d, s = l.bottom;
    } else {
      const d = e.h * u, f = c.size || l.width;
      vo(c.start) && (i = c.start), l.fullSize ? Uo(l, i, o.top, f, n.outerHeight - o.bottom - o.top) : Uo(l, i, e.top + c.placed, f, d), c.start = i, c.placed += d, i = l.right;
    }
  }
  e.x = i, e.y = s;
}
var Yo = {
  addBox(t, e) {
    t.boxes || (t.boxes = []), e.fullSize = e.fullSize || !1, e.position = e.position || "top", e.weight = e.weight || 0, e._layers = e._layers || function() {
      return [
        {
          z: 0,
          draw(n) {
            e.draw(n);
          }
        }
      ];
    }, t.boxes.push(e);
  },
  removeBox(t, e) {
    const n = t.boxes ? t.boxes.indexOf(e) : -1;
    n !== -1 && t.boxes.splice(n, 1);
  },
  configure(t, e, n) {
    e.fullSize = n.fullSize, e.position = n.position, e.weight = n.weight;
  },
  update(t, e, n, r) {
    if (!t)
      return;
    const o = Lt(t.options.layout.padding), i = Math.max(e - o.width, 0), s = Math.max(n - o.height, 0), a = Yy(t.boxes), l = a.vertical, c = a.horizontal;
    Le(t.boxes, (g) => {
      typeof g.beforeLayout == "function" && g.beforeLayout();
    });
    const u = l.reduce((g, m) => m.box.options && m.box.options.display === !1 ? g : g + 1, 0) || 1, d = Object.freeze({
      outerWidth: e,
      outerHeight: n,
      padding: o,
      availableWidth: i,
      availableHeight: s,
      vBoxMaxWidth: i / 2 / u,
      hBoxMaxHeight: s / 2
    }), f = Object.assign({}, o);
    Eh(f, Lt(r));
    const h = Object.assign({
      maxPadding: f,
      w: i,
      h: s,
      x: o.left,
      y: o.top
    }, o), p = Uy(l.concat(c), d);
    Jr(a.fullSize, h, d, p), Jr(l, h, d, p), Jr(c, h, d, p) && Jr(l, h, d, p), Gy(h), _u(a.leftAndTop, h, d, p), h.x += h.w, h.y += h.h, _u(a.rightAndBottom, h, d, p), t.chartArea = {
      left: h.left,
      top: h.top,
      right: h.left + h.w,
      bottom: h.top + h.h,
      height: h.h,
      width: h.w
    }, Le(a.chartArea, (g) => {
      const m = g.box;
      Object.assign(m, t.chartArea), m.update(h.w, h.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
class Mh {
  acquireContext(e, n) {
  }
  releaseContext(e) {
    return !1;
  }
  addEventListener(e, n, r) {
  }
  removeEventListener(e, n, r) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(e, n, r, o) {
    return n = Math.max(0, n || e.width), r = r || e.height, {
      width: n,
      height: Math.max(0, o ? Math.floor(n / o) : r)
    };
  }
  isAttached(e) {
    return !0;
  }
  updateConfig(e) {
  }
}
class Xy extends Mh {
  acquireContext(e) {
    return e && e.getContext && e.getContext("2d") || null;
  }
  updateConfig(e) {
    e.options.animation = !1;
  }
}
const pi = "$chartjs", Zy = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, Cu = (t) => t === null || t === "";
function Qy(t, e) {
  const n = t.style, r = t.getAttribute("height"), o = t.getAttribute("width");
  if (t[pi] = {
    initial: {
      height: r,
      width: o,
      style: {
        display: n.display,
        height: n.height,
        width: n.width
      }
    }
  }, n.display = n.display || "block", n.boxSizing = n.boxSizing || "border-box", Cu(o)) {
    const i = iu(t, "width");
    i !== void 0 && (t.width = i);
  }
  if (Cu(r))
    if (t.style.height === "")
      t.height = t.width / (e || 2);
    else {
      const i = iu(t, "height");
      i !== void 0 && (t.height = i);
    }
  return t;
}
const kh = J1 ? {
  passive: !0
} : !1;
function Jy(t, e, n) {
  t.addEventListener(e, n, kh);
}
function ew(t, e, n) {
  t.canvas.removeEventListener(e, n, kh);
}
function tw(t, e) {
  const n = Zy[t.type] || t.type, { x: r, y: o } = qn(t, e);
  return {
    type: n,
    chart: e,
    native: t,
    x: r !== void 0 ? r : null,
    y: o !== void 0 ? o : null
  };
}
function Fi(t, e) {
  for (const n of t)
    if (n === e || n.contains(e))
      return !0;
}
function nw(t, e, n) {
  const r = t.canvas, o = new MutationObserver((i) => {
    let s = !1;
    for (const a of i)
      s = s || Fi(a.addedNodes, r), s = s && !Fi(a.removedNodes, r);
    s && n();
  });
  return o.observe(document, {
    childList: !0,
    subtree: !0
  }), o;
}
function rw(t, e, n) {
  const r = t.canvas, o = new MutationObserver((i) => {
    let s = !1;
    for (const a of i)
      s = s || Fi(a.removedNodes, r), s = s && !Fi(a.addedNodes, r);
    s && n();
  });
  return o.observe(document, {
    childList: !0,
    subtree: !0
  }), o;
}
const yo = /* @__PURE__ */ new Map();
let Eu = 0;
function Oh() {
  const t = window.devicePixelRatio;
  t !== Eu && (Eu = t, yo.forEach((e, n) => {
    n.currentDevicePixelRatio !== t && e();
  }));
}
function ow(t, e) {
  yo.size || window.addEventListener("resize", Oh), yo.set(t, e);
}
function iw(t) {
  yo.delete(t), yo.size || window.removeEventListener("resize", Oh);
}
function sw(t, e, n) {
  const r = t.canvas, o = r && El(r);
  if (!o)
    return;
  const i = sh((a, l) => {
    const c = o.clientWidth;
    n(a, l), c < o.clientWidth && n();
  }, window), s = new ResizeObserver((a) => {
    const l = a[0], c = l.contentRect.width, u = l.contentRect.height;
    c === 0 && u === 0 || i(c, u);
  });
  return s.observe(o), ow(t, i), s;
}
function Ds(t, e, n) {
  n && n.disconnect(), e === "resize" && iw(t);
}
function aw(t, e, n) {
  const r = t.canvas, o = sh((i) => {
    t.ctx !== null && n(tw(i, t));
  }, t);
  return Jy(r, e, o), o;
}
class lw extends Mh {
  acquireContext(e, n) {
    const r = e && e.getContext && e.getContext("2d");
    return r && r.canvas === e ? (Qy(e, n), r) : null;
  }
  releaseContext(e) {
    const n = e.canvas;
    if (!n[pi])
      return !1;
    const r = n[pi].initial;
    [
      "height",
      "width"
    ].forEach((i) => {
      const s = r[i];
      Ve(s) ? n.removeAttribute(i) : n.setAttribute(i, s);
    });
    const o = r.style || {};
    return Object.keys(o).forEach((i) => {
      n.style[i] = o[i];
    }), n.width = n.width, delete n[pi], !0;
  }
  addEventListener(e, n, r) {
    this.removeEventListener(e, n);
    const o = e.$proxies || (e.$proxies = {}), s = {
      attach: nw,
      detach: rw,
      resize: sw
    }[n] || aw;
    o[n] = s(e, n, r);
  }
  removeEventListener(e, n) {
    const r = e.$proxies || (e.$proxies = {}), o = r[n];
    if (!o)
      return;
    ({
      attach: Ds,
      detach: Ds,
      resize: Ds
    }[n] || ew)(e, n, o), r[n] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(e, n, r, o) {
    return Q1(e, n, r, o);
  }
  isAttached(e) {
    const n = El(e);
    return !!(n && n.isConnected);
  }
}
function cw(t) {
  return !vh() || typeof OffscreenCanvas < "u" && t instanceof OffscreenCanvas ? Xy : lw;
}
var ui;
let Ar = (ui = class {
  constructor() {
    fe(this, "x");
    fe(this, "y");
    fe(this, "active", !1);
    fe(this, "options");
    fe(this, "$animations");
  }
  tooltipPosition(e) {
    const { x: n, y: r } = this.getProps([
      "x",
      "y"
    ], e);
    return {
      x: n,
      y: r
    };
  }
  hasValue() {
    return bo(this.x) && bo(this.y);
  }
  getProps(e, n) {
    const r = this.$animations;
    if (!n || !r)
      return this;
    const o = {};
    return e.forEach((i) => {
      o[i] = r[i] && r[i].active() ? r[i]._to : this[i];
    }), o;
  }
}, fe(ui, "defaults", {}), fe(ui, "defaultRoutes"), ui);
function uw(t, e) {
  const n = t.options.ticks, r = dw(t), o = Math.min(n.maxTicksLimit || r, r), i = n.major.enabled ? hw(e) : [], s = i.length, a = i[0], l = i[s - 1], c = [];
  if (s > o)
    return pw(e, c, i, s / o), c;
  const u = fw(i, e, o);
  if (s > 0) {
    let d, f;
    const h = s > 1 ? Math.round((l - a) / (s - 1)) : null;
    for (Ko(e, c, u, Ve(h) ? 0 : a - h, a), d = 0, f = s - 1; d < f; d++)
      Ko(e, c, u, i[d], i[d + 1]);
    return Ko(e, c, u, l, Ve(h) ? e.length : l + h), c;
  }
  return Ko(e, c, u), c;
}
function dw(t) {
  const e = t.options.offset, n = t._tickSize(), r = t._length / n + (e ? 0 : 1), o = t._maxLength / n;
  return Math.floor(Math.min(r, o));
}
function fw(t, e, n) {
  const r = gw(t), o = e.length / n;
  if (!r)
    return Math.max(o, 1);
  const i = Qb(r);
  for (let s = 0, a = i.length - 1; s < a; s++) {
    const l = i[s];
    if (l > o)
      return l;
  }
  return Math.max(o, 1);
}
function hw(t) {
  const e = [];
  let n, r;
  for (n = 0, r = t.length; n < r; n++)
    t[n].major && e.push(n);
  return e;
}
function pw(t, e, n, r) {
  let o = 0, i = n[0], s;
  for (r = Math.ceil(r), s = 0; s < t.length; s++)
    s === i && (e.push(t[s]), o++, i = n[o * r]);
}
function Ko(t, e, n, r, o) {
  const i = Fe(r, 0), s = Math.min(Fe(o, t.length), t.length);
  let a = 0, l, c, u;
  for (n = Math.ceil(n), o && (l = o - r, n = l / Math.floor(l / n)), u = i; u < 0; )
    a++, u = Math.round(i + a * n);
  for (c = Math.max(i, 0); c < s; c++)
    c === u && (e.push(t[c]), a++, u = Math.round(i + a * n));
}
function gw(t) {
  const e = t.length;
  let n, r;
  if (e < 2)
    return !1;
  for (r = t[0], n = 1; n < e; ++n)
    if (t[n] - t[n - 1] !== r)
      return !1;
  return r;
}
const mw = (t) => t === "left" ? "right" : t === "right" ? "left" : t, Mu = (t, e, n) => e === "top" || e === "left" ? t[e] + n : t[e] - n, ku = (t, e) => Math.min(e || t, t);
function Ou(t, e) {
  const n = [], r = t.length / e, o = t.length;
  let i = 0;
  for (; i < o; i += r)
    n.push(t[Math.floor(i)]);
  return n;
}
function vw(t, e, n) {
  const r = t.ticks.length, o = Math.min(e, r - 1), i = t._startPixel, s = t._endPixel, a = 1e-6;
  let l = t.getPixelForTick(o), c;
  if (!(n && (r === 1 ? c = Math.max(l - i, s - l) : e === 0 ? c = (t.getPixelForTick(1) - l) / 2 : c = (l - t.getPixelForTick(o - 1)) / 2, l += o < e ? c : -c, l < i - a || l > s + a)))
    return l;
}
function bw(t, e) {
  Le(t, (n) => {
    const r = n.gc, o = r.length / 2;
    let i;
    if (o > e) {
      for (i = 0; i < o; ++i)
        delete n.data[r[i]];
      r.splice(0, o);
    }
  });
}
function Yr(t) {
  return t.drawTicks ? t.tickLength : 0;
}
function Su(t, e) {
  if (!t.display)
    return 0;
  const n = kt(t.font, e), r = Lt(t.padding);
  return (Ye(t.text) ? t.text.length : 1) * n.lineHeight + r.height;
}
function yw(t, e) {
  return Bn(t, {
    scale: e,
    type: "scale"
  });
}
function ww(t, e, n) {
  return Bn(t, {
    tick: n,
    index: e,
    type: "tick"
  });
}
function xw(t, e, n) {
  let r = a1(t);
  return (n && e !== "right" || !n && e === "right") && (r = mw(r)), r;
}
function _w(t, e, n, r) {
  const { top: o, left: i, bottom: s, right: a, chart: l } = t, { chartArea: c, scales: u } = l;
  let d = 0, f, h, p;
  const g = s - o, m = a - i;
  if (t.isHorizontal()) {
    if (h = Xc(r, i, a), Se(n)) {
      const b = Object.keys(n)[0], v = n[b];
      p = u[b].getPixelForValue(v) + g - e;
    } else
      n === "center" ? p = (c.bottom + c.top) / 2 + g - e : p = Mu(t, n, e);
    f = a - i;
  } else {
    if (Se(n)) {
      const b = Object.keys(n)[0], v = n[b];
      h = u[b].getPixelForValue(v) - m + e;
    } else
      n === "center" ? h = (c.left + c.right) / 2 - m + e : h = Mu(t, n, e);
    p = Xc(r, s, o), d = n === "left" ? -wt : wt;
  }
  return {
    titleX: h,
    titleY: p,
    maxWidth: f,
    rotation: d
  };
}
class ur extends Ar {
  constructor(e) {
    super(), this.id = e.id, this.type = e.type, this.options = void 0, this.ctx = e.ctx, this.chart = e.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(e) {
    this.options = e.setContext(this.getContext()), this.axis = e.axis, this._userMin = this.parse(e.min), this._userMax = this.parse(e.max), this._suggestedMin = this.parse(e.suggestedMin), this._suggestedMax = this.parse(e.suggestedMax);
  }
  parse(e, n) {
    return e;
  }
  getUserBounds() {
    let { _userMin: e, _userMax: n, _suggestedMin: r, _suggestedMax: o } = this;
    return e = _t(e, Number.POSITIVE_INFINITY), n = _t(n, Number.NEGATIVE_INFINITY), r = _t(r, Number.POSITIVE_INFINITY), o = _t(o, Number.NEGATIVE_INFINITY), {
      min: _t(e, r),
      max: _t(n, o),
      minDefined: it(e),
      maxDefined: it(n)
    };
  }
  getMinMax(e) {
    let { min: n, max: r, minDefined: o, maxDefined: i } = this.getUserBounds(), s;
    if (o && i)
      return {
        min: n,
        max: r
      };
    const a = this.getMatchingVisibleMetas();
    for (let l = 0, c = a.length; l < c; ++l)
      s = a[l].controller.getMinMax(this, e), o || (n = Math.min(n, s.min)), i || (r = Math.max(r, s.max));
    return n = i && n > r ? r : n, r = o && n > r ? n : r, {
      min: _t(n, _t(r, n)),
      max: _t(r, _t(n, r))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const e = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? e.xLabels : e.yLabels) || e.labels || [];
  }
  getLabelItems(e = this.chart.chartArea) {
    return this._labelItems || (this._labelItems = this._computeLabelItems(e));
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    Ge(this.options.beforeUpdate, [
      this
    ]);
  }
  update(e, n, r) {
    const { beginAtZero: o, grace: i, ticks: s } = this.options, a = s.sampleSize;
    this.beforeUpdate(), this.maxWidth = e, this.maxHeight = n, this._margins = r = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, r), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + r.left + r.right : this.height + r.top + r.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = I1(this, i, o), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const l = a < this.ticks.length;
    this._convertTicksToLabels(l ? Ou(this.ticks, a) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), s.display && (s.autoSkip || s.source === "auto") && (this.ticks = uw(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), l && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let e = this.options.reverse, n, r;
    this.isHorizontal() ? (n = this.left, r = this.right) : (n = this.top, r = this.bottom, e = !e), this._startPixel = n, this._endPixel = r, this._reversePixels = e, this._length = r - n, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    Ge(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    Ge(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    Ge(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(e) {
    this.chart.notifyPlugins(e, this.getContext()), Ge(this.options[e], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    Ge(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(e) {
    const n = this.options.ticks;
    let r, o, i;
    for (r = 0, o = e.length; r < o; r++)
      i = e[r], i.label = Ge(n.callback, [
        i.value,
        r,
        e
      ], this);
  }
  afterTickToLabelConversion() {
    Ge(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    Ge(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const e = this.options, n = e.ticks, r = ku(this.ticks.length, e.ticks.maxTicksLimit), o = n.minRotation || 0, i = n.maxRotation;
    let s = o, a, l, c;
    if (!this._isVisible() || !n.display || o >= i || r <= 1 || !this.isHorizontal()) {
      this.labelRotation = o;
      return;
    }
    const u = this._getLabelSizes(), d = u.widest.width, f = u.highest.height, h = Mt(this.chart.width - d, 0, this.maxWidth);
    a = e.offset ? this.maxWidth / r : h / (r - 1), d + 6 > a && (a = h / (r - (e.offset ? 0.5 : 1)), l = this.maxHeight - Yr(e.grid) - n.padding - Su(e.title, this.chart.options.font), c = Math.sqrt(d * d + f * f), s = vl(Math.min(Math.asin(Mt((u.highest.height + 6) / a, -1, 1)), Math.asin(Mt(l / c, -1, 1)) - Math.asin(Mt(f / c, -1, 1)))), s = Math.max(o, Math.min(i, s))), this.labelRotation = s;
  }
  afterCalculateLabelRotation() {
    Ge(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    Ge(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const e = {
      width: 0,
      height: 0
    }, { chart: n, options: { ticks: r, title: o, grid: i } } = this, s = this._isVisible(), a = this.isHorizontal();
    if (s) {
      const l = Su(o, n.options.font);
      if (a ? (e.width = this.maxWidth, e.height = Yr(i) + l) : (e.height = this.maxHeight, e.width = Yr(i) + l), r.display && this.ticks.length) {
        const { first: c, last: u, widest: d, highest: f } = this._getLabelSizes(), h = r.padding * 2, p = In(this.labelRotation), g = Math.cos(p), m = Math.sin(p);
        if (a) {
          const b = r.mirror ? 0 : m * d.width + g * f.height;
          e.height = Math.min(this.maxHeight, e.height + b + h);
        } else {
          const b = r.mirror ? 0 : g * d.width + m * f.height;
          e.width = Math.min(this.maxWidth, e.width + b + h);
        }
        this._calculatePadding(c, u, m, g);
      }
    }
    this._handleMargins(), a ? (this.width = this._length = n.width - this._margins.left - this._margins.right, this.height = e.height) : (this.width = e.width, this.height = this._length = n.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(e, n, r, o) {
    const { ticks: { align: i, padding: s }, position: a } = this.options, l = this.labelRotation !== 0, c = a !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const u = this.getPixelForTick(0) - this.left, d = this.right - this.getPixelForTick(this.ticks.length - 1);
      let f = 0, h = 0;
      l ? c ? (f = o * e.width, h = r * n.height) : (f = r * e.height, h = o * n.width) : i === "start" ? h = n.width : i === "end" ? f = e.width : i !== "inner" && (f = e.width / 2, h = n.width / 2), this.paddingLeft = Math.max((f - u + s) * this.width / (this.width - u), 0), this.paddingRight = Math.max((h - d + s) * this.width / (this.width - d), 0);
    } else {
      let u = n.height / 2, d = e.height / 2;
      i === "start" ? (u = 0, d = e.height) : i === "end" && (u = n.height, d = 0), this.paddingTop = u + s, this.paddingBottom = d + s;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    Ge(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis: e, position: n } = this.options;
    return n === "top" || n === "bottom" || e === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(e) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(e);
    let n, r;
    for (n = 0, r = e.length; n < r; n++)
      Ve(e[n].label) && (e.splice(n, 1), r--, n--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let e = this._labelSizes;
    if (!e) {
      const n = this.options.ticks.sampleSize;
      let r = this.ticks;
      n < r.length && (r = Ou(r, n)), this._labelSizes = e = this._computeLabelSizes(r, r.length, this.options.ticks.maxTicksLimit);
    }
    return e;
  }
  _computeLabelSizes(e, n, r) {
    const { ctx: o, _longestTextCache: i } = this, s = [], a = [], l = Math.floor(n / ku(n, r));
    let c = 0, u = 0, d, f, h, p, g, m, b, v, _, x, y;
    for (d = 0; d < n; d += l) {
      if (p = e[d].label, g = this._resolveTickFontOptions(d), o.font = m = g.string, b = i[m] = i[m] || {
        data: {},
        gc: []
      }, v = g.lineHeight, _ = x = 0, !Ve(p) && !Ye(p))
        _ = Ni(o, b.data, b.gc, _, p), x = v;
      else if (Ye(p))
        for (f = 0, h = p.length; f < h; ++f)
          y = p[f], !Ve(y) && !Ye(y) && (_ = Ni(o, b.data, b.gc, _, y), x += v);
      s.push(_), a.push(x), c = Math.max(_, c), u = Math.max(x, u);
    }
    bw(i, n);
    const M = s.indexOf(c), k = a.indexOf(u), O = (S) => ({
      width: s[S] || 0,
      height: a[S] || 0
    });
    return {
      first: O(0),
      last: O(n - 1),
      widest: O(M),
      highest: O(k),
      widths: s,
      heights: a
    };
  }
  getLabelForValue(e) {
    return e;
  }
  getPixelForValue(e, n) {
    return NaN;
  }
  getValueForPixel(e) {
  }
  getPixelForTick(e) {
    const n = this.ticks;
    return e < 0 || e > n.length - 1 ? null : this.getPixelForValue(n[e].value);
  }
  getPixelForDecimal(e) {
    this._reversePixels && (e = 1 - e);
    const n = this._startPixel + e * this._length;
    return n1(this._alignToPixels ? Yn(this.chart, n, 0) : n);
  }
  getDecimalForPixel(e) {
    const n = (e - this._startPixel) / this._length;
    return this._reversePixels ? 1 - n : n;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: e, max: n } = this;
    return e < 0 && n < 0 ? n : e > 0 && n > 0 ? e : 0;
  }
  getContext(e) {
    const n = this.ticks || [];
    if (e >= 0 && e < n.length) {
      const r = n[e];
      return r.$context || (r.$context = ww(this.getContext(), e, r));
    }
    return this.$context || (this.$context = yw(this.chart.getContext(), this));
  }
  _tickSize() {
    const e = this.options.ticks, n = In(this.labelRotation), r = Math.abs(Math.cos(n)), o = Math.abs(Math.sin(n)), i = this._getLabelSizes(), s = e.autoSkipPadding || 0, a = i ? i.widest.width + s : 0, l = i ? i.highest.height + s : 0;
    return this.isHorizontal() ? l * r > a * o ? a / r : l / o : l * o < a * r ? l / r : a / o;
  }
  _isVisible() {
    const e = this.options.display;
    return e !== "auto" ? !!e : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(e) {
    const n = this.axis, r = this.chart, o = this.options, { grid: i, position: s, border: a } = o, l = i.offset, c = this.isHorizontal(), d = this.ticks.length + (l ? 1 : 0), f = Yr(i), h = [], p = a.setContext(this.getContext()), g = p.display ? p.width : 0, m = g / 2, b = function(Y) {
      return Yn(r, Y, g);
    };
    let v, _, x, y, M, k, O, S, D, P, N, T;
    if (s === "top")
      v = b(this.bottom), k = this.bottom - f, S = v - m, P = b(e.top) + m, T = e.bottom;
    else if (s === "bottom")
      v = b(this.top), P = e.top, T = b(e.bottom) - m, k = v + m, S = this.top + f;
    else if (s === "left")
      v = b(this.right), M = this.right - f, O = v - m, D = b(e.left) + m, N = e.right;
    else if (s === "right")
      v = b(this.left), D = e.left, N = b(e.right) - m, M = v + m, O = this.left + f;
    else if (n === "x") {
      if (s === "center")
        v = b((e.top + e.bottom) / 2 + 0.5);
      else if (Se(s)) {
        const Y = Object.keys(s)[0], V = s[Y];
        v = b(this.chart.scales[Y].getPixelForValue(V));
      }
      P = e.top, T = e.bottom, k = v + m, S = k + f;
    } else if (n === "y") {
      if (s === "center")
        v = b((e.left + e.right) / 2);
      else if (Se(s)) {
        const Y = Object.keys(s)[0], V = s[Y];
        v = b(this.chart.scales[Y].getPixelForValue(V));
      }
      M = v - m, O = M - f, D = e.left, N = e.right;
    }
    const U = Fe(o.ticks.maxTicksLimit, d), R = Math.max(1, Math.ceil(d / U));
    for (_ = 0; _ < d; _ += R) {
      const Y = this.getContext(_), V = i.setContext(Y), z = a.setContext(Y), ee = V.lineWidth, $ = V.color, F = z.dash || [], te = z.dashOffset, J = V.tickWidth, re = V.tickColor, j = V.tickBorderDash || [], A = V.tickBorderDashOffset;
      x = vw(this, _, l), x !== void 0 && (y = Yn(r, x, ee), c ? M = O = D = N = y : k = S = P = T = y, h.push({
        tx1: M,
        ty1: k,
        tx2: O,
        ty2: S,
        x1: D,
        y1: P,
        x2: N,
        y2: T,
        width: ee,
        color: $,
        borderDash: F,
        borderDashOffset: te,
        tickWidth: J,
        tickColor: re,
        tickBorderDash: j,
        tickBorderDashOffset: A
      }));
    }
    return this._ticksLength = d, this._borderValue = v, h;
  }
  _computeLabelItems(e) {
    const n = this.axis, r = this.options, { position: o, ticks: i } = r, s = this.isHorizontal(), a = this.ticks, { align: l, crossAlign: c, padding: u, mirror: d } = i, f = Yr(r.grid), h = f + u, p = d ? -u : h, g = -In(this.labelRotation), m = [];
    let b, v, _, x, y, M, k, O, S, D, P, N, T = "middle";
    if (o === "top")
      M = this.bottom - p, k = this._getXAxisLabelAlignment();
    else if (o === "bottom")
      M = this.top + p, k = this._getXAxisLabelAlignment();
    else if (o === "left") {
      const R = this._getYAxisLabelAlignment(f);
      k = R.textAlign, y = R.x;
    } else if (o === "right") {
      const R = this._getYAxisLabelAlignment(f);
      k = R.textAlign, y = R.x;
    } else if (n === "x") {
      if (o === "center")
        M = (e.top + e.bottom) / 2 + h;
      else if (Se(o)) {
        const R = Object.keys(o)[0], Y = o[R];
        M = this.chart.scales[R].getPixelForValue(Y) + h;
      }
      k = this._getXAxisLabelAlignment();
    } else if (n === "y") {
      if (o === "center")
        y = (e.left + e.right) / 2 - h;
      else if (Se(o)) {
        const R = Object.keys(o)[0], Y = o[R];
        y = this.chart.scales[R].getPixelForValue(Y);
      }
      k = this._getYAxisLabelAlignment(f).textAlign;
    }
    n === "y" && (l === "start" ? T = "top" : l === "end" && (T = "bottom"));
    const U = this._getLabelSizes();
    for (b = 0, v = a.length; b < v; ++b) {
      _ = a[b], x = _.label;
      const R = i.setContext(this.getContext(b));
      O = this.getPixelForTick(b) + i.labelOffset, S = this._resolveTickFontOptions(b), D = S.lineHeight, P = Ye(x) ? x.length : 1;
      const Y = P / 2, V = R.color, z = R.textStrokeColor, ee = R.textStrokeWidth;
      let $ = k;
      s ? (y = O, k === "inner" && (b === v - 1 ? $ = this.options.reverse ? "left" : "right" : b === 0 ? $ = this.options.reverse ? "right" : "left" : $ = "center"), o === "top" ? c === "near" || g !== 0 ? N = -P * D + D / 2 : c === "center" ? N = -U.highest.height / 2 - Y * D + D : N = -U.highest.height + D / 2 : c === "near" || g !== 0 ? N = D / 2 : c === "center" ? N = U.highest.height / 2 - Y * D : N = U.highest.height - P * D, d && (N *= -1), g !== 0 && !R.showLabelBackdrop && (y += D / 2 * Math.sin(g))) : (M = O, N = (1 - P) * D / 2);
      let F;
      if (R.showLabelBackdrop) {
        const te = Lt(R.backdropPadding), J = U.heights[b], re = U.widths[b];
        let j = N - te.top, A = 0 - te.left;
        switch (T) {
          case "middle":
            j -= J / 2;
            break;
          case "bottom":
            j -= J;
            break;
        }
        switch (k) {
          case "center":
            A -= re / 2;
            break;
          case "right":
            A -= re;
            break;
        }
        F = {
          left: A,
          top: j,
          width: re + te.width,
          height: J + te.height,
          color: R.backdropColor
        };
      }
      m.push({
        label: x,
        font: S,
        textOffset: N,
        options: {
          rotation: g,
          color: V,
          strokeColor: z,
          strokeWidth: ee,
          textAlign: $,
          textBaseline: T,
          translation: [
            y,
            M
          ],
          backdrop: F
        }
      });
    }
    return m;
  }
  _getXAxisLabelAlignment() {
    const { position: e, ticks: n } = this.options;
    if (-In(this.labelRotation))
      return e === "top" ? "left" : "right";
    let o = "center";
    return n.align === "start" ? o = "left" : n.align === "end" ? o = "right" : n.align === "inner" && (o = "inner"), o;
  }
  _getYAxisLabelAlignment(e) {
    const { position: n, ticks: { crossAlign: r, mirror: o, padding: i } } = this.options, s = this._getLabelSizes(), a = e + i, l = s.widest.width;
    let c, u;
    return n === "left" ? o ? (u = this.right + i, r === "near" ? c = "left" : r === "center" ? (c = "center", u += l / 2) : (c = "right", u += l)) : (u = this.right - a, r === "near" ? c = "right" : r === "center" ? (c = "center", u -= l / 2) : (c = "left", u = this.left)) : n === "right" ? o ? (u = this.left + i, r === "near" ? c = "right" : r === "center" ? (c = "center", u -= l / 2) : (c = "left", u -= l)) : (u = this.left + a, r === "near" ? c = "left" : r === "center" ? (c = "center", u += l / 2) : (c = "right", u = this.right)) : c = "right", {
      textAlign: c,
      x: u
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const e = this.chart, n = this.options.position;
    if (n === "left" || n === "right")
      return {
        top: 0,
        left: this.left,
        bottom: e.height,
        right: this.right
      };
    if (n === "top" || n === "bottom")
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: e.width
      };
  }
  drawBackground() {
    const { ctx: e, options: { backgroundColor: n }, left: r, top: o, width: i, height: s } = this;
    n && (e.save(), e.fillStyle = n, e.fillRect(r, o, i, s), e.restore());
  }
  getLineWidthForValue(e) {
    const n = this.options.grid;
    if (!this._isVisible() || !n.display)
      return 0;
    const o = this.ticks.findIndex((i) => i.value === e);
    return o >= 0 ? n.setContext(this.getContext(o)).lineWidth : 0;
  }
  drawGrid(e) {
    const n = this.options.grid, r = this.ctx, o = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(e));
    let i, s;
    const a = (l, c, u) => {
      !u.width || !u.color || (r.save(), r.lineWidth = u.width, r.strokeStyle = u.color, r.setLineDash(u.borderDash || []), r.lineDashOffset = u.borderDashOffset, r.beginPath(), r.moveTo(l.x, l.y), r.lineTo(c.x, c.y), r.stroke(), r.restore());
    };
    if (n.display)
      for (i = 0, s = o.length; i < s; ++i) {
        const l = o[i];
        n.drawOnChartArea && a({
          x: l.x1,
          y: l.y1
        }, {
          x: l.x2,
          y: l.y2
        }, l), n.drawTicks && a({
          x: l.tx1,
          y: l.ty1
        }, {
          x: l.tx2,
          y: l.ty2
        }, {
          color: l.tickColor,
          width: l.tickWidth,
          borderDash: l.tickBorderDash,
          borderDashOffset: l.tickBorderDashOffset
        });
      }
  }
  drawBorder() {
    const { chart: e, ctx: n, options: { border: r, grid: o } } = this, i = r.setContext(this.getContext()), s = r.display ? i.width : 0;
    if (!s)
      return;
    const a = o.setContext(this.getContext(0)).lineWidth, l = this._borderValue;
    let c, u, d, f;
    this.isHorizontal() ? (c = Yn(e, this.left, s) - s / 2, u = Yn(e, this.right, a) + a / 2, d = f = l) : (d = Yn(e, this.top, s) - s / 2, f = Yn(e, this.bottom, a) + a / 2, c = u = l), n.save(), n.lineWidth = i.width, n.strokeStyle = i.color, n.beginPath(), n.moveTo(c, d), n.lineTo(u, f), n.stroke(), n.restore();
  }
  drawLabels(e) {
    if (!this.options.ticks.display)
      return;
    const r = this.ctx, o = this._computeLabelArea();
    o && lh(r, o);
    const i = this.getLabelItems(e);
    for (const s of i) {
      const a = s.options, l = s.font, c = s.label, u = s.textOffset;
      Ri(r, c, 0, u, l, a);
    }
    o && ch(r);
  }
  drawTitle() {
    const { ctx: e, options: { position: n, title: r, reverse: o } } = this;
    if (!r.display)
      return;
    const i = kt(r.font), s = Lt(r.padding), a = r.align;
    let l = i.lineHeight / 2;
    n === "bottom" || n === "center" || Se(n) ? (l += s.bottom, Ye(r.text) && (l += i.lineHeight * (r.text.length - 1))) : l += s.top;
    const { titleX: c, titleY: u, maxWidth: d, rotation: f } = _w(this, l, n, a);
    Ri(e, r.text, 0, 0, i, {
      color: r.color,
      maxWidth: d,
      rotation: f,
      textAlign: xw(a, n, o),
      textBaseline: "middle",
      translation: [
        c,
        u
      ]
    });
  }
  draw(e) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(e), this.drawBorder(), this.drawTitle(), this.drawLabels(e));
  }
  _layers() {
    const e = this.options, n = e.ticks && e.ticks.z || 0, r = Fe(e.grid && e.grid.z, -1), o = Fe(e.border && e.border.z, 0);
    return !this._isVisible() || this.draw !== ur.prototype.draw ? [
      {
        z: n,
        draw: (i) => {
          this.draw(i);
        }
      }
    ] : [
      {
        z: r,
        draw: (i) => {
          this.drawBackground(), this.drawGrid(i), this.drawTitle();
        }
      },
      {
        z: o,
        draw: () => {
          this.drawBorder();
        }
      },
      {
        z: n,
        draw: (i) => {
          this.drawLabels(i);
        }
      }
    ];
  }
  getMatchingVisibleMetas(e) {
    const n = this.chart.getSortedVisibleDatasetMetas(), r = this.axis + "AxisID", o = [];
    let i, s;
    for (i = 0, s = n.length; i < s; ++i) {
      const a = n[i];
      a[r] === this.id && (!e || a.type === e) && o.push(a);
    }
    return o;
  }
  _resolveTickFontOptions(e) {
    const n = this.options.ticks.setContext(this.getContext(e));
    return kt(n.font);
  }
  _maxDigits() {
    const e = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / e;
  }
}
class Go {
  constructor(e, n, r) {
    this.type = e, this.scope = n, this.override = r, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(e) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, e.prototype);
  }
  register(e) {
    const n = Object.getPrototypeOf(e);
    let r;
    Mw(n) && (r = this.register(n));
    const o = this.items, i = e.id, s = this.scope + "." + i;
    if (!i)
      throw new Error("class does not have id: " + e);
    return i in o || (o[i] = e, Cw(e, s, r), this.override && Ze.override(e.id, e.overrides)), s;
  }
  get(e) {
    return this.items[e];
  }
  unregister(e) {
    const n = this.items, r = e.id, o = this.scope;
    r in n && delete n[r], o && r in Ze[o] && (delete Ze[o][r], this.override && delete or[r]);
  }
}
function Cw(t, e, n) {
  const r = mo(/* @__PURE__ */ Object.create(null), [
    n ? Ze.get(n) : {},
    Ze.get(e),
    t.defaults
  ]);
  Ze.set(e, r), t.defaultRoutes && Ew(e, t.defaultRoutes), t.descriptors && Ze.describe(e, t.descriptors);
}
function Ew(t, e) {
  Object.keys(e).forEach((n) => {
    const r = n.split("."), o = r.pop(), i = [
      t
    ].concat(r).join("."), s = e[n].split("."), a = s.pop(), l = s.join(".");
    Ze.route(i, o, l, a);
  });
}
function Mw(t) {
  return "id" in t && "defaults" in t;
}
class kw {
  constructor() {
    this.controllers = new Go(Mr, "datasets", !0), this.elements = new Go(Ar, "elements"), this.plugins = new Go(Object, "plugins"), this.scales = new Go(ur, "scales"), this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...e) {
    this._each("register", e);
  }
  remove(...e) {
    this._each("unregister", e);
  }
  addControllers(...e) {
    this._each("register", e, this.controllers);
  }
  addElements(...e) {
    this._each("register", e, this.elements);
  }
  addPlugins(...e) {
    this._each("register", e, this.plugins);
  }
  addScales(...e) {
    this._each("register", e, this.scales);
  }
  getController(e) {
    return this._get(e, this.controllers, "controller");
  }
  getElement(e) {
    return this._get(e, this.elements, "element");
  }
  getPlugin(e) {
    return this._get(e, this.plugins, "plugin");
  }
  getScale(e) {
    return this._get(e, this.scales, "scale");
  }
  removeControllers(...e) {
    this._each("unregister", e, this.controllers);
  }
  removeElements(...e) {
    this._each("unregister", e, this.elements);
  }
  removePlugins(...e) {
    this._each("unregister", e, this.plugins);
  }
  removeScales(...e) {
    this._each("unregister", e, this.scales);
  }
  _each(e, n, r) {
    [
      ...n
    ].forEach((o) => {
      const i = r || this._getRegistryForType(o);
      r || i.isForType(o) || i === this.plugins && o.id ? this._exec(e, i, o) : Le(o, (s) => {
        const a = r || this._getRegistryForType(s);
        this._exec(e, a, s);
      });
    });
  }
  _exec(e, n, r) {
    const o = ml(e);
    Ge(r["before" + o], [], r), n[e](r), Ge(r["after" + o], [], r);
  }
  _getRegistryForType(e) {
    for (let n = 0; n < this._typedRegistries.length; n++) {
      const r = this._typedRegistries[n];
      if (r.isForType(e))
        return r;
    }
    return this.plugins;
  }
  _get(e, n, r) {
    const o = n.get(e);
    if (o === void 0)
      throw new Error('"' + e + '" is not a registered ' + r + ".");
    return o;
  }
}
var Jt = /* @__PURE__ */ new kw();
class Ow {
  constructor() {
    this._init = [];
  }
  notify(e, n, r, o) {
    n === "beforeInit" && (this._init = this._createDescriptors(e, !0), this._notify(this._init, e, "install"));
    const i = o ? this._descriptors(e).filter(o) : this._descriptors(e), s = this._notify(i, e, n, r);
    return n === "afterDestroy" && (this._notify(i, e, "stop"), this._notify(this._init, e, "uninstall")), s;
  }
  _notify(e, n, r, o) {
    o = o || {};
    for (const i of e) {
      const s = i.plugin, a = s[r], l = [
        n,
        o,
        i.options
      ];
      if (Ge(a, l, s) === !1 && o.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    Ve(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(e) {
    if (this._cache)
      return this._cache;
    const n = this._cache = this._createDescriptors(e);
    return this._notifyStateChanges(e), n;
  }
  _createDescriptors(e, n) {
    const r = e && e.config, o = Fe(r.options && r.options.plugins, {}), i = Sw(r);
    return o === !1 && !n ? [] : Iw(e, i, o, n);
  }
  _notifyStateChanges(e) {
    const n = this._oldCache || [], r = this._cache, o = (i, s) => i.filter((a) => !s.some((l) => a.plugin.id === l.plugin.id));
    this._notify(o(n, r), e, "stop"), this._notify(o(r, n), e, "start");
  }
}
function Sw(t) {
  const e = {}, n = [], r = Object.keys(Jt.plugins.items);
  for (let i = 0; i < r.length; i++)
    n.push(Jt.getPlugin(r[i]));
  const o = t.plugins || [];
  for (let i = 0; i < o.length; i++) {
    const s = o[i];
    n.indexOf(s) === -1 && (n.push(s), e[s.id] = !0);
  }
  return {
    plugins: n,
    localIds: e
  };
}
function Pw(t, e) {
  return !e && t === !1 ? null : t === !0 ? {} : t;
}
function Iw(t, { plugins: e, localIds: n }, r, o) {
  const i = [], s = t.getContext();
  for (const a of e) {
    const l = a.id, c = Pw(r[l], o);
    c !== null && i.push({
      plugin: a,
      options: Tw(t.config, {
        plugin: a,
        local: n[l]
      }, c, s)
    });
  }
  return i;
}
function Tw(t, { plugin: e, local: n }, r, o) {
  const i = t.pluginScopeKeys(e), s = t.getOptionScopes(r, i);
  return n && e.defaults && s.push(e.defaults), t.createResolver(s, o, [
    ""
  ], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function xa(t, e) {
  const n = Ze.datasets[t] || {};
  return ((e.datasets || {})[t] || {}).indexAxis || e.indexAxis || n.indexAxis || "x";
}
function Dw(t, e) {
  let n = t;
  return t === "_index_" ? n = e : t === "_value_" && (n = e === "x" ? "y" : "x"), n;
}
function $w(t, e) {
  return t === e ? "_index_" : "_value_";
}
function Pu(t) {
  if (t === "x" || t === "y" || t === "r")
    return t;
}
function Nw(t) {
  if (t === "top" || t === "bottom")
    return "x";
  if (t === "left" || t === "right")
    return "y";
}
function _a(t, ...e) {
  if (Pu(t))
    return t;
  for (const n of e) {
    const r = n.axis || Nw(n.position) || t.length > 1 && Pu(t[0].toLowerCase());
    if (r)
      return r;
  }
  throw new Error(`Cannot determine type of '${t}' axis. Please provide 'axis' or 'position' option.`);
}
function Iu(t, e, n) {
  if (n[e + "AxisID"] === t)
    return {
      axis: e
    };
}
function Rw(t, e) {
  if (e.data && e.data.datasets) {
    const n = e.data.datasets.filter((r) => r.xAxisID === t || r.yAxisID === t);
    if (n.length)
      return Iu(t, "x", n[0]) || Iu(t, "y", n[0]);
  }
  return {};
}
function Aw(t, e) {
  const n = or[t.type] || {
    scales: {}
  }, r = e.scales || {}, o = xa(t.type, e), i = /* @__PURE__ */ Object.create(null);
  return Object.keys(r).forEach((s) => {
    const a = r[s];
    if (!Se(a))
      return console.error(`Invalid scale configuration for scale: ${s}`);
    if (a._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${s}`);
    const l = _a(s, a, Rw(s, t), Ze.scales[a.type]), c = $w(l, o), u = n.scales || {};
    i[s] = ro(/* @__PURE__ */ Object.create(null), [
      {
        axis: l
      },
      a,
      u[l],
      u[c]
    ]);
  }), t.data.datasets.forEach((s) => {
    const a = s.type || t.type, l = s.indexAxis || xa(a, e), u = (or[a] || {}).scales || {};
    Object.keys(u).forEach((d) => {
      const f = Dw(d, l), h = s[f + "AxisID"] || f;
      i[h] = i[h] || /* @__PURE__ */ Object.create(null), ro(i[h], [
        {
          axis: f
        },
        r[h],
        u[d]
      ]);
    });
  }), Object.keys(i).forEach((s) => {
    const a = i[s];
    ro(a, [
      Ze.scales[a.type],
      Ze.scale
    ]);
  }), i;
}
function Sh(t) {
  const e = t.options || (t.options = {});
  e.plugins = Fe(e.plugins, {}), e.scales = Aw(t, e);
}
function Ph(t) {
  return t = t || {}, t.datasets = t.datasets || [], t.labels = t.labels || [], t;
}
function Lw(t) {
  return t = t || {}, t.data = Ph(t.data), Sh(t), t;
}
const Tu = /* @__PURE__ */ new Map(), Ih = /* @__PURE__ */ new Set();
function qo(t, e) {
  let n = Tu.get(t);
  return n || (n = e(), Tu.set(t, n), Ih.add(n)), n;
}
const Kr = (t, e, n) => {
  const r = Or(e, n);
  r !== void 0 && t.add(r);
};
class Fw {
  constructor(e) {
    this._config = Lw(e), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(e) {
    this._config.type = e;
  }
  get data() {
    return this._config.data;
  }
  set data(e) {
    this._config.data = Ph(e);
  }
  get options() {
    return this._config.options;
  }
  set options(e) {
    this._config.options = e;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const e = this._config;
    this.clearCache(), Sh(e);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(e) {
    return qo(e, () => [
      [
        `datasets.${e}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(e, n) {
    return qo(`${e}.transition.${n}`, () => [
      [
        `datasets.${e}.transitions.${n}`,
        `transitions.${n}`
      ],
      [
        `datasets.${e}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(e, n) {
    return qo(`${e}-${n}`, () => [
      [
        `datasets.${e}.elements.${n}`,
        `datasets.${e}`,
        `elements.${n}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(e) {
    const n = e.id, r = this.type;
    return qo(`${r}-plugin-${n}`, () => [
      [
        `plugins.${n}`,
        ...e.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(e, n) {
    const r = this._scopeCache;
    let o = r.get(e);
    return (!o || n) && (o = /* @__PURE__ */ new Map(), r.set(e, o)), o;
  }
  getOptionScopes(e, n, r) {
    const { options: o, type: i } = this, s = this._cachedScopes(e, r), a = s.get(n);
    if (a)
      return a;
    const l = /* @__PURE__ */ new Set();
    n.forEach((u) => {
      e && (l.add(e), u.forEach((d) => Kr(l, e, d))), u.forEach((d) => Kr(l, o, d)), u.forEach((d) => Kr(l, or[i] || {}, d)), u.forEach((d) => Kr(l, Ze, d)), u.forEach((d) => Kr(l, ya, d));
    });
    const c = Array.from(l);
    return c.length === 0 && c.push(/* @__PURE__ */ Object.create(null)), Ih.has(n) && s.set(n, c), c;
  }
  chartOptionScopes() {
    const { options: e, type: n } = this;
    return [
      e,
      or[n] || {},
      Ze.datasets[n] || {},
      {
        type: n
      },
      Ze,
      ya
    ];
  }
  resolveNamedOptions(e, n, r, o = [
    ""
  ]) {
    const i = {
      $shared: !0
    }, { resolver: s, subPrefixes: a } = Du(this._resolverCache, e, o);
    let l = s;
    if (Ww(s, n)) {
      i.$shared = !1, r = Wn(r) ? r() : r;
      const c = this.createResolver(e, r, a);
      l = Sr(s, r, c);
    }
    for (const c of n)
      i[c] = l[c];
    return i;
  }
  createResolver(e, n, r = [
    ""
  ], o) {
    const { resolver: i } = Du(this._resolverCache, e, r);
    return Se(n) ? Sr(i, n, void 0, o) : i;
  }
}
function Du(t, e, n) {
  let r = t.get(e);
  r || (r = /* @__PURE__ */ new Map(), t.set(e, r));
  const o = n.join();
  let i = r.get(o);
  return i || (i = {
    resolver: xl(e, n),
    subPrefixes: n.filter((a) => !a.toLowerCase().includes("hover"))
  }, r.set(o, i)), i;
}
const Vw = (t) => Se(t) && Object.getOwnPropertyNames(t).reduce((e, n) => e || Wn(t[n]), !1);
function Ww(t, e) {
  const { isScriptable: n, isIndexable: r } = fh(t);
  for (const o of e) {
    const i = n(o), s = r(o), a = (s || i) && t[o];
    if (i && (Wn(a) || Vw(a)) || s && Ye(a))
      return !0;
  }
  return !1;
}
var Hw = "4.3.3";
const Bw = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function $u(t, e) {
  return t === "top" || t === "bottom" || Bw.indexOf(t) === -1 && e === "x";
}
function Nu(t, e) {
  return function(n, r) {
    return n[t] === r[t] ? n[e] - r[e] : n[t] - r[t];
  };
}
function Ru(t) {
  const e = t.chart, n = e.options.animation;
  e.notifyPlugins("afterRender"), Ge(n && n.onComplete, [
    t
  ], e);
}
function jw(t) {
  const e = t.chart, n = e.options.animation;
  Ge(n && n.onProgress, [
    t
  ], e);
}
function Th(t) {
  return vh() && typeof t == "string" ? t = document.getElementById(t) : t && t.length && (t = t[0]), t && t.canvas && (t = t.canvas), t;
}
const gi = {}, Au = (t) => {
  const e = Th(t);
  return Object.values(gi).filter((n) => n.canvas === e).pop();
};
function zw(t, e, n) {
  const r = Object.keys(t);
  for (const o of r) {
    const i = +o;
    if (i >= e) {
      const s = t[o];
      delete t[o], (n > 0 || i > e) && (t[i + n] = s);
    }
  }
}
function Uw(t, e, n, r) {
  return !n || t.type === "mouseout" ? null : r ? e : t;
}
function Yw(t) {
  const { xScale: e, yScale: n } = t;
  if (e && n)
    return {
      left: e.left,
      right: e.right,
      top: n.top,
      bottom: n.bottom
    };
}
var Mn;
let kl = (Mn = class {
  static register(...e) {
    Jt.add(...e), Lu();
  }
  static unregister(...e) {
    Jt.remove(...e), Lu();
  }
  constructor(e, n) {
    const r = this.config = new Fw(n), o = Th(e), i = Au(o);
    if (i)
      throw new Error("Canvas is already in use. Chart with ID '" + i.id + "' must be destroyed before the canvas with ID '" + i.canvas.id + "' can be reused.");
    const s = r.createResolver(r.chartOptionScopes(), this.getContext());
    this.platform = new (r.platform || cw(o))(), this.platform.updateConfig(r);
    const a = this.platform.acquireContext(o, s.aspectRatio), l = a && a.canvas, c = l && l.height, u = l && l.width;
    if (this.id = jb(), this.ctx = a, this.canvas = l, this.width = u, this.height = c, this._options = s, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new Ow(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = s1((d) => this.update(d), s.resizeDelay || 0), this._dataChanges = [], gi[this.id] = this, !a || !l) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    fn.listen(this, "complete", Ru), fn.listen(this, "progress", jw), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: e, maintainAspectRatio: n }, width: r, height: o, _aspectRatio: i } = this;
    return Ve(e) ? n && i ? i : o ? r / o : null : e;
  }
  get data() {
    return this.config.data;
  }
  set data(e) {
    this.config.data = e;
  }
  get options() {
    return this._options;
  }
  set options(e) {
    this.config.options = e;
  }
  get registry() {
    return Jt;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : ou(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return tu(this.canvas, this.ctx), this;
  }
  stop() {
    return fn.stop(this), this;
  }
  resize(e, n) {
    fn.running(this) ? this._resizeBeforeDraw = {
      width: e,
      height: n
    } : this._resize(e, n);
  }
  _resize(e, n) {
    const r = this.options, o = this.canvas, i = r.maintainAspectRatio && this.aspectRatio, s = this.platform.getMaximumSize(o, e, n, i), a = r.devicePixelRatio || this.platform.getDevicePixelRatio(), l = this.width ? "resize" : "attach";
    this.width = s.width, this.height = s.height, this._aspectRatio = this.aspectRatio, ou(this, a, !0) && (this.notifyPlugins("resize", {
      size: s
    }), Ge(r.onResize, [
      this,
      s
    ], this), this.attached && this._doResize(l) && this.render());
  }
  ensureScalesHaveIDs() {
    const n = this.options.scales || {};
    Le(n, (r, o) => {
      r.id = o;
    });
  }
  buildOrUpdateScales() {
    const e = this.options, n = e.scales, r = this.scales, o = Object.keys(r).reduce((s, a) => (s[a] = !1, s), {});
    let i = [];
    n && (i = i.concat(Object.keys(n).map((s) => {
      const a = n[s], l = _a(s, a), c = l === "r", u = l === "x";
      return {
        options: a,
        dposition: c ? "chartArea" : u ? "bottom" : "left",
        dtype: c ? "radialLinear" : u ? "category" : "linear"
      };
    }))), Le(i, (s) => {
      const a = s.options, l = a.id, c = _a(l, a), u = Fe(a.type, s.dtype);
      (a.position === void 0 || $u(a.position, c) !== $u(s.dposition)) && (a.position = s.dposition), o[l] = !0;
      let d = null;
      if (l in r && r[l].type === u)
        d = r[l];
      else {
        const f = Jt.getScale(u);
        d = new f({
          id: l,
          type: u,
          ctx: this.ctx,
          chart: this
        }), r[d.id] = d;
      }
      d.init(a, e);
    }), Le(o, (s, a) => {
      s || delete r[a];
    }), Le(r, (s) => {
      Yo.configure(this, s, s.options), Yo.addBox(this, s);
    });
  }
  _updateMetasets() {
    const e = this._metasets, n = this.data.datasets.length, r = e.length;
    if (e.sort((o, i) => o.index - i.index), r > n) {
      for (let o = n; o < r; ++o)
        this._destroyDatasetMeta(o);
      e.splice(n, r - n);
    }
    this._sortedMetasets = e.slice(0).sort(Nu("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: e, data: { datasets: n } } = this;
    e.length > n.length && delete this._stacks, e.forEach((r, o) => {
      n.filter((i) => i === r._dataset).length === 0 && this._destroyDatasetMeta(o);
    });
  }
  buildOrUpdateControllers() {
    const e = [], n = this.data.datasets;
    let r, o;
    for (this._removeUnreferencedMetasets(), r = 0, o = n.length; r < o; r++) {
      const i = n[r];
      let s = this.getDatasetMeta(r);
      const a = i.type || this.config.type;
      if (s.type && s.type !== a && (this._destroyDatasetMeta(r), s = this.getDatasetMeta(r)), s.type = a, s.indexAxis = i.indexAxis || xa(a, this.options), s.order = i.order || 0, s.index = r, s.label = "" + i.label, s.visible = this.isDatasetVisible(r), s.controller)
        s.controller.updateIndex(r), s.controller.linkScales();
      else {
        const l = Jt.getController(a), { datasetElementType: c, dataElementType: u } = Ze.datasets[a];
        Object.assign(l, {
          dataElementType: Jt.getElement(u),
          datasetElementType: c && Jt.getElement(c)
        }), s.controller = new l(this, r), e.push(s.controller);
      }
    }
    return this._updateMetasets(), e;
  }
  _resetElements() {
    Le(this.data.datasets, (e, n) => {
      this.getDatasetMeta(n).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(e) {
    const n = this.config;
    n.update();
    const r = this._options = n.createResolver(n.chartOptionScopes(), this.getContext()), o = this._animationsDisabled = !r.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", {
      mode: e,
      cancelable: !0
    }) === !1)
      return;
    const i = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let s = 0;
    for (let c = 0, u = this.data.datasets.length; c < u; c++) {
      const { controller: d } = this.getDatasetMeta(c), f = !o && i.indexOf(d) === -1;
      d.buildOrUpdateElements(f), s = Math.max(+d.getMaxOverflow(), s);
    }
    s = this._minPadding = r.layout.autoPadding ? s : 0, this._updateLayout(s), o || Le(i, (c) => {
      c.reset();
    }), this._updateDatasets(e), this.notifyPlugins("afterUpdate", {
      mode: e
    }), this._layers.sort(Nu("z", "_idx"));
    const { _active: a, _lastEvent: l } = this;
    l ? this._eventHandler(l, !0) : a.length && this._updateHoverStyles(a, a, !0), this.render();
  }
  _updateScales() {
    Le(this.scales, (e) => {
      Yo.removeBox(this, e);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const e = this.options, n = new Set(Object.keys(this._listeners)), r = new Set(e.events);
    (!Uc(n, r) || !!this._responsiveListeners !== e.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: e } = this, n = this._getUniformDataChanges() || [];
    for (const { method: r, start: o, count: i } of n) {
      const s = r === "_removeElements" ? -i : i;
      zw(e, o, s);
    }
  }
  _getUniformDataChanges() {
    const e = this._dataChanges;
    if (!e || !e.length)
      return;
    this._dataChanges = [];
    const n = this.data.datasets.length, r = (i) => new Set(e.filter((s) => s[0] === i).map((s, a) => a + "," + s.splice(1).join(","))), o = r(0);
    for (let i = 1; i < n; i++)
      if (!Uc(o, r(i)))
        return;
    return Array.from(o).map((i) => i.split(",")).map((i) => ({
      method: i[1],
      start: +i[2],
      count: +i[3]
    }));
  }
  _updateLayout(e) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: !0
    }) === !1)
      return;
    Yo.update(this, this.width, this.height, e);
    const n = this.chartArea, r = n.width <= 0 || n.height <= 0;
    this._layers = [], Le(this.boxes, (o) => {
      r && o.position === "chartArea" || (o.configure && o.configure(), this._layers.push(...o._layers()));
    }, this), this._layers.forEach((o, i) => {
      o._idx = i;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(e) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode: e,
      cancelable: !0
    }) !== !1) {
      for (let n = 0, r = this.data.datasets.length; n < r; ++n)
        this.getDatasetMeta(n).controller.configure();
      for (let n = 0, r = this.data.datasets.length; n < r; ++n)
        this._updateDataset(n, Wn(e) ? e({
          datasetIndex: n
        }) : e);
      this.notifyPlugins("afterDatasetsUpdate", {
        mode: e
      });
    }
  }
  _updateDataset(e, n) {
    const r = this.getDatasetMeta(e), o = {
      meta: r,
      index: e,
      mode: n,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetUpdate", o) !== !1 && (r.controller._update(n), o.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", o));
  }
  render() {
    this.notifyPlugins("beforeRender", {
      cancelable: !0
    }) !== !1 && (fn.has(this) ? this.attached && !fn.running(this) && fn.start(this) : (this.draw(), Ru({
      chart: this
    })));
  }
  draw() {
    let e;
    if (this._resizeBeforeDraw) {
      const { width: r, height: o } = this._resizeBeforeDraw;
      this._resize(r, o), this._resizeBeforeDraw = null;
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", {
      cancelable: !0
    }) === !1)
      return;
    const n = this._layers;
    for (e = 0; e < n.length && n[e].z <= 0; ++e)
      n[e].draw(this.chartArea);
    for (this._drawDatasets(); e < n.length; ++e)
      n[e].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(e) {
    const n = this._sortedMetasets, r = [];
    let o, i;
    for (o = 0, i = n.length; o < i; ++o) {
      const s = n[o];
      (!e || s.visible) && r.push(s);
    }
    return r;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: !0
    }) === !1)
      return;
    const e = this.getSortedVisibleDatasetMetas();
    for (let n = e.length - 1; n >= 0; --n)
      this._drawDataset(e[n]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(e) {
    const n = this.ctx, r = e._clip, o = !r.disabled, i = Yw(e) || this.chartArea, s = {
      meta: e,
      index: e.index,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetDraw", s) !== !1 && (o && lh(n, {
      left: r.left === !1 ? 0 : i.left - r.left,
      right: r.right === !1 ? this.width : i.right + r.right,
      top: r.top === !1 ? 0 : i.top - r.top,
      bottom: r.bottom === !1 ? this.height : i.bottom + r.bottom
    }), e.controller.draw(), o && ch(n), s.cancelable = !1, this.notifyPlugins("afterDatasetDraw", s));
  }
  isPointInArea(e) {
    return gn(e, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(e, n, r, o) {
    const i = By.modes[n];
    return typeof i == "function" ? i(this, e, r, o) : [];
  }
  getDatasetMeta(e) {
    const n = this.data.datasets[e], r = this._metasets;
    let o = r.filter((i) => i && i._dataset === n).pop();
    return o || (o = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: n && n.order || 0,
      index: e,
      _dataset: n,
      _parsed: [],
      _sorted: !1
    }, r.push(o)), o;
  }
  getContext() {
    return this.$context || (this.$context = Bn(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(e) {
    const n = this.data.datasets[e];
    if (!n)
      return !1;
    const r = this.getDatasetMeta(e);
    return typeof r.hidden == "boolean" ? !r.hidden : !n.hidden;
  }
  setDatasetVisibility(e, n) {
    const r = this.getDatasetMeta(e);
    r.hidden = !n;
  }
  toggleDataVisibility(e) {
    this._hiddenIndices[e] = !this._hiddenIndices[e];
  }
  getDataVisibility(e) {
    return !this._hiddenIndices[e];
  }
  _updateVisibility(e, n, r) {
    const o = r ? "show" : "hide", i = this.getDatasetMeta(e), s = i.controller._resolveAnimations(void 0, o);
    vo(n) ? (i.data[n].hidden = !r, this.update()) : (this.setDatasetVisibility(e, r), s.update(i, {
      visible: r
    }), this.update((a) => a.datasetIndex === e ? o : void 0));
  }
  hide(e, n) {
    this._updateVisibility(e, n, !1);
  }
  show(e, n) {
    this._updateVisibility(e, n, !0);
  }
  _destroyDatasetMeta(e) {
    const n = this._metasets[e];
    n && n.controller && n.controller._destroy(), delete this._metasets[e];
  }
  _stop() {
    let e, n;
    for (this.stop(), fn.remove(this), e = 0, n = this.data.datasets.length; e < n; ++e)
      this._destroyDatasetMeta(e);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: e, ctx: n } = this;
    this._stop(), this.config.clearCache(), e && (this.unbindEvents(), tu(e, n), this.platform.releaseContext(n), this.canvas = null, this.ctx = null), delete gi[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...e) {
    return this.canvas.toDataURL(...e);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const e = this._listeners, n = this.platform, r = (i, s) => {
      n.addEventListener(this, i, s), e[i] = s;
    }, o = (i, s, a) => {
      i.offsetX = s, i.offsetY = a, this._eventHandler(i);
    };
    Le(this.options.events, (i) => r(i, o));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const e = this._responsiveListeners, n = this.platform, r = (l, c) => {
      n.addEventListener(this, l, c), e[l] = c;
    }, o = (l, c) => {
      e[l] && (n.removeEventListener(this, l, c), delete e[l]);
    }, i = (l, c) => {
      this.canvas && this.resize(l, c);
    };
    let s;
    const a = () => {
      o("attach", a), this.attached = !0, this.resize(), r("resize", i), r("detach", s);
    };
    s = () => {
      this.attached = !1, o("resize", i), this._stop(), this._resize(0, 0), r("attach", a);
    }, n.isAttached(this.canvas) ? a() : s();
  }
  unbindEvents() {
    Le(this._listeners, (e, n) => {
      this.platform.removeEventListener(this, n, e);
    }), this._listeners = {}, Le(this._responsiveListeners, (e, n) => {
      this.platform.removeEventListener(this, n, e);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(e, n, r) {
    const o = r ? "set" : "remove";
    let i, s, a, l;
    for (n === "dataset" && (i = this.getDatasetMeta(e[0].datasetIndex), i.controller["_" + o + "DatasetHoverStyle"]()), a = 0, l = e.length; a < l; ++a) {
      s = e[a];
      const c = s && this.getDatasetMeta(s.datasetIndex).controller;
      c && c[o + "HoverStyle"](s.element, s.datasetIndex, s.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(e) {
    const n = this._active || [], r = e.map(({ datasetIndex: i, index: s }) => {
      const a = this.getDatasetMeta(i);
      if (!a)
        throw new Error("No dataset found at index " + i);
      return {
        datasetIndex: i,
        element: a.data[s],
        index: s
      };
    });
    !Ti(r, n) && (this._active = r, this._lastEvent = null, this._updateHoverStyles(r, n));
  }
  notifyPlugins(e, n, r) {
    return this._plugins.notify(this, e, n, r);
  }
  isPluginEnabled(e) {
    return this._plugins._cache.filter((n) => n.plugin.id === e).length === 1;
  }
  _updateHoverStyles(e, n, r) {
    const o = this.options.hover, i = (l, c) => l.filter((u) => !c.some((d) => u.datasetIndex === d.datasetIndex && u.index === d.index)), s = i(n, e), a = r ? e : i(e, n);
    s.length && this.updateHoverStyle(s, o.mode, !1), a.length && o.mode && this.updateHoverStyle(a, o.mode, !0);
  }
  _eventHandler(e, n) {
    const r = {
      event: e,
      replay: n,
      cancelable: !0,
      inChartArea: this.isPointInArea(e)
    }, o = (s) => (s.options.events || this.options.events).includes(e.native.type);
    if (this.notifyPlugins("beforeEvent", r, o) === !1)
      return;
    const i = this._handleEvent(e, n, r.inChartArea);
    return r.cancelable = !1, this.notifyPlugins("afterEvent", r, o), (i || r.changed) && this.render(), this;
  }
  _handleEvent(e, n, r) {
    const { _active: o = [], options: i } = this, s = n, a = this._getActiveElements(e, o, r, s), l = qb(e), c = Uw(e, this._lastEvent, r, l);
    r && (this._lastEvent = null, Ge(i.onHover, [
      e,
      a,
      this
    ], this), l && Ge(i.onClick, [
      e,
      a,
      this
    ], this));
    const u = !Ti(a, o);
    return (u || n) && (this._active = a, this._updateHoverStyles(a, o, n)), this._lastEvent = c, u;
  }
  _getActiveElements(e, n, r, o) {
    if (e.type === "mouseout")
      return [];
    if (!r)
      return n;
    const i = this.options.hover;
    return this.getElementsAtEventForMode(e, i.mode, i, o);
  }
}, fe(Mn, "defaults", Ze), fe(Mn, "instances", gi), fe(Mn, "overrides", or), fe(Mn, "registry", Jt), fe(Mn, "version", Hw), fe(Mn, "getChart", Au), Mn);
function Lu() {
  return Le(kl.instances, (t) => t._plugins.invalidate());
}
function Dh(t, e, n = e) {
  t.lineCap = Fe(n.borderCapStyle, e.borderCapStyle), t.setLineDash(Fe(n.borderDash, e.borderDash)), t.lineDashOffset = Fe(n.borderDashOffset, e.borderDashOffset), t.lineJoin = Fe(n.borderJoinStyle, e.borderJoinStyle), t.lineWidth = Fe(n.borderWidth, e.borderWidth), t.strokeStyle = Fe(n.borderColor, e.borderColor);
}
function Kw(t, e, n) {
  t.lineTo(n.x, n.y);
}
function Gw(t) {
  return t.stepped ? x1 : t.tension || t.cubicInterpolationMode === "monotone" ? _1 : Kw;
}
function $h(t, e, n = {}) {
  const r = t.length, { start: o = 0, end: i = r - 1 } = n, { start: s, end: a } = e, l = Math.max(o, s), c = Math.min(i, a), u = o < s && i < s || o > a && i > a;
  return {
    count: r,
    start: l,
    loop: e.loop,
    ilen: c < l && !u ? r + c - l : c - l
  };
}
function qw(t, e, n, r) {
  const { points: o, options: i } = e, { count: s, start: a, loop: l, ilen: c } = $h(o, n, r), u = Gw(i);
  let { move: d = !0, reverse: f } = r || {}, h, p, g;
  for (h = 0; h <= c; ++h)
    p = o[(a + (f ? c - h : h)) % s], !p.skip && (d ? (t.moveTo(p.x, p.y), d = !1) : u(t, g, p, f, i.stepped), g = p);
  return l && (p = o[(a + (f ? c : 0)) % s], u(t, g, p, f, i.stepped)), !!l;
}
function Xw(t, e, n, r) {
  const o = e.points, { count: i, start: s, ilen: a } = $h(o, n, r), { move: l = !0, reverse: c } = r || {};
  let u = 0, d = 0, f, h, p, g, m, b;
  const v = (x) => (s + (c ? a - x : x)) % i, _ = () => {
    g !== m && (t.lineTo(u, m), t.lineTo(u, g), t.lineTo(u, b));
  };
  for (l && (h = o[v(0)], t.moveTo(h.x, h.y)), f = 0; f <= a; ++f) {
    if (h = o[v(f)], h.skip)
      continue;
    const x = h.x, y = h.y, M = x | 0;
    M === p ? (y < g ? g = y : y > m && (m = y), u = (d * u + x) / ++d) : (_(), t.lineTo(x, y), p = M, d = 0, g = m = y), b = y;
  }
  _();
}
function Ca(t) {
  const e = t.options, n = e.borderDash && e.borderDash.length;
  return !t._decimated && !t._loop && !e.tension && e.cubicInterpolationMode !== "monotone" && !e.stepped && !n ? Xw : qw;
}
function Zw(t) {
  return t.stepped ? ey : t.tension || t.cubicInterpolationMode === "monotone" ? ty : Xn;
}
function Qw(t, e, n, r) {
  let o = e._path;
  o || (o = e._path = new Path2D(), e.path(o, n, r) && o.closePath()), Dh(t, e.options), t.stroke(o);
}
function Jw(t, e, n, r) {
  const { segments: o, options: i } = e, s = Ca(e);
  for (const a of o)
    Dh(t, i, a.style), t.beginPath(), s(t, e, a, {
      start: n,
      end: n + r - 1
    }) && t.closePath(), t.stroke();
}
const ex = typeof Path2D == "function";
function tx(t, e, n, r) {
  ex && !e.options.segment ? Qw(t, e, n, r) : Jw(t, e, n, r);
}
class eo extends Ar {
  constructor(e) {
    super(), this.animated = !0, this.options = void 0, this._chart = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, e && Object.assign(this, e);
  }
  updateControlPoints(e, n) {
    const r = this.options;
    if ((r.tension || r.cubicInterpolationMode === "monotone") && !r.stepped && !this._pointsUpdated) {
      const o = r.spanGaps ? this._loop : this._fullLoop;
      Y1(this._points, r, e, o, n), this._pointsUpdated = !0;
    }
  }
  set points(e) {
    this._points = e, delete this._segments, delete this._path, this._pointsUpdated = !1;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = dy(this, this.options.segment));
  }
  first() {
    const e = this.segments, n = this.points;
    return e.length && n[e[0].start];
  }
  last() {
    const e = this.segments, n = this.points, r = e.length;
    return r && n[e[r - 1].end];
  }
  interpolate(e, n) {
    const r = this.options, o = e[n], i = this.points, s = ly(this, {
      property: n,
      start: o,
      end: o
    });
    if (!s.length)
      return;
    const a = [], l = Zw(r);
    let c, u;
    for (c = 0, u = s.length; c < u; ++c) {
      const { start: d, end: f } = s[c], h = i[d], p = i[f];
      if (h === p) {
        a.push(h);
        continue;
      }
      const g = Math.abs((o - h[n]) / (p[n] - h[n])), m = l(h, p, g, r.stepped);
      m[n] = e[n], a.push(m);
    }
    return a.length === 1 ? a[0] : a;
  }
  pathSegment(e, n, r) {
    return Ca(this)(e, this, n, r);
  }
  path(e, n, r) {
    const o = this.segments, i = Ca(this);
    let s = this._loop;
    n = n || 0, r = r || this.points.length - n;
    for (const a of o)
      s &= i(e, this, a, {
        start: n,
        end: n + r - 1
      });
    return !!s;
  }
  draw(e, n, r, o) {
    const i = this.options || {};
    (this.points || []).length && i.borderWidth && (e.save(), tx(e, this, r, o), e.restore()), this.animated && (this._pointsUpdated = !1, this._path = void 0);
  }
}
fe(eo, "id", "line"), fe(eo, "defaults", {
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderWidth: 3,
  capBezierPoints: !0,
  cubicInterpolationMode: "default",
  fill: !1,
  spanGaps: !1,
  stepped: !1,
  tension: 0
}), fe(eo, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
}), fe(eo, "descriptors", {
  _scriptable: !0,
  _indexable: (e) => e !== "borderDash" && e !== "fill"
});
function Fu(t, e, n, r) {
  const o = t.options, { [n]: i } = t.getProps([
    n
  ], r);
  return Math.abs(e - i) < o.radius + o.hitRadius;
}
class mi extends Ar {
  constructor(n) {
    super();
    fe(this, "parsed");
    fe(this, "skip");
    fe(this, "stop");
    this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, n && Object.assign(this, n);
  }
  inRange(n, r, o) {
    const i = this.options, { x: s, y: a } = this.getProps([
      "x",
      "y"
    ], o);
    return Math.pow(n - s, 2) + Math.pow(r - a, 2) < Math.pow(i.hitRadius + i.radius, 2);
  }
  inXRange(n, r) {
    return Fu(this, n, "x", r);
  }
  inYRange(n, r) {
    return Fu(this, n, "y", r);
  }
  getCenterPoint(n) {
    const { x: r, y: o } = this.getProps([
      "x",
      "y"
    ], n);
    return {
      x: r,
      y: o
    };
  }
  size(n) {
    n = n || this.options || {};
    let r = n.radius || 0;
    r = Math.max(r, r && n.hoverRadius || 0);
    const o = r && n.borderWidth || 0;
    return (r + o) * 2;
  }
  draw(n, r) {
    const o = this.options;
    this.skip || o.radius < 0.1 || !gn(this, r, this.size(o) / 2) || (n.strokeStyle = o.borderColor, n.lineWidth = o.borderWidth, n.fillStyle = o.backgroundColor, wa(n, o, this.x, this.y));
  }
  getRange() {
    const n = this.options || {};
    return n.radius + n.hitRadius;
  }
}
fe(mi, "id", "point"), /**
* @type {any}
*/
fe(mi, "defaults", {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: "circle",
  radius: 3,
  rotation: 0
}), /**
* @type {any}
*/
fe(mi, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
function Nh(t, e) {
  const { x: n, y: r, base: o, width: i, height: s } = t.getProps([
    "x",
    "y",
    "base",
    "width",
    "height"
  ], e);
  let a, l, c, u, d;
  return t.horizontal ? (d = s / 2, a = Math.min(n, o), l = Math.max(n, o), c = r - d, u = r + d) : (d = i / 2, a = n - d, l = n + d, c = Math.min(r, o), u = Math.max(r, o)), {
    left: a,
    top: c,
    right: l,
    bottom: u
  };
}
function Tn(t, e, n, r) {
  return t ? 0 : Mt(e, n, r);
}
function nx(t, e, n) {
  const r = t.options.borderWidth, o = t.borderSkipped, i = dh(r);
  return {
    t: Tn(o.top, i.top, 0, n),
    r: Tn(o.right, i.right, 0, e),
    b: Tn(o.bottom, i.bottom, 0, n),
    l: Tn(o.left, i.left, 0, e)
  };
}
function rx(t, e, n) {
  const { enableBorderRadius: r } = t.getProps([
    "enableBorderRadius"
  ]), o = t.options.borderRadius, i = Er(o), s = Math.min(e, n), a = t.borderSkipped, l = r || Se(o);
  return {
    topLeft: Tn(!l || a.top || a.left, i.topLeft, 0, s),
    topRight: Tn(!l || a.top || a.right, i.topRight, 0, s),
    bottomLeft: Tn(!l || a.bottom || a.left, i.bottomLeft, 0, s),
    bottomRight: Tn(!l || a.bottom || a.right, i.bottomRight, 0, s)
  };
}
function ox(t) {
  const e = Nh(t), n = e.right - e.left, r = e.bottom - e.top, o = nx(t, n / 2, r / 2), i = rx(t, n / 2, r / 2);
  return {
    outer: {
      x: e.left,
      y: e.top,
      w: n,
      h: r,
      radius: i
    },
    inner: {
      x: e.left + o.l,
      y: e.top + o.t,
      w: n - o.l - o.r,
      h: r - o.t - o.b,
      radius: {
        topLeft: Math.max(0, i.topLeft - Math.max(o.t, o.l)),
        topRight: Math.max(0, i.topRight - Math.max(o.t, o.r)),
        bottomLeft: Math.max(0, i.bottomLeft - Math.max(o.b, o.l)),
        bottomRight: Math.max(0, i.bottomRight - Math.max(o.b, o.r))
      }
    }
  };
}
function $s(t, e, n, r) {
  const o = e === null, i = n === null, a = t && !(o && i) && Nh(t, r);
  return a && (o || ba(e, a.left, a.right)) && (i || ba(n, a.top, a.bottom));
}
function ix(t) {
  return t.topLeft || t.topRight || t.bottomLeft || t.bottomRight;
}
function sx(t, e) {
  t.rect(e.x, e.y, e.w, e.h);
}
function Ns(t, e, n = {}) {
  const r = t.x !== n.x ? -e : 0, o = t.y !== n.y ? -e : 0, i = (t.x + t.w !== n.x + n.w ? e : 0) - r, s = (t.y + t.h !== n.y + n.h ? e : 0) - o;
  return {
    x: t.x + r,
    y: t.y + o,
    w: t.w + i,
    h: t.h + s,
    radius: t.radius
  };
}
class vi extends Ar {
  constructor(e) {
    super(), this.options = void 0, this.horizontal = void 0, this.base = void 0, this.width = void 0, this.height = void 0, this.inflateAmount = void 0, e && Object.assign(this, e);
  }
  draw(e) {
    const { inflateAmount: n, options: { borderColor: r, backgroundColor: o } } = this, { inner: i, outer: s } = ox(this), a = ix(s.radius) ? Ai : sx;
    e.save(), (s.w !== i.w || s.h !== i.h) && (e.beginPath(), a(e, Ns(s, n, i)), e.clip(), a(e, Ns(i, -n, s)), e.fillStyle = r, e.fill("evenodd")), e.beginPath(), a(e, Ns(i, n)), e.fillStyle = o, e.fill(), e.restore();
  }
  inRange(e, n, r) {
    return $s(this, e, n, r);
  }
  inXRange(e, n) {
    return $s(this, e, null, n);
  }
  inYRange(e, n) {
    return $s(this, null, e, n);
  }
  getCenterPoint(e) {
    const { x: n, y: r, base: o, horizontal: i } = this.getProps([
      "x",
      "y",
      "base",
      "horizontal"
    ], e);
    return {
      x: i ? (n + o) / 2 : n,
      y: i ? r : (r + o) / 2
    };
  }
  getRange(e) {
    return e === "x" ? this.width / 2 : this.height / 2;
  }
}
fe(vi, "id", "bar"), fe(vi, "defaults", {
  borderSkipped: "start",
  borderWidth: 0,
  borderRadius: 0,
  inflateAmount: "auto",
  pointStyle: void 0
}), fe(vi, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
const to = {
  average(t) {
    if (!t.length)
      return !1;
    let e, n, r = 0, o = 0, i = 0;
    for (e = 0, n = t.length; e < n; ++e) {
      const s = t[e].element;
      if (s && s.hasValue()) {
        const a = s.tooltipPosition();
        r += a.x, o += a.y, ++i;
      }
    }
    return {
      x: r / i,
      y: o / i
    };
  },
  nearest(t, e) {
    if (!t.length)
      return !1;
    let n = e.x, r = e.y, o = Number.POSITIVE_INFINITY, i, s, a;
    for (i = 0, s = t.length; i < s; ++i) {
      const l = t[i].element;
      if (l && l.hasValue()) {
        const c = l.getCenterPoint(), u = va(e, c);
        u < o && (o = u, a = l);
      }
    }
    if (a) {
      const l = a.tooltipPosition();
      n = l.x, r = l.y;
    }
    return {
      x: n,
      y: r
    };
  }
};
function Qt(t, e) {
  return e && (Ye(e) ? Array.prototype.push.apply(t, e) : t.push(e)), t;
}
function hn(t) {
  return (typeof t == "string" || t instanceof String) && t.indexOf(`
`) > -1 ? t.split(`
`) : t;
}
function ax(t, e) {
  const { element: n, datasetIndex: r, index: o } = e, i = t.getDatasetMeta(r).controller, { label: s, value: a } = i.getLabelAndValue(o);
  return {
    chart: t,
    label: s,
    parsed: i.getParsed(o),
    raw: t.data.datasets[r].data[o],
    formattedValue: a,
    dataset: i.getDataset(),
    dataIndex: o,
    datasetIndex: r,
    element: n
  };
}
function Vu(t, e) {
  const n = t.chart.ctx, { body: r, footer: o, title: i } = t, { boxWidth: s, boxHeight: a } = e, l = kt(e.bodyFont), c = kt(e.titleFont), u = kt(e.footerFont), d = i.length, f = o.length, h = r.length, p = Lt(e.padding);
  let g = p.height, m = 0, b = r.reduce((x, y) => x + y.before.length + y.lines.length + y.after.length, 0);
  if (b += t.beforeBody.length + t.afterBody.length, d && (g += d * c.lineHeight + (d - 1) * e.titleSpacing + e.titleMarginBottom), b) {
    const x = e.displayColors ? Math.max(a, l.lineHeight) : l.lineHeight;
    g += h * x + (b - h) * l.lineHeight + (b - 1) * e.bodySpacing;
  }
  f && (g += e.footerMarginTop + f * u.lineHeight + (f - 1) * e.footerSpacing);
  let v = 0;
  const _ = function(x) {
    m = Math.max(m, n.measureText(x).width + v);
  };
  return n.save(), n.font = c.string, Le(t.title, _), n.font = l.string, Le(t.beforeBody.concat(t.afterBody), _), v = e.displayColors ? s + 2 + e.boxPadding : 0, Le(r, (x) => {
    Le(x.before, _), Le(x.lines, _), Le(x.after, _);
  }), v = 0, n.font = u.string, Le(t.footer, _), n.restore(), m += p.width, {
    width: m,
    height: g
  };
}
function lx(t, e) {
  const { y: n, height: r } = e;
  return n < r / 2 ? "top" : n > t.height - r / 2 ? "bottom" : "center";
}
function cx(t, e, n, r) {
  const { x: o, width: i } = r, s = n.caretSize + n.caretPadding;
  if (t === "left" && o + i + s > e.width || t === "right" && o - i - s < 0)
    return !0;
}
function ux(t, e, n, r) {
  const { x: o, width: i } = n, { width: s, chartArea: { left: a, right: l } } = t;
  let c = "center";
  return r === "center" ? c = o <= (a + l) / 2 ? "left" : "right" : o <= i / 2 ? c = "left" : o >= s - i / 2 && (c = "right"), cx(c, t, e, n) && (c = "center"), c;
}
function Wu(t, e, n) {
  const r = n.yAlign || e.yAlign || lx(t, n);
  return {
    xAlign: n.xAlign || e.xAlign || ux(t, e, n, r),
    yAlign: r
  };
}
function dx(t, e) {
  let { x: n, width: r } = t;
  return e === "right" ? n -= r : e === "center" && (n -= r / 2), n;
}
function fx(t, e, n) {
  let { y: r, height: o } = t;
  return e === "top" ? r += n : e === "bottom" ? r -= o + n : r -= o / 2, r;
}
function Hu(t, e, n, r) {
  const { caretSize: o, caretPadding: i, cornerRadius: s } = t, { xAlign: a, yAlign: l } = n, c = o + i, { topLeft: u, topRight: d, bottomLeft: f, bottomRight: h } = Er(s);
  let p = dx(e, a);
  const g = fx(e, l, c);
  return l === "center" ? a === "left" ? p += c : a === "right" && (p -= c) : a === "left" ? p -= Math.max(u, f) + o : a === "right" && (p += Math.max(d, h) + o), {
    x: Mt(p, 0, r.width - e.width),
    y: Mt(g, 0, r.height - e.height)
  };
}
function Xo(t, e, n) {
  const r = Lt(n.padding);
  return e === "center" ? t.x + t.width / 2 : e === "right" ? t.x + t.width - r.right : t.x + r.left;
}
function Bu(t) {
  return Qt([], hn(t));
}
function hx(t, e, n) {
  return Bn(t, {
    tooltip: e,
    tooltipItems: n,
    type: "tooltip"
  });
}
function ju(t, e) {
  const n = e && e.dataset && e.dataset.tooltip && e.dataset.tooltip.callbacks;
  return n ? t.override(n) : t;
}
const Rh = {
  beforeTitle: un,
  title(t) {
    if (t.length > 0) {
      const e = t[0], n = e.chart.data.labels, r = n ? n.length : 0;
      if (this && this.options && this.options.mode === "dataset")
        return e.dataset.label || "";
      if (e.label)
        return e.label;
      if (r > 0 && e.dataIndex < r)
        return n[e.dataIndex];
    }
    return "";
  },
  afterTitle: un,
  beforeBody: un,
  beforeLabel: un,
  label(t) {
    if (this && this.options && this.options.mode === "dataset")
      return t.label + ": " + t.formattedValue || t.formattedValue;
    let e = t.dataset.label || "";
    e && (e += ": ");
    const n = t.formattedValue;
    return Ve(n) || (e += n), e;
  },
  labelColor(t) {
    const n = t.chart.getDatasetMeta(t.datasetIndex).controller.getStyle(t.dataIndex);
    return {
      borderColor: n.borderColor,
      backgroundColor: n.backgroundColor,
      borderWidth: n.borderWidth,
      borderDash: n.borderDash,
      borderDashOffset: n.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(t) {
    const n = t.chart.getDatasetMeta(t.datasetIndex).controller.getStyle(t.dataIndex);
    return {
      pointStyle: n.pointStyle,
      rotation: n.rotation
    };
  },
  afterLabel: un,
  afterBody: un,
  beforeFooter: un,
  footer: un,
  afterFooter: un
};
function mt(t, e, n, r) {
  const o = t[e].call(n, r);
  return typeof o > "u" ? Rh[e].call(n, r) : o;
}
var ia;
let zu = (ia = class extends Ar {
  constructor(e) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = e.chart, this.options = e.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(e) {
    this.options = e, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const e = this._cachedAnimations;
    if (e)
      return e;
    const n = this.chart, r = this.options.setContext(this.getContext()), o = r.enabled && n.options.animation && r.animations, i = new yh(this.chart, o);
    return o._cacheable && (this._cachedAnimations = Object.freeze(i)), i;
  }
  getContext() {
    return this.$context || (this.$context = hx(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(e, n) {
    const { callbacks: r } = n, o = mt(r, "beforeTitle", this, e), i = mt(r, "title", this, e), s = mt(r, "afterTitle", this, e);
    let a = [];
    return a = Qt(a, hn(o)), a = Qt(a, hn(i)), a = Qt(a, hn(s)), a;
  }
  getBeforeBody(e, n) {
    return Bu(mt(n.callbacks, "beforeBody", this, e));
  }
  getBody(e, n) {
    const { callbacks: r } = n, o = [];
    return Le(e, (i) => {
      const s = {
        before: [],
        lines: [],
        after: []
      }, a = ju(r, i);
      Qt(s.before, hn(mt(a, "beforeLabel", this, i))), Qt(s.lines, mt(a, "label", this, i)), Qt(s.after, hn(mt(a, "afterLabel", this, i))), o.push(s);
    }), o;
  }
  getAfterBody(e, n) {
    return Bu(mt(n.callbacks, "afterBody", this, e));
  }
  getFooter(e, n) {
    const { callbacks: r } = n, o = mt(r, "beforeFooter", this, e), i = mt(r, "footer", this, e), s = mt(r, "afterFooter", this, e);
    let a = [];
    return a = Qt(a, hn(o)), a = Qt(a, hn(i)), a = Qt(a, hn(s)), a;
  }
  _createItems(e) {
    const n = this._active, r = this.chart.data, o = [], i = [], s = [];
    let a = [], l, c;
    for (l = 0, c = n.length; l < c; ++l)
      a.push(ax(this.chart, n[l]));
    return e.filter && (a = a.filter((u, d, f) => e.filter(u, d, f, r))), e.itemSort && (a = a.sort((u, d) => e.itemSort(u, d, r))), Le(a, (u) => {
      const d = ju(e.callbacks, u);
      o.push(mt(d, "labelColor", this, u)), i.push(mt(d, "labelPointStyle", this, u)), s.push(mt(d, "labelTextColor", this, u));
    }), this.labelColors = o, this.labelPointStyles = i, this.labelTextColors = s, this.dataPoints = a, a;
  }
  update(e, n) {
    const r = this.options.setContext(this.getContext()), o = this._active;
    let i, s = [];
    if (!o.length)
      this.opacity !== 0 && (i = {
        opacity: 0
      });
    else {
      const a = to[r.position].call(this, o, this._eventPosition);
      s = this._createItems(r), this.title = this.getTitle(s, r), this.beforeBody = this.getBeforeBody(s, r), this.body = this.getBody(s, r), this.afterBody = this.getAfterBody(s, r), this.footer = this.getFooter(s, r);
      const l = this._size = Vu(this, r), c = Object.assign({}, a, l), u = Wu(this.chart, r, c), d = Hu(r, c, u, this.chart);
      this.xAlign = u.xAlign, this.yAlign = u.yAlign, i = {
        opacity: 1,
        x: d.x,
        y: d.y,
        width: l.width,
        height: l.height,
        caretX: a.x,
        caretY: a.y
      };
    }
    this._tooltipItems = s, this.$context = void 0, i && this._resolveAnimations().update(this, i), e && r.external && r.external.call(this, {
      chart: this.chart,
      tooltip: this,
      replay: n
    });
  }
  drawCaret(e, n, r, o) {
    const i = this.getCaretPosition(e, r, o);
    n.lineTo(i.x1, i.y1), n.lineTo(i.x2, i.y2), n.lineTo(i.x3, i.y3);
  }
  getCaretPosition(e, n, r) {
    const { xAlign: o, yAlign: i } = this, { caretSize: s, cornerRadius: a } = r, { topLeft: l, topRight: c, bottomLeft: u, bottomRight: d } = Er(a), { x: f, y: h } = e, { width: p, height: g } = n;
    let m, b, v, _, x, y;
    return i === "center" ? (x = h + g / 2, o === "left" ? (m = f, b = m - s, _ = x + s, y = x - s) : (m = f + p, b = m + s, _ = x - s, y = x + s), v = m) : (o === "left" ? b = f + Math.max(l, u) + s : o === "right" ? b = f + p - Math.max(c, d) - s : b = this.caretX, i === "top" ? (_ = h, x = _ - s, m = b - s, v = b + s) : (_ = h + g, x = _ + s, m = b + s, v = b - s), y = _), {
      x1: m,
      x2: b,
      x3: v,
      y1: _,
      y2: x,
      y3: y
    };
  }
  drawTitle(e, n, r) {
    const o = this.title, i = o.length;
    let s, a, l;
    if (i) {
      const c = ks(r.rtl, this.x, this.width);
      for (e.x = Xo(this, r.titleAlign, r), n.textAlign = c.textAlign(r.titleAlign), n.textBaseline = "middle", s = kt(r.titleFont), a = r.titleSpacing, n.fillStyle = r.titleColor, n.font = s.string, l = 0; l < i; ++l)
        n.fillText(o[l], c.x(e.x), e.y + s.lineHeight / 2), e.y += s.lineHeight + a, l + 1 === i && (e.y += r.titleMarginBottom - a);
    }
  }
  _drawColorBox(e, n, r, o, i) {
    const s = this.labelColors[r], a = this.labelPointStyles[r], { boxHeight: l, boxWidth: c } = i, u = kt(i.bodyFont), d = Xo(this, "left", i), f = o.x(d), h = l < u.lineHeight ? (u.lineHeight - l) / 2 : 0, p = n.y + h;
    if (i.usePointStyle) {
      const g = {
        radius: Math.min(c, l) / 2,
        pointStyle: a.pointStyle,
        rotation: a.rotation,
        borderWidth: 1
      }, m = o.leftForLtr(f, c) + c / 2, b = p + l / 2;
      e.strokeStyle = i.multiKeyBackground, e.fillStyle = i.multiKeyBackground, wa(e, g, m, b), e.strokeStyle = s.borderColor, e.fillStyle = s.backgroundColor, wa(e, g, m, b);
    } else {
      e.lineWidth = Se(s.borderWidth) ? Math.max(...Object.values(s.borderWidth)) : s.borderWidth || 1, e.strokeStyle = s.borderColor, e.setLineDash(s.borderDash || []), e.lineDashOffset = s.borderDashOffset || 0;
      const g = o.leftForLtr(f, c), m = o.leftForLtr(o.xPlus(f, 1), c - 2), b = Er(s.borderRadius);
      Object.values(b).some((v) => v !== 0) ? (e.beginPath(), e.fillStyle = i.multiKeyBackground, Ai(e, {
        x: g,
        y: p,
        w: c,
        h: l,
        radius: b
      }), e.fill(), e.stroke(), e.fillStyle = s.backgroundColor, e.beginPath(), Ai(e, {
        x: m,
        y: p + 1,
        w: c - 2,
        h: l - 2,
        radius: b
      }), e.fill()) : (e.fillStyle = i.multiKeyBackground, e.fillRect(g, p, c, l), e.strokeRect(g, p, c, l), e.fillStyle = s.backgroundColor, e.fillRect(m, p + 1, c - 2, l - 2));
    }
    e.fillStyle = this.labelTextColors[r];
  }
  drawBody(e, n, r) {
    const { body: o } = this, { bodySpacing: i, bodyAlign: s, displayColors: a, boxHeight: l, boxWidth: c, boxPadding: u } = r, d = kt(r.bodyFont);
    let f = d.lineHeight, h = 0;
    const p = ks(r.rtl, this.x, this.width), g = function(O) {
      n.fillText(O, p.x(e.x + h), e.y + f / 2), e.y += f + i;
    }, m = p.textAlign(s);
    let b, v, _, x, y, M, k;
    for (n.textAlign = s, n.textBaseline = "middle", n.font = d.string, e.x = Xo(this, m, r), n.fillStyle = r.bodyColor, Le(this.beforeBody, g), h = a && m !== "right" ? s === "center" ? c / 2 + u : c + 2 + u : 0, x = 0, M = o.length; x < M; ++x) {
      for (b = o[x], v = this.labelTextColors[x], n.fillStyle = v, Le(b.before, g), _ = b.lines, a && _.length && (this._drawColorBox(n, e, x, p, r), f = Math.max(d.lineHeight, l)), y = 0, k = _.length; y < k; ++y)
        g(_[y]), f = d.lineHeight;
      Le(b.after, g);
    }
    h = 0, f = d.lineHeight, Le(this.afterBody, g), e.y -= i;
  }
  drawFooter(e, n, r) {
    const o = this.footer, i = o.length;
    let s, a;
    if (i) {
      const l = ks(r.rtl, this.x, this.width);
      for (e.x = Xo(this, r.footerAlign, r), e.y += r.footerMarginTop, n.textAlign = l.textAlign(r.footerAlign), n.textBaseline = "middle", s = kt(r.footerFont), n.fillStyle = r.footerColor, n.font = s.string, a = 0; a < i; ++a)
        n.fillText(o[a], l.x(e.x), e.y + s.lineHeight / 2), e.y += s.lineHeight + r.footerSpacing;
    }
  }
  drawBackground(e, n, r, o) {
    const { xAlign: i, yAlign: s } = this, { x: a, y: l } = e, { width: c, height: u } = r, { topLeft: d, topRight: f, bottomLeft: h, bottomRight: p } = Er(o.cornerRadius);
    n.fillStyle = o.backgroundColor, n.strokeStyle = o.borderColor, n.lineWidth = o.borderWidth, n.beginPath(), n.moveTo(a + d, l), s === "top" && this.drawCaret(e, n, r, o), n.lineTo(a + c - f, l), n.quadraticCurveTo(a + c, l, a + c, l + f), s === "center" && i === "right" && this.drawCaret(e, n, r, o), n.lineTo(a + c, l + u - p), n.quadraticCurveTo(a + c, l + u, a + c - p, l + u), s === "bottom" && this.drawCaret(e, n, r, o), n.lineTo(a + h, l + u), n.quadraticCurveTo(a, l + u, a, l + u - h), s === "center" && i === "left" && this.drawCaret(e, n, r, o), n.lineTo(a, l + d), n.quadraticCurveTo(a, l, a + d, l), n.closePath(), n.fill(), o.borderWidth > 0 && n.stroke();
  }
  _updateAnimationTarget(e) {
    const n = this.chart, r = this.$animations, o = r && r.x, i = r && r.y;
    if (o || i) {
      const s = to[e.position].call(this, this._active, this._eventPosition);
      if (!s)
        return;
      const a = this._size = Vu(this, e), l = Object.assign({}, s, this._size), c = Wu(n, e, l), u = Hu(e, l, c, n);
      (o._to !== u.x || i._to !== u.y) && (this.xAlign = c.xAlign, this.yAlign = c.yAlign, this.width = a.width, this.height = a.height, this.caretX = s.x, this.caretY = s.y, this._resolveAnimations().update(this, u));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(e) {
    const n = this.options.setContext(this.getContext());
    let r = this.opacity;
    if (!r)
      return;
    this._updateAnimationTarget(n);
    const o = {
      width: this.width,
      height: this.height
    }, i = {
      x: this.x,
      y: this.y
    };
    r = Math.abs(r) < 1e-3 ? 0 : r;
    const s = Lt(n.padding), a = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    n.enabled && a && (e.save(), e.globalAlpha = r, this.drawBackground(i, e, o, n), oy(e, n.textDirection), i.y += s.top, this.drawTitle(i, e, n), this.drawBody(i, e, n), this.drawFooter(i, e, n), iy(e, n.textDirection), e.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(e, n) {
    const r = this._active, o = e.map(({ datasetIndex: a, index: l }) => {
      const c = this.chart.getDatasetMeta(a);
      if (!c)
        throw new Error("Cannot find a dataset at index " + a);
      return {
        datasetIndex: a,
        element: c.data[l],
        index: l
      };
    }), i = !Ti(r, o), s = this._positionChanged(o, n);
    (i || s) && (this._active = o, this._eventPosition = n, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(e, n, r = !0) {
    if (n && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const o = this.options, i = this._active || [], s = this._getActiveElements(e, i, n, r), a = this._positionChanged(s, e), l = n || !Ti(s, i) || a;
    return l && (this._active = s, (o.enabled || o.external) && (this._eventPosition = {
      x: e.x,
      y: e.y
    }, this.update(!0, n))), l;
  }
  _getActiveElements(e, n, r, o) {
    const i = this.options;
    if (e.type === "mouseout")
      return [];
    if (!o)
      return n;
    const s = this.chart.getElementsAtEventForMode(e, i.mode, i, r);
    return i.reverse && s.reverse(), s;
  }
  _positionChanged(e, n) {
    const { caretX: r, caretY: o, options: i } = this, s = to[i.position].call(this, e, n);
    return s !== !1 && (r !== s.x || o !== s.y);
  }
}, fe(ia, "positioners", to), ia);
var px = {
  id: "tooltip",
  _element: zu,
  positioners: to,
  afterInit(t, e, n) {
    n && (t.tooltip = new zu({
      chart: t,
      options: n
    }));
  },
  beforeUpdate(t, e, n) {
    t.tooltip && t.tooltip.initialize(n);
  },
  reset(t, e, n) {
    t.tooltip && t.tooltip.initialize(n);
  },
  afterDraw(t) {
    const e = t.tooltip;
    if (e && e._willRender()) {
      const n = {
        tooltip: e
      };
      if (t.notifyPlugins("beforeTooltipDraw", {
        ...n,
        cancelable: !0
      }) === !1)
        return;
      e.draw(t.ctx), t.notifyPlugins("afterTooltipDraw", n);
    }
  },
  afterEvent(t, e) {
    if (t.tooltip) {
      const n = e.replay;
      t.tooltip.handleEvent(e.event, n, e.inChartArea) && (e.changed = !0);
    }
  },
  defaults: {
    enabled: !0,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (t, e) => e.bodyFont.size,
    boxWidth: (t, e) => e.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: !0,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "width",
          "height",
          "caretX",
          "caretY"
        ]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: Rh
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (t) => t !== "filter" && t !== "itemSort" && t !== "external",
    _indexable: !1,
    callbacks: {
      _scriptable: !1,
      _indexable: !1
    },
    animation: {
      _fallback: !1
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: [
    "interaction"
  ]
};
const gx = (t, e, n, r) => (typeof e == "string" ? (n = t.push(e) - 1, r.unshift({
  index: n,
  label: e
})) : isNaN(e) && (n = null), n);
function mx(t, e, n, r) {
  const o = t.indexOf(e);
  if (o === -1)
    return gx(t, e, n, r);
  const i = t.lastIndexOf(e);
  return o !== i ? n : o;
}
const vx = (t, e) => t === null ? null : Mt(Math.round(t), 0, e);
function Uu(t) {
  const e = this.getLabels();
  return t >= 0 && t < e.length ? e[t] : t;
}
class Ea extends ur {
  constructor(e) {
    super(e), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
  }
  init(e) {
    const n = this._addedLabels;
    if (n.length) {
      const r = this.getLabels();
      for (const { index: o, label: i } of n)
        r[o] === i && r.splice(o, 1);
      this._addedLabels = [];
    }
    super.init(e);
  }
  parse(e, n) {
    if (Ve(e))
      return null;
    const r = this.getLabels();
    return n = isFinite(n) && r[n] === e ? n : mx(r, e, Fe(n, e), this._addedLabels), vx(n, r.length - 1);
  }
  determineDataLimits() {
    const { minDefined: e, maxDefined: n } = this.getUserBounds();
    let { min: r, max: o } = this.getMinMax(!0);
    this.options.bounds === "ticks" && (e || (r = 0), n || (o = this.getLabels().length - 1)), this.min = r, this.max = o;
  }
  buildTicks() {
    const e = this.min, n = this.max, r = this.options.offset, o = [];
    let i = this.getLabels();
    i = e === 0 && n === i.length - 1 ? i : i.slice(e, n + 1), this._valueRange = Math.max(i.length - (r ? 0 : 1), 1), this._startValue = this.min - (r ? 0.5 : 0);
    for (let s = e; s <= n; s++)
      o.push({
        value: s
      });
    return o;
  }
  getLabelForValue(e) {
    return Uu.call(this, e);
  }
  configure() {
    super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
  }
  getPixelForValue(e) {
    return typeof e != "number" && (e = this.parse(e)), e === null ? NaN : this.getPixelForDecimal((e - this._startValue) / this._valueRange);
  }
  getPixelForTick(e) {
    const n = this.ticks;
    return e < 0 || e > n.length - 1 ? null : this.getPixelForValue(n[e].value);
  }
  getValueForPixel(e) {
    return Math.round(this._startValue + this.getDecimalForPixel(e) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
fe(Ea, "id", "category"), fe(Ea, "defaults", {
  ticks: {
    callback: Uu
  }
});
function bx(t, e) {
  const n = [], { bounds: o, step: i, min: s, max: a, precision: l, count: c, maxTicks: u, maxDigits: d, includeBounds: f } = t, h = i || 1, p = u - 1, { min: g, max: m } = e, b = !Ve(s), v = !Ve(a), _ = !Ve(c), x = (m - g) / (d + 1);
  let y = Kc((m - g) / p / h) * h, M, k, O, S;
  if (y < 1e-14 && !b && !v)
    return [
      {
        value: g
      },
      {
        value: m
      }
    ];
  S = Math.ceil(m / y) - Math.floor(g / y), S > p && (y = Kc(S * y / p / h) * h), Ve(l) || (M = Math.pow(10, l), y = Math.ceil(y * M) / M), o === "ticks" ? (k = Math.floor(g / y) * y, O = Math.ceil(m / y) * y) : (k = g, O = m), b && v && i && Jb((a - s) / i, y / 1e3) ? (S = Math.round(Math.min((a - s) / y, u)), y = (a - s) / S, k = s, O = a) : _ ? (k = b ? s : k, O = v ? a : O, S = c - 1, y = (O - k) / S) : (S = (O - k) / y, oo(S, Math.round(S), y / 1e3) ? S = Math.round(S) : S = Math.ceil(S));
  const D = Math.max(Gc(y), Gc(k));
  M = Math.pow(10, Ve(l) ? D : l), k = Math.round(k * M) / M, O = Math.round(O * M) / M;
  let P = 0;
  for (b && (f && k !== s ? (n.push({
    value: s
  }), k < s && P++, oo(Math.round((k + P * y) * M) / M, s, Yu(s, x, t)) && P++) : k < s && P++); P < S; ++P) {
    const N = Math.round((k + P * y) * M) / M;
    if (v && N > a)
      break;
    n.push({
      value: N
    });
  }
  return v && f && O !== a ? n.length && oo(n[n.length - 1].value, a, Yu(a, x, t)) ? n[n.length - 1].value = a : n.push({
    value: a
  }) : (!v || O === a) && n.push({
    value: O
  }), n;
}
function Yu(t, e, { horizontal: n, minRotation: r }) {
  const o = In(r), i = (n ? Math.sin(o) : Math.cos(o)) || 1e-3, s = 0.75 * e * ("" + t).length;
  return Math.min(e / i, s);
}
class Vi extends ur {
  constructor(e) {
    super(e), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(e, n) {
    return Ve(e) || (typeof e == "number" || e instanceof Number) && !isFinite(+e) ? null : +e;
  }
  handleTickRangeOptions() {
    const { beginAtZero: e } = this.options, { minDefined: n, maxDefined: r } = this.getUserBounds();
    let { min: o, max: i } = this;
    const s = (l) => o = n ? o : l, a = (l) => i = r ? i : l;
    if (e) {
      const l = on(o), c = on(i);
      l < 0 && c < 0 ? a(0) : l > 0 && c > 0 && s(0);
    }
    if (o === i) {
      let l = i === 0 ? 1 : Math.abs(i * 0.05);
      a(i + l), e || s(o - l);
    }
    this.min = o, this.max = i;
  }
  getTickLimit() {
    const e = this.options.ticks;
    let { maxTicksLimit: n, stepSize: r } = e, o;
    return r ? (o = Math.ceil(this.max / r) - Math.floor(this.min / r) + 1, o > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${r} would result generating up to ${o} ticks. Limiting to 1000.`), o = 1e3)) : (o = this.computeTickLimit(), n = n || 11), n && (o = Math.min(n, o)), o;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const e = this.options, n = e.ticks;
    let r = this.getTickLimit();
    r = Math.max(2, r);
    const o = {
      maxTicks: r,
      bounds: e.bounds,
      min: e.min,
      max: e.max,
      precision: n.precision,
      step: n.stepSize,
      count: n.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: n.minRotation || 0,
      includeBounds: n.includeBounds !== !1
    }, i = this._range || this, s = bx(o, i);
    return e.bounds === "ticks" && th(s, this, "value"), e.reverse ? (s.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), s;
  }
  configure() {
    const e = this.ticks;
    let n = this.min, r = this.max;
    if (super.configure(), this.options.offset && e.length) {
      const o = (r - n) / Math.max(e.length - 1, 1) / 2;
      n -= o, r += o;
    }
    this._startValue = n, this._endValue = r, this._valueRange = r - n;
  }
  getLabelForValue(e) {
    return wl(e, this.chart.options.locale, this.options.ticks.format);
  }
}
class Ma extends Vi {
  determineDataLimits() {
    const { min: e, max: n } = this.getMinMax(!0);
    this.min = it(e) ? e : 0, this.max = it(n) ? n : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const e = this.isHorizontal(), n = e ? this.width : this.height, r = In(this.options.ticks.minRotation), o = (e ? Math.sin(r) : Math.cos(r)) || 1e-3, i = this._resolveTickFontOptions(0);
    return Math.ceil(n / Math.min(40, i.lineHeight / o));
  }
  getPixelForValue(e) {
    return e === null ? NaN : this.getPixelForDecimal((e - this._startValue) / this._valueRange);
  }
  getValueForPixel(e) {
    return this._startValue + this.getDecimalForPixel(e) * this._valueRange;
  }
}
fe(Ma, "id", "linear"), fe(Ma, "defaults", {
  ticks: {
    callback: is.formatters.numeric
  }
});
const wo = (t) => Math.floor(Pn(t)), Gn = (t, e) => Math.pow(10, wo(t) + e);
function Ku(t) {
  return t / Math.pow(10, wo(t)) === 1;
}
function Gu(t, e, n) {
  const r = Math.pow(10, n), o = Math.floor(t / r);
  return Math.ceil(e / r) - o;
}
function yx(t, e) {
  const n = e - t;
  let r = wo(n);
  for (; Gu(t, e, r) > 10; )
    r++;
  for (; Gu(t, e, r) < 10; )
    r--;
  return Math.min(r, wo(t));
}
function wx(t, { min: e, max: n }) {
  e = _t(t.min, e);
  const r = [], o = wo(e);
  let i = yx(e, n), s = i < 0 ? Math.pow(10, Math.abs(i)) : 1;
  const a = Math.pow(10, i), l = o > i ? Math.pow(10, o) : 0, c = Math.round((e - l) * s) / s, u = Math.floor((e - l) / a / 10) * a * 10;
  let d = Math.floor((c - u) / Math.pow(10, i)), f = _t(t.min, Math.round((l + u + d * Math.pow(10, i)) * s) / s);
  for (; f < n; )
    r.push({
      value: f,
      major: Ku(f),
      significand: d
    }), d >= 10 ? d = d < 15 ? 15 : 20 : d++, d >= 20 && (i++, d = 2, s = i >= 0 ? 1 : s), f = Math.round((l + u + d * Math.pow(10, i)) * s) / s;
  const h = _t(t.max, f);
  return r.push({
    value: h,
    major: Ku(h),
    significand: d
  }), r;
}
class qu extends ur {
  constructor(e) {
    super(e), this.start = void 0, this.end = void 0, this._startValue = void 0, this._valueRange = 0;
  }
  parse(e, n) {
    const r = Vi.prototype.parse.apply(this, [
      e,
      n
    ]);
    if (r === 0) {
      this._zero = !0;
      return;
    }
    return it(r) && r > 0 ? r : null;
  }
  determineDataLimits() {
    const { min: e, max: n } = this.getMinMax(!0);
    this.min = it(e) ? Math.max(0, e) : null, this.max = it(n) ? Math.max(0, n) : null, this.options.beginAtZero && (this._zero = !0), this._zero && this.min !== this._suggestedMin && !it(this._userMin) && (this.min = e === Gn(this.min, 0) ? Gn(this.min, -1) : Gn(this.min, 0)), this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const { minDefined: e, maxDefined: n } = this.getUserBounds();
    let r = this.min, o = this.max;
    const i = (a) => r = e ? r : a, s = (a) => o = n ? o : a;
    r === o && (r <= 0 ? (i(1), s(10)) : (i(Gn(r, -1)), s(Gn(o, 1)))), r <= 0 && i(Gn(o, -1)), o <= 0 && s(Gn(r, 1)), this.min = r, this.max = o;
  }
  buildTicks() {
    const e = this.options, n = {
      min: this._userMin,
      max: this._userMax
    }, r = wx(n, this);
    return e.bounds === "ticks" && th(r, this, "value"), e.reverse ? (r.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), r;
  }
  getLabelForValue(e) {
    return e === void 0 ? "0" : wl(e, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const e = this.min;
    super.configure(), this._startValue = Pn(e), this._valueRange = Pn(this.max) - Pn(e);
  }
  getPixelForValue(e) {
    return (e === void 0 || e === 0) && (e = this.min), e === null || isNaN(e) ? NaN : this.getPixelForDecimal(e === this.min ? 0 : (Pn(e) - this._startValue) / this._valueRange);
  }
  getValueForPixel(e) {
    const n = this.getDecimalForPixel(e);
    return Math.pow(10, this._startValue + n * this._valueRange);
  }
}
fe(qu, "id", "logarithmic"), fe(qu, "defaults", {
  ticks: {
    callback: is.formatters.logarithmic,
    major: {
      enabled: !0
    }
  }
});
function ka(t) {
  const e = t.ticks;
  if (e.display && t.display) {
    const n = Lt(e.backdropPadding);
    return Fe(e.font && e.font.size, Ze.font.size) + n.height;
  }
  return 0;
}
function xx(t, e, n) {
  return n = Ye(n) ? n : [
    n
  ], {
    w: y1(t, e.string, n),
    h: n.length * e.lineHeight
  };
}
function Xu(t, e, n, r, o) {
  return t === r || t === o ? {
    start: e - n / 2,
    end: e + n / 2
  } : t < r || t > o ? {
    start: e - n,
    end: e
  } : {
    start: e,
    end: e + n
  };
}
function _x(t) {
  const e = {
    l: t.left + t._padding.left,
    r: t.right - t._padding.right,
    t: t.top + t._padding.top,
    b: t.bottom - t._padding.bottom
  }, n = Object.assign({}, e), r = [], o = [], i = t._pointLabels.length, s = t.options.pointLabels, a = s.centerPointLabels ? st / i : 0;
  for (let l = 0; l < i; l++) {
    const c = s.setContext(t.getPointLabelContext(l));
    o[l] = c.padding;
    const u = t.getPointPosition(l, t.drawingArea + o[l], a), d = kt(c.font), f = xx(t.ctx, d, t._pointLabels[l]);
    r[l] = f;
    const h = jt(t.getIndexAngle(l) + a), p = Math.round(vl(h)), g = Xu(p, u.x, f.w, 0, 180), m = Xu(p, u.y, f.h, 90, 270);
    Cx(n, e, h, g, m);
  }
  t.setCenterPoint(e.l - n.l, n.r - e.r, e.t - n.t, n.b - e.b), t._pointLabelItems = kx(t, r, o);
}
function Cx(t, e, n, r, o) {
  const i = Math.abs(Math.sin(n)), s = Math.abs(Math.cos(n));
  let a = 0, l = 0;
  r.start < e.l ? (a = (e.l - r.start) / i, t.l = Math.min(t.l, e.l - a)) : r.end > e.r && (a = (r.end - e.r) / i, t.r = Math.max(t.r, e.r + a)), o.start < e.t ? (l = (e.t - o.start) / s, t.t = Math.min(t.t, e.t - l)) : o.end > e.b && (l = (o.end - e.b) / s, t.b = Math.max(t.b, e.b + l));
}
function Ex(t, e, n) {
  const r = t.drawingArea, { extra: o, additionalAngle: i, padding: s, size: a } = n, l = t.getPointPosition(e, r + o + s, i), c = Math.round(vl(jt(l.angle + wt))), u = Px(l.y, a.h, c), d = Ox(c), f = Sx(l.x, a.w, d);
  return {
    visible: !0,
    x: l.x,
    y: u,
    textAlign: d,
    left: f,
    top: u,
    right: f + a.w,
    bottom: u + a.h
  };
}
function Mx(t, e) {
  if (!e)
    return !0;
  const { left: n, top: r, right: o, bottom: i } = t;
  return !(gn({
    x: n,
    y: r
  }, e) || gn({
    x: n,
    y: i
  }, e) || gn({
    x: o,
    y: r
  }, e) || gn({
    x: o,
    y: i
  }, e));
}
function kx(t, e, n) {
  const r = [], o = t._pointLabels.length, i = t.options, { centerPointLabels: s, display: a } = i.pointLabels, l = {
    extra: ka(i) / 2,
    additionalAngle: s ? st / o : 0
  };
  let c;
  for (let u = 0; u < o; u++) {
    l.padding = n[u], l.size = e[u];
    const d = Ex(t, u, l);
    r.push(d), a === "auto" && (d.visible = Mx(d, c), d.visible && (c = d));
  }
  return r;
}
function Ox(t) {
  return t === 0 || t === 180 ? "center" : t < 180 ? "left" : "right";
}
function Sx(t, e, n) {
  return n === "right" ? t -= e : n === "center" && (t -= e / 2), t;
}
function Px(t, e, n) {
  return n === 90 || n === 270 ? t -= e / 2 : (n > 270 || n < 90) && (t -= e), t;
}
function Ix(t, e, n) {
  const { left: r, top: o, right: i, bottom: s } = n, { backdropColor: a } = e;
  if (!Ve(a)) {
    const l = Er(e.borderRadius), c = Lt(e.backdropPadding);
    t.fillStyle = a;
    const u = r - c.left, d = o - c.top, f = i - r + c.width, h = s - o + c.height;
    Object.values(l).some((p) => p !== 0) ? (t.beginPath(), Ai(t, {
      x: u,
      y: d,
      w: f,
      h,
      radius: l
    }), t.fill()) : t.fillRect(u, d, f, h);
  }
}
function Tx(t, e) {
  const { ctx: n, options: { pointLabels: r } } = t;
  for (let o = e - 1; o >= 0; o--) {
    const i = t._pointLabelItems[o];
    if (!i.visible)
      continue;
    const s = r.setContext(t.getPointLabelContext(o));
    Ix(n, s, i);
    const a = kt(s.font), { x: l, y: c, textAlign: u } = i;
    Ri(n, t._pointLabels[o], l, c + a.lineHeight / 2, a, {
      color: s.color,
      textAlign: u,
      textBaseline: "middle"
    });
  }
}
function Ah(t, e, n, r) {
  const { ctx: o } = t;
  if (n)
    o.arc(t.xCenter, t.yCenter, e, 0, $t);
  else {
    let i = t.getPointPosition(0, e);
    o.moveTo(i.x, i.y);
    for (let s = 1; s < r; s++)
      i = t.getPointPosition(s, e), o.lineTo(i.x, i.y);
  }
}
function Dx(t, e, n, r, o) {
  const i = t.ctx, s = e.circular, { color: a, lineWidth: l } = e;
  !s && !r || !a || !l || n < 0 || (i.save(), i.strokeStyle = a, i.lineWidth = l, i.setLineDash(o.dash), i.lineDashOffset = o.dashOffset, i.beginPath(), Ah(t, n, s, r), i.closePath(), i.stroke(), i.restore());
}
function $x(t, e, n) {
  return Bn(t, {
    label: n,
    index: e,
    type: "pointLabel"
  });
}
class Zo extends Vi {
  constructor(e) {
    super(e), this.xCenter = void 0, this.yCenter = void 0, this.drawingArea = void 0, this._pointLabels = [], this._pointLabelItems = [];
  }
  setDimensions() {
    const e = this._padding = Lt(ka(this.options) / 2), n = this.width = this.maxWidth - e.width, r = this.height = this.maxHeight - e.height;
    this.xCenter = Math.floor(this.left + n / 2 + e.left), this.yCenter = Math.floor(this.top + r / 2 + e.top), this.drawingArea = Math.floor(Math.min(n, r) / 2);
  }
  determineDataLimits() {
    const { min: e, max: n } = this.getMinMax(!1);
    this.min = it(e) && !isNaN(e) ? e : 0, this.max = it(n) && !isNaN(n) ? n : 0, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / ka(this.options));
  }
  generateTickLabels(e) {
    Vi.prototype.generateTickLabels.call(this, e), this._pointLabels = this.getLabels().map((n, r) => {
      const o = Ge(this.options.pointLabels.callback, [
        n,
        r
      ], this);
      return o || o === 0 ? o : "";
    }).filter((n, r) => this.chart.getDataVisibility(r));
  }
  fit() {
    const e = this.options;
    e.display && e.pointLabels.display ? _x(this) : this.setCenterPoint(0, 0, 0, 0);
  }
  setCenterPoint(e, n, r, o) {
    this.xCenter += Math.floor((e - n) / 2), this.yCenter += Math.floor((r - o) / 2), this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(e, n, r, o));
  }
  getIndexAngle(e) {
    const n = $t / (this._pointLabels.length || 1), r = this.options.startAngle || 0;
    return jt(e * n + In(r));
  }
  getDistanceFromCenterForValue(e) {
    if (Ve(e))
      return NaN;
    const n = this.drawingArea / (this.max - this.min);
    return this.options.reverse ? (this.max - e) * n : (e - this.min) * n;
  }
  getValueForDistanceFromCenter(e) {
    if (Ve(e))
      return NaN;
    const n = e / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - n : this.min + n;
  }
  getPointLabelContext(e) {
    const n = this._pointLabels || [];
    if (e >= 0 && e < n.length) {
      const r = n[e];
      return $x(this.getContext(), e, r);
    }
  }
  getPointPosition(e, n, r = 0) {
    const o = this.getIndexAngle(e) - wt + r;
    return {
      x: Math.cos(o) * n + this.xCenter,
      y: Math.sin(o) * n + this.yCenter,
      angle: o
    };
  }
  getPointPositionForValue(e, n) {
    return this.getPointPosition(e, this.getDistanceFromCenterForValue(n));
  }
  getBasePosition(e) {
    return this.getPointPositionForValue(e || 0, this.getBaseValue());
  }
  getPointLabelPosition(e) {
    const { left: n, top: r, right: o, bottom: i } = this._pointLabelItems[e];
    return {
      left: n,
      top: r,
      right: o,
      bottom: i
    };
  }
  drawBackground() {
    const { backgroundColor: e, grid: { circular: n } } = this.options;
    if (e) {
      const r = this.ctx;
      r.save(), r.beginPath(), Ah(this, this.getDistanceFromCenterForValue(this._endValue), n, this._pointLabels.length), r.closePath(), r.fillStyle = e, r.fill(), r.restore();
    }
  }
  drawGrid() {
    const e = this.ctx, n = this.options, { angleLines: r, grid: o, border: i } = n, s = this._pointLabels.length;
    let a, l, c;
    if (n.pointLabels.display && Tx(this, s), o.display && this.ticks.forEach((u, d) => {
      if (d !== 0) {
        l = this.getDistanceFromCenterForValue(u.value);
        const f = this.getContext(d), h = o.setContext(f), p = i.setContext(f);
        Dx(this, h, l, s, p);
      }
    }), r.display) {
      for (e.save(), a = s - 1; a >= 0; a--) {
        const u = r.setContext(this.getPointLabelContext(a)), { color: d, lineWidth: f } = u;
        !f || !d || (e.lineWidth = f, e.strokeStyle = d, e.setLineDash(u.borderDash), e.lineDashOffset = u.borderDashOffset, l = this.getDistanceFromCenterForValue(n.ticks.reverse ? this.min : this.max), c = this.getPointPosition(a, l), e.beginPath(), e.moveTo(this.xCenter, this.yCenter), e.lineTo(c.x, c.y), e.stroke());
      }
      e.restore();
    }
  }
  drawBorder() {
  }
  drawLabels() {
    const e = this.ctx, n = this.options, r = n.ticks;
    if (!r.display)
      return;
    const o = this.getIndexAngle(0);
    let i, s;
    e.save(), e.translate(this.xCenter, this.yCenter), e.rotate(o), e.textAlign = "center", e.textBaseline = "middle", this.ticks.forEach((a, l) => {
      if (l === 0 && !n.reverse)
        return;
      const c = r.setContext(this.getContext(l)), u = kt(c.font);
      if (i = this.getDistanceFromCenterForValue(this.ticks[l].value), c.showLabelBackdrop) {
        e.font = u.string, s = e.measureText(a.label).width, e.fillStyle = c.backdropColor;
        const d = Lt(c.backdropPadding);
        e.fillRect(-s / 2 - d.left, -i - u.size / 2 - d.top, s + d.width, u.size + d.height);
      }
      Ri(e, a.label, 0, -i, u, {
        color: c.color,
        strokeColor: c.textStrokeColor,
        strokeWidth: c.textStrokeWidth
      });
    }), e.restore();
  }
  drawTitle() {
  }
}
fe(Zo, "id", "radialLinear"), fe(Zo, "defaults", {
  display: !0,
  animate: !0,
  position: "chartArea",
  angleLines: {
    display: !0,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0
  },
  grid: {
    circular: !1
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: !0,
    callback: is.formatters.numeric
  },
  pointLabels: {
    backdropColor: void 0,
    backdropPadding: 2,
    display: !0,
    font: {
      size: 10
    },
    callback(e) {
      return e;
    },
    padding: 5,
    centerPointLabels: !1
  }
}), fe(Zo, "defaultRoutes", {
  "angleLines.color": "borderColor",
  "pointLabels.color": "color",
  "ticks.color": "color"
}), fe(Zo, "descriptors", {
  angleLines: {
    _fallback: "grid"
  }
});
const as = {
  millisecond: {
    common: !0,
    size: 1,
    steps: 1e3
  },
  second: {
    common: !0,
    size: 1e3,
    steps: 60
  },
  minute: {
    common: !0,
    size: 6e4,
    steps: 60
  },
  hour: {
    common: !0,
    size: 36e5,
    steps: 24
  },
  day: {
    common: !0,
    size: 864e5,
    steps: 30
  },
  week: {
    common: !1,
    size: 6048e5,
    steps: 4
  },
  month: {
    common: !0,
    size: 2628e6,
    steps: 12
  },
  quarter: {
    common: !1,
    size: 7884e6,
    steps: 4
  },
  year: {
    common: !0,
    size: 3154e7
  }
}, vt = /* @__PURE__ */ Object.keys(as);
function Zu(t, e) {
  return t - e;
}
function Qu(t, e) {
  if (Ve(e))
    return null;
  const n = t._adapter, { parser: r, round: o, isoWeekday: i } = t._parseOpts;
  let s = e;
  return typeof r == "function" && (s = r(s)), it(s) || (s = typeof r == "string" ? n.parse(s, r) : n.parse(s)), s === null ? null : (o && (s = o === "week" && (bo(i) || i === !0) ? n.startOf(s, "isoWeek", i) : n.startOf(s, o)), +s);
}
function Ju(t, e, n, r) {
  const o = vt.length;
  for (let i = vt.indexOf(t); i < o - 1; ++i) {
    const s = as[vt[i]], a = s.steps ? s.steps : Number.MAX_SAFE_INTEGER;
    if (s.common && Math.ceil((n - e) / (a * s.size)) <= r)
      return vt[i];
  }
  return vt[o - 1];
}
function Nx(t, e, n, r, o) {
  for (let i = vt.length - 1; i >= vt.indexOf(n); i--) {
    const s = vt[i];
    if (as[s].common && t._adapter.diff(o, r, s) >= e - 1)
      return s;
  }
  return vt[n ? vt.indexOf(n) : 0];
}
function Rx(t) {
  for (let e = vt.indexOf(t) + 1, n = vt.length; e < n; ++e)
    if (as[vt[e]].common)
      return vt[e];
}
function ed(t, e, n) {
  if (!n)
    t[e] = !0;
  else if (n.length) {
    const { lo: r, hi: o } = bl(n, e), i = n[r] >= e ? n[r] : n[o];
    t[i] = !0;
  }
}
function Ax(t, e, n, r) {
  const o = t._adapter, i = +o.startOf(e[0].value, r), s = e[e.length - 1].value;
  let a, l;
  for (a = i; a <= s; a = +o.add(a, 1, r))
    l = n[a], l >= 0 && (e[l].major = !0);
  return e;
}
function td(t, e, n) {
  const r = [], o = {}, i = e.length;
  let s, a;
  for (s = 0; s < i; ++s)
    a = e[s], o[a] = s, r.push({
      value: a,
      major: !1
    });
  return i === 0 || !n ? r : Ax(t, r, o, n);
}
class xo extends ur {
  constructor(e) {
    super(e), this._cache = {
      data: [],
      labels: [],
      all: []
    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
  }
  init(e, n = {}) {
    const r = e.time || (e.time = {}), o = this._adapter = new _h._date(e.adapters.date);
    o.init(n), ro(r.displayFormats, o.formats()), this._parseOpts = {
      parser: r.parser,
      round: r.round,
      isoWeekday: r.isoWeekday
    }, super.init(e), this._normalized = n.normalized;
  }
  parse(e, n) {
    return e === void 0 ? null : Qu(this, e);
  }
  beforeLayout() {
    super.beforeLayout(), this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const e = this.options, n = this._adapter, r = e.time.unit || "day";
    let { min: o, max: i, minDefined: s, maxDefined: a } = this.getUserBounds();
    function l(c) {
      !s && !isNaN(c.min) && (o = Math.min(o, c.min)), !a && !isNaN(c.max) && (i = Math.max(i, c.max));
    }
    (!s || !a) && (l(this._getLabelBounds()), (e.bounds !== "ticks" || e.ticks.source !== "labels") && l(this.getMinMax(!1))), o = it(o) && !isNaN(o) ? o : +n.startOf(Date.now(), r), i = it(i) && !isNaN(i) ? i : +n.endOf(Date.now(), r) + 1, this.min = Math.min(o, i - 1), this.max = Math.max(o + 1, i);
  }
  _getLabelBounds() {
    const e = this.getLabelTimestamps();
    let n = Number.POSITIVE_INFINITY, r = Number.NEGATIVE_INFINITY;
    return e.length && (n = e[0], r = e[e.length - 1]), {
      min: n,
      max: r
    };
  }
  buildTicks() {
    const e = this.options, n = e.time, r = e.ticks, o = r.source === "labels" ? this.getLabelTimestamps() : this._generate();
    e.bounds === "ticks" && o.length && (this.min = this._userMin || o[0], this.max = this._userMax || o[o.length - 1]);
    const i = this.min, s = this.max, a = o1(o, i, s);
    return this._unit = n.unit || (r.autoSkip ? Ju(n.minUnit, this.min, this.max, this._getLabelCapacity(i)) : Nx(this, a.length, n.minUnit, this.min, this.max)), this._majorUnit = !r.major.enabled || this._unit === "year" ? void 0 : Rx(this._unit), this.initOffsets(o), e.reverse && a.reverse(), td(this, a, this._majorUnit);
  }
  afterAutoSkip() {
    this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((e) => +e.value));
  }
  initOffsets(e = []) {
    let n = 0, r = 0, o, i;
    this.options.offset && e.length && (o = this.getDecimalForValue(e[0]), e.length === 1 ? n = 1 - o : n = (this.getDecimalForValue(e[1]) - o) / 2, i = this.getDecimalForValue(e[e.length - 1]), e.length === 1 ? r = i : r = (i - this.getDecimalForValue(e[e.length - 2])) / 2);
    const s = e.length < 3 ? 0.5 : 0.25;
    n = Mt(n, 0, s), r = Mt(r, 0, s), this._offsets = {
      start: n,
      end: r,
      factor: 1 / (n + 1 + r)
    };
  }
  _generate() {
    const e = this._adapter, n = this.min, r = this.max, o = this.options, i = o.time, s = i.unit || Ju(i.minUnit, n, r, this._getLabelCapacity(n)), a = Fe(o.ticks.stepSize, 1), l = s === "week" ? i.isoWeekday : !1, c = bo(l) || l === !0, u = {};
    let d = n, f, h;
    if (c && (d = +e.startOf(d, "isoWeek", l)), d = +e.startOf(d, c ? "day" : s), e.diff(r, n, s) > 1e5 * a)
      throw new Error(n + " and " + r + " are too far apart with stepSize of " + a + " " + s);
    const p = o.ticks.source === "data" && this.getDataTimestamps();
    for (f = d, h = 0; f < r; f = +e.add(f, a, s), h++)
      ed(u, f, p);
    return (f === r || o.bounds === "ticks" || h === 1) && ed(u, f, p), Object.keys(u).sort(Zu).map((g) => +g);
  }
  getLabelForValue(e) {
    const n = this._adapter, r = this.options.time;
    return r.tooltipFormat ? n.format(e, r.tooltipFormat) : n.format(e, r.displayFormats.datetime);
  }
  format(e, n) {
    const o = this.options.time.displayFormats, i = this._unit, s = n || o[i];
    return this._adapter.format(e, s);
  }
  _tickFormatFunction(e, n, r, o) {
    const i = this.options, s = i.ticks.callback;
    if (s)
      return Ge(s, [
        e,
        n,
        r
      ], this);
    const a = i.time.displayFormats, l = this._unit, c = this._majorUnit, u = l && a[l], d = c && a[c], f = r[n], h = c && d && f && f.major;
    return this._adapter.format(e, o || (h ? d : u));
  }
  generateTickLabels(e) {
    let n, r, o;
    for (n = 0, r = e.length; n < r; ++n)
      o = e[n], o.label = this._tickFormatFunction(o.value, n, e);
  }
  getDecimalForValue(e) {
    return e === null ? NaN : (e - this.min) / (this.max - this.min);
  }
  getPixelForValue(e) {
    const n = this._offsets, r = this.getDecimalForValue(e);
    return this.getPixelForDecimal((n.start + r) * n.factor);
  }
  getValueForPixel(e) {
    const n = this._offsets, r = this.getDecimalForPixel(e) / n.factor - n.end;
    return this.min + r * (this.max - this.min);
  }
  _getLabelSize(e) {
    const n = this.options.ticks, r = this.ctx.measureText(e).width, o = In(this.isHorizontal() ? n.maxRotation : n.minRotation), i = Math.cos(o), s = Math.sin(o), a = this._resolveTickFontOptions(0).size;
    return {
      w: r * i + a * s,
      h: r * s + a * i
    };
  }
  _getLabelCapacity(e) {
    const n = this.options.time, r = n.displayFormats, o = r[n.unit] || r.millisecond, i = this._tickFormatFunction(e, 0, td(this, [
      e
    ], this._majorUnit), o), s = this._getLabelSize(i), a = Math.floor(this.isHorizontal() ? this.width / s.w : this.height / s.h) - 1;
    return a > 0 ? a : 1;
  }
  getDataTimestamps() {
    let e = this._cache.data || [], n, r;
    if (e.length)
      return e;
    const o = this.getMatchingVisibleMetas();
    if (this._normalized && o.length)
      return this._cache.data = o[0].controller.getAllParsedValues(this);
    for (n = 0, r = o.length; n < r; ++n)
      e = e.concat(o[n].controller.getAllParsedValues(this));
    return this._cache.data = this.normalize(e);
  }
  getLabelTimestamps() {
    const e = this._cache.labels || [];
    let n, r;
    if (e.length)
      return e;
    const o = this.getLabels();
    for (n = 0, r = o.length; n < r; ++n)
      e.push(Qu(this, o[n]));
    return this._cache.labels = this._normalized ? e : this.normalize(e);
  }
  normalize(e) {
    return oh(e.sort(Zu));
  }
}
fe(xo, "id", "time"), fe(xo, "defaults", {
  bounds: "data",
  adapters: {},
  time: {
    parser: !1,
    unit: !1,
    round: !1,
    isoWeekday: !1,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    callback: !1,
    major: {
      enabled: !1
    }
  }
});
function Qo(t, e, n) {
  let r = 0, o = t.length - 1, i, s, a, l;
  n ? (e >= t[r].pos && e <= t[o].pos && ({ lo: r, hi: o } = Jn(t, "pos", e)), { pos: i, time: a } = t[r], { pos: s, time: l } = t[o]) : (e >= t[r].time && e <= t[o].time && ({ lo: r, hi: o } = Jn(t, "time", e)), { time: i, pos: a } = t[r], { time: s, pos: l } = t[o]);
  const c = s - i;
  return c ? a + (l - a) * (e - i) / c : a;
}
class nd extends xo {
  constructor(e) {
    super(e), this._table = [], this._minPos = void 0, this._tableRange = void 0;
  }
  initOffsets() {
    const e = this._getTimestampsForTable(), n = this._table = this.buildLookupTable(e);
    this._minPos = Qo(n, this.min), this._tableRange = Qo(n, this.max) - this._minPos, super.initOffsets(e);
  }
  buildLookupTable(e) {
    const { min: n, max: r } = this, o = [], i = [];
    let s, a, l, c, u;
    for (s = 0, a = e.length; s < a; ++s)
      c = e[s], c >= n && c <= r && o.push(c);
    if (o.length < 2)
      return [
        {
          time: n,
          pos: 0
        },
        {
          time: r,
          pos: 1
        }
      ];
    for (s = 0, a = o.length; s < a; ++s)
      u = o[s + 1], l = o[s - 1], c = o[s], Math.round((u + l) / 2) !== c && i.push({
        time: c,
        pos: s / (a - 1)
      });
    return i;
  }
  _generate() {
    const e = this.min, n = this.max;
    let r = super.getDataTimestamps();
    return (!r.includes(e) || !r.length) && r.splice(0, 0, e), (!r.includes(n) || r.length === 1) && r.push(n), r.sort((o, i) => o - i);
  }
  _getTimestampsForTable() {
    let e = this._cache.all || [];
    if (e.length)
      return e;
    const n = this.getDataTimestamps(), r = this.getLabelTimestamps();
    return n.length && r.length ? e = this.normalize(n.concat(r)) : e = n.length ? n : r, e = this._cache.all = e, e;
  }
  getDecimalForValue(e) {
    return (Qo(this._table, e) - this._minPos) / this._tableRange;
  }
  getValueForPixel(e) {
    const n = this._offsets, r = this.getDecimalForPixel(e) / n.factor - n.end;
    return Qo(this._table, r * this._tableRange + this._minPos, !0);
  }
}
fe(nd, "id", "timeseries"), fe(nd, "defaults", xo.defaults);
const Lh = "label";
function rd(t, e) {
  typeof t == "function" ? t(e) : t && (t.current = e);
}
function Lx(t, e) {
  const n = t.options;
  n && e && Object.assign(n, e);
}
function Fh(t, e) {
  t.labels = e;
}
function Vh(t, e) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Lh;
  const r = [];
  t.datasets = e.map((o) => {
    const i = t.datasets.find((s) => s[n] === o[n]);
    return !i || !o.data || r.includes(i) ? {
      ...o
    } : (r.push(i), Object.assign(i, o), i);
  });
}
function Fx(t) {
  let e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Lh;
  const n = {
    labels: [],
    datasets: []
  };
  return Fh(n, t.labels), Vh(n, t.datasets, e), n;
}
function Vx(t, e) {
  const { height: n = 150, width: r = 300, redraw: o = !1, datasetIdKey: i, type: s, data: a, options: l, plugins: c = [], fallbackContent: u, updateMode: d, ...f } = t, h = ae(null), p = ae(), g = () => {
    h.current && (p.current = new kl(h.current, {
      type: s,
      data: Fx(a, i),
      options: l && {
        ...l
      },
      plugins: c
    }), rd(e, p.current));
  }, m = () => {
    rd(e, null), p.current && (p.current.destroy(), p.current = null);
  };
  return ue(() => {
    !o && p.current && l && Lx(p.current, l);
  }, [
    o,
    l
  ]), ue(() => {
    !o && p.current && Fh(p.current.config.data, a.labels);
  }, [
    o,
    a.labels
  ]), ue(() => {
    !o && p.current && a.datasets && Vh(p.current.config.data, a.datasets, i);
  }, [
    o,
    a.datasets
  ]), ue(() => {
    p.current && (o ? (m(), setTimeout(g)) : p.current.update(d));
  }, [
    o,
    l,
    a.labels,
    a.datasets,
    d
  ]), ue(() => {
    p.current && (m(), setTimeout(g));
  }, [
    s
  ]), ue(() => (g(), () => m()), []), /* @__PURE__ */ I.createElement("canvas", Object.assign({
    ref: h,
    role: "img",
    height: n,
    width: r
  }, f), u);
}
const Wx = /* @__PURE__ */ de(Vx);
function zt(t) {
  "@babel/helpers - typeof";
  return zt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, zt(t);
}
function Ne(t) {
  if (t === null || t === !0 || t === !1)
    return NaN;
  var e = Number(t);
  return isNaN(e) ? e : e < 0 ? Math.ceil(e) : Math.floor(e);
}
function Q(t, e) {
  if (e.length < t)
    throw new TypeError(t + " argument" + (t > 1 ? "s" : "") + " required, but only " + e.length + " present");
}
function le(t) {
  Q(1, arguments);
  var e = Object.prototype.toString.call(t);
  return t instanceof Date || zt(t) === "object" && e === "[object Date]" ? new Date(t.getTime()) : typeof t == "number" || e === "[object Number]" ? new Date(t) : ((typeof t == "string" || e === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function Et(t, e) {
  Q(2, arguments);
  var n = le(t), r = Ne(e);
  return isNaN(r) ? /* @__PURE__ */ new Date(NaN) : (r && n.setDate(n.getDate() + r), n);
}
function Ft(t, e) {
  Q(2, arguments);
  var n = le(t), r = Ne(e);
  if (isNaN(r))
    return /* @__PURE__ */ new Date(NaN);
  if (!r)
    return n;
  var o = n.getDate(), i = new Date(n.getTime());
  i.setMonth(n.getMonth() + r + 1, 0);
  var s = i.getDate();
  return o >= s ? i : (n.setFullYear(i.getFullYear(), i.getMonth(), o), n);
}
function Oo(t, e) {
  Q(2, arguments);
  var n = le(t).getTime(), r = Ne(e);
  return new Date(n + r);
}
var Hx = 36e5;
function Bx(t, e) {
  Q(2, arguments);
  var n = Ne(e);
  return Oo(t, n * Hx);
}
var jx = {};
function ln() {
  return jx;
}
function Vt(t, e) {
  var n, r, o, i, s, a, l, c;
  Q(1, arguments);
  var u = ln(), d = Ne((n = (r = (o = (i = e == null ? void 0 : e.weekStartsOn) !== null && i !== void 0 ? i : e == null || (s = e.locale) === null || s === void 0 || (a = s.options) === null || a === void 0 ? void 0 : a.weekStartsOn) !== null && o !== void 0 ? o : u.weekStartsOn) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = le(t), h = f.getDay(), p = (h < d ? 7 : 0) + h - d;
  return f.setDate(f.getDate() - p), f.setHours(0, 0, 0, 0), f;
}
function ir(t) {
  return Q(1, arguments), Vt(t, {
    weekStartsOn: 1
  });
}
function zx(t) {
  Q(1, arguments);
  var e = le(t), n = e.getFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  var o = ir(r), i = /* @__PURE__ */ new Date(0);
  i.setFullYear(n, 0, 4), i.setHours(0, 0, 0, 0);
  var s = ir(i);
  return e.getTime() >= o.getTime() ? n + 1 : e.getTime() >= s.getTime() ? n : n - 1;
}
function Ux(t) {
  Q(1, arguments);
  var e = zx(t), n = /* @__PURE__ */ new Date(0);
  n.setFullYear(e, 0, 4), n.setHours(0, 0, 0, 0);
  var r = ir(n);
  return r;
}
function Ir(t) {
  var e = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
  return e.setUTCFullYear(t.getFullYear()), t.getTime() - e.getTime();
}
function sr(t) {
  Q(1, arguments);
  var e = le(t);
  return e.setHours(0, 0, 0, 0), e;
}
var Yx = 864e5;
function Dt(t, e) {
  Q(2, arguments);
  var n = sr(t), r = sr(e), o = n.getTime() - Ir(n), i = r.getTime() - Ir(r);
  return Math.round((o - i) / Yx);
}
var Kx = 6e4;
function Gx(t, e) {
  Q(2, arguments);
  var n = Ne(e);
  return Oo(t, n * Kx);
}
function qx(t, e) {
  Q(2, arguments);
  var n = Ne(e), r = n * 3;
  return Ft(t, r);
}
function Xx(t, e) {
  Q(2, arguments);
  var n = Ne(e);
  return Oo(t, n * 1e3);
}
function Wi(t, e) {
  Q(2, arguments);
  var n = Ne(e), r = n * 7;
  return Et(t, r);
}
function Wh(t, e) {
  Q(2, arguments);
  var n = Ne(e);
  return Ft(t, n * 12);
}
function Zx(t) {
  Q(1, arguments);
  var e;
  if (t && typeof t.forEach == "function")
    e = t;
  else if (zt(t) === "object" && t !== null)
    e = Array.prototype.slice.call(t);
  else
    return /* @__PURE__ */ new Date(NaN);
  var n;
  return e.forEach(function(r) {
    var o = le(r);
    (n === void 0 || n < o || isNaN(Number(o))) && (n = o);
  }), n || /* @__PURE__ */ new Date(NaN);
}
function Qx(t) {
  Q(1, arguments);
  var e;
  if (t && typeof t.forEach == "function")
    e = t;
  else if (zt(t) === "object" && t !== null)
    e = Array.prototype.slice.call(t);
  else
    return /* @__PURE__ */ new Date(NaN);
  var n;
  return e.forEach(function(r) {
    var o = le(r);
    (n === void 0 || n > o || isNaN(o.getDate())) && (n = o);
  }), n || /* @__PURE__ */ new Date(NaN);
}
function ao(t, e) {
  Q(2, arguments);
  var n = le(t), r = le(e), o = n.getTime() - r.getTime();
  return o < 0 ? -1 : o > 0 ? 1 : o;
}
var ls = 6e4, cs = 36e5, Jx = 1e3;
function bt(t, e) {
  Q(2, arguments);
  var n = sr(t), r = sr(e);
  return n.getTime() === r.getTime();
}
function Ol(t) {
  return Q(1, arguments), t instanceof Date || zt(t) === "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function Sl(t) {
  if (Q(1, arguments), !Ol(t) && typeof t != "number")
    return !1;
  var e = le(t);
  return !isNaN(Number(e));
}
function Tr(t, e) {
  Q(2, arguments);
  var n = le(t), r = le(e), o = n.getFullYear() - r.getFullYear(), i = n.getMonth() - r.getMonth();
  return o * 12 + i;
}
var e_ = 6048e5;
function t_(t, e, n) {
  Q(2, arguments);
  var r = Vt(t, n), o = Vt(e, n), i = r.getTime() - Ir(r), s = o.getTime() - Ir(o);
  return Math.round((i - s) / e_);
}
function n_(t, e) {
  Q(2, arguments);
  var n = le(t), r = le(e);
  return n.getFullYear() - r.getFullYear();
}
function od(t, e) {
  var n = t.getFullYear() - e.getFullYear() || t.getMonth() - e.getMonth() || t.getDate() - e.getDate() || t.getHours() - e.getHours() || t.getMinutes() - e.getMinutes() || t.getSeconds() - e.getSeconds() || t.getMilliseconds() - e.getMilliseconds();
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function Hh(t, e) {
  Q(2, arguments);
  var n = le(t), r = le(e), o = od(n, r), i = Math.abs(Dt(n, r));
  n.setDate(n.getDate() - o * i);
  var s = +(od(n, r) === -o), a = o * (i - s);
  return a === 0 ? 0 : a;
}
function us(t, e) {
  return Q(2, arguments), le(t).getTime() - le(e).getTime();
}
var id = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function(e) {
    return e < 0 ? Math.ceil(e) : Math.floor(e);
  }
  // Math.trunc is not supported by IE
}, r_ = "trunc";
function So(t) {
  return t ? id[t] : id[r_];
}
function o_(t, e, n) {
  Q(2, arguments);
  var r = us(t, e) / cs;
  return So(n == null ? void 0 : n.roundingMethod)(r);
}
function i_(t, e, n) {
  Q(2, arguments);
  var r = us(t, e) / ls;
  return So(n == null ? void 0 : n.roundingMethod)(r);
}
function Bh(t) {
  Q(1, arguments);
  var e = le(t);
  return e.setHours(23, 59, 59, 999), e;
}
function Po(t) {
  Q(1, arguments);
  var e = le(t), n = e.getMonth();
  return e.setFullYear(e.getFullYear(), n + 1, 0), e.setHours(23, 59, 59, 999), e;
}
function s_(t) {
  Q(1, arguments);
  var e = le(t);
  return Bh(e).getTime() === Po(e).getTime();
}
function jh(t, e) {
  Q(2, arguments);
  var n = le(t), r = le(e), o = ao(n, r), i = Math.abs(Tr(n, r)), s;
  if (i < 1)
    s = 0;
  else {
    n.getMonth() === 1 && n.getDate() > 27 && n.setDate(30), n.setMonth(n.getMonth() - o * i);
    var a = ao(n, r) === -o;
    s_(le(t)) && i === 1 && ao(t, r) === 1 && (a = !1), s = o * (i - Number(a));
  }
  return s === 0 ? 0 : s;
}
function a_(t, e, n) {
  Q(2, arguments);
  var r = jh(t, e) / 3;
  return So(n == null ? void 0 : n.roundingMethod)(r);
}
function l_(t, e, n) {
  Q(2, arguments);
  var r = us(t, e) / 1e3;
  return So(n == null ? void 0 : n.roundingMethod)(r);
}
function c_(t, e, n) {
  Q(2, arguments);
  var r = Hh(t, e) / 7;
  return So(n == null ? void 0 : n.roundingMethod)(r);
}
function u_(t, e) {
  Q(2, arguments);
  var n = le(t), r = le(e), o = ao(n, r), i = Math.abs(n_(n, r));
  n.setFullYear(1584), r.setFullYear(1584);
  var s = ao(n, r) === -o, a = o * (i - Number(s));
  return a === 0 ? 0 : a;
}
function d_(t) {
  Q(1, arguments);
  var e = le(t);
  return e.setSeconds(0, 0), e;
}
function f_(t) {
  Q(1, arguments);
  var e = le(t), n = e.getMonth(), r = n - n % 3;
  return e.setMonth(r, 1), e.setHours(0, 0, 0, 0), e;
}
function ht(t) {
  Q(1, arguments);
  var e = le(t);
  return e.setDate(1), e.setHours(0, 0, 0, 0), e;
}
function h_(t) {
  Q(1, arguments);
  var e = le(t), n = e.getFullYear();
  return e.setFullYear(n + 1, 0, 0), e.setHours(23, 59, 59, 999), e;
}
function zh(t) {
  Q(1, arguments);
  var e = le(t), n = /* @__PURE__ */ new Date(0);
  return n.setFullYear(e.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function p_(t) {
  Q(1, arguments);
  var e = le(t);
  return e.setMinutes(59, 59, 999), e;
}
function ds(t, e) {
  var n, r, o, i, s, a, l, c;
  Q(1, arguments);
  var u = ln(), d = Ne((n = (r = (o = (i = e == null ? void 0 : e.weekStartsOn) !== null && i !== void 0 ? i : e == null || (s = e.locale) === null || s === void 0 || (a = s.options) === null || a === void 0 ? void 0 : a.weekStartsOn) !== null && o !== void 0 ? o : u.weekStartsOn) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = le(t), h = f.getDay(), p = (h < d ? -7 : 0) + 6 - (h - d);
  return f.setDate(f.getDate() + p), f.setHours(23, 59, 59, 999), f;
}
function Uh(t) {
  return Q(1, arguments), ds(t, {
    weekStartsOn: 1
  });
}
function g_(t) {
  Q(1, arguments);
  var e = le(t);
  return e.setSeconds(59, 999), e;
}
function m_(t) {
  Q(1, arguments);
  var e = le(t), n = e.getMonth(), r = n - n % 3 + 3;
  return e.setMonth(r, 0), e.setHours(23, 59, 59, 999), e;
}
function v_(t) {
  Q(1, arguments);
  var e = le(t);
  return e.setMilliseconds(999), e;
}
function Yh(t, e) {
  Q(2, arguments);
  var n = Ne(e);
  return Oo(t, -n);
}
var b_ = 864e5;
function y_(t) {
  Q(1, arguments);
  var e = le(t), n = e.getTime();
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
  var r = e.getTime(), o = n - r;
  return Math.floor(o / b_) + 1;
}
function Dr(t) {
  Q(1, arguments);
  var e = 1, n = le(t), r = n.getUTCDay(), o = (r < e ? 7 : 0) + r - e;
  return n.setUTCDate(n.getUTCDate() - o), n.setUTCHours(0, 0, 0, 0), n;
}
function Kh(t) {
  Q(1, arguments);
  var e = le(t), n = e.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var o = Dr(r), i = /* @__PURE__ */ new Date(0);
  i.setUTCFullYear(n, 0, 4), i.setUTCHours(0, 0, 0, 0);
  var s = Dr(i);
  return e.getTime() >= o.getTime() ? n + 1 : e.getTime() >= s.getTime() ? n : n - 1;
}
function w_(t) {
  Q(1, arguments);
  var e = Kh(t), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = Dr(n);
  return r;
}
var x_ = 6048e5;
function Gh(t) {
  Q(1, arguments);
  var e = le(t), n = Dr(e).getTime() - w_(e).getTime();
  return Math.round(n / x_) + 1;
}
function ar(t, e) {
  var n, r, o, i, s, a, l, c;
  Q(1, arguments);
  var u = ln(), d = Ne((n = (r = (o = (i = e == null ? void 0 : e.weekStartsOn) !== null && i !== void 0 ? i : e == null || (s = e.locale) === null || s === void 0 || (a = s.options) === null || a === void 0 ? void 0 : a.weekStartsOn) !== null && o !== void 0 ? o : u.weekStartsOn) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = le(t), h = f.getUTCDay(), p = (h < d ? 7 : 0) + h - d;
  return f.setUTCDate(f.getUTCDate() - p), f.setUTCHours(0, 0, 0, 0), f;
}
function Pl(t, e) {
  var n, r, o, i, s, a, l, c;
  Q(1, arguments);
  var u = le(t), d = u.getUTCFullYear(), f = ln(), h = Ne((n = (r = (o = (i = e == null ? void 0 : e.firstWeekContainsDate) !== null && i !== void 0 ? i : e == null || (s = e.locale) === null || s === void 0 || (a = s.options) === null || a === void 0 ? void 0 : a.firstWeekContainsDate) !== null && o !== void 0 ? o : f.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = f.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(h >= 1 && h <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var p = /* @__PURE__ */ new Date(0);
  p.setUTCFullYear(d + 1, 0, h), p.setUTCHours(0, 0, 0, 0);
  var g = ar(p, e), m = /* @__PURE__ */ new Date(0);
  m.setUTCFullYear(d, 0, h), m.setUTCHours(0, 0, 0, 0);
  var b = ar(m, e);
  return u.getTime() >= g.getTime() ? d + 1 : u.getTime() >= b.getTime() ? d : d - 1;
}
function __(t, e) {
  var n, r, o, i, s, a, l, c;
  Q(1, arguments);
  var u = ln(), d = Ne((n = (r = (o = (i = e == null ? void 0 : e.firstWeekContainsDate) !== null && i !== void 0 ? i : e == null || (s = e.locale) === null || s === void 0 || (a = s.options) === null || a === void 0 ? void 0 : a.firstWeekContainsDate) !== null && o !== void 0 ? o : u.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), f = Pl(t, e), h = /* @__PURE__ */ new Date(0);
  h.setUTCFullYear(f, 0, d), h.setUTCHours(0, 0, 0, 0);
  var p = ar(h, e);
  return p;
}
var C_ = 6048e5;
function qh(t, e) {
  Q(1, arguments);
  var n = le(t), r = ar(n, e).getTime() - __(n, e).getTime();
  return Math.round(r / C_) + 1;
}
function Ae(t, e) {
  for (var n = t < 0 ? "-" : "", r = Math.abs(t).toString(); r.length < e; )
    r = "0" + r;
  return n + r;
}
var E_ = {
  // Year
  y: function(e, n) {
    var r = e.getUTCFullYear(), o = r > 0 ? r : 1 - r;
    return Ae(n === "yy" ? o % 100 : o, n.length);
  },
  // Month
  M: function(e, n) {
    var r = e.getUTCMonth();
    return n === "M" ? String(r + 1) : Ae(r + 1, 2);
  },
  // Day of the month
  d: function(e, n) {
    return Ae(e.getUTCDate(), n.length);
  },
  // AM or PM
  a: function(e, n) {
    var r = e.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(e, n) {
    return Ae(e.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function(e, n) {
    return Ae(e.getUTCHours(), n.length);
  },
  // Minute
  m: function(e, n) {
    return Ae(e.getUTCMinutes(), n.length);
  },
  // Second
  s: function(e, n) {
    return Ae(e.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function(e, n) {
    var r = n.length, o = e.getUTCMilliseconds(), i = Math.floor(o * Math.pow(10, r - 3));
    return Ae(i, n.length);
  }
};
const En = E_;
var mr = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, M_ = {
  // Era
  G: function(e, n, r) {
    var o = e.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(o, {
          width: "abbreviated"
        });
      case "GGGGG":
        return r.era(o, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return r.era(o, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(e, n, r) {
    if (n === "yo") {
      var o = e.getUTCFullYear(), i = o > 0 ? o : 1 - o;
      return r.ordinalNumber(i, {
        unit: "year"
      });
    }
    return En.y(e, n);
  },
  // Local week-numbering year
  Y: function(e, n, r, o) {
    var i = Pl(e, o), s = i > 0 ? i : 1 - i;
    if (n === "YY") {
      var a = s % 100;
      return Ae(a, 2);
    }
    return n === "Yo" ? r.ordinalNumber(s, {
      unit: "year"
    }) : Ae(s, n.length);
  },
  // ISO week-numbering year
  R: function(e, n) {
    var r = Kh(e);
    return Ae(r, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, n) {
    var r = e.getUTCFullYear();
    return Ae(r, n.length);
  },
  // Quarter
  Q: function(e, n, r) {
    var o = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(o);
      case "QQ":
        return Ae(o, 2);
      case "Qo":
        return r.ordinalNumber(o, {
          unit: "quarter"
        });
      case "QQQ":
        return r.quarter(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(o, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, n, r) {
    var o = Math.ceil((e.getUTCMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(o);
      case "qq":
        return Ae(o, 2);
      case "qo":
        return r.ordinalNumber(o, {
          unit: "quarter"
        });
      case "qqq":
        return r.quarter(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(o, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, n, r) {
    var o = e.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return En.M(e, n);
      case "Mo":
        return r.ordinalNumber(o + 1, {
          unit: "month"
        });
      case "MMM":
        return r.month(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(o, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(e, n, r) {
    var o = e.getUTCMonth();
    switch (n) {
      case "L":
        return String(o + 1);
      case "LL":
        return Ae(o + 1, 2);
      case "Lo":
        return r.ordinalNumber(o + 1, {
          unit: "month"
        });
      case "LLL":
        return r.month(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(o, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(e, n, r, o) {
    var i = qh(e, o);
    return n === "wo" ? r.ordinalNumber(i, {
      unit: "week"
    }) : Ae(i, n.length);
  },
  // ISO week of year
  I: function(e, n, r) {
    var o = Gh(e);
    return n === "Io" ? r.ordinalNumber(o, {
      unit: "week"
    }) : Ae(o, n.length);
  },
  // Day of the month
  d: function(e, n, r) {
    return n === "do" ? r.ordinalNumber(e.getUTCDate(), {
      unit: "date"
    }) : En.d(e, n);
  },
  // Day of year
  D: function(e, n, r) {
    var o = y_(e);
    return n === "Do" ? r.ordinalNumber(o, {
      unit: "dayOfYear"
    }) : Ae(o, n.length);
  },
  // Day of week
  E: function(e, n, r) {
    var o = e.getUTCDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(o, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, n, r, o) {
    var i = e.getUTCDay(), s = (i - o.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(s);
      case "ee":
        return Ae(s, 2);
      case "eo":
        return r.ordinalNumber(s, {
          unit: "day"
        });
      case "eee":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, n, r, o) {
    var i = e.getUTCDay(), s = (i - o.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(s);
      case "cc":
        return Ae(s, n.length);
      case "co":
        return r.ordinalNumber(s, {
          unit: "day"
        });
      case "ccc":
        return r.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, n, r) {
    var o = e.getUTCDay(), i = o === 0 ? 7 : o;
    switch (n) {
      case "i":
        return String(i);
      case "ii":
        return Ae(i, n.length);
      case "io":
        return r.ordinalNumber(i, {
          unit: "day"
        });
      case "iii":
        return r.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(o, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, n, r) {
    var o = e.getUTCHours(), i = o / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, n, r) {
    var o = e.getUTCHours(), i;
    switch (o === 12 ? i = mr.noon : o === 0 ? i = mr.midnight : i = o / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, n, r) {
    var o = e.getUTCHours(), i;
    switch (o >= 17 ? i = mr.evening : o >= 12 ? i = mr.afternoon : o >= 4 ? i = mr.morning : i = mr.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, n, r) {
    if (n === "ho") {
      var o = e.getUTCHours() % 12;
      return o === 0 && (o = 12), r.ordinalNumber(o, {
        unit: "hour"
      });
    }
    return En.h(e, n);
  },
  // Hour [0-23]
  H: function(e, n, r) {
    return n === "Ho" ? r.ordinalNumber(e.getUTCHours(), {
      unit: "hour"
    }) : En.H(e, n);
  },
  // Hour [0-11]
  K: function(e, n, r) {
    var o = e.getUTCHours() % 12;
    return n === "Ko" ? r.ordinalNumber(o, {
      unit: "hour"
    }) : Ae(o, n.length);
  },
  // Hour [1-24]
  k: function(e, n, r) {
    var o = e.getUTCHours();
    return o === 0 && (o = 24), n === "ko" ? r.ordinalNumber(o, {
      unit: "hour"
    }) : Ae(o, n.length);
  },
  // Minute
  m: function(e, n, r) {
    return n === "mo" ? r.ordinalNumber(e.getUTCMinutes(), {
      unit: "minute"
    }) : En.m(e, n);
  },
  // Second
  s: function(e, n, r) {
    return n === "so" ? r.ordinalNumber(e.getUTCSeconds(), {
      unit: "second"
    }) : En.s(e, n);
  },
  // Fraction of second
  S: function(e, n) {
    return En.S(e, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, n, r, o) {
    var i = o._originalDate || e, s = i.getTimezoneOffset();
    if (s === 0)
      return "Z";
    switch (n) {
      case "X":
        return ad(s);
      case "XXXX":
      case "XX":
        return Zn(s);
      case "XXXXX":
      case "XXX":
      default:
        return Zn(s, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, n, r, o) {
    var i = o._originalDate || e, s = i.getTimezoneOffset();
    switch (n) {
      case "x":
        return ad(s);
      case "xxxx":
      case "xx":
        return Zn(s);
      case "xxxxx":
      case "xxx":
      default:
        return Zn(s, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, n, r, o) {
    var i = o._originalDate || e, s = i.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + sd(s, ":");
      case "OOOO":
      default:
        return "GMT" + Zn(s, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, n, r, o) {
    var i = o._originalDate || e, s = i.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + sd(s, ":");
      case "zzzz":
      default:
        return "GMT" + Zn(s, ":");
    }
  },
  // Seconds timestamp
  t: function(e, n, r, o) {
    var i = o._originalDate || e, s = Math.floor(i.getTime() / 1e3);
    return Ae(s, n.length);
  },
  // Milliseconds timestamp
  T: function(e, n, r, o) {
    var i = o._originalDate || e, s = i.getTime();
    return Ae(s, n.length);
  }
};
function sd(t, e) {
  var n = t > 0 ? "-" : "+", r = Math.abs(t), o = Math.floor(r / 60), i = r % 60;
  if (i === 0)
    return n + String(o);
  var s = e || "";
  return n + String(o) + s + Ae(i, 2);
}
function ad(t, e) {
  if (t % 60 === 0) {
    var n = t > 0 ? "-" : "+";
    return n + Ae(Math.abs(t) / 60, 2);
  }
  return Zn(t, e);
}
function Zn(t, e) {
  var n = e || "", r = t > 0 ? "-" : "+", o = Math.abs(t), i = Ae(Math.floor(o / 60), 2), s = Ae(o % 60, 2);
  return r + i + n + s;
}
const k_ = M_;
var ld = function(e, n) {
  switch (e) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, Xh = function(e, n) {
  switch (e) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, O_ = function(e, n) {
  var r = e.match(/(P+)(p+)?/) || [], o = r[1], i = r[2];
  if (!i)
    return ld(e, n);
  var s;
  switch (o) {
    case "P":
      s = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      s = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      s = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      s = n.dateTime({
        width: "full"
      });
      break;
  }
  return s.replace("{{date}}", ld(o, n)).replace("{{time}}", Xh(i, n));
}, S_ = {
  p: Xh,
  P: O_
};
const Oa = S_;
var P_ = ["D", "DD"], I_ = ["YY", "YYYY"];
function Zh(t) {
  return P_.indexOf(t) !== -1;
}
function Qh(t) {
  return I_.indexOf(t) !== -1;
}
function Hi(t, e, n) {
  if (t === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(e, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(e, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(e, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(e, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var T_ = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, D_ = function(e, n, r) {
  var o, i = T_[e];
  return typeof i == "string" ? o = i : n === 1 ? o = i.one : o = i.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + o : o + " ago" : o;
};
const $_ = D_;
function Rs(t) {
  return function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.width ? String(e.width) : t.defaultWidth, r = t.formats[n] || t.formats[t.defaultWidth];
    return r;
  };
}
var N_ = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, R_ = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, A_ = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, L_ = {
  date: Rs({
    formats: N_,
    defaultWidth: "full"
  }),
  time: Rs({
    formats: R_,
    defaultWidth: "full"
  }),
  dateTime: Rs({
    formats: A_,
    defaultWidth: "full"
  })
};
const F_ = L_;
var V_ = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, W_ = function(e, n, r, o) {
  return V_[e];
};
const H_ = W_;
function Gr(t) {
  return function(e, n) {
    var r = n != null && n.context ? String(n.context) : "standalone", o;
    if (r === "formatting" && t.formattingValues) {
      var i = t.defaultFormattingWidth || t.defaultWidth, s = n != null && n.width ? String(n.width) : i;
      o = t.formattingValues[s] || t.formattingValues[i];
    } else {
      var a = t.defaultWidth, l = n != null && n.width ? String(n.width) : t.defaultWidth;
      o = t.values[l] || t.values[a];
    }
    var c = t.argumentCallback ? t.argumentCallback(e) : e;
    return o[c];
  };
}
var B_ = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, j_ = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, z_ = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, U_ = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, Y_ = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, K_ = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, G_ = function(e, n) {
  var r = Number(e), o = r % 100;
  if (o > 20 || o < 10)
    switch (o % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, q_ = {
  ordinalNumber: G_,
  era: Gr({
    values: B_,
    defaultWidth: "wide"
  }),
  quarter: Gr({
    values: j_,
    defaultWidth: "wide",
    argumentCallback: function(e) {
      return e - 1;
    }
  }),
  month: Gr({
    values: z_,
    defaultWidth: "wide"
  }),
  day: Gr({
    values: U_,
    defaultWidth: "wide"
  }),
  dayPeriod: Gr({
    values: Y_,
    defaultWidth: "wide",
    formattingValues: K_,
    defaultFormattingWidth: "wide"
  })
};
const X_ = q_;
function qr(t) {
  return function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, o = r && t.matchPatterns[r] || t.matchPatterns[t.defaultMatchWidth], i = e.match(o);
    if (!i)
      return null;
    var s = i[0], a = r && t.parsePatterns[r] || t.parsePatterns[t.defaultParseWidth], l = Array.isArray(a) ? Q_(a, function(d) {
      return d.test(s);
    }) : Z_(a, function(d) {
      return d.test(s);
    }), c;
    c = t.valueCallback ? t.valueCallback(l) : l, c = n.valueCallback ? n.valueCallback(c) : c;
    var u = e.slice(s.length);
    return {
      value: c,
      rest: u
    };
  };
}
function Z_(t, e) {
  for (var n in t)
    if (t.hasOwnProperty(n) && e(t[n]))
      return n;
}
function Q_(t, e) {
  for (var n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function J_(t) {
  return function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = e.match(t.matchPattern);
    if (!r)
      return null;
    var o = r[0], i = e.match(t.parsePattern);
    if (!i)
      return null;
    var s = t.valueCallback ? t.valueCallback(i[0]) : i[0];
    s = n.valueCallback ? n.valueCallback(s) : s;
    var a = e.slice(o.length);
    return {
      value: s,
      rest: a
    };
  };
}
var e2 = /^(\d+)(th|st|nd|rd)?/i, t2 = /\d+/i, n2 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, r2 = {
  any: [/^b/i, /^(a|c)/i]
}, o2 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, i2 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, s2 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, a2 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, l2 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, c2 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, u2 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, d2 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, f2 = {
  ordinalNumber: J_({
    matchPattern: e2,
    parsePattern: t2,
    valueCallback: function(e) {
      return parseInt(e, 10);
    }
  }),
  era: qr({
    matchPatterns: n2,
    defaultMatchWidth: "wide",
    parsePatterns: r2,
    defaultParseWidth: "any"
  }),
  quarter: qr({
    matchPatterns: o2,
    defaultMatchWidth: "wide",
    parsePatterns: i2,
    defaultParseWidth: "any",
    valueCallback: function(e) {
      return e + 1;
    }
  }),
  month: qr({
    matchPatterns: s2,
    defaultMatchWidth: "wide",
    parsePatterns: a2,
    defaultParseWidth: "any"
  }),
  day: qr({
    matchPatterns: l2,
    defaultMatchWidth: "wide",
    parsePatterns: c2,
    defaultParseWidth: "any"
  }),
  dayPeriod: qr({
    matchPatterns: u2,
    defaultMatchWidth: "any",
    parsePatterns: d2,
    defaultParseWidth: "any"
  })
};
const h2 = f2;
var p2 = {
  code: "en-US",
  formatDistance: $_,
  formatLong: F_,
  formatRelative: H_,
  localize: X_,
  match: h2,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const Il = p2;
var g2 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, m2 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, v2 = /^'([^]*?)'?$/, b2 = /''/g, y2 = /[a-zA-Z]/;
function lt(t, e, n) {
  var r, o, i, s, a, l, c, u, d, f, h, p, g, m, b, v, _, x;
  Q(2, arguments);
  var y = String(e), M = ln(), k = (r = (o = n == null ? void 0 : n.locale) !== null && o !== void 0 ? o : M.locale) !== null && r !== void 0 ? r : Il, O = Ne((i = (s = (a = (l = n == null ? void 0 : n.firstWeekContainsDate) !== null && l !== void 0 ? l : n == null || (c = n.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && a !== void 0 ? a : M.firstWeekContainsDate) !== null && s !== void 0 ? s : (d = M.locale) === null || d === void 0 || (f = d.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(O >= 1 && O <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var S = Ne((h = (p = (g = (m = n == null ? void 0 : n.weekStartsOn) !== null && m !== void 0 ? m : n == null || (b = n.locale) === null || b === void 0 || (v = b.options) === null || v === void 0 ? void 0 : v.weekStartsOn) !== null && g !== void 0 ? g : M.weekStartsOn) !== null && p !== void 0 ? p : (_ = M.locale) === null || _ === void 0 || (x = _.options) === null || x === void 0 ? void 0 : x.weekStartsOn) !== null && h !== void 0 ? h : 0);
  if (!(S >= 0 && S <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!k.localize)
    throw new RangeError("locale must contain localize property");
  if (!k.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var D = le(t);
  if (!Sl(D))
    throw new RangeError("Invalid time value");
  var P = Ir(D), N = Yh(D, P), T = {
    firstWeekContainsDate: O,
    weekStartsOn: S,
    locale: k,
    _originalDate: D
  }, U = y.match(m2).map(function(R) {
    var Y = R[0];
    if (Y === "p" || Y === "P") {
      var V = Oa[Y];
      return V(R, k.formatLong);
    }
    return R;
  }).join("").match(g2).map(function(R) {
    if (R === "''")
      return "'";
    var Y = R[0];
    if (Y === "'")
      return w2(R);
    var V = k_[Y];
    if (V)
      return !(n != null && n.useAdditionalWeekYearTokens) && Qh(R) && Hi(R, e, String(t)), !(n != null && n.useAdditionalDayOfYearTokens) && Zh(R) && Hi(R, e, String(t)), V(N, R, k.localize, T);
    if (Y.match(y2))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + Y + "`");
    return R;
  }).join("");
  return U;
}
function w2(t) {
  var e = t.match(v2);
  return e ? e[1].replace(b2, "'") : t;
}
function x2(t, e) {
  if (t == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
  return t;
}
function _2(t) {
  Q(1, arguments);
  var e = le(t), n = e.getFullYear(), r = e.getMonth(), o = /* @__PURE__ */ new Date(0);
  return o.setFullYear(n, r + 1, 0), o.setHours(0, 0, 0, 0), o.getDate();
}
var C2 = 6048e5;
function E2(t) {
  Q(1, arguments);
  var e = le(t), n = ir(e).getTime() - Ux(e).getTime();
  return Math.round(n / C2) + 1;
}
function M2(t) {
  Q(1, arguments);
  var e = le(t), n = e.getTime();
  return n;
}
function k2(t) {
  return Q(1, arguments), Math.floor(M2(t) / 1e3);
}
function O2(t, e) {
  var n, r, o, i, s, a, l, c;
  Q(1, arguments);
  var u = le(t), d = u.getFullYear(), f = ln(), h = Ne((n = (r = (o = (i = e == null ? void 0 : e.firstWeekContainsDate) !== null && i !== void 0 ? i : e == null || (s = e.locale) === null || s === void 0 || (a = s.options) === null || a === void 0 ? void 0 : a.firstWeekContainsDate) !== null && o !== void 0 ? o : f.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = f.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(h >= 1 && h <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var p = /* @__PURE__ */ new Date(0);
  p.setFullYear(d + 1, 0, h), p.setHours(0, 0, 0, 0);
  var g = Vt(p, e), m = /* @__PURE__ */ new Date(0);
  m.setFullYear(d, 0, h), m.setHours(0, 0, 0, 0);
  var b = Vt(m, e);
  return u.getTime() >= g.getTime() ? d + 1 : u.getTime() >= b.getTime() ? d : d - 1;
}
function S2(t, e) {
  var n, r, o, i, s, a, l, c;
  Q(1, arguments);
  var u = ln(), d = Ne((n = (r = (o = (i = e == null ? void 0 : e.firstWeekContainsDate) !== null && i !== void 0 ? i : e == null || (s = e.locale) === null || s === void 0 || (a = s.options) === null || a === void 0 ? void 0 : a.firstWeekContainsDate) !== null && o !== void 0 ? o : u.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = u.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), f = O2(t, e), h = /* @__PURE__ */ new Date(0);
  h.setFullYear(f, 0, d), h.setHours(0, 0, 0, 0);
  var p = Vt(h, e);
  return p;
}
var P2 = 6048e5;
function I2(t, e) {
  Q(1, arguments);
  var n = le(t), r = Vt(n, e).getTime() - S2(n, e).getTime();
  return Math.round(r / P2) + 1;
}
function T2(t) {
  Q(1, arguments);
  var e = le(t), n = e.getMonth();
  return e.setFullYear(e.getFullYear(), n + 1, 0), e.setHours(0, 0, 0, 0), e;
}
function D2(t, e) {
  return Q(1, arguments), t_(T2(t), ht(t), e) + 1;
}
function Jh(t, e) {
  Q(2, arguments);
  var n = le(t), r = le(e);
  return n.getTime() > r.getTime();
}
function ep(t, e) {
  Q(2, arguments);
  var n = le(t), r = le(e);
  return n.getTime() < r.getTime();
}
function cd(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = new Array(e); n < e; n++)
    r[n] = t[n];
  return r;
}
function $2(t, e) {
  if (t) {
    if (typeof t == "string")
      return cd(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set")
      return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return cd(t, e);
  }
}
function ud(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (!n) {
    if (Array.isArray(t) || (n = $2(t)) || e && t && typeof t.length == "number") {
      n && (t = n);
      var r = 0, o = function() {
      };
      return {
        s: o,
        n: function() {
          return r >= t.length ? {
            done: !0
          } : {
            done: !1,
            value: t[r++]
          };
        },
        e: function(c) {
          throw c;
        },
        f: o
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i = !0, s = !1, a;
  return {
    s: function() {
      n = n.call(t);
    },
    n: function() {
      var c = n.next();
      return i = c.done, c;
    },
    e: function(c) {
      s = !0, a = c;
    },
    f: function() {
      try {
        !i && n.return != null && n.return();
      } finally {
        if (s)
          throw a;
      }
    }
  };
}
function ce(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Sa(t, e) {
  return Sa = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, Sa(t, e);
}
function ke(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && Sa(t, e);
}
function Bi(t) {
  return Bi = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Bi(t);
}
function N2() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function R2(t, e) {
  if (e && (zt(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return ce(t);
}
function Oe(t) {
  var e = N2();
  return function() {
    var r = Bi(t), o;
    if (e) {
      var i = Bi(this).constructor;
      o = Reflect.construct(r, arguments, i);
    } else
      o = r.apply(this, arguments);
    return R2(this, o);
  };
}
function Ce(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function A2(t, e) {
  if (zt(t) !== "object" || t === null)
    return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e || "default");
    if (zt(r) !== "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function tp(t) {
  var e = A2(t, "string");
  return zt(e) === "symbol" ? e : String(e);
}
function dd(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, tp(r.key), r);
  }
}
function Ee(t, e, n) {
  return e && dd(t.prototype, e), n && dd(t, n), Object.defineProperty(t, "prototype", {
    writable: !1
  }), t;
}
function se(t, e, n) {
  return e = tp(e), e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
var L2 = 10, np = /* @__PURE__ */ function() {
  function t() {
    Ce(this, t), se(this, "priority", void 0), se(this, "subPriority", 0);
  }
  return Ee(t, [{
    key: "validate",
    value: function(n, r) {
      return !0;
    }
  }]), t;
}(), F2 = /* @__PURE__ */ function(t) {
  ke(n, t);
  var e = Oe(n);
  function n(r, o, i, s, a) {
    var l;
    return Ce(this, n), l = e.call(this), l.value = r, l.validateValue = o, l.setValue = i, l.priority = s, a && (l.subPriority = a), l;
  }
  return Ee(n, [{
    key: "validate",
    value: function(o, i) {
      return this.validateValue(o, this.value, i);
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return this.setValue(o, i, this.value, s);
    }
  }]), n;
}(np), V2 = /* @__PURE__ */ function(t) {
  ke(n, t);
  var e = Oe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), se(ce(r), "priority", L2), se(ce(r), "subPriority", -1), r;
  }
  return Ee(n, [{
    key: "set",
    value: function(o, i) {
      if (i.timestampIsSet)
        return o;
      var s = /* @__PURE__ */ new Date(0);
      return s.setFullYear(o.getUTCFullYear(), o.getUTCMonth(), o.getUTCDate()), s.setHours(o.getUTCHours(), o.getUTCMinutes(), o.getUTCSeconds(), o.getUTCMilliseconds()), s;
    }
  }]), n;
}(np), Te = /* @__PURE__ */ function() {
  function t() {
    Ce(this, t), se(this, "incompatibleTokens", void 0), se(this, "priority", void 0), se(this, "subPriority", void 0);
  }
  return Ee(t, [{
    key: "run",
    value: function(n, r, o, i) {
      var s = this.parse(n, r, o, i);
      return s ? {
        setter: new F2(s.value, this.validate, this.set, this.priority, this.subPriority),
        rest: s.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(n, r, o) {
      return !0;
    }
  }]), t;
}(), W2 = /* @__PURE__ */ function(t) {
  ke(n, t);
  var e = Oe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), se(ce(r), "priority", 140), se(ce(r), "incompatibleTokens", ["R", "u", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "G":
        case "GG":
        case "GGG":
          return s.era(o, {
            width: "abbreviated"
          }) || s.era(o, {
            width: "narrow"
          });
        case "GGGGG":
          return s.era(o, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return s.era(o, {
            width: "wide"
          }) || s.era(o, {
            width: "abbreviated"
          }) || s.era(o, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return i.era = s, o.setUTCFullYear(s, 0, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(Te), Qe = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, en = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function Je(t, e) {
  return t && {
    value: e(t.value),
    rest: t.rest
  };
}
function Ke(t, e) {
  var n = e.match(t);
  return n ? {
    value: parseInt(n[0], 10),
    rest: e.slice(n[0].length)
  } : null;
}
function tn(t, e) {
  var n = e.match(t);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: e.slice(1)
    };
  var r = n[1] === "+" ? 1 : -1, o = n[2] ? parseInt(n[2], 10) : 0, i = n[3] ? parseInt(n[3], 10) : 0, s = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: r * (o * cs + i * ls + s * Jx),
    rest: e.slice(n[0].length)
  };
}
function rp(t) {
  return Ke(Qe.anyDigitsSigned, t);
}
function qe(t, e) {
  switch (t) {
    case 1:
      return Ke(Qe.singleDigit, e);
    case 2:
      return Ke(Qe.twoDigits, e);
    case 3:
      return Ke(Qe.threeDigits, e);
    case 4:
      return Ke(Qe.fourDigits, e);
    default:
      return Ke(new RegExp("^\\d{1," + t + "}"), e);
  }
}
function ji(t, e) {
  switch (t) {
    case 1:
      return Ke(Qe.singleDigitSigned, e);
    case 2:
      return Ke(Qe.twoDigitsSigned, e);
    case 3:
      return Ke(Qe.threeDigitsSigned, e);
    case 4:
      return Ke(Qe.fourDigitsSigned, e);
    default:
      return Ke(new RegExp("^-?\\d{1," + t + "}"), e);
  }
}
function Tl(t) {
  switch (t) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function op(t, e) {
  var n = e > 0, r = n ? e : 1 - e, o;
  if (r <= 50)
    o = t || 100;
  else {
    var i = r + 50, s = Math.floor(i / 100) * 100, a = t >= i % 100;
    o = t + s - (a ? 100 : 0);
  }
  return n ? o : 1 - o;
}
function ip(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
var H2 = /* @__PURE__ */ function(t) {
  ke(n, t);
  var e = Oe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), se(ce(r), "priority", 130), se(ce(r), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      var a = function(c) {
        return {
          year: c,
          isTwoDigitYear: i === "yy"
        };
      };
      switch (i) {
        case "y":
          return Je(qe(4, o), a);
        case "yo":
          return Je(s.ordinalNumber(o, {
            unit: "year"
          }), a);
        default:
          return Je(qe(i.length, o), a);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      var a = o.getUTCFullYear();
      if (s.isTwoDigitYear) {
        var l = op(s.year, a);
        return o.setUTCFullYear(l, 0, 1), o.setUTCHours(0, 0, 0, 0), o;
      }
      var c = !("era" in i) || i.era === 1 ? s.year : 1 - s.year;
      return o.setUTCFullYear(c, 0, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(Te), B2 = /* @__PURE__ */ function(t) {
  ke(n, t);
  var e = Oe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), se(ce(r), "priority", 130), se(ce(r), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      var a = function(c) {
        return {
          year: c,
          isTwoDigitYear: i === "YY"
        };
      };
      switch (i) {
        case "Y":
          return Je(qe(4, o), a);
        case "Yo":
          return Je(s.ordinalNumber(o, {
            unit: "year"
          }), a);
        default:
          return Je(qe(i.length, o), a);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i.isTwoDigitYear || i.year > 0;
    }
  }, {
    key: "set",
    value: function(o, i, s, a) {
      var l = Pl(o, a);
      if (s.isTwoDigitYear) {
        var c = op(s.year, l);
        return o.setUTCFullYear(c, 0, a.firstWeekContainsDate), o.setUTCHours(0, 0, 0, 0), ar(o, a);
      }
      var u = !("era" in i) || i.era === 1 ? s.year : 1 - s.year;
      return o.setUTCFullYear(u, 0, a.firstWeekContainsDate), o.setUTCHours(0, 0, 0, 0), ar(o, a);
    }
  }]), n;
}(Te), j2 = /* @__PURE__ */ function(t) {
  ke(n, t);
  var e = Oe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), se(ce(r), "priority", 130), se(ce(r), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i) {
      return ji(i === "R" ? 4 : i.length, o);
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      var a = /* @__PURE__ */ new Date(0);
      return a.setUTCFullYear(s, 0, 4), a.setUTCHours(0, 0, 0, 0), Dr(a);
    }
  }]), n;
}(Te), z2 = /* @__PURE__ */ function(t) {
  ke(n, t);
  var e = Oe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), se(ce(r), "priority", 130), se(ce(r), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i) {
      return ji(i === "u" ? 4 : i.length, o);
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCFullYear(s, 0, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(Te), U2 = /* @__PURE__ */ function(t) {
  ke(n, t);
  var e = Oe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), se(ce(r), "priority", 120), se(ce(r), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "Q":
        case "QQ":
          return qe(i.length, o);
        case "Qo":
          return s.ordinalNumber(o, {
            unit: "quarter"
          });
        case "QQQ":
          return s.quarter(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.quarter(o, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return s.quarter(o, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return s.quarter(o, {
            width: "wide",
            context: "formatting"
          }) || s.quarter(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.quarter(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCMonth((s - 1) * 3, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(Te), Y2 = /* @__PURE__ */ function(t) {
  ke(n, t);
  var e = Oe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), se(ce(r), "priority", 120), se(ce(r), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "q":
        case "qq":
          return qe(i.length, o);
        case "qo":
          return s.ordinalNumber(o, {
            unit: "quarter"
          });
        case "qqq":
          return s.quarter(o, {
            width: "abbreviated",
            context: "standalone"
          }) || s.quarter(o, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return s.quarter(o, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return s.quarter(o, {
            width: "wide",
            context: "standalone"
          }) || s.quarter(o, {
            width: "abbreviated",
            context: "standalone"
          }) || s.quarter(o, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 1 && i <= 4;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCMonth((s - 1) * 3, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(Te), K2 = /* @__PURE__ */ function(t) {
  ke(n, t);
  var e = Oe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), se(ce(r), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), se(ce(r), "priority", 110), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      var a = function(c) {
        return c - 1;
      };
      switch (i) {
        case "M":
          return Je(Ke(Qe.month, o), a);
        case "MM":
          return Je(qe(2, o), a);
        case "Mo":
          return Je(s.ordinalNumber(o, {
            unit: "month"
          }), a);
        case "MMM":
          return s.month(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.month(o, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return s.month(o, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return s.month(o, {
            width: "wide",
            context: "formatting"
          }) || s.month(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.month(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCMonth(s, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(Te), G2 = /* @__PURE__ */ function(t) {
  ke(n, t);
  var e = Oe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), se(ce(r), "priority", 110), se(ce(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      var a = function(c) {
        return c - 1;
      };
      switch (i) {
        case "L":
          return Je(Ke(Qe.month, o), a);
        case "LL":
          return Je(qe(2, o), a);
        case "Lo":
          return Je(s.ordinalNumber(o, {
            unit: "month"
          }), a);
        case "LLL":
          return s.month(o, {
            width: "abbreviated",
            context: "standalone"
          }) || s.month(o, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return s.month(o, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return s.month(o, {
            width: "wide",
            context: "standalone"
          }) || s.month(o, {
            width: "abbreviated",
            context: "standalone"
          }) || s.month(o, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCMonth(s, 1), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(Te);
function q2(t, e, n) {
  Q(2, arguments);
  var r = le(t), o = Ne(e), i = qh(r, n) - o;
  return r.setUTCDate(r.getUTCDate() - i * 7), r;
}
var X2 = /* @__PURE__ */ function(t) {
  ke(n, t);
  var e = Oe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), se(ce(r), "priority", 100), se(ce(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "w":
          return Ke(Qe.week, o);
        case "wo":
          return s.ordinalNumber(o, {
            unit: "week"
          });
        default:
          return qe(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(o, i, s, a) {
      return ar(q2(o, s, a), a);
    }
  }]), n;
}(Te);
function Z2(t, e) {
  Q(2, arguments);
  var n = le(t), r = Ne(e), o = Gh(n) - r;
  return n.setUTCDate(n.getUTCDate() - o * 7), n;
}
var Q2 = /* @__PURE__ */ function(t) {
  ke(n, t);
  var e = Oe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), se(ce(r), "priority", 100), se(ce(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "I":
          return Ke(Qe.week, o);
        case "Io":
          return s.ordinalNumber(o, {
            unit: "week"
          });
        default:
          return qe(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 1 && i <= 53;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return Dr(Z2(o, s));
    }
  }]), n;
}(Te), J2 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], eC = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], tC = /* @__PURE__ */ function(t) {
  ke(n, t);
  var e = Oe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), se(ce(r), "priority", 90), se(ce(r), "subPriority", 1), se(ce(r), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "d":
          return Ke(Qe.date, o);
        case "do":
          return s.ordinalNumber(o, {
            unit: "date"
          });
        default:
          return qe(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      var s = o.getUTCFullYear(), a = ip(s), l = o.getUTCMonth();
      return a ? i >= 1 && i <= eC[l] : i >= 1 && i <= J2[l];
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCDate(s), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(Te), nC = /* @__PURE__ */ function(t) {
  ke(n, t);
  var e = Oe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), se(ce(r), "priority", 90), se(ce(r), "subpriority", 1), se(ce(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "D":
        case "DD":
          return Ke(Qe.dayOfYear, o);
        case "Do":
          return s.ordinalNumber(o, {
            unit: "date"
          });
        default:
          return qe(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      var s = o.getUTCFullYear(), a = ip(s);
      return a ? i >= 1 && i <= 366 : i >= 1 && i <= 365;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCMonth(0, s), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(Te);
function Dl(t, e, n) {
  var r, o, i, s, a, l, c, u;
  Q(2, arguments);
  var d = ln(), f = Ne((r = (o = (i = (s = n == null ? void 0 : n.weekStartsOn) !== null && s !== void 0 ? s : n == null || (a = n.locale) === null || a === void 0 || (l = a.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && i !== void 0 ? i : d.weekStartsOn) !== null && o !== void 0 ? o : (c = d.locale) === null || c === void 0 || (u = c.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var h = le(t), p = Ne(e), g = h.getUTCDay(), m = p % 7, b = (m + 7) % 7, v = (b < f ? 7 : 0) + p - g;
  return h.setUTCDate(h.getUTCDate() + v), h;
}
var rC = /* @__PURE__ */ function(t) {
  ke(n, t);
  var e = Oe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), se(ce(r), "priority", 90), se(ce(r), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "E":
        case "EE":
        case "EEE":
          return s.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(o, {
            width: "short",
            context: "formatting"
          }) || s.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return s.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return s.day(o, {
            width: "short",
            context: "formatting"
          }) || s.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return s.day(o, {
            width: "wide",
            context: "formatting"
          }) || s.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(o, {
            width: "short",
            context: "formatting"
          }) || s.day(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(o, i, s, a) {
      return o = Dl(o, s, a), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(Te), oC = /* @__PURE__ */ function(t) {
  ke(n, t);
  var e = Oe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), se(ce(r), "priority", 90), se(ce(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s, a) {
      var l = function(u) {
        var d = Math.floor((u - 1) / 7) * 7;
        return (u + a.weekStartsOn + 6) % 7 + d;
      };
      switch (i) {
        case "e":
        case "ee":
          return Je(qe(i.length, o), l);
        case "eo":
          return Je(s.ordinalNumber(o, {
            unit: "day"
          }), l);
        case "eee":
          return s.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(o, {
            width: "short",
            context: "formatting"
          }) || s.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return s.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return s.day(o, {
            width: "short",
            context: "formatting"
          }) || s.day(o, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return s.day(o, {
            width: "wide",
            context: "formatting"
          }) || s.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(o, {
            width: "short",
            context: "formatting"
          }) || s.day(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(o, i, s, a) {
      return o = Dl(o, s, a), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(Te), iC = /* @__PURE__ */ function(t) {
  ke(n, t);
  var e = Oe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), se(ce(r), "priority", 90), se(ce(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s, a) {
      var l = function(u) {
        var d = Math.floor((u - 1) / 7) * 7;
        return (u + a.weekStartsOn + 6) % 7 + d;
      };
      switch (i) {
        case "c":
        case "cc":
          return Je(qe(i.length, o), l);
        case "co":
          return Je(s.ordinalNumber(o, {
            unit: "day"
          }), l);
        case "ccc":
          return s.day(o, {
            width: "abbreviated",
            context: "standalone"
          }) || s.day(o, {
            width: "short",
            context: "standalone"
          }) || s.day(o, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return s.day(o, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return s.day(o, {
            width: "short",
            context: "standalone"
          }) || s.day(o, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return s.day(o, {
            width: "wide",
            context: "standalone"
          }) || s.day(o, {
            width: "abbreviated",
            context: "standalone"
          }) || s.day(o, {
            width: "short",
            context: "standalone"
          }) || s.day(o, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 6;
    }
  }, {
    key: "set",
    value: function(o, i, s, a) {
      return o = Dl(o, s, a), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(Te);
function sC(t, e) {
  Q(2, arguments);
  var n = Ne(e);
  n % 7 === 0 && (n = n - 7);
  var r = 1, o = le(t), i = o.getUTCDay(), s = n % 7, a = (s + 7) % 7, l = (a < r ? 7 : 0) + n - i;
  return o.setUTCDate(o.getUTCDate() + l), o;
}
var aC = /* @__PURE__ */ function(t) {
  ke(n, t);
  var e = Oe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), se(ce(r), "priority", 90), se(ce(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      var a = function(c) {
        return c === 0 ? 7 : c;
      };
      switch (i) {
        case "i":
        case "ii":
          return qe(i.length, o);
        case "io":
          return s.ordinalNumber(o, {
            unit: "day"
          });
        case "iii":
          return Je(s.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(o, {
            width: "short",
            context: "formatting"
          }) || s.day(o, {
            width: "narrow",
            context: "formatting"
          }), a);
        case "iiiii":
          return Je(s.day(o, {
            width: "narrow",
            context: "formatting"
          }), a);
        case "iiiiii":
          return Je(s.day(o, {
            width: "short",
            context: "formatting"
          }) || s.day(o, {
            width: "narrow",
            context: "formatting"
          }), a);
        case "iiii":
        default:
          return Je(s.day(o, {
            width: "wide",
            context: "formatting"
          }) || s.day(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(o, {
            width: "short",
            context: "formatting"
          }) || s.day(o, {
            width: "narrow",
            context: "formatting"
          }), a);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 1 && i <= 7;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o = sC(o, s), o.setUTCHours(0, 0, 0, 0), o;
    }
  }]), n;
}(Te), lC = /* @__PURE__ */ function(t) {
  ke(n, t);
  var e = Oe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), se(ce(r), "priority", 80), se(ce(r), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "a":
        case "aa":
        case "aaa":
          return s.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return s.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return s.dayPeriod(o, {
            width: "wide",
            context: "formatting"
          }) || s.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCHours(Tl(s), 0, 0, 0), o;
    }
  }]), n;
}(Te), cC = /* @__PURE__ */ function(t) {
  ke(n, t);
  var e = Oe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), se(ce(r), "priority", 80), se(ce(r), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "b":
        case "bb":
        case "bbb":
          return s.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return s.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return s.dayPeriod(o, {
            width: "wide",
            context: "formatting"
          }) || s.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCHours(Tl(s), 0, 0, 0), o;
    }
  }]), n;
}(Te), uC = /* @__PURE__ */ function(t) {
  ke(n, t);
  var e = Oe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), se(ce(r), "priority", 80), se(ce(r), "incompatibleTokens", ["a", "b", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "B":
        case "BB":
        case "BBB":
          return s.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return s.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return s.dayPeriod(o, {
            width: "wide",
            context: "formatting"
          }) || s.dayPeriod(o, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(o, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCHours(Tl(s), 0, 0, 0), o;
    }
  }]), n;
}(Te), dC = /* @__PURE__ */ function(t) {
  ke(n, t);
  var e = Oe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), se(ce(r), "priority", 70), se(ce(r), "incompatibleTokens", ["H", "K", "k", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "h":
          return Ke(Qe.hour12h, o);
        case "ho":
          return s.ordinalNumber(o, {
            unit: "hour"
          });
        default:
          return qe(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 1 && i <= 12;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      var a = o.getUTCHours() >= 12;
      return a && s < 12 ? o.setUTCHours(s + 12, 0, 0, 0) : !a && s === 12 ? o.setUTCHours(0, 0, 0, 0) : o.setUTCHours(s, 0, 0, 0), o;
    }
  }]), n;
}(Te), fC = /* @__PURE__ */ function(t) {
  ke(n, t);
  var e = Oe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), se(ce(r), "priority", 70), se(ce(r), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "H":
          return Ke(Qe.hour23h, o);
        case "Ho":
          return s.ordinalNumber(o, {
            unit: "hour"
          });
        default:
          return qe(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 23;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCHours(s, 0, 0, 0), o;
    }
  }]), n;
}(Te), hC = /* @__PURE__ */ function(t) {
  ke(n, t);
  var e = Oe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), se(ce(r), "priority", 70), se(ce(r), "incompatibleTokens", ["h", "H", "k", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "K":
          return Ke(Qe.hour11h, o);
        case "Ko":
          return s.ordinalNumber(o, {
            unit: "hour"
          });
        default:
          return qe(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 11;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      var a = o.getUTCHours() >= 12;
      return a && s < 12 ? o.setUTCHours(s + 12, 0, 0, 0) : o.setUTCHours(s, 0, 0, 0), o;
    }
  }]), n;
}(Te), pC = /* @__PURE__ */ function(t) {
  ke(n, t);
  var e = Oe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), se(ce(r), "priority", 70), se(ce(r), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "k":
          return Ke(Qe.hour24h, o);
        case "ko":
          return s.ordinalNumber(o, {
            unit: "hour"
          });
        default:
          return qe(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 1 && i <= 24;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      var a = s <= 24 ? s % 24 : s;
      return o.setUTCHours(a, 0, 0, 0), o;
    }
  }]), n;
}(Te), gC = /* @__PURE__ */ function(t) {
  ke(n, t);
  var e = Oe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), se(ce(r), "priority", 60), se(ce(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "m":
          return Ke(Qe.minute, o);
        case "mo":
          return s.ordinalNumber(o, {
            unit: "minute"
          });
        default:
          return qe(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCMinutes(s, 0, 0), o;
    }
  }]), n;
}(Te), mC = /* @__PURE__ */ function(t) {
  ke(n, t);
  var e = Oe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), se(ce(r), "priority", 50), se(ce(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i, s) {
      switch (i) {
        case "s":
          return Ke(Qe.second, o);
        case "so":
          return s.ordinalNumber(o, {
            unit: "second"
          });
        default:
          return qe(i.length, o);
      }
    }
  }, {
    key: "validate",
    value: function(o, i) {
      return i >= 0 && i <= 59;
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCSeconds(s, 0), o;
    }
  }]), n;
}(Te), vC = /* @__PURE__ */ function(t) {
  ke(n, t);
  var e = Oe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), se(ce(r), "priority", 30), se(ce(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i) {
      var s = function(l) {
        return Math.floor(l * Math.pow(10, -i.length + 3));
      };
      return Je(qe(i.length, o), s);
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return o.setUTCMilliseconds(s), o;
    }
  }]), n;
}(Te), bC = /* @__PURE__ */ function(t) {
  ke(n, t);
  var e = Oe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), se(ce(r), "priority", 10), se(ce(r), "incompatibleTokens", ["t", "T", "x"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i) {
      switch (i) {
        case "X":
          return tn(en.basicOptionalMinutes, o);
        case "XX":
          return tn(en.basic, o);
        case "XXXX":
          return tn(en.basicOptionalSeconds, o);
        case "XXXXX":
          return tn(en.extendedOptionalSeconds, o);
        case "XXX":
        default:
          return tn(en.extended, o);
      }
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return i.timestampIsSet ? o : new Date(o.getTime() - s);
    }
  }]), n;
}(Te), yC = /* @__PURE__ */ function(t) {
  ke(n, t);
  var e = Oe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), se(ce(r), "priority", 10), se(ce(r), "incompatibleTokens", ["t", "T", "X"]), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o, i) {
      switch (i) {
        case "x":
          return tn(en.basicOptionalMinutes, o);
        case "xx":
          return tn(en.basic, o);
        case "xxxx":
          return tn(en.basicOptionalSeconds, o);
        case "xxxxx":
          return tn(en.extendedOptionalSeconds, o);
        case "xxx":
        default:
          return tn(en.extended, o);
      }
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return i.timestampIsSet ? o : new Date(o.getTime() - s);
    }
  }]), n;
}(Te), wC = /* @__PURE__ */ function(t) {
  ke(n, t);
  var e = Oe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), se(ce(r), "priority", 40), se(ce(r), "incompatibleTokens", "*"), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o) {
      return rp(o);
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return [new Date(s * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(Te), xC = /* @__PURE__ */ function(t) {
  ke(n, t);
  var e = Oe(n);
  function n() {
    var r;
    Ce(this, n);
    for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
      i[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(i)), se(ce(r), "priority", 20), se(ce(r), "incompatibleTokens", "*"), r;
  }
  return Ee(n, [{
    key: "parse",
    value: function(o) {
      return rp(o);
    }
  }, {
    key: "set",
    value: function(o, i, s) {
      return [new Date(s), {
        timestampIsSet: !0
      }];
    }
  }]), n;
}(Te), _C = {
  G: new W2(),
  y: new H2(),
  Y: new B2(),
  R: new j2(),
  u: new z2(),
  Q: new U2(),
  q: new Y2(),
  M: new K2(),
  L: new G2(),
  w: new X2(),
  I: new Q2(),
  d: new tC(),
  D: new nC(),
  E: new rC(),
  e: new oC(),
  c: new iC(),
  i: new aC(),
  a: new lC(),
  b: new cC(),
  B: new uC(),
  h: new dC(),
  H: new fC(),
  K: new hC(),
  k: new pC(),
  m: new gC(),
  s: new mC(),
  S: new vC(),
  X: new bC(),
  x: new yC(),
  t: new wC(),
  T: new xC()
}, CC = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, EC = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, MC = /^'([^]*?)'?$/, kC = /''/g, OC = /\S/, SC = /[a-zA-Z]/;
function wr(t, e, n, r) {
  var o, i, s, a, l, c, u, d, f, h, p, g, m, b, v, _, x, y;
  Q(3, arguments);
  var M = String(t), k = String(e), O = ln(), S = (o = (i = r == null ? void 0 : r.locale) !== null && i !== void 0 ? i : O.locale) !== null && o !== void 0 ? o : Il;
  if (!S.match)
    throw new RangeError("locale must contain match property");
  var D = Ne((s = (a = (l = (c = r == null ? void 0 : r.firstWeekContainsDate) !== null && c !== void 0 ? c : r == null || (u = r.locale) === null || u === void 0 || (d = u.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && l !== void 0 ? l : O.firstWeekContainsDate) !== null && a !== void 0 ? a : (f = O.locale) === null || f === void 0 || (h = f.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && s !== void 0 ? s : 1);
  if (!(D >= 1 && D <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var P = Ne((p = (g = (m = (b = r == null ? void 0 : r.weekStartsOn) !== null && b !== void 0 ? b : r == null || (v = r.locale) === null || v === void 0 || (_ = v.options) === null || _ === void 0 ? void 0 : _.weekStartsOn) !== null && m !== void 0 ? m : O.weekStartsOn) !== null && g !== void 0 ? g : (x = O.locale) === null || x === void 0 || (y = x.options) === null || y === void 0 ? void 0 : y.weekStartsOn) !== null && p !== void 0 ? p : 0);
  if (!(P >= 0 && P <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (k === "")
    return M === "" ? le(n) : /* @__PURE__ */ new Date(NaN);
  var N = {
    firstWeekContainsDate: D,
    weekStartsOn: P,
    locale: S
  }, T = [new V2()], U = k.match(EC).map(function(H) {
    var q = H[0];
    if (q in Oa) {
      var oe = Oa[q];
      return oe(H, S.formatLong);
    }
    return H;
  }).join("").match(CC), R = [], Y = ud(U), V;
  try {
    var z = function() {
      var q = V.value;
      !(r != null && r.useAdditionalWeekYearTokens) && Qh(q) && Hi(q, k, t), !(r != null && r.useAdditionalDayOfYearTokens) && Zh(q) && Hi(q, k, t);
      var oe = q[0], Z = _C[oe];
      if (Z) {
        var G = Z.incompatibleTokens;
        if (Array.isArray(G)) {
          var we = R.find(function(Re) {
            return G.includes(Re.token) || Re.token === oe;
          });
          if (we)
            throw new RangeError("The format string mustn't contain `".concat(we.fullToken, "` and `").concat(q, "` at the same time"));
        } else if (Z.incompatibleTokens === "*" && R.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(q, "` and any other token at the same time"));
        R.push({
          token: oe,
          fullToken: q
        });
        var Pe = Z.run(M, q, S.match, N);
        if (!Pe)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        T.push(Pe.setter), M = Pe.rest;
      } else {
        if (oe.match(SC))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + oe + "`");
        if (q === "''" ? q = "'" : oe === "'" && (q = PC(q)), M.indexOf(q) === 0)
          M = M.slice(q.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (Y.s(); !(V = Y.n()).done; ) {
      var ee = z();
      if (zt(ee) === "object")
        return ee.v;
    }
  } catch (H) {
    Y.e(H);
  } finally {
    Y.f();
  }
  if (M.length > 0 && OC.test(M))
    return /* @__PURE__ */ new Date(NaN);
  var $ = T.map(function(H) {
    return H.priority;
  }).sort(function(H, q) {
    return q - H;
  }).filter(function(H, q, oe) {
    return oe.indexOf(H) === q;
  }).map(function(H) {
    return T.filter(function(q) {
      return q.priority === H;
    }).sort(function(q, oe) {
      return oe.subPriority - q.subPriority;
    });
  }).map(function(H) {
    return H[0];
  }), F = le(n);
  if (isNaN(F.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var te = Yh(F, Ir(F)), J = {}, re = ud($), j;
  try {
    for (re.s(); !(j = re.n()).done; ) {
      var A = j.value;
      if (!A.validate(te, N))
        return /* @__PURE__ */ new Date(NaN);
      var W = A.set(te, J, N);
      Array.isArray(W) ? (te = W[0], x2(J, W[1])) : te = W;
    }
  } catch (H) {
    re.e(H);
  } finally {
    re.f();
  }
  return te;
}
function PC(t) {
  return t.match(MC)[1].replace(kC, "'");
}
function IC(t) {
  Q(1, arguments);
  var e = le(t);
  return e.setMinutes(0, 0, 0), e;
}
function $l(t, e) {
  Q(2, arguments);
  var n = le(t), r = le(e);
  return n.getFullYear() === r.getFullYear() && n.getMonth() === r.getMonth();
}
function TC(t) {
  Q(1, arguments);
  var e = le(t);
  return e.setMilliseconds(0), e;
}
function DC(t, e) {
  Q(2, arguments);
  var n = le(t), r = le(e);
  return n.getFullYear() === r.getFullYear();
}
function fd(t, e) {
  Q(2, arguments);
  var n = Ne(e);
  return Et(t, -n);
}
function $C(t, e) {
  var n;
  Q(1, arguments);
  var r = Ne((n = e == null ? void 0 : e.additionalDigits) !== null && n !== void 0 ? n : 2);
  if (r !== 2 && r !== 1 && r !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (!(typeof t == "string" || Object.prototype.toString.call(t) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var o = LC(t), i;
  if (o.date) {
    var s = FC(o.date, r);
    i = VC(s.restDateString, s.year);
  }
  if (!i || isNaN(i.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var a = i.getTime(), l = 0, c;
  if (o.time && (l = WC(o.time), isNaN(l)))
    return /* @__PURE__ */ new Date(NaN);
  if (o.timezone) {
    if (c = HC(o.timezone), isNaN(c))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    var u = new Date(a + l), d = /* @__PURE__ */ new Date(0);
    return d.setFullYear(u.getUTCFullYear(), u.getUTCMonth(), u.getUTCDate()), d.setHours(u.getUTCHours(), u.getUTCMinutes(), u.getUTCSeconds(), u.getUTCMilliseconds()), d;
  }
  return new Date(a + l + c);
}
var Jo = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, NC = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, RC = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, AC = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function LC(t) {
  var e = {}, n = t.split(Jo.dateTimeDelimiter), r;
  if (n.length > 2)
    return e;
  if (/:/.test(n[0]) ? r = n[0] : (e.date = n[0], r = n[1], Jo.timeZoneDelimiter.test(e.date) && (e.date = t.split(Jo.timeZoneDelimiter)[0], r = t.substr(e.date.length, t.length))), r) {
    var o = Jo.timezone.exec(r);
    o ? (e.time = r.replace(o[1], ""), e.timezone = o[1]) : e.time = r;
  }
  return e;
}
function FC(t, e) {
  var n = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + e) + "})|(\\d{2}|[+-]\\d{" + (2 + e) + "})$)"), r = t.match(n);
  if (!r)
    return {
      year: NaN,
      restDateString: ""
    };
  var o = r[1] ? parseInt(r[1]) : null, i = r[2] ? parseInt(r[2]) : null;
  return {
    year: i === null ? o : i * 100,
    restDateString: t.slice((r[1] || r[2]).length)
  };
}
function VC(t, e) {
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  var n = t.match(NC);
  if (!n)
    return /* @__PURE__ */ new Date(NaN);
  var r = !!n[4], o = Xr(n[1]), i = Xr(n[2]) - 1, s = Xr(n[3]), a = Xr(n[4]), l = Xr(n[5]) - 1;
  if (r)
    return YC(e, a, l) ? BC(e, a, l) : /* @__PURE__ */ new Date(NaN);
  var c = /* @__PURE__ */ new Date(0);
  return !zC(e, i, s) || !UC(e, o) ? /* @__PURE__ */ new Date(NaN) : (c.setUTCFullYear(e, i, Math.max(o, s)), c);
}
function Xr(t) {
  return t ? parseInt(t) : 1;
}
function WC(t) {
  var e = t.match(RC);
  if (!e)
    return NaN;
  var n = As(e[1]), r = As(e[2]), o = As(e[3]);
  return KC(n, r, o) ? n * cs + r * ls + o * 1e3 : NaN;
}
function As(t) {
  return t && parseFloat(t.replace(",", ".")) || 0;
}
function HC(t) {
  if (t === "Z")
    return 0;
  var e = t.match(AC);
  if (!e)
    return 0;
  var n = e[1] === "+" ? -1 : 1, r = parseInt(e[2]), o = e[3] && parseInt(e[3]) || 0;
  return GC(r, o) ? n * (r * cs + o * ls) : NaN;
}
function BC(t, e, n) {
  var r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(t, 0, 4);
  var o = r.getUTCDay() || 7, i = (e - 1) * 7 + n + 1 - o;
  return r.setUTCDate(r.getUTCDate() + i), r;
}
var jC = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function sp(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function zC(t, e, n) {
  return e >= 0 && e <= 11 && n >= 1 && n <= (jC[e] || (sp(t) ? 29 : 28));
}
function UC(t, e) {
  return e >= 1 && e <= (sp(t) ? 366 : 365);
}
function YC(t, e, n) {
  return e >= 1 && e <= 53 && n >= 0 && n <= 6;
}
function KC(t, e, n) {
  return t === 24 ? e === 0 && n === 0 : n >= 0 && n < 60 && e >= 0 && e < 60 && t >= 0 && t < 25;
}
function GC(t, e) {
  return e >= 0 && e <= 59;
}
function Ls(t, e) {
  Q(2, arguments);
  var n = le(t), r = Ne(e), o = n.getFullYear(), i = n.getDate(), s = /* @__PURE__ */ new Date(0);
  s.setFullYear(o, r, 15), s.setHours(0, 0, 0, 0);
  var a = _2(s);
  return n.setMonth(r, Math.min(i, a)), n;
}
function hd(t, e) {
  Q(2, arguments);
  var n = le(t), r = Ne(e);
  return isNaN(n.getTime()) ? /* @__PURE__ */ new Date(NaN) : (n.setFullYear(r), n);
}
/*!
 * chartjs-adapter-date-fns v3.0.0
 * https://www.chartjs.org
 * (c) 2022 chartjs-adapter-date-fns Contributors
 * Released under the MIT license
 */
const qC = {
  datetime: "MMM d, yyyy, h:mm:ss aaaa",
  millisecond: "h:mm:ss.SSS aaaa",
  second: "h:mm:ss aaaa",
  minute: "h:mm aaaa",
  hour: "ha",
  day: "MMM d",
  week: "PP",
  month: "MMM yyyy",
  quarter: "qqq - yyyy",
  year: "yyyy"
};
_h._date.override({
  _id: "date-fns",
  // DEBUG
  formats: function() {
    return qC;
  },
  parse: function(t, e) {
    if (t === null || typeof t > "u")
      return null;
    const n = typeof t;
    return n === "number" || t instanceof Date ? t = le(t) : n === "string" && (typeof e == "string" ? t = wr(t, e, /* @__PURE__ */ new Date(), this.options) : t = $C(t, this.options)), Sl(t) ? t.getTime() : null;
  },
  format: function(t, e) {
    return lt(t, e, this.options);
  },
  add: function(t, e, n) {
    switch (n) {
      case "millisecond":
        return Oo(t, e);
      case "second":
        return Xx(t, e);
      case "minute":
        return Gx(t, e);
      case "hour":
        return Bx(t, e);
      case "day":
        return Et(t, e);
      case "week":
        return Wi(t, e);
      case "month":
        return Ft(t, e);
      case "quarter":
        return qx(t, e);
      case "year":
        return Wh(t, e);
      default:
        return t;
    }
  },
  diff: function(t, e, n) {
    switch (n) {
      case "millisecond":
        return us(t, e);
      case "second":
        return l_(t, e);
      case "minute":
        return i_(t, e);
      case "hour":
        return o_(t, e);
      case "day":
        return Hh(t, e);
      case "week":
        return c_(t, e);
      case "month":
        return jh(t, e);
      case "quarter":
        return a_(t, e);
      case "year":
        return u_(t, e);
      default:
        return 0;
    }
  },
  startOf: function(t, e, n) {
    switch (e) {
      case "second":
        return TC(t);
      case "minute":
        return d_(t);
      case "hour":
        return IC(t);
      case "day":
        return sr(t);
      case "week":
        return Vt(t);
      case "isoWeek":
        return Vt(t, { weekStartsOn: +n });
      case "month":
        return ht(t);
      case "quarter":
        return f_(t);
      case "year":
        return zh(t);
      default:
        return t;
    }
  },
  endOf: function(t, e) {
    switch (e) {
      case "second":
        return v_(t);
      case "minute":
        return g_(t);
      case "hour":
        return p_(t);
      case "day":
        return Bh(t);
      case "week":
        return ds(t);
      case "month":
        return Po(t);
      case "quarter":
        return m_(t);
      case "year":
        return h_(t);
      default:
        return t;
    }
  }
});
function Dn(t, e) {
  const { format: n = "rgba" } = e || {}, r = `rgba(${getComputedStyle(
    document.documentElement
  ).getPropertyValue(t)})`;
  return n === "hex" ? XC(r) : r;
}
const XC = (t) => {
  const e = t.replace(/^rgba?\(|\s+|\)$/g, "").split(","), n = parseInt(e[0], 10), r = parseInt(e[1], 10), o = parseInt(e[2], 10), i = Math.round(parseFloat(e[3]) * 255), s = (a) => a.toString(16).padStart(2, "0");
  return `#${s(n)}${s(r)}${s(o)}${Number.isNaN(i) ? "" : s(i)}`;
}, ap = () => /* @__PURE__ */ B("div", { className: "relative flex h-52 flex-1 flex-col justify-between", children: [
  /* @__PURE__ */ w("div", { className: "h-px w-full bg-neutral-100" }),
  /* @__PURE__ */ w("div", { className: "h-px w-full bg-neutral-100" }),
  /* @__PURE__ */ w("div", { className: "h-px w-full bg-neutral-100" }),
  /* @__PURE__ */ w("div", { className: "h-px w-full bg-neutral-100" }),
  /* @__PURE__ */ w("div", { className: "h-px w-full bg-neutral-100" }),
  /* @__PURE__ */ B("div", { className: "absolute inset-0 flex flex-col items-center justify-center space-y-2.5", children: [
    /* @__PURE__ */ w(lp, {}),
    /* @__PURE__ */ w("p", { className: "text-xs font-medium text-foundations-boldest", children: "No data in this period" })
  ] })
] }), lp = ({ className: t }) => /* @__PURE__ */ B(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "112",
    height: "84",
    viewBox: "0 0 112 84",
    fill: "none",
    className: t,
    children: [
      /* @__PURE__ */ w(
        "path",
        {
          d: "M56.7368 84C79.9328 84 98.7368 65.196 98.7368 42C98.7368 18.804 79.9328 0 56.7368 0C33.5409 0 14.7368 18.804 14.7368 42C14.7368 65.196 33.5409 84 56.7368 84Z",
          className: "fill-[theme(backgroundColor.foundations-subtlest)]"
        }
      ),
      /* @__PURE__ */ w("g", { filter: "url(#filter0_d_18659_25530)", children: /* @__PURE__ */ w(
        "path",
        {
          d: "M8.19249 29.5547H103.392C104.328 29.5547 105.224 29.9262 105.886 30.5874C106.547 31.2486 106.918 32.1455 106.918 33.0806V50.7102C106.918 51.6454 106.547 52.5422 105.886 53.2034C105.224 53.8647 104.328 54.2362 103.392 54.2362H8.19249C7.25736 54.2362 6.36052 53.8647 5.69928 53.2034C5.03805 52.5422 4.66656 51.6454 4.66656 50.7102V33.0806C4.66656 32.1455 5.03805 31.2486 5.69928 30.5874C6.36052 29.9262 7.25736 29.5547 8.19249 29.5547V29.5547Z",
          className: "fill-[theme(backgroundColor.foundations-default)]"
        }
      ) }),
      /* @__PURE__ */ w(
        "path",
        {
          d: "M53.324 35.1953H34.9892C33.8208 35.1953 32.8736 36.1425 32.8736 37.3109C32.8736 38.4793 33.8208 39.4264 34.9892 39.4264H53.324C54.4924 39.4264 55.4395 38.4793 55.4395 37.3109C55.4395 36.1425 54.4924 35.1953 53.324 35.1953Z",
          className: "fill-[theme(backgroundColor.chart-categorical-8-subtler)]"
        }
      ),
      /* @__PURE__ */ w(
        "path",
        {
          d: "M66.0171 44.3633H34.989C33.8206 44.3633 32.8734 45.3104 32.8734 46.4788C32.8734 47.6472 33.8206 48.5944 34.989 48.5944H66.0171C67.1855 48.5944 68.1327 47.6472 68.1327 46.4788C68.1327 45.3104 67.1855 44.3633 66.0171 44.3633Z",
          className: "fill-[theme(backgroundColor.chart-categorical-8-subtler)]"
        }
      ),
      /* @__PURE__ */ w(
        "path",
        {
          d: "M27.2341 41.8951C27.2341 36.2479 22.6562 31.6699 17.0089 31.6699C11.3617 31.6699 6.78375 36.2479 6.78375 41.8951C6.78375 47.5423 11.3617 52.1203 17.0089 52.1203C22.6562 52.1203 27.2341 47.5423 27.2341 41.8951Z",
          className: "fill-[theme(backgroundColor.chart-neutral)]"
        }
      ),
      /* @__PURE__ */ B("g", { clipPath: "url(#clip0_18659_25530)", children: [
        /* @__PURE__ */ w(
          "path",
          {
            d: "M12.1339 42.6223C12.1339 42.2787 12.4124 42.0001 12.7561 42.0001H14.0005C14.3442 42.0001 14.6227 42.2787 14.6227 42.6223V45.7334C14.6227 46.0771 14.3442 46.3556 14.0005 46.3556H12.7561C12.4124 46.3556 12.1339 46.0771 12.1339 45.7334V42.6223Z",
            className: "fill-[theme(backgroundColor.foundations-default)]"
          }
        ),
        /* @__PURE__ */ w(
          "path",
          {
            d: "M15.8672 40.1334C15.8672 39.7898 16.1458 39.5112 16.4894 39.5112H17.7338C18.0775 39.5112 18.3561 39.7898 18.3561 40.1334V45.7334C18.3561 46.0771 18.0775 46.3556 17.7338 46.3556H16.4894C16.1458 46.3556 15.8672 46.0771 15.8672 45.7334V40.1334Z",
            className: "fill-[theme(backgroundColor.foundations-default)]"
          }
        ),
        /* @__PURE__ */ w(
          "path",
          {
            d: "M19.6005 38.2668C19.6005 37.9231 19.8791 37.6445 20.2227 37.6445H21.4672C21.8108 37.6445 22.0894 37.9231 22.0894 38.2668V45.7334C22.0894 46.0771 21.8108 46.3556 21.4672 46.3556H20.2227C19.8791 46.3556 19.6005 46.0771 19.6005 45.7334V38.2668Z",
            className: "fill-[theme(backgroundColor.foundations-default)]"
          }
        )
      ] }),
      /* @__PURE__ */ B("defs", { children: [
        /* @__PURE__ */ B(
          "filter",
          {
            id: "filter0_d_18659_25530",
            x: "0.435454",
            y: "27.4391",
            width: "110.714",
            height: "33.1439",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ w("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
              /* @__PURE__ */ w(
                "feColorMatrix",
                {
                  in: "SourceAlpha",
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                  result: "hardAlpha"
                }
              ),
              /* @__PURE__ */ w("feOffset", { dy: "2.11556" }),
              /* @__PURE__ */ w("feGaussianBlur", { stdDeviation: "2.11556" }),
              /* @__PURE__ */ w(
                "feColorMatrix",
                {
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
                }
              ),
              /* @__PURE__ */ w(
                "feBlend",
                {
                  mode: "normal",
                  in2: "BackgroundImageFix",
                  result: "effect1_dropShadow_18659_25530"
                }
              ),
              /* @__PURE__ */ w(
                "feBlend",
                {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "effect1_dropShadow_18659_25530",
                  result: "shape"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ w("clipPath", { id: "clip0_18659_25530", children: /* @__PURE__ */ w(
          "rect",
          {
            width: "12.4444",
            height: "12.4444",
            className: "fill-[theme(backgroundColor.foundations-default)]",
            transform: "translate(10.8894 35.7773)"
          }
        ) })
      ] })
    ]
  }
);
function ZC() {
  const [t, e] = C.useReducer((n) => !n, !1);
  return e;
}
function pd(t) {
  const e = C.useRef(t);
  return C.useEffect(() => {
    e.current = t;
  }), C.useMemo(
    () => (...n) => {
      var r;
      return (r = e.current) == null ? void 0 : r.call(e, ...n);
    },
    []
  );
}
const cp = ({ children: t }) => /* @__PURE__ */ w(F0, { asChild: !0, children: t });
kl.register(
  Ea,
  Ma,
  xo,
  vi,
  eo,
  mi,
  hi,
  fi,
  px
);
const QC = ({
  type: t,
  labels: e,
  datasets: n,
  horizontal: r = !1,
  hideLegend: o = !1,
  scaleXWeekFormat: i = !1,
  extraScales: s,
  disableAnimation: a = !1,
  tooltipLabelFormatter: l,
  tooltipValueFormatter: c,
  maxYValue: u,
  formatXLabel: d,
  ...f
}) => {
  const [h, p] = C.useState(null), g = C.useRef(null), m = e.length > 50;
  return e.length === 0 ? /* @__PURE__ */ w(ap, {}) : /* @__PURE__ */ B("div", { className: "relative h-full", children: [
    !o && h && n.length > 1 && /* @__PURE__ */ w(JC, { chart: h, datasets: n }),
    /* @__PURE__ */ w(
      Wx,
      {
        ref: p,
        width: "100%",
        type: t,
        data: {
          labels: e,
          datasets: n
        },
        options: {
          layout: {
            padding: {
              right: 40
            }
          },
          animation: !a,
          transitions: {
            active: {
              animation: {
                duration: 0
              }
            }
          },
          responsive: !0,
          maintainAspectRatio: !1,
          indexAxis: r ? "y" : "x",
          interaction: {
            intersect: !1,
            axis: "x",
            mode: "nearest"
          },
          elements: {
            bar: {
              borderRadius: 4
            },
            point: {
              radius: 0,
              hitRadius: 4,
              pointStyle: "circle"
            },
            line: {
              borderWidth: 2,
              tension: 0.02
            }
          },
          plugins: {
            tooltip: {
              mode: "nearest",
              intersect: !1,
              enabled: !1,
              external: (b) => {
                var y, M;
                if (!b.chart.$rendered)
                  return;
                const v = b.tooltip;
                if (v.opacity === 0) {
                  (y = g.current) == null || y.updateTooltip({
                    opacity: 0,
                    top: void 0,
                    left: void 0,
                    xAlign: void 0
                  });
                  return;
                }
                const _ = b.chart.canvas.getBoundingClientRect(), x = {
                  opacity: 1,
                  left: _.left + v.caretX + window.scrollX,
                  top: _.top + v.caretY + window.scrollY,
                  xAlign: v.xAlign,
                  dataPoints: v.dataPoints.map((k) => {
                    var O;
                    return {
                      label: k.label,
                      dataset: k.dataset,
                      raw: k.raw,
                      rawLabel: (O = k.chart.data.labels) == null ? void 0 : O[k.dataIndex]
                    };
                  })
                };
                (M = g.current) == null || M.updateTooltip(x);
              }
            },
            zoom: {
              zoom: {
                wheel: {
                  enabled: m
                },
                pinch: {
                  enabled: m
                },
                drag: {
                  enabled: m
                },
                mode: "x"
              }
            }
          },
          scales: {
            y: {
              beginAtZero: !0,
              grace: "5%",
              grid: {
                display: !1
              },
              ticks: {
                padding: 8,
                color: Dn("--text-foundations-bold"),
                count: 2
              },
              border: {
                display: !1
              },
              max: u
            },
            x: {
              offset: !0,
              type: "time",
              time: {
                unit: "day",
                displayFormats: {
                  day: i ? "E" : "MMM d"
                },
                tooltipFormat: "MMM d, yyy"
              },
              grid: {
                color: "transparent",
                tickColor: Dn(
                  "--border-foundations-bold"
                ),
                offset: !1
              },
              ticks: {
                padding: 8,
                color: Dn("--text-foundations-bold"),
                align: "inner",
                autoSkip: !1,
                maxRotation: 0,
                minRotation: 0,
                source: "labels",
                callback(b, v) {
                  return v === 0 || v === e.length - 1 ? d ? d(b, v) : lt(b, "MMM d, yyy") : void 0;
                }
              },
              border: {
                color: Dn("--border-foundations-bold")
              }
            },
            ...s
          }
        },
        plugins: [
          C.useMemo(t5, []),
          n5
        ],
        ...f
      }
    ),
    /* @__PURE__ */ w(cp, { children: /* @__PURE__ */ w(
      e5,
      {
        ref: g,
        tooltipLabelFormatter: l && pd(l),
        tooltipValueFormatter: c && pd(c),
        isLargeDataSet: m,
        showLabel: n.length > 1
      }
    ) })
  ] });
};
QC.displayName = "Chart";
function JC({
  datasets: t,
  chart: e
}) {
  const [n, r] = C.useState(null), [o, i] = C.useState(/* @__PURE__ */ new Set()), s = ZC(), a = C.useCallback(
    (l) => {
      o.has(l) ? (i((u) => {
        const d = new Set(u);
        return d.delete(l), d;
      }), e.setDatasetVisibility(l, !0)) : (i((u) => new Set(u).add(l)), e.setDatasetVisibility(l, !1)), e.update(), s();
    },
    [e, o, s]
  );
  return /* @__PURE__ */ w("div", { className: "flex justify-end space-x-2 pr-10", children: t.map((l, c) => {
    var u;
    return /* @__PURE__ */ B(
      "button",
      {
        className: he(
          "flex items-center space-x-1 p-1 transition-opacity duration-300",
          n === c && "opacity-20",
          o.has(c) && "line-through opacity-50"
        ),
        onClick: () => a(c),
        onMouseEnter: () => {
          o.has(c) || (r(c), e.config.data.datasets.forEach((d, f) => {
            var h, p, g, m;
            if (!o.has(f)) {
              if (c === f) {
                e.config.data.datasets[c].backgroundColor = d.backgroundColor, e.config.data.datasets[c].borderColor = d.borderColor;
                return;
              }
              d.backgroundColor = (p = (h = d.backgroundColor) == null ? void 0 : h.replace) == null ? void 0 : p.call(h, ")", ", 0.3)"), d.borderColor = (m = (g = d.borderColor) == null ? void 0 : g.replace) == null ? void 0 : m.call(
                g,
                ")",
                ", 0.3)"
              );
            }
          }), e.update(), s());
        },
        onMouseLeave: () => {
          r(null), e.config.data.datasets.forEach((d, f) => {
            o.has(f) || (d.backgroundColor = d.backgroundColor = t[f].backgroundColor, d.borderColor = d.borderColor = t[f].borderColor);
          }), e.update(), s();
        },
        children: [
          /* @__PURE__ */ w(
            "div",
            {
              className: he(
                "h-2 w-2 rounded-full bg-foundations-subtle transition-opacity duration-300",
                o.has(c) && "opacity-30"
              ),
              style: {
                backgroundColor: ((u = l.backgroundColor) == null ? void 0 : u.toString()) || void 0
              }
            }
          ),
          /* @__PURE__ */ w("span", { className: "text-xs font-medium text-foundations-boldest", children: l.label })
        ]
      },
      l.label
    );
  }) });
}
const e5 = C.memo(
  C.forwardRef(
    ({
      isLargeDataSet: t,
      tooltipLabelFormatter: e,
      tooltipValueFormatter: n,
      showLabel: r
    }, o) => {
      const [i, s] = C.useState({
        opacity: 0,
        top: 0,
        left: 0,
        xAlign: ""
      });
      C.useImperativeHandle(o, () => ({
        updateTooltip: (f) => {
          i.opacity === f.opacity && i.left === f.left && i.top === f.top || s((h) => ({
            opacity: f.opacity,
            top: f.top ?? h.top,
            left: f.left ?? h.left,
            xAlign: f.xAlign ?? h.xAlign,
            dataPoints: f.dataPoints ?? h.dataPoints
          }));
        }
      }));
      const { top: a, left: l, opacity: c, xAlign: u, dataPoints: d } = i;
      return /* @__PURE__ */ w(
        "div",
        {
          className: he(
            "pointer-events-none fixed z-50 -translate-y-[calc(100%-8px)] space-y-2 rounded-lg border border-foundations-subtle bg-foundations-default px-3 py-2 shadow-3 transition-all",
            u === "left" ? "translate-x-[calc(8px+6px)]" : "-translate-x-[calc(100%+8px+6px)]",
            t ? "duration-100" : "duration-200"
          ),
          style: {
            top: a,
            left: l,
            opacity: c
          },
          children: d == null ? void 0 : d.map((f) => /* @__PURE__ */ B(
            "div",
            {
              className: "flex space-x-2 whitespace-nowrap",
              children: [
                /* @__PURE__ */ w(
                  "div",
                  {
                    className: "w-[3px] rounded-full",
                    style: {
                      backgroundColor: f.dataset.backgroundColor
                    }
                  }
                ),
                /* @__PURE__ */ B("div", { className: "space-y-1 text-xs font-medium text-foundations-boldest", children: [
                  r && /* @__PURE__ */ w("p", { children: f.dataset.label }),
                  /* @__PURE__ */ w("p", { className: "text-[11px] uppercase text-foundations-subtle", children: e ? e(f.rawLabel) : f.label }),
                  /* @__PURE__ */ w("p", { children: n ? n(f.raw) : String(f.raw) })
                ] })
              ]
            },
            f.dataset.label
          ))
        }
      );
    }
  )
);
function Uk(t) {
  return {
    grace: "5%",
    grid: {
      drawOnChartArea: !1,
      drawTicks: !1
    },
    ticks: {
      padding: 8,
      color: Dn("--text-foundations-subtle")
    },
    border: {
      display: !1
    },
    ...t
  };
}
const t5 = () => {
  let t = null;
  return {
    id: "hover-label",
    afterEvent(n, { inChartArea: r, event: o }) {
      var s, a;
      if (!r) {
        t = null;
        return;
      }
      const [i] = n.getElementsAtEventForMode(
        //@ts-expect-error
        o,
        "nearest",
        { intersect: !1, axis: (a = (s = n.config.options) == null ? void 0 : s.interaction) == null ? void 0 : a.axis },
        !0
      );
      t = (i == null ? void 0 : i.index) ?? null;
    },
    afterDatasetDraw(n) {
      var b;
      const {
        ctx: r,
        chartArea: { top: o, bottom: i },
        scales: { x: s }
      } = n;
      if (r.save(), t == null)
        return;
      const a = (b = n.data.labels) == null ? void 0 : b[t], c = n.getDatasetMeta(0).data[t], u = c ? c.x : s.getPixelForValue(new Date(a).getTime()), d = 1;
      r.beginPath(), r.setLineDash([3, 3]), r.strokeStyle = Dn("--border-foundations-bolder"), r.lineWidth = d;
      const f = u - d / 2;
      r.moveTo(f, o), r.lineTo(f, i), r.stroke();
      const h = 8, p = new Date(a).getTime(), g = lt(p, "MMM d, yyy"), m = r.measureText(`${g}`).width + h;
      r.fillStyle = Dn(
        "--background-foundations-subtlest"
      ), r.roundRect(u - m / 2, i + 12, m, 20, 4), r.fill(), r.font = "500 12px 'DM Sans', Arial", r.fillStyle = Dn("--text-foundations-boldest"), r.fillText(
        g,
        u - m / 2 + h / 2,
        i + 12 + 20 / 2 + 5
      ), r.restore();
    }
  };
}, n5 = {
  id: "fully-rendered",
  afterRender: function(t) {
    t.$rendered || (t.$rendered = !0);
  }
}, r5 = (t) => /* @__PURE__ */ C.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "ArrowNarrowShortUp/solid"
}, t), /* @__PURE__ */ C.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.293 9.707a1 1 0 0 1 0-1.414l4.005-4a1.002 1.002 0 0 1 1.416 0l4.005 4a1 1 0 0 1-1.416 1.414l-2.296-2.293V15a1 1 0 0 1-1.001 1 1.002 1.002 0 0 1-1.001-1V7.414L6.709 9.707a1.002 1.002 0 0 1-1.416 0Z",
  clipRule: "evenodd"
})), o5 = (t) => /* @__PURE__ */ C.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "ChevronUp/solid"
}, t), /* @__PURE__ */ C.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.707 12.707a1 1 0 0 1-1.414 0L10 9.414l-3.293 3.293a1 1 0 0 1-1.414-1.414l4-4a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414Z",
  clipRule: "evenodd"
})), up = (t) => Number(t.toFixed(2)), i5 = Kt(
  "transition-all duration-1000 stroke-neutral-300",
  {
    variants: {
      variant: {
        success: "stroke-[theme(backgroundColor.chart-categorical-2-subtle)]",
        danger: "stroke-[theme(backgroundColor.chart-categorical-3-subtle)]",
        primary: "stroke-[theme(backgroundColor.info-bold)]"
      }
    }
  }
), dp = C.forwardRef(
  ({
    variant: t,
    value: e,
    size: n = 170,
    strokeWidth: r = 10,
    strokeClassName: o,
    strokeLinecap: i = "round"
  }, s) => {
    const l = n / 2 - r, c = 2 * Math.PI * l, u = c * ((100 - (e || 0)) / 100);
    return /* @__PURE__ */ B("svg", { ref: s, width: n, height: n, children: [
      /* @__PURE__ */ w(
        "circle",
        {
          className: he("stroke-neutral-100", o),
          fill: "none",
          strokeWidth: r,
          r: l,
          cx: n / 2,
          cy: n / 2
        }
      ),
      /* @__PURE__ */ w(
        "circle",
        {
          className: he(
            "stroke-[theme(backgroundColor.chart-neutral)]",
            i5({ variant: t })
          ),
          fill: "none",
          strokeWidth: r,
          r: l,
          cx: n / 2,
          cy: n / 2,
          strokeDasharray: c,
          strokeDashoffset: u,
          strokeLinecap: i,
          transform: "rotate(-90)",
          "transform-origin": "center"
        }
      )
    ] });
  }
), s5 = C.forwardRef(
  ({
    variant: t,
    value: e,
    size: n = 170,
    strokeWidth: r = 10,
    strokeClassName: o,
    className: i,
    children: s
  }, a) => /* @__PURE__ */ B("div", { ref: a, className: he("relative inline-flex", i), children: [
    /* @__PURE__ */ w(
      dp,
      {
        value: e,
        variant: t,
        size: n,
        strokeWidth: r,
        strokeClassName: o
      }
    ),
    /* @__PURE__ */ w("div", { className: "absolute inset-0 flex flex-col items-center justify-center space-y-1.5", children: e === null ? /* @__PURE__ */ B("div", { className: "flex scale-[0.8] flex-col items-center", children: [
      /* @__PURE__ */ w(lp, {}),
      /* @__PURE__ */ w("p", { className: "-mt-4 text-xs font-medium text-foundations-boldest", children: "No data in this period" })
    ] }) : /* @__PURE__ */ B(nt, { children: [
      /* @__PURE__ */ B("p", { className: "text-xl font-bold text-foundations-boldest", children: [
        up(e),
        "%"
      ] }),
      s
    ] }) })
  ] })
);
s5.displayName = "CircleChart";
const a5 = Kt(
  "flex items-center justify-center rounded-md border border-foundations-bold bg-foundations-subtlest text-foundations-boldest py-0.5 px-1.5",
  {
    variants: {
      variant: {
        success: "bg-success-subtler border-success-subtle",
        danger: "bg-danger-subtler border-danger-subtle"
      }
    }
  }
), Yk = C.forwardRef(({ diffPercentage: t, variant: e, className: n, ...r }, o) => /* @__PURE__ */ B(
  "span",
  {
    ref: o,
    className: he(a5({ variant: e }), n),
    ...r,
    children: [
      !!t && /* @__PURE__ */ w(
        r5,
        {
          className: he("h-4 w-4", t < 0 && " rotate-180")
        }
      ),
      /* @__PURE__ */ B("span", { className: "text-xs font-medium", children: [
        up(Math.abs(t)),
        "%"
      ] })
    ]
  }
)), l5 = ({
  items: t,
  formatValue: e,
  tooltipContent: n,
  onBarHover: r
}) => {
  const o = C.useMemo(
    () => Math.max(...t.map((i) => i.value)),
    [t]
  );
  return t.length === 0 ? /* @__PURE__ */ w(ap, {}) : /* @__PURE__ */ w("div", { className: "space-y-4 text-xs font-medium", children: t.map((i) => /* @__PURE__ */ B("div", { children: [
    /* @__PURE__ */ w("p", { className: "uppercase text-foundations-boldest", children: i.label }),
    /* @__PURE__ */ B(
      "div",
      {
        className: "mt-0.5 flex items-center space-x-2",
        style: {
          width: `${i.value ? i.value / o * 100 : 0}%`
        },
        children: [
          /* @__PURE__ */ w(
            rr,
            {
              content: n == null ? void 0 : n(i),
              disabled: !n,
              delayDuration: 0,
              onOpenChange: (s) => {
                r == null || r(s, i);
              },
              children: /* @__PURE__ */ w(
                "div",
                {
                  className: he(
                    "h-2 min-w-[2px] flex-1 bg-neutral-200",
                    i.barClassName
                  )
                }
              )
            }
          ),
          /* @__PURE__ */ w("span", { className: "tabular-nums text-foundations-subtle", children: (e == null ? void 0 : e(i)) || i.value })
        ]
      }
    )
  ] }, i.label)) });
};
l5.displayName = "HorizontalBarsChart";
const c5 = Kt(
  "inline-flex flex-shrink-0 items-center py-0.5 text-xs font-medium text-foundations-bolder",
  {
    variants: {
      variant: {
        primary: "border border-info-subtle bg-info-subtler",
        secondary: "bg-gold-400 text-white",
        warning: "border border-warning-subtle bg-warning-subtler",
        dimmed: "bg-foundations-bolder text-white",
        default: "border border-foundations-subtle bg-foundations-subtlest text-foundations-subtle",
        success: "border border-success-subtle bg-success-subtler",
        danger: "border border-danger-subtle bg-danger-subtler",
        pending: "bg-warning-subtler text-gold-400"
      },
      size: {
        sm: "px-2",
        md: "px-2.5"
      },
      shape: {
        pill: "rounded-full",
        square: "rounded-md"
      }
    },
    defaultVariants: {
      size: "md",
      shape: "pill",
      variant: "default"
    }
  }
), u5 = I.forwardRef(
  ({ variant: t, size: e, shape: n, className: r, children: o, asChild: i, ...s }, a) => /* @__PURE__ */ w(
    i ? Rt : "div",
    {
      ref: a,
      className: he(c5({ variant: t, size: e, shape: n, className: r })),
      ...s,
      children: o
    }
  )
);
u5.displayName = "Badge";
const d5 = (t) => /* @__PURE__ */ C.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Calendar/outline"
}, t), /* @__PURE__ */ C.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2Z"
})), Io = (t) => /* @__PURE__ */ C.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Check/outline"
}, t), /* @__PURE__ */ C.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m5 13 4 4L19 7"
})), fp = (t) => /* @__PURE__ */ C.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ChevronDown/outline"
}, t), /* @__PURE__ */ C.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m19 9-7 7-7-7"
})), f5 = (t) => /* @__PURE__ */ C.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ChevronLeft/outline"
}, t), /* @__PURE__ */ C.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m15 19-7-7 7-7"
})), h5 = (t) => /* @__PURE__ */ C.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ChevronRight/outline"
}, t), /* @__PURE__ */ C.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m9 5 7 7-7 7"
})), p5 = (t) => /* @__PURE__ */ C.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "DocumentDuplicate/outline"
}, t), /* @__PURE__ */ C.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M8 7v8a2 2 0 0 0 2 2h6M8 7V5a2 2 0 0 1 2-2h4.586a1 1 0 0 1 .707.293l4.414 4.414a1 1 0 0 1 .293.707V15a2 2 0 0 1-2 2h-2M8 7H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-2"
})), gd = (t) => /* @__PURE__ */ C.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ExclamationCircle/outline"
}, t), /* @__PURE__ */ C.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M12 8v4m0 4h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
})), g5 = (t) => /* @__PURE__ */ C.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ExternalLink/outline"
}, t), /* @__PURE__ */ C.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M10 6H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-4M14 4h6m0 0v6m0-6L10 14"
})), m5 = (t) => /* @__PURE__ */ C.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "EyeOff/outline"
}, t), /* @__PURE__ */ C.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m3 3 3.59 3.59M21 21l-3.589-3.589m-3.536 1.414A10.05 10.05 0 0 1 12 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 0 1 1.563-3.029m5.858.908a3 3 0 1 1 4.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532L6.59 6.59m7.532 7.532 3.29 3.29M6.59 6.59A9.953 9.953 0 0 1 12 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 0 1-4.132 5.411"
})), v5 = (t) => /* @__PURE__ */ C.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Eye/outline"
}, t), /* @__PURE__ */ C.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
}), /* @__PURE__ */ C.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M2.458 12C3.733 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.543 7-1.275 4.057-5.065 7-9.542 7-4.478 0-8.268-2.943-9.543-7Z"
})), md = (t) => /* @__PURE__ */ C.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "FolderDownload/outline"
}, t), /* @__PURE__ */ C.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M12 10v6m0 0-3-3m3 3 3-3M3 17V7a2 2 0 0 1 2-2h6l2 2h6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z"
})), b5 = (t) => /* @__PURE__ */ C.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "InformationCircle/outline"
}, t), /* @__PURE__ */ C.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
})), y5 = (t) => /* @__PURE__ */ C.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "QuestionMarkCircle/outline"
}, t), /* @__PURE__ */ C.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
})), w5 = (t) => /* @__PURE__ */ C.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Search/outline"
}, t), /* @__PURE__ */ C.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m21 21-6-6m2-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
})), x5 = (t) => /* @__PURE__ */ C.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "XCircle/outline"
}, t), /* @__PURE__ */ C.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m10 14 2-2m0 0 2-2m-2 2-2-2m2 2 2 2m7-2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
})), hp = (t) => /* @__PURE__ */ C.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "X/outline"
}, t), /* @__PURE__ */ C.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M6 18 18 6M6 6l12 12"
})), _5 = Kt(
  "relative flex items-center flex-shrink-0 w-full p-4 rounded-md overflow-hidden",
  {
    variants: {
      state: {
        success: "",
        danger: "",
        informative: "",
        warning: "",
        neutral: ""
      },
      contrast: {
        low: "border text-foundations-boldest [&_.icon]:w-5 [&_.icon]:h-5 [&_.icon_svg]:w-4 [&_.icon_svg]:h-4 [&_.close-btn]:text-foundations-subtle",
        medium: "text-foundations-inverse shadow-2 [&_.icon]:w-8 [&_.icon]:h-8 [&_.icon_svg]:w-6 [&_.icon_svg]:h-6"
      },
      fullWidth: {
        true: "",
        false: "max-w-[25rem]"
      }
    },
    defaultVariants: {
      state: "informative",
      contrast: "low",
      fullWidth: !1
    },
    compoundVariants: [
      {
        state: "success",
        contrast: "low",
        className: "bg-success-subtler border-success-subtle [&_.icon]:bg-success-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "danger",
        contrast: "low",
        className: "bg-danger-subtler border-danger-subtle [&_.icon]:bg-danger-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "informative",
        contrast: "low",
        className: "bg-info-subtler border-info-subtle [&_.icon]:bg-info-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "warning",
        contrast: "low",
        className: "bg-warning-subtler border-warning-subtle [&_.icon]:bg-warning-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "neutral",
        contrast: "low",
        className: "bg-foundations-subtlest border-foundations-bold [&_.icon]:bg-foundations-subtler [&_.icon]:text-foundations-inverse"
      },
      {
        state: "success",
        contrast: "medium",
        className: "bg-success-subtle text-foundations-boldest [&_.icon]:bg-success-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "danger",
        contrast: "medium",
        className: "bg-danger-subtle text-foundations-boldest [&_.icon]:bg-danger-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "informative",
        contrast: "medium",
        className: "bg-info-subtle text-foundations-boldest [&_.icon]:bg-info-bold [&_.icon]:text-foundations-inverse"
      },
      {
        state: "warning",
        contrast: "medium",
        className: "bg-warning-subtle text-foundations-boldest [&_.icon]:bg-warning-bold [&_.icon]:text-foundations-inverse"
      }
    ]
  }
), C5 = C.forwardRef(
  ({
    title: t,
    state: e = "neutral",
    contrast: n,
    fullWidth: r,
    className: o,
    onClose: i,
    actions: s,
    content: a,
    Icon: l,
    ...c
  }, u) => /* @__PURE__ */ B(
    "div",
    {
      ref: u,
      className: he(_5({ state: e, contrast: n, fullWidth: r }), o),
      ...c,
      children: [
        /* @__PURE__ */ w(pp, { state: e, CustomIcon: l }),
        /* @__PURE__ */ B("div", { className: "ml-4 flex-1", children: [
          /* @__PURE__ */ w("div", { className: "text-sm font-medium", children: t }),
          a && /* @__PURE__ */ w("div", { className: "mt-2", children: a })
        ] }),
        s && /* @__PURE__ */ w("div", { className: "ml-4 space-x-2", children: s }),
        i && /* @__PURE__ */ w(
          "button",
          {
            onClick: i,
            className: "close-btn ml-2 flex-shrink-0 rounded-sm hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500",
            children: /* @__PURE__ */ w(hp, { className: "h-4 w-4 " })
          }
        )
      ]
    }
  )
);
C5.displayName = "Alert";
const E5 = {
  success: Io,
  danger: hp,
  informative: b5,
  warning: gd,
  neutral: gd
}, pp = ({
  state: t,
  CustomIcon: e
}) => {
  const n = E5[t];
  return /* @__PURE__ */ w("div", { className: "icon flex flex-shrink-0 items-center justify-center rounded-full", children: e ? /* @__PURE__ */ w(e, {}) : /* @__PURE__ */ w(n, {}) });
};
pp.displayName = "AlertIcon";
const M5 = C.forwardRef(
  ({ asChild: t, className: e, disableHover: n, ...r }, o) => /* @__PURE__ */ w(
    t ? Rt : "div",
    {
      ref: o,
      className: he(
        "block rounded-lg border border-foundations-subtle bg-foundations-default p-6 transition-colors focus:border-info-bold focus:outline-none focus:ring-1 focus:ring-info-bold [&:has(.link-overlay:focus)]:border-info-bold [&:has(.link-overlay:focus)]:ring-1 [&:has(.link-overlay:focus)]:ring-info-bold",
        !n && "hover:border-foundations-bold hover:shadow-3",
        e
      ),
      ...r
    }
  )
);
M5.displayName = "Card";
const k5 = C.forwardRef(
  ({ asChild: t, className: e, ...n }, r) => /* @__PURE__ */ w(
    t ? Rt : "div",
    {
      ref: r,
      className: he(
        "relative [&_button]:relative [&_button]:z-[1] [&_a:not(.link-overlay)]:relative [&_a:not(.link-overlay)]:z-[1]",
        e
      ),
      ...n
    }
  )
);
k5.displayName = "LinkBox";
const O5 = C.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ w(
  "a",
  {
    ref: n,
    className: he(
      "link-overlay before:absolute before:inset-0 focus:outline-none",
      t
    ),
    ...e
  }
));
O5.displayName = "LinkOverlay";
const S5 = (t) => /* @__PURE__ */ w(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 66,
    viewBox: "0 0 184 150",
    fill: "none",
    ...t,
    children: /* @__PURE__ */ B("g", { id: "Illustrations/Empty States/08", children: [
      /* @__PURE__ */ w(
        "path",
        {
          id: "Ellipse 653",
          d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ B("g", { id: "Mask Group 3", children: [
        /* @__PURE__ */ B("g", { id: "Group 26805", children: [
          /* @__PURE__ */ w("g", { id: "Group", children: /* @__PURE__ */ w(
            "path",
            {
              id: "Path 25918",
              d: "M39.5 30.6754C38.3371 30.9512 37.2627 31.5449 36.4038 32.4038C35.1848 33.6228 34.5 35.2761 34.5 37V62C34.5 63.7239 35.1848 65.3772 36.4038 66.5962C37.6228 67.8152 39.2761 68.5 41 68.5H176C177.724 68.5 179.377 67.8152 180.596 66.5962C181.815 65.3772 182.5 63.7239 182.5 62V37C182.5 35.2761 181.815 33.6228 180.596 32.4038C179.377 31.1848 177.724 30.5 176 30.5H41H39.5V30.6754Z",
              className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]",
              strokeWidth: 3
            }
          ) }),
          /* @__PURE__ */ B("g", { id: "Group 26775", children: [
            /* @__PURE__ */ w(
              "path",
              {
                id: "Rectangle 5617",
                d: "M105 40H79C77.3431 40 76 41.3431 76 43C76 44.6569 77.3431 46 79 46H105C106.657 46 108 44.6569 108 43C108 41.3431 106.657 40 105 40Z",
                className: "fill-[theme(backgroundColor.foundations-bold)]"
              }
            ),
            /* @__PURE__ */ w(
              "path",
              {
                id: "Rectangle 5618",
                d: "M123 53H79C77.3431 53 76 54.3431 76 56C76 57.6569 77.3431 59 79 59H123C124.657 59 126 57.6569 126 56C126 54.3431 124.657 53 123 53Z",
                className: "fill-[theme(backgroundColor.foundations-subtle)]"
              }
            )
          ] }),
          /* @__PURE__ */ B("g", { id: "Group 26804", children: [
            /* @__PURE__ */ w(
              "path",
              {
                id: "Rectangle 5624",
                d: "M68 49.5C68 41.4919 61.5081 35 53.5 35C45.4919 35 39 41.4919 39 49.5C39 57.5081 45.4919 64 53.5 64C61.5081 64 68 57.5081 68 49.5Z",
                className: "fill-[theme(backgroundColor.foundations-bold)]"
              }
            ),
            /* @__PURE__ */ w("g", { id: "bx-search", children: /* @__PURE__ */ w(
              "path",
              {
                id: "Path 25920",
                d: "M52.6007 54.194C53.842 54.1939 55.0477 53.7785 56.0257 53.014L59.1007 56.089L60.0897 55.1L57.0137 52.024C57.7865 51.0248 58.1981 49.7934 58.1815 48.5303C58.1648 47.2672 57.7208 46.047 56.9219 45.0686C56.123 44.0901 55.0162 43.4111 53.782 43.1422C52.5478 42.8733 51.2588 43.0303 50.1253 43.5877C48.9917 44.1451 48.0804 45.07 47.5398 46.2117C46.9992 47.3533 46.8612 48.6444 47.1483 49.8746C47.4354 51.1047 48.1306 52.2013 49.1208 52.9857C50.1109 53.7701 51.3375 54.196 52.6007 54.194ZM52.6007 44.4C53.4314 44.4 54.2434 44.6464 54.9341 45.1079C55.6248 45.5694 56.1631 46.2253 56.481 46.9928C56.7989 47.7602 56.8821 48.6047 56.72 49.4194C56.5579 50.2341 56.1579 50.9825 55.5705 51.5699C54.9832 52.1573 54.2348 52.5573 53.4201 52.7193C52.6054 52.8814 51.7609 52.7982 50.9934 52.4803C50.226 52.1624 49.57 51.6241 49.1085 50.9334C48.647 50.2427 48.4007 49.4307 48.4007 48.6C48.4007 47.4861 48.8432 46.4178 49.6308 45.6302C50.4185 44.8425 51.4868 44.4 52.6007 44.4Z",
                className: "fill-[theme(backgroundColor.foundations-default)]"
              }
            ) })
          ] })
        ] }),
        /* @__PURE__ */ B("g", { id: "Group 26784", children: [
          /* @__PURE__ */ w("g", { id: "Group_2", children: /* @__PURE__ */ w(
            "path",
            {
              id: "Rectangle 5623",
              d: "M161 81.5H26C22.4101 81.5 19.5 84.4101 19.5 88V113C19.5 116.59 22.4101 119.5 26 119.5H161C164.59 119.5 167.5 116.59 167.5 113V88C167.5 84.4102 164.59 81.5 161 81.5Z",
              className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]",
              strokeWidth: 3
            }
          ) }),
          /* @__PURE__ */ B("g", { id: "Group 26775_2", children: [
            /* @__PURE__ */ w(
              "path",
              {
                id: "Rectangle 5617_2",
                d: "M90 91H64C62.3431 91 61 92.3431 61 94C61 95.6569 62.3431 97 64 97H90C91.6569 97 93 95.6569 93 94C93 92.3431 91.6569 91 90 91Z",
                className: "fill-[theme(backgroundColor.foundations-bold)]"
              }
            ),
            /* @__PURE__ */ w(
              "path",
              {
                id: "Rectangle 5618_2",
                d: "M108 104H64C62.3431 104 61 105.343 61 107C61 108.657 62.3431 110 64 110H108C109.657 110 111 108.657 111 107C111 105.343 109.657 104 108 104Z",
                className: "fill-[theme(backgroundColor.foundations-subtle)]"
              }
            )
          ] }),
          /* @__PURE__ */ B("g", { id: "Group 26807", children: [
            /* @__PURE__ */ w(
              "path",
              {
                id: "Rectangle 5624_2",
                d: "M53 100.5C53 92.4919 46.5081 86 38.5 86C30.4919 86 24 92.4919 24 100.5C24 108.508 30.4919 115 38.5 115C46.5081 115 53 108.508 53 100.5Z",
                className: "fill-[theme(backgroundColor.foundations-bold)]"
              }
            ),
            /* @__PURE__ */ w("g", { id: "bx-search_2", children: /* @__PURE__ */ w(
              "path",
              {
                id: "Path 25920_2",
                d: "M37.6007 105.194C38.842 105.194 40.0477 104.778 41.0257 104.014L44.1007 107.089L45.0897 106.1L42.0137 103.024C42.7865 102.025 43.1981 100.793 43.1815 99.5303C43.1648 98.2672 42.7208 97.047 41.9219 96.0686C41.123 95.0901 40.0162 94.4111 38.782 94.1422C37.5478 93.8733 36.2588 94.0303 35.1253 94.5877C33.9917 95.1451 33.0804 96.07 32.5398 97.2117C31.9992 98.3533 31.8612 99.6444 32.1483 100.875C32.4354 102.105 33.1306 103.201 34.1208 103.986C35.1109 104.77 36.3375 105.196 37.6007 105.194ZM37.6007 95.4C38.4314 95.4 39.2434 95.6464 39.9341 96.1079C40.6248 96.5694 41.1631 97.2253 41.481 97.9928C41.7989 98.7602 41.8821 99.6047 41.72 100.419C41.5579 101.234 41.1579 101.983 40.5705 102.57C39.9832 103.157 39.2348 103.557 38.4201 103.719C37.6054 103.881 36.7609 103.798 35.9934 103.48C35.226 103.162 34.57 102.624 34.1085 101.933C33.647 101.243 33.4007 100.431 33.4007 99.6C33.4007 98.4861 33.8432 97.4178 34.6308 96.6302C35.4185 95.8425 36.4868 95.4 37.6007 95.4Z",
                fill: "white"
              }
            ) })
          ] })
        ] })
      ] })
    ] })
  }
), gp = (t) => /* @__PURE__ */ w(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 150 153",
    fill: "none",
    ...t,
    children: /* @__PURE__ */ B("g", { id: "Illustrations/Empty States/07", children: [
      /* @__PURE__ */ w(
        "path",
        {
          id: "Ellipse 653",
          d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ w(
        "path",
        {
          id: "Subtraction 1",
          d: "M109.755 47.2509L109.748 47.2439C108.398 45.9026 107.328 44.3068 106.599 42.549C106.102 41.3514 105.77 40.0949 105.61 38.8138C105.395 37.0834 103.972 35.5 101.996 35.5H47.9978C46.0262 35.5 44.6038 37.0766 44.3853 38.8043C43.9832 41.9829 42.5372 44.9584 40.2478 47.2478C37.9584 49.5372 34.9829 50.9832 31.8043 51.3853C30.0766 51.6038 28.5 53.0262 28.5 54.9978V148C28.5 149.933 30.067 151.5 32 151.5H118C119.933 151.5 121.5 149.933 121.5 148V55.0044C121.5 53.0279 119.916 51.6052 118.186 51.3897C116.905 51.2301 115.648 50.8984 114.45 50.4015C112.692 49.6721 111.097 48.6013 109.755 47.2509Z",
          strokeWidth: 3,
          className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]"
        }
      ),
      /* @__PURE__ */ w(
        "path",
        {
          id: "Ellipse 665",
          d: "M75 102C88.2548 102 99 91.2548 99 78C99 64.7452 88.2548 54 75 54C61.7452 54 51 64.7452 51 78C51 91.2548 61.7452 102 75 102Z",
          className: "fill-[theme(backgroundColor.foundations-bold)]"
        }
      ),
      /* @__PURE__ */ w("g", { id: "ic_add_48px", children: /* @__PURE__ */ w(
        "path",
        {
          id: "Path 25936",
          d: "M84.8995 87.8997C84.1184 88.6807 82.8521 88.6807 82.0711 87.8997L76.4142 82.2428C75.6332 81.4618 74.3668 81.4618 73.5858 82.2428L67.9289 87.8997C67.1479 88.6807 65.8816 88.6807 65.1005 87.8997C64.3195 87.1186 64.3195 85.8523 65.1005 85.0712L70.7574 79.4144C71.5384 78.6333 71.5384 77.367 70.7574 76.5859L65.1005 70.9291C64.3195 70.148 64.3195 68.8817 65.1005 68.1007C65.8816 67.3196 67.1479 67.3196 67.9289 68.1007L73.5858 73.7575C74.3668 74.5386 75.6332 74.5386 76.4142 73.7575L82.0711 68.1007C82.8521 67.3196 84.1184 67.3196 84.8995 68.1007C85.6805 68.8817 85.6805 70.148 84.8995 70.9291L79.2426 76.5859C78.4616 77.367 78.4616 78.6333 79.2426 79.4144L84.8995 85.0712C85.6805 85.8523 85.6805 87.1186 84.8995 87.8997Z",
          className: "fill-[theme(backgroundColor.foundations-default)]"
        }
      ) }),
      /* @__PURE__ */ w(
        "path",
        {
          id: "Rectangle 5617",
          d: "M88 108H62C60.3431 108 59 109.343 59 111C59 112.657 60.3431 114 62 114H88C89.6569 114 91 112.657 91 111C91 109.343 89.6569 108 88 108Z",
          className: "fill-[theme(backgroundColor.foundations-subtle)]"
        }
      ),
      /* @__PURE__ */ w(
        "path",
        {
          id: "Rectangle 5618",
          d: "M97 120H53C51.3431 120 50 121.343 50 123C50 124.657 51.3431 126 53 126H97C98.6569 126 100 124.657 100 123C100 121.343 98.6569 120 97 120Z",
          className: "fill-[theme(backgroundColor.foundations-subtle)]"
        }
      )
    ] })
  }
), Kk = (t) => /* @__PURE__ */ w(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    ...t,
    children: /* @__PURE__ */ B("g", { id: "Illustrations/Empty States/10", children: [
      /* @__PURE__ */ w(
        "path",
        {
          id: "Ellipse 653",
          d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ B("g", { id: "Group 1489", children: [
        /* @__PURE__ */ B("g", { id: "Group 3", children: [
          /* @__PURE__ */ w(
            "rect",
            {
              id: "Rectangle 1",
              x: 34,
              y: 46,
              width: 67,
              height: 39,
              rx: 3,
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          ),
          /* @__PURE__ */ w(
            "circle",
            {
              id: "Ellipse 1",
              cx: 68,
              cy: 65,
              r: 12,
              className: "fill-[theme(backgroundColor.foundations-subtlest)]"
            }
          )
        ] }),
        /* @__PURE__ */ B("g", { id: "Group 1", children: [
          /* @__PURE__ */ w(
            "rect",
            {
              id: "Rectangle 1_2",
              x: 49,
              y: 65,
              width: 67,
              height: 39,
              rx: 3,
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          ),
          /* @__PURE__ */ w(
            "circle",
            {
              id: "Ellipse 1_2",
              cx: 83,
              cy: 84,
              r: 12,
              className: "fill-[theme(backgroundColor.foundations-default)]"
            }
          )
        ] })
      ] })
    ] })
  }
), Gk = (t) => /* @__PURE__ */ w(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 194,
    height: 168,
    viewBox: "0 0 194 168",
    fill: "none",
    ...t,
    children: /* @__PURE__ */ B("g", { id: "Illustrations/Empty States/01", children: [
      /* @__PURE__ */ w(
        "path",
        {
          id: "Rectangle 5625",
          d: "M159 0H39C33.4772 0 29 5.37258 29 12V156C29 162.627 33.4772 168 39 168H159C164.523 168 169 162.627 169 156V12C169 5.37258 164.523 0 159 0Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ B("g", { id: "Group 26800", children: [
        /* @__PURE__ */ w("g", { id: "Group", children: /* @__PURE__ */ w(
          "path",
          {
            id: "Path 25918",
            d: "M49.5 64.6754C48.3371 64.9512 47.2627 65.5449 46.4038 66.4038C45.1848 67.6228 44.5 69.2761 44.5 71V96C44.5 97.7239 45.1848 99.3772 46.4038 100.596C47.6228 101.815 49.2761 102.5 51 102.5H186C187.724 102.5 189.377 101.815 190.596 100.596C191.815 99.3772 192.5 97.7239 192.5 96V71C192.5 69.2761 191.815 67.6228 190.596 66.4038C189.377 65.1848 187.724 64.5 186 64.5H51H49.5V64.6754Z",
            strokeWidth: 3,
            className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]"
          }
        ) }),
        /* @__PURE__ */ B("g", { id: "Group 26775", children: [
          /* @__PURE__ */ w(
            "path",
            {
              id: "Rectangle 5617",
              d: "M125 74H99C97.3431 74 96 75.3431 96 77C96 78.6569 97.3431 80 99 80H125C126.657 80 128 78.6569 128 77C128 75.3431 126.657 74 125 74Z",
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          ),
          /* @__PURE__ */ w(
            "path",
            {
              id: "Rectangle 5618",
              d: "M143 87H99C97.3431 87 96 88.3431 96 90C96 91.6569 97.3431 93 99 93H143C144.657 93 146 91.6569 146 90C146 88.3431 144.657 87 143 87Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          )
        ] }),
        /* @__PURE__ */ w("g", { id: "Group 26799", children: /* @__PURE__ */ w("g", { id: "Group 26756", children: /* @__PURE__ */ w(
          "path",
          {
            id: "Ellipse 647",
            d: "M76.5 93C81.7467 93 86 88.7467 86 83.5C86 78.2533 81.7467 74 76.5 74C71.2533 74 67 78.2533 67 83.5C67 88.7467 71.2533 93 76.5 93Z",
            className: "fill-[theme(backgroundColor.foundations-bold)]"
          }
        ) }) })
      ] }),
      /* @__PURE__ */ B("g", { id: "Group 26798", children: [
        /* @__PURE__ */ w("g", { id: "Group_2", children: /* @__PURE__ */ w(
          "path",
          {
            id: "Path 25919",
            d: "M6.5 112.675C5.33714 112.951 4.26267 113.545 3.40381 114.404C2.18482 115.623 1.5 117.276 1.5 119V144C1.5 145.724 2.18482 147.377 3.40381 148.596C4.62279 149.815 6.27609 150.5 8 150.5H143C144.724 150.5 146.377 149.815 147.596 148.596C148.815 147.377 149.5 145.724 149.5 144V119C149.5 117.276 148.815 115.623 147.596 114.404C146.377 113.185 144.724 112.5 143 112.5H8H6.5V112.675Z",
            strokeWidth: 3,
            className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]"
          }
        ) }),
        /* @__PURE__ */ B("g", { id: "Group 26775_2", children: [
          /* @__PURE__ */ w(
            "path",
            {
              id: "Rectangle 5617_2",
              d: "M68 122H42C40.3431 122 39 123.343 39 125C39 126.657 40.3431 128 42 128H68C69.6569 128 71 126.657 71 125C71 123.343 69.6569 122 68 122Z",
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          ),
          /* @__PURE__ */ w(
            "path",
            {
              id: "Rectangle 5618_2",
              d: "M86 135H42C40.3431 135 39 136.343 39 138C39 139.657 40.3431 141 42 141H86C87.6569 141 89 139.657 89 138C89 136.343 87.6569 135 86 135Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          )
        ] }),
        /* @__PURE__ */ w("g", { id: "Group 26796", children: /* @__PURE__ */ w("g", { id: "Group 26757", children: /* @__PURE__ */ w("g", { id: "Ellipse 648", children: /* @__PURE__ */ w(
          "path",
          {
            id: "Vector",
            d: "M20.5 141C25.7467 141 30 136.747 30 131.5C30 126.253 25.7467 122 20.5 122C15.2533 122 11 126.253 11 131.5C11 136.747 15.2533 141 20.5 141Z",
            className: "fill-[theme(backgroundColor.foundations-bold)]"
          }
        ) }) }) })
      ] }),
      /* @__PURE__ */ B("g", { id: "Group 26802", children: [
        /* @__PURE__ */ w("g", { id: "Group_3", children: /* @__PURE__ */ w(
          "path",
          {
            id: "Rectangle 5623",
            d: "M143 16.5H8C4.41015 16.5 1.5 19.4101 1.5 23V48C1.5 51.5899 4.41015 54.5 8 54.5H143C146.59 54.5 149.5 51.5899 149.5 48V23C149.5 19.4102 146.59 16.5 143 16.5Z",
            strokeWidth: 3,
            className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]"
          }
        ) }),
        /* @__PURE__ */ B("g", { id: "Group 26775_3", children: [
          /* @__PURE__ */ w(
            "path",
            {
              id: "Rectangle 5617_3",
              d: "M80 26H54C52.3431 26 51 27.3431 51 29C51 30.6569 52.3431 32 54 32H80C81.6569 32 83 30.6569 83 29C83 27.3431 81.6569 26 80 26Z",
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          ),
          /* @__PURE__ */ w(
            "path",
            {
              id: "Rectangle 5618_3",
              d: "M98 39H54C52.3431 39 51 40.3431 51 42C51 43.6569 52.3431 45 54 45H98C99.6569 45 101 43.6569 101 42C101 40.3431 99.6569 39 98 39Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          )
        ] }),
        /* @__PURE__ */ w("g", { id: "Group 26801", children: /* @__PURE__ */ w("g", { id: "Group 26756_2", children: /* @__PURE__ */ w(
          "path",
          {
            id: "Ellipse 647_2",
            d: "M33.5 45C38.7467 45 43 40.7467 43 35.5C43 30.2533 38.7467 26 33.5 26C28.2533 26 24 30.2533 24 35.5C24 40.7467 28.2533 45 33.5 45Z",
            className: "fill-[theme(backgroundColor.foundations-bold)]"
          }
        ) }) })
      ] })
    ] })
  }
), qk = (t) => /* @__PURE__ */ w(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 169,
    viewBox: "0 0 150 169",
    fill: "none",
    ...t,
    children: /* @__PURE__ */ B("g", { id: "Illustrations/Empty States/02", children: [
      /* @__PURE__ */ B("g", { id: "Mask Group 1", children: [
        /* @__PURE__ */ w(
          "path",
          {
            id: "Ellipse 652",
            d: "M75 158C116.421 158 150 124.421 150 83C150 41.5786 116.421 8 75 8C33.5786 8 0 41.5786 0 83C0 124.421 33.5786 158 75 158Z",
            className: "fill-[theme(backgroundColor.foundations-subtler)]"
          }
        ),
        /* @__PURE__ */ w("g", { id: "Group", children: /* @__PURE__ */ w(
          "path",
          {
            id: "Rectangle 5615",
            d: "M118 49.5H32C28.4101 49.5 25.5 52.4101 25.5 56V161C25.5 164.59 28.4101 167.5 32 167.5H118C121.59 167.5 124.5 164.59 124.5 161V56C124.5 52.4101 121.59 49.5 118 49.5Z",
            strokeWidth: 3,
            className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]"
          }
        ) }),
        /* @__PURE__ */ B("g", { id: "Group 26776", children: [
          /* @__PURE__ */ w(
            "path",
            {
              id: "Rectangle 5617",
              d: "M65 66H39C37.3431 66 36 67.3431 36 69C36 70.6569 37.3431 72 39 72H65C66.6569 72 68 70.6569 68 69C68 67.3431 66.6569 66 65 66Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          ),
          /* @__PURE__ */ w(
            "path",
            {
              id: "Rectangle 5618",
              d: "M83 79H39C37.3431 79 36 80.3431 36 82C36 83.6569 37.3431 85 39 85H83C84.6569 85 86 83.6569 86 82C86 80.3431 84.6569 79 83 79Z",
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          )
        ] }),
        /* @__PURE__ */ B("g", { id: "Group 26777", children: [
          /* @__PURE__ */ w(
            "path",
            {
              id: "Rectangle 5617_2",
              d: "M65 93H39C37.3431 93 36 94.3431 36 96C36 97.6569 37.3431 99 39 99H65C66.6569 99 68 97.6569 68 96C68 94.3431 66.6569 93 65 93Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          ),
          /* @__PURE__ */ w(
            "path",
            {
              id: "Rectangle 5618_2",
              d: "M83 106H39C37.3431 106 36 107.343 36 109C36 110.657 37.3431 112 39 112H83C84.6569 112 86 110.657 86 109C86 107.343 84.6569 106 83 106Z",
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          )
        ] }),
        /* @__PURE__ */ B("g", { id: "Group 26778", children: [
          /* @__PURE__ */ w(
            "path",
            {
              id: "Rectangle 5617_3",
              d: "M65 120H39C37.3431 120 36 121.343 36 123C36 124.657 37.3431 126 39 126H65C66.6569 126 68 124.657 68 123C68 121.343 66.6569 120 65 120Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          ),
          /* @__PURE__ */ w(
            "path",
            {
              id: "Rectangle 5618_3",
              d: "M83 133H39C37.3431 133 36 134.343 36 136C36 137.657 37.3431 139 39 139H83C84.6569 139 86 137.657 86 136C86 134.343 84.6569 133 83 133Z",
              className: "fill-[theme(backgroundColor.foundations-subtle)]"
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ B("g", { id: "Group 26779", children: [
        /* @__PURE__ */ w("g", { id: "Group_2", children: /* @__PURE__ */ w(
          "path",
          {
            id: "Rectangle 5616",
            d: "M118 0H32C29.2386 0 27 2.23858 27 5V35C27 37.7614 29.2386 40 32 40H118C120.761 40 123 37.7614 123 35V5C123 2.23858 120.761 0 118 0Z",
            className: "fill-[theme(backgroundColor.foundations-subtle)]"
          }
        ) }),
        /* @__PURE__ */ B("g", { id: "Group 26775", children: [
          /* @__PURE__ */ w(
            "path",
            {
              id: "Rectangle 5617_4",
              d: "M65 11H39C37.3431 11 36 12.3431 36 14C36 15.6569 37.3431 17 39 17H65C66.6569 17 68 15.6569 68 14C68 12.3431 66.6569 11 65 11Z",
              className: "fill-[theme(backgroundColor.foundations-bold)]"
            }
          ),
          /* @__PURE__ */ w(
            "path",
            {
              id: "Rectangle 5618_4",
              d: "M83 24H39C37.3431 24 36 25.3431 36 27C36 28.6569 37.3431 30 39 30H83C84.6569 30 86 28.6569 86 27C86 25.3431 84.6569 24 83 24Z",
              className: "fill-[theme(backgroundColor.foundations-subtlest)]"
            }
          )
        ] })
      ] })
    ] })
  }
), Xk = (t) => /* @__PURE__ */ w(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 158,
    height: 169,
    viewBox: "0 0 158 169",
    fill: "none",
    ...t,
    children: /* @__PURE__ */ B("g", { id: "Illustrations/Empty States/03", children: [
      /* @__PURE__ */ w(
        "path",
        {
          id: "Ellipse 652",
          d: "M79 158C122.63 158 158 122.63 158 79C158 35.3695 122.63 0 79 0C35.3695 0 0 35.3695 0 79C0 122.63 35.3695 158 79 158Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ w("g", { id: "Group", children: /* @__PURE__ */ w("g", { id: "Mask Group", children: /* @__PURE__ */ w(
        "path",
        {
          id: "Rectangle 5615",
          d: "M122 49.5H36C32.4101 49.5 29.5 52.4101 29.5 56V161C29.5 164.59 32.4101 167.5 36 167.5H122C125.59 167.5 128.5 164.59 128.5 161V56C128.5 52.4101 125.59 49.5 122 49.5Z",
          strokeWidth: 3,
          className: "fill-[theme(backgroundColor.foundations-subtelst-02)] stroke-[theme(borderColor.foundations-subtle)]"
        }
      ) }) }),
      /* @__PURE__ */ w(
        "path",
        {
          id: "Rectangle 5617",
          d: "M70 61H44C42.3431 61 41 62.3431 41 64C41 65.6569 42.3431 67 44 67H70C71.6569 67 73 65.6569 73 64C73 62.3431 71.6569 61 70 61Z",
          className: "fill-[theme(backgroundColor.foundations-subtle)]"
        }
      ),
      /* @__PURE__ */ w(
        "path",
        {
          id: "Rectangle 5620",
          d: "M70 103H44C42.3431 103 41 104.343 41 106C41 107.657 42.3431 109 44 109H70C71.6569 109 73 107.657 73 106C73 104.343 71.6569 103 70 103Z",
          className: "fill-[theme(backgroundColor.foundations-subtle)]"
        }
      ),
      /* @__PURE__ */ w("g", { id: "Rectangle 5618", children: /* @__PURE__ */ w(
        "path",
        {
          id: "Vector",
          d: "M112 76H46C43.7909 76 42 77.7909 42 80V90C42 92.2091 43.7909 94 46 94H112C114.209 94 116 92.2091 116 90V80C116 77.7909 114.209 76 112 76Z",
          className: "fill-[theme(backgroundColor.foundations-bold)]"
        }
      ) }),
      /* @__PURE__ */ w(
        "path",
        {
          id: "Rectangle 5619",
          d: "M112 117H46C43.2386 117 41 119.239 41 122V130C41 132.761 43.2386 135 46 135H112C114.761 135 117 132.761 117 130V122C117 119.239 114.761 117 112 117Z",
          className: "fill-[theme(backgroundColor.foundations-bold)]"
        }
      ),
      /* @__PURE__ */ B("g", { id: "Group 26781", children: [
        /* @__PURE__ */ w(
          "path",
          {
            id: "Ellipse 654",
            d: "M57 40C59.2091 40 61 38.2091 61 36C61 33.7909 59.2091 32 57 32C54.7909 32 53 33.7909 53 36C53 38.2091 54.7909 40 57 40Z",
            className: "fill-[theme(backgroundColor.foundations-subtle)]"
          }
        ),
        /* @__PURE__ */ w(
          "path",
          {
            id: "Ellipse 655",
            d: "M79 40C81.2091 40 83 38.2091 83 36C83 33.7909 81.2091 32 79 32C76.7909 32 75 33.7909 75 36C75 38.2091 76.7909 40 79 40Z",
            className: "fill-[theme(backgroundColor.foundations-bold)]"
          }
        ),
        /* @__PURE__ */ w(
          "path",
          {
            id: "Ellipse 656",
            d: "M101 40C103.209 40 105 38.2091 105 36C105 33.7909 103.209 32 101 32C98.7909 32 97 33.7909 97 36C97 38.2091 98.7909 40 101 40Z",
            className: "fill-[theme(backgroundColor.foundations-subtle)]"
          }
        )
      ] }),
      /* @__PURE__ */ B("g", { id: "Group 26782", children: [
        /* @__PURE__ */ w(
          "path",
          {
            id: "Ellipse 658",
            d: "M90 96C92.7614 96 95 93.7614 95 91C95 88.2386 92.7614 86 90 86C87.2386 86 85 88.2386 85 91C85 93.7614 87.2386 96 90 96Z",
            className: "fill-[theme(backgroundColor.foundations-subtelst-02)]"
          }
        ),
        /* @__PURE__ */ w(
          "path",
          {
            id: "Path 25916",
            d: "M93.9071 112.37C93.1071 112.37 92.3601 112.37 91.6801 112.327C90.8425 112.27 90.0367 111.984 89.3515 111.499C88.6662 111.014 88.128 110.349 87.7961 109.578L83.5771 101.24C83.2676 100.88 83.1131 100.412 83.1472 99.938C83.1813 99.4643 83.4012 99.0233 83.7591 98.711C84.0522 98.4754 84.418 98.3485 84.7941 98.352C85.071 98.3601 85.3428 98.4281 85.5909 98.5513C85.839 98.6746 86.0574 98.8502 86.2311 99.066L88.1471 101.681L88.1761 101.715V91.78C88.1761 91.2871 88.3719 90.8144 88.7204 90.4659C89.069 90.1173 89.5417 89.9215 90.0346 89.9215C90.5275 89.9215 91.0002 90.1173 91.3487 90.4659C91.6973 90.8144 91.8931 91.2871 91.8931 91.78V98.28C91.8715 98.0408 91.9 97.7998 91.9767 97.5722C92.0534 97.3446 92.1767 97.1355 92.3387 96.9582C92.5007 96.781 92.6979 96.6394 92.9176 96.5425C93.1374 96.4456 93.3749 96.3956 93.6151 96.3956C93.8552 96.3956 94.0928 96.4456 94.3125 96.5425C94.5323 96.6394 94.7294 96.781 94.8914 96.9582C95.0534 97.1355 95.1767 97.3446 95.2535 97.5722C95.3302 97.7998 95.3587 98.0408 95.3371 98.28V99.635C95.3155 99.3958 95.344 99.1548 95.4207 98.9272C95.4974 98.6996 95.6207 98.4905 95.7827 98.3132C95.9447 98.136 96.1419 97.9944 96.3616 97.8975C96.5814 97.8006 96.8189 97.7506 97.0591 97.7506C97.2992 97.7506 97.5368 97.8006 97.7565 97.8975C97.9763 97.9944 98.1734 98.136 98.3354 98.3132C98.4974 98.4905 98.6207 98.6996 98.6975 98.9272C98.7742 99.1548 98.8027 99.3958 98.7811 99.635V100.679C98.7595 100.44 98.788 100.199 98.8647 99.9712C98.9414 99.7436 99.0647 99.5345 99.2267 99.3572C99.3887 99.18 99.5859 99.0384 99.8056 98.9415C100.025 98.8446 100.263 98.7946 100.503 98.7946C100.743 98.7946 100.981 98.8446 101.201 98.9415C101.42 99.0384 101.617 99.18 101.779 99.3572C101.941 99.5345 102.065 99.7436 102.141 99.9712C102.218 100.199 102.247 100.44 102.225 100.679V107.016C102.191 108.965 101.31 112.251 98.2111 112.251C97.9861 112.261 96.0801 112.371 93.9111 112.371L93.9071 112.37Z",
            className: "fill-[theme(backgroundColor.foundations-bold)] stroke-[theme(backgroundColor.foundations-default)]"
          }
        )
      ] })
    ] })
  }
), Zk = (t) => /* @__PURE__ */ B(
  "svg",
  {
    width: "150",
    height: "150",
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ w(
        "path",
        {
          d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
          className: "fill-[theme(backgroundColor.foundations-subtlest)]"
        }
      ),
      /* @__PURE__ */ w(
        "path",
        {
          d: "M120 150H30V53C34.242 52.9952 38.3089 51.308 41.3084 48.3085C44.308 45.3089 45.9952 41.242 46 37H104C103.996 39.1014 104.408 41.1828 105.213 43.1238C106.018 45.0648 107.2 46.8268 108.691 48.308C110.172 49.7991 111.934 50.9816 113.875 51.787C115.817 52.5924 117.898 53.0047 120 53V150Z",
          className: "fill-[theme(backgroundColor.foundations-default)]"
        }
      ),
      /* @__PURE__ */ w(
        "path",
        {
          d: "M75 102C88.2548 102 99 91.2548 99 78C99 64.7452 88.2548 54 75 54C61.7452 54 51 64.7452 51 78C51 91.2548 61.7452 102 75 102Z",
          className: "fill-[theme(backgroundColor.foundations-bold)]"
        }
      ),
      /* @__PURE__ */ w("g", { clipPath: "url(#clip0_22879_245463)", children: /* @__PURE__ */ w(
        "path",
        {
          d: "M73.4 66.7992C73.4 65.9156 74.1163 65.1992 75 65.1992C75.8837 65.1992 76.6 65.9156 76.6 66.7992V75.5992C76.6 76.041 76.9582 76.3992 77.4 76.3992C77.8418 76.3992 78.2 76.041 78.2 75.5992V68.3992C78.2 67.5156 78.9163 66.7992 79.8 66.7992C80.6837 66.7992 81.4 67.5156 81.4 68.3992V75.5992C81.4 76.041 81.7582 76.3992 82.2 76.3992C82.6418 76.3992 83 76.041 83 75.5992V71.5992C83 70.7156 83.7163 69.9992 84.6 69.9992C85.4837 69.9992 86.2 70.7156 86.2 71.5992V79.5992C86.2 85.7848 81.1856 90.7992 75 90.7992C68.8144 90.7992 63.8 85.7848 63.8 79.5992V76.3992C63.8 75.5156 64.5163 74.7992 65.4 74.7992C66.2837 74.7992 67 75.5156 67 76.3992V80.3992C67 80.841 67.3582 81.1992 67.8 81.1992C68.2418 81.1992 68.6 80.841 68.6 80.3992V68.3992C68.6 67.5156 69.3163 66.7992 70.2 66.7992C71.0837 66.7992 71.8 67.5156 71.8 68.3992V75.5992C71.8 76.041 72.1582 76.3992 72.6 76.3992C73.0418 76.3992 73.4 76.041 73.4 75.5992V66.7992Z",
          className: "fill-[theme(backgroundColor.foundations-default)]"
        }
      ) }),
      /* @__PURE__ */ w(
        "path",
        {
          d: "M88 108H62C60.3431 108 59 109.343 59 111C59 112.657 60.3431 114 62 114H88C89.6569 114 91 112.657 91 111C91 109.343 89.6569 108 88 108Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ w(
        "path",
        {
          d: "M97 120H53C51.3431 120 50 121.343 50 123C50 124.657 51.3431 126 53 126H97C98.6569 126 100 124.657 100 123C100 121.343 98.6569 120 97 120Z",
          className: "fill-[theme(backgroundColor.foundations-subtler)]"
        }
      ),
      /* @__PURE__ */ w("defs", { children: /* @__PURE__ */ w("clipPath", { id: "clip0_22879_245463", children: /* @__PURE__ */ w(
        "rect",
        {
          width: "32",
          height: "32",
          className: "fill-[theme(backgroundColor.foundations-default)]",
          transform: "translate(59 62)"
        }
      ) }) })
    ]
  }
), P5 = (t, e = 5, n = "*") => {
  const r = String(t), o = n.repeat(
    Math.max(r.length - e, 3)
  );
  return r.slice(0, e) + o;
};
function I5(t, e) {
  return /* @__PURE__ */ C.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: e
  }, t), /* @__PURE__ */ C.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5 13l4 4L19 7"
  }));
}
const T5 = C.forwardRef(I5), D5 = T5, $5 = () => {
  const [t, e] = ye(null), [n, r] = ye(!1);
  return ue(() => {
    if (!n)
      return;
    const i = setTimeout(() => {
      r(!1);
    }, 1e3);
    return () => clearTimeout(i);
  }, [n]), { copiedText: t, copy: async (i) => {
    try {
      return await navigator.clipboard.writeText(i), e(i), r(!0), !0;
    } catch (s) {
      return console.warn("Copy failed", s), e(null), !1;
    }
  }, isCopied: n };
}, N5 = ({
  text: t,
  className: e,
  iconClassName: n
}) => {
  const { copy: r, isCopied: o } = $5();
  return /* @__PURE__ */ w(ga, { children: /* @__PURE__ */ w(rr, { content: "Copy", size: "sm", children: /* @__PURE__ */ w(
    "button",
    {
      type: "button",
      onClick: () => {
        o || r(t);
      },
      className: e,
      "aria-label": "Copy to clipboard",
      children: o ? /* @__PURE__ */ w(
        D5,
        {
          className: he("h-4 w-4 text-success", n),
          "aria-hidden": "true"
        }
      ) : /* @__PURE__ */ w(
        p5,
        {
          className: he("h-4 w-4 stroke-2", n)
        }
      )
    }
  ) }) });
}, mp = de(
  ({
    type: t = "text",
    value: e,
    defaultValue: n,
    name: r,
    label: o,
    helpText: i,
    onChange: s,
    onFocus: a,
    onBlur: l,
    icon: c,
    className: u,
    containerClassName: d,
    readOnly: f,
    copyable: h,
    encrypted: p,
    nativeChangeEvent: g,
    ...m
  }, b) => {
    const [v, _] = ye(
      !(e || n)
    ), [x, y] = ye(!1), [M, k] = ye(!1), O = p && !v, S = Rn(
      () => O ? P5(e || "") : e,
      [O, e]
    );
    return /* @__PURE__ */ B("div", { className: d, children: [
      o && /* @__PURE__ */ w(
        "label",
        {
          htmlFor: r,
          className: "mb-4 block text-sm font-medium text-foundations-bold",
          children: o
        }
      ),
      /* @__PURE__ */ B("div", { className: "relative block", children: [
        /* @__PURE__ */ w(
          "input",
          {
            type: O ? "text" : t,
            name: r,
            id: r,
            ref: b,
            defaultValue: n,
            value: S,
            placeholder: "Type your method...",
            onChange: (P) => {
              g ? s(P) : s(P.currentTarget.value, P);
            },
            className: he(
              "peer block w-full min-w-0 flex-1 rounded-md border-foundations-bold bg-foundations-default text-foundations-bolder placeholder:text-foundations-subtle focus:border-info-bold focus:outline-none focus:ring-info-bold sm:text-sm",
              c ? "pl-8" : "",
              h && p ? "pr-[68px] truncate" : h || p ? "pr-9 truncate" : "",
              u
            ),
            readOnly: f || O,
            onFocus: (P) => {
              a == null || a(P), k(!0), v || y(!0);
            },
            onBlur: (P) => {
              l == null || l(P), k(!1);
            },
            ...m
          }
        ),
        /* @__PURE__ */ w("span", { className: "pointer-events-none absolute inset-y-0 left-2 flex transform items-center text-foundations-subtler peer-focus:text-blue-500", children: c }),
        (h || p) && /* @__PURE__ */ B("div", { className: "absolute inset-y-0 right-2 flex items-center justify-center gap-2 text-foundations-subtler peer-focus:text-blue-500", children: [
          p && /* @__PURE__ */ w(
            rr,
            {
              open: x,
              content: M && !v ? "Reveal first to be able to edit" : v ? "Hide" : "Reveal",
              size: "sm",
              onOpenChange: (P) => y(P),
              children: /* @__PURE__ */ w(
                "button",
                {
                  type: "button",
                  className: " ",
                  onClick: () => {
                    y(!1), _((P) => !P);
                  },
                  children: v ? /* @__PURE__ */ w(m5, { className: "h-5 w-5" }) : /* @__PURE__ */ w(v5, { className: "h-5 w-5" })
                }
              )
            }
          ),
          h && /* @__PURE__ */ w(N5, { text: e ?? "", iconClassName: "h-5 w-5" })
        ] })
      ] }),
      i && /* @__PURE__ */ w(
        "p",
        {
          className: "mt-2 text-sm text-foundations-subtler",
          id: "email-description",
          children: i
        }
      )
    ] });
  }
);
mp.displayName = "Input";
function vp(t) {
  return (e) => {
    t.forEach((n) => {
      typeof n == "function" ? n(e) : n != null && (n.current = e);
    });
  };
}
const bp = C.forwardRef(
  ({ className: t, label: e, description: n, isIndeterminate: r = !1, ...o }, i) => {
    const s = C.useRef(null);
    return C.useEffect(() => {
      s.current && (s.current.indeterminate = r);
    }, [r]), /* @__PURE__ */ B("label", { className: "flex space-x-2", children: [
      /* @__PURE__ */ w(
        "input",
        {
          ref: vp([s, i]),
          className: he(
            "cursor-pointer rounded checked:bg-foundations-boldest indeterminate:bg-foundations-boldest hover:checked:bg-foundations-inverse hover:indeterminate:bg-foundations-inverse focus:ring-2 focus:ring-info-bold focus:ring-offset-0 focus:checked:bg-foundations-boldest focus:indeterminate:bg-foundations-boldest",
            e && "mt-0.5",
            t
          ),
          type: "checkbox",
          ...o
        }
      ),
      (e || n) && /* @__PURE__ */ B("div", { className: "flex flex-col text-sm", children: [
        e && /* @__PURE__ */ w(nt, { children: typeof e == "string" ? /* @__PURE__ */ w("span", { className: "font-medium text-foundations-boldest", children: e }) : e }),
        n && /* @__PURE__ */ w("span", { className: "text-foundations-subtle", children: n })
      ] })
    ] });
  }
);
bp.displayName = "Checkbox";
function R5(t) {
  const e = ae({
    value: t,
    previous: t
  });
  return Rn(() => (e.current.value !== t && (e.current.previous = e.current.value, e.current.value = t), e.current.previous), [
    t
  ]);
}
const yp = "Switch", [A5, Qk] = an(yp), [L5, F5] = A5(yp), V5 = /* @__PURE__ */ de((t, e) => {
  const { __scopeSwitch: n, name: r, checked: o, defaultChecked: i, required: s, disabled: a, value: l = "on", onCheckedChange: c, ...u } = t, [d, f] = ye(null), h = et(
    e,
    (v) => f(v)
  ), p = ae(!1), g = d ? !!d.closest("form") : !0, [m = !1, b] = Hn({
    prop: o,
    defaultProp: i,
    onChange: c
  });
  return /* @__PURE__ */ L(L5, {
    scope: n,
    checked: m,
    disabled: a
  }, /* @__PURE__ */ L(je.button, ne({
    type: "button",
    role: "switch",
    "aria-checked": m,
    "aria-required": s,
    "data-state": wp(m),
    "data-disabled": a ? "" : void 0,
    disabled: a,
    value: l
  }, u, {
    ref: h,
    onClick: be(t.onClick, (v) => {
      b(
        (_) => !_
      ), g && (p.current = v.isPropagationStopped(), p.current || v.stopPropagation());
    })
  })), g && /* @__PURE__ */ L(B5, {
    control: d,
    bubbles: !p.current,
    name: r,
    value: l,
    checked: m,
    required: s,
    disabled: a,
    style: {
      transform: "translateX(-100%)"
    }
  }));
}), W5 = "SwitchThumb", H5 = /* @__PURE__ */ de((t, e) => {
  const { __scopeSwitch: n, ...r } = t, o = F5(W5, n);
  return /* @__PURE__ */ L(je.span, ne({
    "data-state": wp(o.checked),
    "data-disabled": o.disabled ? "" : void 0
  }, r, {
    ref: e
  }));
}), B5 = (t) => {
  const { control: e, checked: n, bubbles: r = !0, ...o } = t, i = ae(null), s = R5(n), a = ll(e);
  return ue(() => {
    const l = i.current, c = window.HTMLInputElement.prototype, d = Object.getOwnPropertyDescriptor(c, "checked").set;
    if (s !== n && d) {
      const f = new Event("click", {
        bubbles: r
      });
      d.call(l, n), l.dispatchEvent(f);
    }
  }, [
    s,
    n,
    r
  ]), /* @__PURE__ */ L("input", ne({
    type: "checkbox",
    "aria-hidden": !0,
    defaultChecked: n
  }, o, {
    tabIndex: -1,
    ref: i,
    style: {
      ...t.style,
      ...a,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function wp(t) {
  return t ? "checked" : "unchecked";
}
const j5 = V5, z5 = H5, Jk = C.forwardRef(({ className: t, children: e, ...n }, r) => /* @__PURE__ */ B(
  j5,
  {
    ref: r,
    className: he(
      "group/switch relative h-6 w-11 rounded-full border-2 border-transparent bg-foundations-bold transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-info-bold focus:ring-offset-2 focus:ring-offset-[theme(backgroundColor.foundations-default)] disabled:cursor-not-allowed disabled:bg-foundations-subtlest data-[state=checked]:bg-info-bold",
      e && "w-14",
      t
    ),
    ...n,
    children: [
      e && /* @__PURE__ */ w("span", { className: "absolute inset-y-0 left-auto right-1 z-0 inline-flex items-center text-xs font-medium tracking-wider text-foundations-subtle group-data-[state=checked]/switch:left-1 group-data-[state=checked]/switch:right-auto group-data-[state=checked]/switch:text-neutral-white", children: e }),
      /* @__PURE__ */ w(
        z5,
        {
          className: he(
            "thumb block h-5 w-5 translate-x-0 rounded-full bg-white transition-transform duration-200 will-change-transform",
            e ? "data-[state=checked]:translate-x-8" : "data-[state=checked]:translate-x-5"
          )
        }
      )
    ]
  }
)), U5 = C.forwardRef(
  ({ className: t, label: e, description: n, ...r }, o) => /* @__PURE__ */ B("label", { className: "flex space-x-2", children: [
    /* @__PURE__ */ w(
      "input",
      {
        ref: o,
        className: he(
          "cursor-pointer border-foundations-subtle checked:border-info-bold checked:bg-info-bold hover:border-foundations-bold hover:checked:bg-info-bolder focus:ring-offset-[theme(backgroundColor.foundations-default)]",
          e && "mt-0.5",
          t
        ),
        type: "radio",
        ...r
      }
    ),
    /* @__PURE__ */ B("div", { className: "flex flex-col text-sm", children: [
      e && /* @__PURE__ */ w(nt, { children: typeof e == "string" ? /* @__PURE__ */ w("span", { className: "font-medium text-foundations-bolder", children: e }) : e }),
      n && /* @__PURE__ */ w("span", { className: "text-foundations-subtle", children: n })
    ] })
  ] })
);
U5.displayName = "Radio";
const Y5 = Kt(
  "group/link inline-flex items-center space-x-1 font-medium focus:text-info",
  {
    variants: {
      variant: {
        inline: "underline text-info hover:text-link-hovered",
        standalone: "text-info hover:text-link-hovered hover:underline focus:underline"
      },
      size: {
        sm: "text-xs",
        md: "text-sm",
        lg: "text-base"
      }
    },
    defaultVariants: {
      size: "md",
      variant: "standalone"
    }
  }
), K5 = C.forwardRef(
  ({
    className: t,
    children: e,
    size: n,
    variant: r = "standalone",
    showExternalIcon: o = !0,
    truncate: i = !1,
    ...s
  }, a) => /* @__PURE__ */ B(
    "a",
    {
      ref: a,
      className: he(Y5({ variant: r, size: n }), t, {
        "max-w-full overflow-hidden": i
      }),
      ...s,
      children: [
        /* @__PURE__ */ w("span", { className: he({ truncate: i }), children: e }),
        o && /* @__PURE__ */ w(g5, { className: "h-4 w-4 flex-shrink-0" })
      ]
    }
  )
);
K5.displayName = "Link";
function xp(t) {
  const e = t + "CollectionProvider", [n, r] = an(e), [o, i] = n(e, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), s = (h) => {
    const { scope: p, children: g } = h, m = I.useRef(null), b = I.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ I.createElement(o, {
      scope: p,
      itemMap: b,
      collectionRef: m
    }, g);
  }, a = t + "CollectionSlot", l = /* @__PURE__ */ I.forwardRef((h, p) => {
    const { scope: g, children: m } = h, b = i(a, g), v = et(p, b.collectionRef);
    return /* @__PURE__ */ I.createElement(Rt, {
      ref: v
    }, m);
  }), c = t + "CollectionItemSlot", u = "data-radix-collection-item", d = /* @__PURE__ */ I.forwardRef((h, p) => {
    const { scope: g, children: m, ...b } = h, v = I.useRef(null), _ = et(p, v), x = i(c, g);
    return I.useEffect(() => (x.itemMap.set(v, {
      ref: v,
      ...b
    }), () => void x.itemMap.delete(v))), /* @__PURE__ */ I.createElement(Rt, {
      [u]: "",
      ref: _
    }, m);
  });
  function f(h) {
    const p = i(t + "CollectionConsumer", h);
    return I.useCallback(() => {
      const m = p.collectionRef.current;
      if (!m)
        return [];
      const b = Array.from(m.querySelectorAll(`[${u}]`));
      return Array.from(p.itemMap.values()).sort(
        (x, y) => b.indexOf(x.ref.current) - b.indexOf(y.ref.current)
      );
    }, [
      p.collectionRef,
      p.itemMap
    ]);
  }
  return [
    {
      Provider: s,
      Slot: l,
      ItemSlot: d
    },
    f,
    r
  ];
}
const G5 = /* @__PURE__ */ Nt(void 0);
function Nl(t) {
  const e = Yt(G5);
  return t || e || "ltr";
}
const Fs = "rovingFocusGroup.onEntryFocus", q5 = {
  bubbles: !1,
  cancelable: !0
}, Rl = "RovingFocusGroup", [Pa, _p, X5] = xp(Rl), [Z5, fs] = an(Rl, [
  X5
]), [Q5, J5] = Z5(Rl), e6 = /* @__PURE__ */ de((t, e) => /* @__PURE__ */ L(Pa.Provider, {
  scope: t.__scopeRovingFocusGroup
}, /* @__PURE__ */ L(Pa.Slot, {
  scope: t.__scopeRovingFocusGroup
}, /* @__PURE__ */ L(t6, ne({}, t, {
  ref: e
}))))), t6 = /* @__PURE__ */ de((t, e) => {
  const { __scopeRovingFocusGroup: n, orientation: r, loop: o = !1, dir: i, currentTabStopId: s, defaultCurrentTabStopId: a, onCurrentTabStopIdChange: l, onEntryFocus: c, ...u } = t, d = ae(null), f = et(e, d), h = Nl(i), [p = null, g] = Hn({
    prop: s,
    defaultProp: a,
    onChange: l
  }), [m, b] = ye(!1), v = pt(c), _ = _p(n), x = ae(!1), [y, M] = ye(0);
  return ue(() => {
    const k = d.current;
    if (k)
      return k.addEventListener(Fs, v), () => k.removeEventListener(Fs, v);
  }, [
    v
  ]), /* @__PURE__ */ L(Q5, {
    scope: n,
    orientation: r,
    dir: h,
    loop: o,
    currentTabStopId: p,
    onItemFocus: pe(
      (k) => g(k),
      [
        g
      ]
    ),
    onItemShiftTab: pe(
      () => b(!0),
      []
    ),
    onFocusableItemAdd: pe(
      () => M(
        (k) => k + 1
      ),
      []
    ),
    onFocusableItemRemove: pe(
      () => M(
        (k) => k - 1
      ),
      []
    )
  }, /* @__PURE__ */ L(je.div, ne({
    tabIndex: m || y === 0 ? -1 : 0,
    "data-orientation": r
  }, u, {
    ref: f,
    style: {
      outline: "none",
      ...t.style
    },
    onMouseDown: be(t.onMouseDown, () => {
      x.current = !0;
    }),
    onFocus: be(t.onFocus, (k) => {
      const O = !x.current;
      if (k.target === k.currentTarget && O && !m) {
        const S = new CustomEvent(Fs, q5);
        if (k.currentTarget.dispatchEvent(S), !S.defaultPrevented) {
          const D = _().filter(
            (R) => R.focusable
          ), P = D.find(
            (R) => R.active
          ), N = D.find(
            (R) => R.id === p
          ), U = [
            P,
            N,
            ...D
          ].filter(Boolean).map(
            (R) => R.ref.current
          );
          Cp(U);
        }
      }
      x.current = !1;
    }),
    onBlur: be(
      t.onBlur,
      () => b(!1)
    )
  })));
}), n6 = "RovingFocusGroupItem", r6 = /* @__PURE__ */ de((t, e) => {
  const { __scopeRovingFocusGroup: n, focusable: r = !0, active: o = !1, tabStopId: i, ...s } = t, a = fo(), l = i || a, c = J5(n6, n), u = c.currentTabStopId === l, d = _p(n), { onFocusableItemAdd: f, onFocusableItemRemove: h } = c;
  return ue(() => {
    if (r)
      return f(), () => h();
  }, [
    r,
    f,
    h
  ]), /* @__PURE__ */ L(Pa.ItemSlot, {
    scope: n,
    id: l,
    focusable: r,
    active: o
  }, /* @__PURE__ */ L(je.span, ne({
    tabIndex: u ? 0 : -1,
    "data-orientation": c.orientation
  }, s, {
    ref: e,
    onMouseDown: be(t.onMouseDown, (p) => {
      r ? c.onItemFocus(l) : p.preventDefault();
    }),
    onFocus: be(
      t.onFocus,
      () => c.onItemFocus(l)
    ),
    onKeyDown: be(t.onKeyDown, (p) => {
      if (p.key === "Tab" && p.shiftKey) {
        c.onItemShiftTab();
        return;
      }
      if (p.target !== p.currentTarget)
        return;
      const g = s6(p, c.orientation, c.dir);
      if (g !== void 0) {
        p.preventDefault();
        let b = d().filter(
          (v) => v.focusable
        ).map(
          (v) => v.ref.current
        );
        if (g === "last")
          b.reverse();
        else if (g === "prev" || g === "next") {
          g === "prev" && b.reverse();
          const v = b.indexOf(p.currentTarget);
          b = c.loop ? a6(b, v + 1) : b.slice(v + 1);
        }
        setTimeout(
          () => Cp(b)
        );
      }
    })
  })));
}), o6 = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function i6(t, e) {
  return e !== "rtl" ? t : t === "ArrowLeft" ? "ArrowRight" : t === "ArrowRight" ? "ArrowLeft" : t;
}
function s6(t, e, n) {
  const r = i6(t.key, n);
  if (!(e === "vertical" && [
    "ArrowLeft",
    "ArrowRight"
  ].includes(r)) && !(e === "horizontal" && [
    "ArrowUp",
    "ArrowDown"
  ].includes(r)))
    return o6[r];
}
function Cp(t) {
  const e = document.activeElement;
  for (const n of t)
    if (n === e || (n.focus(), document.activeElement !== e))
      return;
}
function a6(t, e) {
  return t.map(
    (n, r) => t[(e + r) % t.length]
  );
}
const Ep = e6, Mp = r6, l6 = /* @__PURE__ */ de((t, e) => {
  const { pressed: n, defaultPressed: r = !1, onPressedChange: o, ...i } = t, [s = !1, a] = Hn({
    prop: n,
    onChange: o,
    defaultProp: r
  });
  return /* @__PURE__ */ L(je.button, ne({
    type: "button",
    "aria-pressed": s,
    "data-state": s ? "on" : "off",
    "data-disabled": t.disabled ? "" : void 0
  }, i, {
    ref: e,
    onClick: be(t.onClick, () => {
      t.disabled || a(!s);
    })
  }));
}), hs = "ToggleGroup", [kp, e8] = an(hs, [
  fs
]), Op = fs(), c6 = /* @__PURE__ */ I.forwardRef((t, e) => {
  const { type: n, ...r } = t;
  if (n === "single") {
    const o = r;
    return /* @__PURE__ */ I.createElement(u6, ne({}, o, {
      ref: e
    }));
  }
  if (n === "multiple") {
    const o = r;
    return /* @__PURE__ */ I.createElement(d6, ne({}, o, {
      ref: e
    }));
  }
  throw new Error(`Missing prop \`type\` expected on \`${hs}\``);
}), [Sp, Pp] = kp(hs), u6 = /* @__PURE__ */ I.forwardRef((t, e) => {
  const { value: n, defaultValue: r, onValueChange: o = () => {
  }, ...i } = t, [s, a] = Hn({
    prop: n,
    defaultProp: r,
    onChange: o
  });
  return /* @__PURE__ */ I.createElement(Sp, {
    scope: t.__scopeToggleGroup,
    type: "single",
    value: s ? [
      s
    ] : [],
    onItemActivate: a,
    onItemDeactivate: I.useCallback(
      () => a(""),
      [
        a
      ]
    )
  }, /* @__PURE__ */ I.createElement(Ip, ne({}, i, {
    ref: e
  })));
}), d6 = /* @__PURE__ */ I.forwardRef((t, e) => {
  const { value: n, defaultValue: r, onValueChange: o = () => {
  }, ...i } = t, [s = [], a] = Hn({
    prop: n,
    defaultProp: r,
    onChange: o
  }), l = I.useCallback(
    (u) => a(
      (d = []) => [
        ...d,
        u
      ]
    ),
    [
      a
    ]
  ), c = I.useCallback(
    (u) => a(
      (d = []) => d.filter(
        (f) => f !== u
      )
    ),
    [
      a
    ]
  );
  return /* @__PURE__ */ I.createElement(Sp, {
    scope: t.__scopeToggleGroup,
    type: "multiple",
    value: s,
    onItemActivate: l,
    onItemDeactivate: c
  }, /* @__PURE__ */ I.createElement(Ip, ne({}, i, {
    ref: e
  })));
}), [f6, h6] = kp(hs), Ip = /* @__PURE__ */ I.forwardRef((t, e) => {
  const { __scopeToggleGroup: n, disabled: r = !1, rovingFocus: o = !0, orientation: i, dir: s, loop: a = !0, ...l } = t, c = Op(n), u = Nl(s), d = {
    role: "group",
    dir: u,
    ...l
  };
  return /* @__PURE__ */ I.createElement(f6, {
    scope: n,
    rovingFocus: o,
    disabled: r
  }, o ? /* @__PURE__ */ I.createElement(Ep, ne({
    asChild: !0
  }, c, {
    orientation: i,
    dir: u,
    loop: a
  }), /* @__PURE__ */ I.createElement(je.div, ne({}, d, {
    ref: e
  }))) : /* @__PURE__ */ I.createElement(je.div, ne({}, d, {
    ref: e
  })));
}), Ia = "ToggleGroupItem", p6 = /* @__PURE__ */ I.forwardRef((t, e) => {
  const n = Pp(Ia, t.__scopeToggleGroup), r = h6(Ia, t.__scopeToggleGroup), o = Op(t.__scopeToggleGroup), i = n.value.includes(t.value), s = r.disabled || t.disabled, a = {
    ...t,
    pressed: i,
    disabled: s
  }, l = I.useRef(null);
  return r.rovingFocus ? /* @__PURE__ */ I.createElement(Mp, ne({
    asChild: !0
  }, o, {
    focusable: !s,
    active: i,
    ref: l
  }), /* @__PURE__ */ I.createElement(vd, ne({}, a, {
    ref: e
  }))) : /* @__PURE__ */ I.createElement(vd, ne({}, a, {
    ref: e
  }));
}), vd = /* @__PURE__ */ I.forwardRef((t, e) => {
  const { __scopeToggleGroup: n, value: r, ...o } = t, i = Pp(Ia, n), s = {
    role: "radio",
    "aria-checked": t.pressed,
    "aria-pressed": void 0
  }, a = i.type === "single" ? s : void 0;
  return /* @__PURE__ */ I.createElement(l6, ne({}, a, o, {
    ref: e,
    onPressedChange: (l) => {
      l ? i.onItemActivate(r) : i.onItemDeactivate(r);
    }
  }));
}), g6 = c6, m6 = p6, v6 = C.forwardRef(({ onValueChange: t, className: e, canReset: n = !1, error: r, ...o }, i) => /* @__PURE__ */ w(
  g6,
  {
    ref: i,
    className: he(
      "inline-flex flex-shrink-0 space-x-2 rounded-md border border-foundations-subtle p-1",
      r && "border-red-500 focus:border-red-500 focus:ring-red-500",
      e
    ),
    type: "single",
    onValueChange: (s) => {
      (s || n) && t(s);
    },
    ...o
  }
));
v6.displayName = "OptionsGroup";
const b6 = C.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ w(
  m6,
  {
    ref: n,
    type: "button",
    className: he(
      "rounded px-2 py-1.5 text-sm font-medium text-foundations-subtle hover:bg-neutral-200 focus:bg-neutral-200 focus:outline-none aria-checked:bg-info-bold aria-checked:text-foundations-inverse aria-checked:focus:bg-info-bolder",
      t
    ),
    ...e
  }
));
b6.displayName = "Option";
var ge = function() {
  return ge = Object.assign || function(e) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
    }
    return e;
  }, ge.apply(this, arguments);
};
function y6(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(t); o < r.length; o++)
      e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[o]) && (n[r[o]] = t[r[o]]);
  return n;
}
function Tp(t, e, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = e.length, i; r < o; r++)
      (i || !(r in e)) && (i || (i = Array.prototype.slice.call(e, 0, r)), i[r] = e[r]);
  return t.concat(i || Array.prototype.slice.call(e));
}
function To(t) {
  return t.mode === "multiple";
}
function Do(t) {
  return t.mode === "range";
}
function ps(t) {
  return t.mode === "single";
}
var w6 = {
  root: "rdp",
  multiple_months: "rdp-multiple_months",
  with_weeknumber: "rdp-with_weeknumber",
  vhidden: "rdp-vhidden",
  button_reset: "rdp-button_reset",
  button: "rdp-button",
  caption: "rdp-caption",
  caption_start: "rdp-caption_start",
  caption_end: "rdp-caption_end",
  caption_between: "rdp-caption_between",
  caption_label: "rdp-caption_label",
  caption_dropdowns: "rdp-caption_dropdowns",
  dropdown: "rdp-dropdown",
  dropdown_month: "rdp-dropdown_month",
  dropdown_year: "rdp-dropdown_year",
  dropdown_icon: "rdp-dropdown_icon",
  months: "rdp-months",
  month: "rdp-month",
  table: "rdp-table",
  tbody: "rdp-tbody",
  tfoot: "rdp-tfoot",
  head: "rdp-head",
  head_row: "rdp-head_row",
  head_cell: "rdp-head_cell",
  nav: "rdp-nav",
  nav_button: "rdp-nav_button",
  nav_button_previous: "rdp-nav_button_previous",
  nav_button_next: "rdp-nav_button_next",
  nav_icon: "rdp-nav_icon",
  row: "rdp-row",
  weeknumber: "rdp-weeknumber",
  cell: "rdp-cell",
  day: "rdp-day",
  day_today: "rdp-day_today",
  day_outside: "rdp-day_outside",
  day_selected: "rdp-day_selected",
  day_disabled: "rdp-day_disabled",
  day_hidden: "rdp-day_hidden",
  day_range_start: "rdp-day_range_start",
  day_range_end: "rdp-day_range_end",
  day_range_middle: "rdp-day_range_middle"
};
function x6(t, e) {
  return lt(t, "LLLL y", e);
}
function _6(t, e) {
  return lt(t, "d", e);
}
function C6(t, e) {
  return lt(t, "LLLL", e);
}
function E6(t) {
  return "".concat(t);
}
function M6(t, e) {
  return lt(t, "cccccc", e);
}
function k6(t, e) {
  return lt(t, "yyyy", e);
}
var O6 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  formatCaption: x6,
  formatDay: _6,
  formatMonthCaption: C6,
  formatWeekNumber: E6,
  formatWeekdayName: M6,
  formatYearCaption: k6
}), S6 = function(t, e, n) {
  return lt(t, "do MMMM (EEEE)", n);
}, P6 = function() {
  return "Month: ";
}, I6 = function() {
  return "Go to next month";
}, T6 = function() {
  return "Go to previous month";
}, D6 = function(t, e) {
  return lt(t, "cccc", e);
}, $6 = function(t) {
  return "Week n. ".concat(t);
}, N6 = function() {
  return "Year: ";
}, R6 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  labelDay: S6,
  labelMonthDropdown: P6,
  labelNext: I6,
  labelPrevious: T6,
  labelWeekNumber: $6,
  labelWeekday: D6,
  labelYearDropdown: N6
});
function A6() {
  var t = "buttons", e = w6, n = Il, r = {}, o = {}, i = 1, s = {}, a = /* @__PURE__ */ new Date();
  return {
    captionLayout: t,
    classNames: e,
    formatters: O6,
    labels: R6,
    locale: n,
    modifiersClassNames: r,
    modifiers: o,
    numberOfMonths: i,
    styles: s,
    today: a,
    mode: "default"
  };
}
function L6(t) {
  var e = t.fromYear, n = t.toYear, r = t.fromMonth, o = t.toMonth, i = t.fromDate, s = t.toDate;
  return r ? i = ht(r) : e && (i = new Date(e, 0, 1)), o ? s = Po(o) : n && (s = new Date(n, 11, 31)), {
    fromDate: i ? sr(i) : void 0,
    toDate: s ? sr(s) : void 0
  };
}
var Dp = Nt(void 0);
function F6(t) {
  var e, n = t.initialProps, r = A6(), o = L6(n), i = o.fromDate, s = o.toDate, a = (e = n.captionLayout) !== null && e !== void 0 ? e : r.captionLayout;
  a !== "buttons" && (!i || !s) && (a = "buttons");
  var l;
  (ps(n) || To(n) || Do(n)) && (l = n.onSelect);
  var c = ge(ge(ge({}, r), n), { captionLayout: a, classNames: ge(ge({}, r.classNames), n.classNames), components: ge({}, n.components), formatters: ge(ge({}, r.formatters), n.formatters), fromDate: i, labels: ge(ge({}, r.labels), n.labels), mode: n.mode || r.mode, modifiers: ge(ge({}, r.modifiers), n.modifiers), modifiersClassNames: ge(ge({}, r.modifiersClassNames), n.modifiersClassNames), onSelect: l, styles: ge(ge({}, r.styles), n.styles), toDate: s });
  return I.createElement(Dp.Provider, { value: c }, t.children);
}
function Ue() {
  var t = Yt(Dp);
  if (!t)
    throw new Error("useDayPicker must be used within a DayPickerProvider.");
  return t;
}
function $p(t) {
  var e = Ue(), n = e.locale, r = e.classNames, o = e.styles, i = e.formatters.formatCaption;
  return I.createElement("div", { className: r.caption_label, style: o.caption_label, "aria-live": "polite", role: "presentation", id: t.id }, i(t.displayMonth, { locale: n }));
}
function V6(t) {
  return I.createElement(
    "svg",
    ge({ width: "8px", height: "8px", viewBox: "0 0 120 120", "data-testid": "iconDropdown" }, t),
    I.createElement("path", { d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z", fill: "currentColor", fillRule: "nonzero" })
  );
}
function Np(t) {
  var e, n, r = t.onChange, o = t.value, i = t.children, s = t.caption, a = t.className, l = t.style, c = Ue(), u = (n = (e = c.components) === null || e === void 0 ? void 0 : e.IconDropdown) !== null && n !== void 0 ? n : V6;
  return I.createElement(
    "div",
    { className: a, style: l },
    I.createElement("span", { className: c.classNames.vhidden }, t["aria-label"]),
    I.createElement("select", { name: t.name, "aria-label": t["aria-label"], className: c.classNames.dropdown, style: c.styles.dropdown, value: o, onChange: r }, i),
    I.createElement(
      "div",
      { className: c.classNames.caption_label, style: c.styles.caption_label, "aria-hidden": "true" },
      s,
      I.createElement(u, { className: c.classNames.dropdown_icon, style: c.styles.dropdown_icon })
    )
  );
}
function W6(t) {
  var e, n = Ue(), r = n.fromDate, o = n.toDate, i = n.styles, s = n.locale, a = n.formatters.formatMonthCaption, l = n.classNames, c = n.components, u = n.labels.labelMonthDropdown;
  if (!r)
    return I.createElement(I.Fragment, null);
  if (!o)
    return I.createElement(I.Fragment, null);
  var d = [];
  if (DC(r, o))
    for (var f = ht(r), h = r.getMonth(); h <= o.getMonth(); h++)
      d.push(Ls(f, h));
  else
    for (var f = ht(/* @__PURE__ */ new Date()), h = 0; h <= 11; h++)
      d.push(Ls(f, h));
  var p = function(m) {
    var b = Number(m.target.value), v = Ls(ht(t.displayMonth), b);
    t.onChange(v);
  }, g = (e = c == null ? void 0 : c.Dropdown) !== null && e !== void 0 ? e : Np;
  return I.createElement(g, { name: "months", "aria-label": u(), className: l.dropdown_month, style: i.dropdown_month, onChange: p, value: t.displayMonth.getMonth(), caption: a(t.displayMonth, { locale: s }) }, d.map(function(m) {
    return I.createElement("option", { key: m.getMonth(), value: m.getMonth() }, a(m, { locale: s }));
  }));
}
function H6(t) {
  var e, n = t.displayMonth, r = Ue(), o = r.fromDate, i = r.toDate, s = r.locale, a = r.styles, l = r.classNames, c = r.components, u = r.formatters.formatYearCaption, d = r.labels.labelYearDropdown, f = [];
  if (!o)
    return I.createElement(I.Fragment, null);
  if (!i)
    return I.createElement(I.Fragment, null);
  for (var h = o.getFullYear(), p = i.getFullYear(), g = h; g <= p; g++)
    f.push(hd(zh(/* @__PURE__ */ new Date()), g));
  var m = function(v) {
    var _ = hd(ht(n), Number(v.target.value));
    t.onChange(_);
  }, b = (e = c == null ? void 0 : c.Dropdown) !== null && e !== void 0 ? e : Np;
  return I.createElement(b, { name: "years", "aria-label": d(), className: l.dropdown_year, style: a.dropdown_year, onChange: m, value: n.getFullYear(), caption: u(n, { locale: s }) }, f.map(function(v) {
    return I.createElement("option", { key: v.getFullYear(), value: v.getFullYear() }, u(v, { locale: s }));
  }));
}
function B6(t, e) {
  var n = ye(t), r = n[0], o = n[1], i = e === void 0 ? r : e;
  return [i, o];
}
function j6(t) {
  var e = t.month, n = t.defaultMonth, r = t.today, o = e || n || r || /* @__PURE__ */ new Date(), i = t.toDate, s = t.fromDate, a = t.numberOfMonths, l = a === void 0 ? 1 : a;
  if (i && Tr(i, o) < 0) {
    var c = -1 * (l - 1);
    o = Ft(i, c);
  }
  return s && Tr(o, s) < 0 && (o = s), ht(o);
}
function z6() {
  var t = Ue(), e = j6(t), n = B6(e, t.month), r = n[0], o = n[1], i = function(s) {
    var a;
    if (!t.disableNavigation) {
      var l = ht(s);
      o(l), (a = t.onMonthChange) === null || a === void 0 || a.call(t, l);
    }
  };
  return [r, i];
}
function U6(t, e) {
  for (var n = e.reverseMonths, r = e.numberOfMonths, o = ht(t), i = ht(Ft(o, r)), s = Tr(i, o), a = [], l = 0; l < s; l++) {
    var c = Ft(o, l);
    a.push(c);
  }
  return n && (a = a.reverse()), a;
}
function Y6(t, e) {
  if (!e.disableNavigation) {
    var n = e.toDate, r = e.pagedNavigation, o = e.numberOfMonths, i = o === void 0 ? 1 : o, s = r ? i : 1, a = ht(t);
    if (!n)
      return Ft(a, s);
    var l = Tr(n, t);
    if (!(l < i))
      return Ft(a, s);
  }
}
function K6(t, e) {
  if (!e.disableNavigation) {
    var n = e.fromDate, r = e.pagedNavigation, o = e.numberOfMonths, i = o === void 0 ? 1 : o, s = r ? i : 1, a = ht(t);
    if (!n)
      return Ft(a, -s);
    var l = Tr(a, n);
    if (!(l <= 0))
      return Ft(a, -s);
  }
}
var Rp = Nt(void 0);
function G6(t) {
  var e = Ue(), n = z6(), r = n[0], o = n[1], i = U6(r, e), s = Y6(r, e), a = K6(r, e), l = function(d) {
    return i.some(function(f) {
      return $l(d, f);
    });
  }, c = function(d, f) {
    l(d) || (f && ep(d, f) ? o(Ft(d, 1 + e.numberOfMonths * -1)) : o(d));
  }, u = {
    currentMonth: r,
    displayMonths: i,
    goToMonth: o,
    goToDate: c,
    previousMonth: a,
    nextMonth: s,
    isDateDisplayed: l
  };
  return I.createElement(Rp.Provider, { value: u }, t.children);
}
function Lr() {
  var t = Yt(Rp);
  if (!t)
    throw new Error("useNavigation must be used within a NavigationProvider");
  return t;
}
function bd(t) {
  var e, n = Ue(), r = n.classNames, o = n.styles, i = n.components, s = Lr().goToMonth, a = function(u) {
    s(u);
  }, l = (e = i == null ? void 0 : i.CaptionLabel) !== null && e !== void 0 ? e : $p, c = I.createElement(l, { id: t.id, displayMonth: t.displayMonth });
  return I.createElement(
    "div",
    { className: r.caption_dropdowns, style: o.caption_dropdowns },
    I.createElement("div", { className: r.vhidden }, c),
    I.createElement(W6, { onChange: a, displayMonth: t.displayMonth }),
    I.createElement(H6, { onChange: a, displayMonth: t.displayMonth })
  );
}
function q6(t) {
  return I.createElement(
    "svg",
    ge({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, t),
    I.createElement("path", { d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z", fill: "currentColor", fillRule: "nonzero" })
  );
}
function X6(t) {
  return I.createElement(
    "svg",
    ge({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, t),
    I.createElement("path", { d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z", fill: "currentColor" })
  );
}
var zi = de(function(t, e) {
  var n = Ue(), r = n.classNames, o = n.styles, i = [r.button_reset, r.button];
  t.className && i.push(t.className);
  var s = i.join(" "), a = ge(ge({}, o.button_reset), o.button);
  return t.style && Object.assign(a, t.style), I.createElement("button", ge({}, t, { ref: e, type: "button", className: s, style: a }));
});
function Z6(t) {
  var e, n, r = Ue(), o = r.dir, i = r.locale, s = r.classNames, a = r.styles, l = r.labels, c = l.labelPrevious, u = l.labelNext, d = r.components;
  if (!t.nextMonth && !t.previousMonth)
    return I.createElement(I.Fragment, null);
  var f = c(t.previousMonth, { locale: i }), h = [
    s.nav_button,
    s.nav_button_previous
  ].join(" "), p = u(t.nextMonth, { locale: i }), g = [
    s.nav_button,
    s.nav_button_next
  ].join(" "), m = (e = d == null ? void 0 : d.IconRight) !== null && e !== void 0 ? e : X6, b = (n = d == null ? void 0 : d.IconLeft) !== null && n !== void 0 ? n : q6;
  return I.createElement(
    "div",
    { className: s.nav, style: a.nav },
    !t.hidePrevious && I.createElement(zi, { name: "previous-month", "aria-label": f, className: h, style: a.nav_button_previous, disabled: !t.previousMonth, onClick: t.onPreviousClick }, o === "rtl" ? I.createElement(m, { className: s.nav_icon, style: a.nav_icon }) : I.createElement(b, { className: s.nav_icon, style: a.nav_icon })),
    !t.hideNext && I.createElement(zi, { name: "next-month", "aria-label": p, className: g, style: a.nav_button_next, disabled: !t.nextMonth, onClick: t.onNextClick }, o === "rtl" ? I.createElement(b, { className: s.nav_icon, style: a.nav_icon }) : I.createElement(m, { className: s.nav_icon, style: a.nav_icon }))
  );
}
function yd(t) {
  var e = Ue().numberOfMonths, n = Lr(), r = n.previousMonth, o = n.nextMonth, i = n.goToMonth, s = n.displayMonths, a = s.findIndex(function(p) {
    return $l(t.displayMonth, p);
  }), l = a === 0, c = a === s.length - 1, u = e > 1 && (l || !c), d = e > 1 && (c || !l), f = function() {
    r && i(r);
  }, h = function() {
    o && i(o);
  };
  return I.createElement(Z6, { displayMonth: t.displayMonth, hideNext: u, hidePrevious: d, nextMonth: o, previousMonth: r, onPreviousClick: f, onNextClick: h });
}
function Q6(t) {
  var e, n = Ue(), r = n.classNames, o = n.disableNavigation, i = n.styles, s = n.captionLayout, a = n.components, l = (e = a == null ? void 0 : a.CaptionLabel) !== null && e !== void 0 ? e : $p, c;
  return o ? c = I.createElement(l, { id: t.id, displayMonth: t.displayMonth }) : s === "dropdown" ? c = I.createElement(bd, { displayMonth: t.displayMonth, id: t.id }) : s === "dropdown-buttons" ? c = I.createElement(
    I.Fragment,
    null,
    I.createElement(bd, { displayMonth: t.displayMonth, id: t.id }),
    I.createElement(yd, { displayMonth: t.displayMonth, id: t.id })
  ) : c = I.createElement(
    I.Fragment,
    null,
    I.createElement(l, { id: t.id, displayMonth: t.displayMonth }),
    I.createElement(yd, { displayMonth: t.displayMonth, id: t.id })
  ), I.createElement("div", { className: r.caption, style: i.caption }, c);
}
function J6(t) {
  var e = Ue(), n = e.footer, r = e.styles, o = e.classNames.tfoot;
  return n ? I.createElement(
    "tfoot",
    { className: o, style: r.tfoot },
    I.createElement(
      "tr",
      null,
      I.createElement("td", { colSpan: 8 }, n)
    )
  ) : I.createElement(I.Fragment, null);
}
function e3(t, e, n) {
  for (var r = n ? ir(/* @__PURE__ */ new Date()) : Vt(/* @__PURE__ */ new Date(), { locale: t, weekStartsOn: e }), o = [], i = 0; i < 7; i++) {
    var s = Et(r, i);
    o.push(s);
  }
  return o;
}
function t3() {
  var t = Ue(), e = t.classNames, n = t.styles, r = t.showWeekNumber, o = t.locale, i = t.weekStartsOn, s = t.ISOWeek, a = t.formatters.formatWeekdayName, l = t.labels.labelWeekday, c = e3(o, i, s);
  return I.createElement(
    "tr",
    { style: n.head_row, className: e.head_row },
    r && I.createElement("td", { style: n.head_cell, className: e.head_cell }),
    c.map(function(u, d) {
      return I.createElement("th", { key: d, scope: "col", className: e.head_cell, style: n.head_cell, "aria-label": l(u, { locale: o }) }, a(u, { locale: o }));
    })
  );
}
function n3() {
  var t, e = Ue(), n = e.classNames, r = e.styles, o = e.components, i = (t = o == null ? void 0 : o.HeadRow) !== null && t !== void 0 ? t : t3;
  return I.createElement(
    "thead",
    { style: r.head, className: n.head },
    I.createElement(i, null)
  );
}
function r3(t) {
  var e = Ue(), n = e.locale, r = e.formatters.formatDay;
  return I.createElement(I.Fragment, null, r(t.date, { locale: n }));
}
var Al = Nt(void 0);
function o3(t) {
  if (!To(t.initialProps)) {
    var e = {
      selected: void 0,
      modifiers: {
        disabled: []
      }
    };
    return I.createElement(Al.Provider, { value: e }, t.children);
  }
  return I.createElement(i3, { initialProps: t.initialProps, children: t.children });
}
function i3(t) {
  var e = t.initialProps, n = t.children, r = e.selected, o = e.min, i = e.max, s = function(c, u, d) {
    var f, h;
    (f = e.onDayClick) === null || f === void 0 || f.call(e, c, u, d);
    var p = !!(u.selected && o && (r == null ? void 0 : r.length) === o);
    if (!p) {
      var g = !!(!u.selected && i && (r == null ? void 0 : r.length) === i);
      if (!g) {
        var m = r ? Tp([], r, !0) : [];
        if (u.selected) {
          var b = m.findIndex(function(v) {
            return bt(c, v);
          });
          m.splice(b, 1);
        } else
          m.push(c);
        (h = e.onSelect) === null || h === void 0 || h.call(e, m, c, u, d);
      }
    }
  }, a = {
    disabled: []
  };
  r && a.disabled.push(function(c) {
    var u = i && r.length > i - 1, d = r.some(function(f) {
      return bt(f, c);
    });
    return !!(u && !d);
  });
  var l = {
    selected: r,
    onDayClick: s,
    modifiers: a
  };
  return I.createElement(Al.Provider, { value: l }, n);
}
function Ll() {
  var t = Yt(Al);
  if (!t)
    throw new Error("useSelectMultiple must be used within a SelectMultipleProvider");
  return t;
}
function s3(t, e) {
  var n = e || {}, r = n.from, o = n.to;
  if (!r)
    return { from: t, to: void 0 };
  if (!o && bt(r, t))
    return { from: r, to: t };
  if (!o && ep(t, r))
    return { from: t, to: r };
  if (!o)
    return { from: r, to: t };
  if (!(bt(o, t) && bt(r, t))) {
    if (bt(o, t))
      return { from: o, to: void 0 };
    if (!bt(r, t))
      return Jh(r, t) ? { from: t, to: o } : { from: r, to: t };
  }
}
var Fl = Nt(void 0);
function a3(t) {
  if (!Do(t.initialProps)) {
    var e = {
      selected: void 0,
      modifiers: {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
      }
    };
    return I.createElement(Fl.Provider, { value: e }, t.children);
  }
  return I.createElement(l3, { initialProps: t.initialProps, children: t.children });
}
function l3(t) {
  var e = t.initialProps, n = t.children, r = e.selected, o = r || {}, i = o.from, s = o.to, a = e.min, l = e.max, c = function(h, p, g) {
    var m, b;
    (m = e.onDayClick) === null || m === void 0 || m.call(e, h, p, g);
    var v = s3(h, r);
    (b = e.onSelect) === null || b === void 0 || b.call(e, v, h, p, g);
  }, u = {
    range_start: [],
    range_end: [],
    range_middle: [],
    disabled: []
  };
  if (i && (u.range_start = [i], s ? (u.range_end = [s], bt(i, s) || (u.range_middle = [
    {
      after: i,
      before: s
    }
  ])) : u.range_end = [i]), a && (i && !s && u.disabled.push({
    after: fd(i, a - 1),
    before: Et(i, a - 1)
  }), i && s && u.disabled.push({
    after: i,
    before: Et(i, a - 1)
  })), l && (i && !s && (u.disabled.push({
    before: Et(i, -l + 1)
  }), u.disabled.push({
    after: Et(i, l - 1)
  })), i && s)) {
    var d = Dt(s, i) + 1, f = l - d;
    u.disabled.push({
      before: fd(i, f)
    }), u.disabled.push({
      after: Et(s, f)
    });
  }
  return I.createElement(Fl.Provider, { value: { selected: r, onDayClick: c, modifiers: u } }, n);
}
function Vl() {
  var t = Yt(Fl);
  if (!t)
    throw new Error("useSelectRange must be used within a SelectRangeProvider");
  return t;
}
function bi(t) {
  return Array.isArray(t) ? Tp([], t, !0) : t !== void 0 ? [t] : [];
}
function c3(t) {
  var e = {};
  return Object.entries(t).forEach(function(n) {
    var r = n[0], o = n[1];
    e[r] = bi(o);
  }), e;
}
var Ut;
(function(t) {
  t.Outside = "outside", t.Disabled = "disabled", t.Selected = "selected", t.Hidden = "hidden", t.Today = "today", t.RangeStart = "range_start", t.RangeEnd = "range_end", t.RangeMiddle = "range_middle";
})(Ut || (Ut = {}));
var u3 = Ut.Selected, dn = Ut.Disabled, d3 = Ut.Hidden, f3 = Ut.Today, Vs = Ut.RangeEnd, Ws = Ut.RangeMiddle, Hs = Ut.RangeStart, h3 = Ut.Outside;
function p3(t, e, n) {
  var r, o = (r = {}, r[u3] = bi(t.selected), r[dn] = bi(t.disabled), r[d3] = bi(t.hidden), r[f3] = [t.today], r[Vs] = [], r[Ws] = [], r[Hs] = [], r[h3] = [], r);
  return t.fromDate && o[dn].push({ before: t.fromDate }), t.toDate && o[dn].push({ after: t.toDate }), To(t) ? o[dn] = o[dn].concat(e.modifiers[dn]) : Do(t) && (o[dn] = o[dn].concat(n.modifiers[dn]), o[Hs] = n.modifiers[Hs], o[Ws] = n.modifiers[Ws], o[Vs] = n.modifiers[Vs]), o;
}
var Ap = Nt(void 0);
function g3(t) {
  var e = Ue(), n = Ll(), r = Vl(), o = p3(e, n, r), i = c3(e.modifiers), s = ge(ge({}, o), i);
  return I.createElement(Ap.Provider, { value: s }, t.children);
}
function Lp() {
  var t = Yt(Ap);
  if (!t)
    throw new Error("useModifiers must be used within a ModifiersProvider");
  return t;
}
function m3(t) {
  return !!(t && typeof t == "object" && "before" in t && "after" in t);
}
function v3(t) {
  return !!(t && typeof t == "object" && "from" in t);
}
function b3(t) {
  return !!(t && typeof t == "object" && "after" in t);
}
function y3(t) {
  return !!(t && typeof t == "object" && "before" in t);
}
function w3(t) {
  return !!(t && typeof t == "object" && "dayOfWeek" in t);
}
function x3(t, e) {
  var n, r = e.from, o = e.to;
  if (!r)
    return !1;
  if (!o && bt(r, t))
    return !0;
  if (!o)
    return !1;
  var i = Dt(o, r) < 0;
  i && (n = [o, r], r = n[0], o = n[1]);
  var s = Dt(t, r) >= 0 && Dt(o, t) >= 0;
  return s;
}
function _3(t) {
  return Ol(t);
}
function C3(t) {
  return Array.isArray(t) && t.every(Ol);
}
function E3(t, e) {
  return e.some(function(n) {
    if (typeof n == "boolean")
      return n;
    if (_3(n))
      return bt(t, n);
    if (C3(n))
      return n.includes(t);
    if (v3(n))
      return x3(t, n);
    if (w3(n))
      return n.dayOfWeek.includes(t.getDay());
    if (m3(n)) {
      var r = Dt(n.before, t), o = Dt(n.after, t), i = r > 0, s = o < 0, a = Jh(n.before, n.after);
      return a ? s && i : i || s;
    }
    return b3(n) ? Dt(t, n.after) > 0 : y3(n) ? Dt(n.before, t) > 0 : typeof n == "function" ? n(t) : !1;
  });
}
function Wl(t, e, n) {
  var r = Object.keys(e).reduce(function(i, s) {
    var a = e[s];
    return E3(t, a) && i.push(s), i;
  }, []), o = {};
  return r.forEach(function(i) {
    return o[i] = !0;
  }), n && !$l(t, n) && (o.outside = !0), o;
}
function M3(t, e) {
  for (var n = ht(t[0]), r = Po(t[t.length - 1]), o, i, s = n; s <= r; ) {
    var a = Wl(s, e), l = !a.disabled && !a.hidden;
    if (!l) {
      s = Et(s, 1);
      continue;
    }
    if (a.selected)
      return s;
    a.today && !i && (i = s), o || (o = s), s = Et(s, 1);
  }
  return i || o;
}
var k3 = 365;
function Fp(t, e) {
  var n = e.moveBy, r = e.direction, o = e.context, i = e.modifiers, s = e.retry, a = s === void 0 ? { count: 0, lastFocused: t } : s, l = o.weekStartsOn, c = o.fromDate, u = o.toDate, d = o.locale, f = {
    day: Et,
    week: Wi,
    month: Ft,
    year: Wh,
    startOfWeek: function(m) {
      return o.ISOWeek ? ir(m) : Vt(m, { locale: d, weekStartsOn: l });
    },
    endOfWeek: function(m) {
      return o.ISOWeek ? Uh(m) : ds(m, { locale: d, weekStartsOn: l });
    }
  }, h = f[n](t, r === "after" ? 1 : -1);
  r === "before" && c ? h = Zx([c, h]) : r === "after" && u && (h = Qx([u, h]));
  var p = !0;
  if (i) {
    var g = Wl(h, i);
    p = !g.disabled && !g.hidden;
  }
  return p ? h : a.count > k3 ? a.lastFocused : Fp(h, {
    moveBy: n,
    direction: r,
    context: o,
    modifiers: i,
    retry: ge(ge({}, a), { count: a.count + 1 })
  });
}
var Vp = Nt(void 0);
function O3(t) {
  var e = Lr(), n = Lp(), r = ye(), o = r[0], i = r[1], s = ye(), a = s[0], l = s[1], c = M3(e.displayMonths, n), u = o ?? (a && e.isDateDisplayed(a)) ? a : c, d = function() {
    l(o), i(void 0);
  }, f = function(m) {
    i(m);
  }, h = Ue(), p = function(m, b) {
    if (o) {
      var v = Fp(o, {
        moveBy: m,
        direction: b,
        context: h,
        modifiers: n
      });
      bt(o, v) || (e.goToDate(v, o), f(v));
    }
  }, g = {
    focusedDay: o,
    focusTarget: u,
    blur: d,
    focus: f,
    focusDayAfter: function() {
      return p("day", "after");
    },
    focusDayBefore: function() {
      return p("day", "before");
    },
    focusWeekAfter: function() {
      return p("week", "after");
    },
    focusWeekBefore: function() {
      return p("week", "before");
    },
    focusMonthBefore: function() {
      return p("month", "before");
    },
    focusMonthAfter: function() {
      return p("month", "after");
    },
    focusYearBefore: function() {
      return p("year", "before");
    },
    focusYearAfter: function() {
      return p("year", "after");
    },
    focusStartOfWeek: function() {
      return p("startOfWeek", "before");
    },
    focusEndOfWeek: function() {
      return p("endOfWeek", "after");
    }
  };
  return I.createElement(Vp.Provider, { value: g }, t.children);
}
function Hl() {
  var t = Yt(Vp);
  if (!t)
    throw new Error("useFocusContext must be used within a FocusProvider");
  return t;
}
function S3(t, e) {
  var n = Lp(), r = Wl(t, n, e);
  return r;
}
var Bl = Nt(void 0);
function P3(t) {
  if (!ps(t.initialProps)) {
    var e = {
      selected: void 0
    };
    return I.createElement(Bl.Provider, { value: e }, t.children);
  }
  return I.createElement(I3, { initialProps: t.initialProps, children: t.children });
}
function I3(t) {
  var e = t.initialProps, n = t.children, r = function(i, s, a) {
    var l, c, u;
    if ((l = e.onDayClick) === null || l === void 0 || l.call(e, i, s, a), s.selected && !e.required) {
      (c = e.onSelect) === null || c === void 0 || c.call(e, void 0, i, s, a);
      return;
    }
    (u = e.onSelect) === null || u === void 0 || u.call(e, i, i, s, a);
  }, o = {
    selected: e.selected,
    onDayClick: r
  };
  return I.createElement(Bl.Provider, { value: o }, n);
}
function Wp() {
  var t = Yt(Bl);
  if (!t)
    throw new Error("useSelectSingle must be used within a SelectSingleProvider");
  return t;
}
function T3(t, e) {
  var n = Ue(), r = Wp(), o = Ll(), i = Vl(), s = Hl(), a = s.focusDayAfter, l = s.focusDayBefore, c = s.focusWeekAfter, u = s.focusWeekBefore, d = s.blur, f = s.focus, h = s.focusMonthBefore, p = s.focusMonthAfter, g = s.focusYearBefore, m = s.focusYearAfter, b = s.focusStartOfWeek, v = s.focusEndOfWeek, _ = function(V) {
    var z, ee, $, F;
    ps(n) ? (z = r.onDayClick) === null || z === void 0 || z.call(r, t, e, V) : To(n) ? (ee = o.onDayClick) === null || ee === void 0 || ee.call(o, t, e, V) : Do(n) ? ($ = i.onDayClick) === null || $ === void 0 || $.call(i, t, e, V) : (F = n.onDayClick) === null || F === void 0 || F.call(n, t, e, V);
  }, x = function(V) {
    var z;
    f(t), (z = n.onDayFocus) === null || z === void 0 || z.call(n, t, e, V);
  }, y = function(V) {
    var z;
    d(), (z = n.onDayBlur) === null || z === void 0 || z.call(n, t, e, V);
  }, M = function(V) {
    var z;
    (z = n.onDayMouseEnter) === null || z === void 0 || z.call(n, t, e, V);
  }, k = function(V) {
    var z;
    (z = n.onDayMouseLeave) === null || z === void 0 || z.call(n, t, e, V);
  }, O = function(V) {
    var z;
    (z = n.onDayPointerEnter) === null || z === void 0 || z.call(n, t, e, V);
  }, S = function(V) {
    var z;
    (z = n.onDayPointerLeave) === null || z === void 0 || z.call(n, t, e, V);
  }, D = function(V) {
    var z;
    (z = n.onDayTouchCancel) === null || z === void 0 || z.call(n, t, e, V);
  }, P = function(V) {
    var z;
    (z = n.onDayTouchEnd) === null || z === void 0 || z.call(n, t, e, V);
  }, N = function(V) {
    var z;
    (z = n.onDayTouchMove) === null || z === void 0 || z.call(n, t, e, V);
  }, T = function(V) {
    var z;
    (z = n.onDayTouchStart) === null || z === void 0 || z.call(n, t, e, V);
  }, U = function(V) {
    var z;
    (z = n.onDayKeyUp) === null || z === void 0 || z.call(n, t, e, V);
  }, R = function(V) {
    var z;
    switch (V.key) {
      case "ArrowLeft":
        V.preventDefault(), V.stopPropagation(), n.dir === "rtl" ? a() : l();
        break;
      case "ArrowRight":
        V.preventDefault(), V.stopPropagation(), n.dir === "rtl" ? l() : a();
        break;
      case "ArrowDown":
        V.preventDefault(), V.stopPropagation(), c();
        break;
      case "ArrowUp":
        V.preventDefault(), V.stopPropagation(), u();
        break;
      case "PageUp":
        V.preventDefault(), V.stopPropagation(), V.shiftKey ? g() : h();
        break;
      case "PageDown":
        V.preventDefault(), V.stopPropagation(), V.shiftKey ? m() : p();
        break;
      case "Home":
        V.preventDefault(), V.stopPropagation(), b();
        break;
      case "End":
        V.preventDefault(), V.stopPropagation(), v();
        break;
    }
    (z = n.onDayKeyDown) === null || z === void 0 || z.call(n, t, e, V);
  }, Y = {
    onClick: _,
    onFocus: x,
    onBlur: y,
    onKeyDown: R,
    onKeyUp: U,
    onMouseEnter: M,
    onMouseLeave: k,
    onPointerEnter: O,
    onPointerLeave: S,
    onTouchCancel: D,
    onTouchEnd: P,
    onTouchMove: N,
    onTouchStart: T
  };
  return Y;
}
function D3() {
  var t = Ue(), e = Wp(), n = Ll(), r = Vl(), o = ps(t) ? e.selected : To(t) ? n.selected : Do(t) ? r.selected : void 0;
  return o;
}
function $3(t) {
  return Object.values(Ut).includes(t);
}
function N3(t, e) {
  var n = [t.classNames.day];
  return Object.keys(e).forEach(function(r) {
    var o = t.modifiersClassNames[r];
    if (o)
      n.push(o);
    else if ($3(r)) {
      var i = t.classNames["day_".concat(r)];
      i && n.push(i);
    }
  }), n;
}
function R3(t, e) {
  var n = ge({}, t.styles.day);
  return Object.keys(e).forEach(function(r) {
    var o;
    n = ge(ge({}, n), (o = t.modifiersStyles) === null || o === void 0 ? void 0 : o[r]);
  }), n;
}
function A3(t, e, n) {
  var r, o, i, s = Ue(), a = Hl(), l = S3(t, e), c = T3(t, l), u = D3(), d = !!(s.onDayClick || s.mode !== "default");
  ue(function() {
    var M;
    l.outside || a.focusedDay && d && bt(a.focusedDay, t) && ((M = n.current) === null || M === void 0 || M.focus());
  }, [
    a.focusedDay,
    t,
    n,
    d,
    l.outside
  ]);
  var f = N3(s, l).join(" "), h = R3(s, l), p = !!(l.outside && !s.showOutsideDays || l.hidden), g = (i = (o = s.components) === null || o === void 0 ? void 0 : o.DayContent) !== null && i !== void 0 ? i : r3, m = I.createElement(g, { date: t, displayMonth: e, activeModifiers: l }), b = {
    style: h,
    className: f,
    children: m,
    role: "gridcell"
  }, v = a.focusTarget && bt(a.focusTarget, t) && !l.outside, _ = a.focusedDay && bt(a.focusedDay, t), x = ge(ge(ge({}, b), (r = { disabled: l.disabled, role: "gridcell" }, r["aria-selected"] = l.selected, r.tabIndex = _ || v ? 0 : -1, r)), c), y = {
    isButton: d,
    isHidden: p,
    activeModifiers: l,
    selectedDays: u,
    buttonProps: x,
    divProps: b
  };
  return y;
}
function L3(t) {
  var e = ae(null), n = A3(t.date, t.displayMonth, e);
  return n.isHidden ? I.createElement("div", { role: "gridcell" }) : n.isButton ? I.createElement(zi, ge({ name: "day", ref: e }, n.buttonProps)) : I.createElement("div", ge({}, n.divProps));
}
function F3(t) {
  var e = t.number, n = t.dates, r = Ue(), o = r.onWeekNumberClick, i = r.styles, s = r.classNames, a = r.locale, l = r.labels.labelWeekNumber, c = r.formatters.formatWeekNumber, u = c(Number(e), { locale: a });
  if (!o)
    return I.createElement("span", { className: s.weeknumber, style: i.weeknumber }, u);
  var d = l(Number(e), { locale: a }), f = function(h) {
    o(e, n, h);
  };
  return I.createElement(zi, { name: "week-number", "aria-label": d, className: s.weeknumber, style: i.weeknumber, onClick: f }, u);
}
function V3(t) {
  var e, n, r = Ue(), o = r.styles, i = r.classNames, s = r.showWeekNumber, a = r.components, l = (e = a == null ? void 0 : a.Day) !== null && e !== void 0 ? e : L3, c = (n = a == null ? void 0 : a.WeekNumber) !== null && n !== void 0 ? n : F3, u;
  return s && (u = I.createElement(
    "td",
    { className: i.cell, style: o.cell },
    I.createElement(c, { number: t.weekNumber, dates: t.dates })
  )), I.createElement(
    "tr",
    { className: i.row, style: o.row },
    u,
    t.dates.map(function(d) {
      return I.createElement(
        "td",
        { className: i.cell, style: o.cell, key: k2(d), role: "presentation" },
        I.createElement(l, { displayMonth: t.displayMonth, date: d })
      );
    })
  );
}
function wd(t, e, n) {
  for (var r = n != null && n.ISOWeek ? Uh(e) : ds(e, n), o = n != null && n.ISOWeek ? ir(t) : Vt(t, n), i = Dt(r, o), s = [], a = 0; a <= i; a++)
    s.push(Et(o, a));
  var l = s.reduce(function(c, u) {
    var d = n != null && n.ISOWeek ? E2(u) : I2(u, n), f = c.find(function(h) {
      return h.weekNumber === d;
    });
    return f ? (f.dates.push(u), c) : (c.push({
      weekNumber: d,
      dates: [u]
    }), c);
  }, []);
  return l;
}
function W3(t, e) {
  var n = wd(ht(t), Po(t), e);
  if (e != null && e.useFixedWeeks) {
    var r = D2(t, e);
    if (r < 6) {
      var o = n[n.length - 1], i = o.dates[o.dates.length - 1], s = Wi(i, 6 - r), a = wd(Wi(i, 1), s, e);
      n.push.apply(n, a);
    }
  }
  return n;
}
function H3(t) {
  var e, n, r, o = Ue(), i = o.locale, s = o.classNames, a = o.styles, l = o.hideHead, c = o.fixedWeeks, u = o.components, d = o.weekStartsOn, f = o.firstWeekContainsDate, h = o.ISOWeek, p = W3(t.displayMonth, {
    useFixedWeeks: !!c,
    ISOWeek: h,
    locale: i,
    weekStartsOn: d,
    firstWeekContainsDate: f
  }), g = (e = u == null ? void 0 : u.Head) !== null && e !== void 0 ? e : n3, m = (n = u == null ? void 0 : u.Row) !== null && n !== void 0 ? n : V3, b = (r = u == null ? void 0 : u.Footer) !== null && r !== void 0 ? r : J6;
  return I.createElement(
    "table",
    { id: t.id, className: s.table, style: a.table, role: "grid", "aria-labelledby": t["aria-labelledby"] },
    !l && I.createElement(g, null),
    I.createElement("tbody", { className: s.tbody, style: a.tbody, role: "rowgroup" }, p.map(function(v) {
      return I.createElement(m, { displayMonth: t.displayMonth, key: v.weekNumber, dates: v.dates, weekNumber: v.weekNumber });
    })),
    I.createElement(b, { displayMonth: t.displayMonth })
  );
}
function B3() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var j3 = B3() ? C.useLayoutEffect : C.useEffect, Bs = !1, z3 = 0;
function xd() {
  return "react-day-picker-".concat(++z3);
}
function U3(t) {
  var e, n = t ?? (Bs ? xd() : null), r = C.useState(n), o = r[0], i = r[1];
  return j3(function() {
    o === null && i(xd());
  }, []), C.useEffect(function() {
    Bs === !1 && (Bs = !0);
  }, []), (e = t ?? o) !== null && e !== void 0 ? e : void 0;
}
function Y3(t) {
  var e, n, r = Ue(), o = r.dir, i = r.classNames, s = r.styles, a = r.components, l = Lr().displayMonths, c = U3(r.id ? "".concat(r.id, "-").concat(t.displayIndex) : void 0), u = r.id ? "".concat(r.id, "-grid-").concat(t.displayIndex) : void 0, d = [i.month], f = s.month, h = t.displayIndex === 0, p = t.displayIndex === l.length - 1, g = !h && !p;
  o === "rtl" && (e = [h, p], p = e[0], h = e[1]), h && (d.push(i.caption_start), f = ge(ge({}, f), s.caption_start)), p && (d.push(i.caption_end), f = ge(ge({}, f), s.caption_end)), g && (d.push(i.caption_between), f = ge(ge({}, f), s.caption_between));
  var m = (n = a == null ? void 0 : a.Caption) !== null && n !== void 0 ? n : Q6;
  return I.createElement(
    "div",
    { key: t.displayIndex, className: d.join(" "), style: f },
    I.createElement(m, { id: c, displayMonth: t.displayMonth }),
    I.createElement(H3, { id: u, "aria-labelledby": c, displayMonth: t.displayMonth })
  );
}
function K3(t) {
  var e = t.initialProps, n = Ue(), r = Hl(), o = Lr(), i = ye(!1), s = i[0], a = i[1];
  ue(function() {
    n.initialFocus && r.focusTarget && (s || (r.focus(r.focusTarget), a(!0)));
  }, [
    n.initialFocus,
    s,
    r.focus,
    r.focusTarget,
    r
  ]);
  var l = [n.classNames.root, n.className];
  n.numberOfMonths > 1 && l.push(n.classNames.multiple_months), n.showWeekNumber && l.push(n.classNames.with_weeknumber);
  var c = ge(ge({}, n.styles.root), n.style), u = Object.keys(e).filter(function(d) {
    return d.startsWith("data-");
  }).reduce(function(d, f) {
    var h;
    return ge(ge({}, d), (h = {}, h[f] = e[f], h));
  }, {});
  return I.createElement(
    "div",
    ge({ className: l.join(" "), style: c, dir: n.dir, id: n.id }, u),
    I.createElement("div", { className: n.classNames.months, style: n.styles.months }, o.displayMonths.map(function(d, f) {
      return I.createElement(Y3, { key: f, displayIndex: f, displayMonth: d });
    }))
  );
}
function G3(t) {
  var e = t.children, n = y6(t, ["children"]);
  return I.createElement(
    F6,
    { initialProps: n },
    I.createElement(
      G6,
      null,
      I.createElement(
        P3,
        { initialProps: n },
        I.createElement(
          o3,
          { initialProps: n },
          I.createElement(
            a3,
            { initialProps: n },
            I.createElement(
              g3,
              null,
              I.createElement(O3, null, e)
            )
          )
        )
      )
    )
  );
}
function q3(t) {
  return I.createElement(
    G3,
    ge({}, t),
    I.createElement(K3, { initialProps: t })
  );
}
const Hp = ({
  className: t,
  ...e
}) => /* @__PURE__ */ w(
  q3,
  {
    showOutsideDays: !0,
    fixedWeeks: !0,
    weekStartsOn: 1,
    className: he(
      "flex rounded-lg bg-foundations-default px-6 py-3",
      t
    ),
    formatters: {
      formatWeekdayName: (n) => lt(n, "E")
    },
    classNames: {
      table: "w-full border-collapse space-y-4",
      head_row: "flex",
      head_cell: "w-9 text-xs text-foundations-subtle font-normal uppercase",
      row: "flex w-full mt-2",
      cell: "p-0 flex justify-center group/cell",
      day: "h-9 w-9 p-0 font-normal text-foundations-boldest text-sm rounded-full aria-selected:!text-neutral-white hover:bg-neutral-100 focus:outline-none focus:ring-2 focus:ring-info-bold focus:z-10",
      day_selected: "!bg-info-bold hover:!bg-info-bolder focus:bg-info-bolder",
      day_today: "bg-neutral-100 rounded-full",
      day_range_start: "start rounded-l-full rounded-r-none",
      day_range_end: "end rounded-l-none [&.start]:rounded-full",
      day_outside: "[&:not(:disabled)]:text-foundations-subtle",
      day_disabled: "!text-neutral-300 cursor-not-allowed",
      day_range_middle: "bg-info-bold rounded-none group-first/cell:rounded-l-full group-last/cell:rounded-r-full",
      day_hidden: "invisible"
    },
    components: {
      Caption: X3
    },
    footer: e.CustomFooter,
    ...e
  }
);
Hp.displayName = "Calendar";
const X3 = (t) => {
  const { goToMonth: e, nextMonth: n, previousMonth: r } = Lr();
  return /* @__PURE__ */ B("div", { className: "mb-4 flex items-center justify-between", children: [
    /* @__PURE__ */ w(
      ua,
      {
        variant: "tertiary",
        size: "xs",
        disabled: !r,
        onClick: () => r && e(r),
        "aria-label": "Go to previous month",
        children: /* @__PURE__ */ w(f5, {})
      }
    ),
    /* @__PURE__ */ w(
      "div",
      {
        id: t.id,
        "aria-live": "polite",
        role: "presentation",
        className: "text-sm font-medium text-foundations-boldest",
        children: lt(t.displayMonth, "MMMM yyyy")
      }
    ),
    /* @__PURE__ */ w(
      ua,
      {
        variant: "tertiary",
        size: "xs",
        disabled: !n,
        onClick: () => n && e(n),
        "aria-label": "Go to next month",
        children: /* @__PURE__ */ w(h5, {})
      }
    )
  ] });
}, Z3 = (t) => t.querySelector("input,textarea") || t, gs = {
  mask: /^.*$/,
  preprocessors: [],
  postprocessors: [],
  plugins: [],
  overwriteMode: "shift"
};
class Q3 {
  constructor() {
    this.now = null, this.past = [], this.future = [];
  }
  undo() {
    const e = this.past.pop();
    e && this.now && (this.future.push(this.now), this.updateElement(e, "historyUndo"));
  }
  redo() {
    const e = this.future.pop();
    e && this.now && (this.past.push(this.now), this.updateElement(e, "historyRedo"));
  }
  updateHistory(e) {
    if (!this.now) {
      this.now = e;
      return;
    }
    const n = this.now.value !== e.value, r = this.now.selection.some((o, i) => o !== e.selection[i]);
    !n && !r || (n && (this.past.push(this.now), this.future = []), this.now = e);
  }
  updateElement(e, n) {
    this.now = e, this.updateElementState(e, {
      inputType: n,
      data: null
    });
  }
}
function J3(t, ...e) {
  return e.every(({
    value: n
  }) => n === t.value);
}
function e9(t, ...e) {
  return e.every(({
    value: n,
    selection: r
  }) => n === t.value && r[0] === t.selection[0] && r[1] === t.selection[1]);
}
function t9({
  value: t,
  selection: e
}, n, r) {
  const [o, i] = e, s = typeof r == "function" ? r({
    value: t,
    selection: e
  }) : r;
  return {
    value: t,
    selection: s === "replace" ? [o, o + n.length] : [o, i]
  };
}
function ms(t) {
  return typeof t == "string";
}
function _d(t, e, n, r) {
  let o = "";
  for (let i = e.length; i < t.length; i++) {
    const s = t[i], a = (r == null ? void 0 : r.value[i]) === s;
    if (!ms(s) || s === n && !a)
      return o;
    o += s;
  }
  return o;
}
function Bp(t, e) {
  return Array.isArray(e) ? t.length === e.length && Array.from(t).every((n, r) => {
    const o = e[r];
    return ms(o) ? n === o : n.match(o);
  }) : e.test(t);
}
function n9(t, e, n) {
  let r = null, o = null;
  const i = Array.from(t.value).reduce((a, l, c) => {
    const u = _d(e, a, l, n), d = a + u, f = e[d.length];
    return ms(f) ? d + f : l.match(f) ? (r === null && c >= t.selection[0] && (r = d.length), o === null && c >= t.selection[1] && (o = d.length), d + l) : d;
  }, ""), s = _d(e, i, "", n);
  return {
    value: Bp(i + s, e) ? i + s : i,
    selection: [r ?? i.length, o ?? i.length]
  };
}
function r9({
  value: t,
  selection: e
}, n) {
  const [r, o] = e;
  let i = r, s = o;
  return {
    value: Array.from(t).reduce((l, c, u) => {
      const d = l + c;
      return r === u && (i = l.length), o === u && (s = l.length), d.match(n) ? d : l;
    }, ""),
    selection: [i, s]
  };
}
function ei(t, e, n = null) {
  if (Bp(t.value, e))
    return t;
  const {
    value: r,
    selection: o
  } = Array.isArray(e) ? n9(t, e, n) : r9(t, e);
  return {
    selection: o,
    value: Array.isArray(e) ? r.slice(0, e.length) : r
  };
}
function Cd(t, e) {
  if (!Array.isArray(e))
    return t;
  const [n, r] = t.selection, o = [], i = Array.from(t.value).reduce((s, a, l) => {
    const c = e[l];
    return l === n && o.push(s.length), l === r && o.push(s.length), ms(c) && c === a ? s : s + a;
  }, "");
  return o.length < 2 && o.push(...Array(2 - o.length).fill(i.length)), {
    value: i,
    selection: [o[0], o[1]]
  };
}
class Ta {
  constructor(e, n) {
    this.initialElementState = e, this.maskOptions = n, this.value = "", this.selection = [0, 0];
    const {
      value: r,
      selection: o
    } = ei(e, this.getMaskExpression(e));
    this.value = r, this.selection = o;
  }
  addCharacters([e, n], r) {
    const {
      value: o
    } = this, i = this.getMaskExpression({
      value: o.slice(0, e) + r + o.slice(n),
      selection: [e + r.length, e + r.length]
    }), s = {
      value: o,
      selection: [e, n]
    }, a = Cd(s, i), [l, c] = t9(a, r, this.maskOptions.overwriteMode).selection, u = a.value.slice(0, l) + r, d = u.length, f = ei({
      value: u + a.value.slice(c),
      selection: [d, d]
    }, i, s);
    if (o.slice(0, l) === ei({
      value: u,
      selection: [d, d]
    }, i, s).value || e9(this, f))
      throw new Error("Invalid mask value");
    this.value = f.value, this.selection = f.selection;
  }
  deleteCharacters([e, n]) {
    if (e === n || !n)
      return;
    const {
      value: r
    } = this, o = this.getMaskExpression({
      value: r.slice(0, e) + r.slice(n),
      selection: [e, e]
    }), i = {
      value: r,
      selection: [e, n]
    }, s = Cd(i, o), [a, l] = s.selection, c = s.value.slice(0, a) + s.value.slice(l), u = ei({
      value: c,
      selection: [a, a]
    }, o, i);
    this.value = u.value, this.selection = u.selection;
  }
  getMaskExpression(e) {
    const {
      mask: n
    } = this.maskOptions;
    return typeof n == "function" ? n(e) : n;
  }
}
class o9 {
  constructor(e) {
    this.element = e, this.listeners = [];
  }
  listen(e, n, r) {
    const o = n;
    this.element.addEventListener(e, o, r), this.listeners.push(() => this.element.removeEventListener(e, o));
  }
  destroy() {
    this.listeners.forEach((e) => e());
  }
}
function lo(t, e, n) {
  return t.ctrlKey === !!(e & 1) && t.altKey === !!(e & 2) && t.shiftKey === !!(e & 4) && t.metaKey === !!(e & 8) && t.keyCode === n;
}
function i9(t) {
  return lo(
    t,
    1,
    89
    /* Y */
  ) || // Windows
  lo(
    t,
    5,
    90
    /* Z */
  ) || // Windows & Android
  lo(
    t,
    12,
    90
    /* Z */
  );
}
function s9(t) {
  return lo(
    t,
    1,
    90
    /* Z */
  ) || // Windows & Android
  lo(
    t,
    8,
    90
    /* Z */
  );
}
function a9(t) {
  return "onbeforeinput" in t;
}
function l9({
  key: t,
  ctrlKey: e,
  metaKey: n,
  altKey: r
}) {
  const o = e || n || r, i = /^.$/u.test(t);
  return !o && t !== "Backspace" && i;
}
function c9({
  value: t,
  selection: e
}, n) {
  const [r, o] = e;
  if (r !== o)
    return [r, o];
  const i = n ? t.slice(r).indexOf(`
`) + 1 || t.length : t.slice(0, o).lastIndexOf(`
`) + 1;
  return [n ? r : i, n ? i : o];
}
function Ed({
  value: t,
  selection: e
}, n) {
  const [r, o] = e;
  return r !== o ? [r, o] : (n ? [r, o + 1] : [r - 1, o]).map((s) => Math.min(Math.max(s, 0), t.length));
}
const Md = /\s+$/g, kd = /^\s+/g, Od = /\s/;
function u9({
  value: t,
  selection: e
}, n) {
  const [r, o] = e;
  if (r !== o)
    return [r, o];
  if (n) {
    const l = t.slice(r), [c] = l.match(kd) || [""], u = l.replace(kd, "").search(Od);
    return [r, u !== -1 ? r + c.length + u : t.length];
  }
  const i = t.slice(0, o), [s] = i.match(Md) || [""], a = i.replace(Md, "").split("").reverse().findIndex((l) => l.match(Od));
  return [a !== -1 ? o - s.length - a : 0, o];
}
function Ui(t = []) {
  return (e, ...n) => t.reduce((r, o) => Object.assign(Object.assign({}, r), o(r, ...n)), e);
}
function d9(t, e) {
  const n = Object.assign(Object.assign({}, gs), e), r = Ui(n.preprocessors), o = Ui(n.postprocessors), i = typeof t == "string" ? {
    value: t,
    selection: [0, 0]
  } : t, {
    elementState: s
  } = r({
    elementState: i,
    data: ""
  }, "validation"), a = new Ta(s, n), {
    value: l,
    selection: c
  } = o(a, i);
  return typeof t == "string" ? l : {
    value: l,
    selection: c
  };
}
class f9 extends Q3 {
  constructor(e, n) {
    super(), this.element = e, this.maskitoOptions = n, this.isTextArea = this.element.nodeName === "TEXTAREA", this.eventListener = new o9(this.element), this.options = Object.assign(Object.assign({}, gs), this.maskitoOptions), this.preprocessor = Ui(this.options.preprocessors), this.postprocessor = Ui(this.options.postprocessors), this.teardowns = this.options.plugins.map((r) => r(this.element, this.options)), this.ensureValueFitsMask(), this.updateHistory(this.elementState), this.eventListener.listen("keydown", (r) => {
      if (i9(r))
        return r.preventDefault(), this.redo();
      if (s9(r))
        return r.preventDefault(), this.undo();
    }), a9(e) ? this.eventListener.listen("beforeinput", (r) => {
      const o = r.inputType.includes("Forward");
      switch (this.updateHistory(this.elementState), r.inputType) {
        case "historyUndo":
          return r.preventDefault(), this.undo();
        case "historyRedo":
          return r.preventDefault(), this.redo();
        case "deleteByCut":
        case "deleteContentBackward":
        case "deleteContentForward":
          return this.handleDelete({
            event: r,
            isForward: o,
            selection: Ed(this.elementState, o)
          });
        case "deleteWordForward":
        case "deleteWordBackward":
          return this.handleDelete({
            event: r,
            isForward: o,
            selection: u9(this.elementState, o),
            force: !0
          });
        case "deleteSoftLineBackward":
        case "deleteSoftLineForward":
        case "deleteHardLineBackward":
        case "deleteHardLineForward":
          return this.handleDelete({
            event: r,
            isForward: o,
            selection: c9(this.elementState, o),
            force: !0
          });
        case "insertLineBreak":
          return this.handleEnter(r);
        case "insertFromPaste":
        case "insertText":
        case "insertFromDrop":
        default:
          return this.handleInsert(r, r.data || "");
      }
    }) : (this.eventListener.listen("keydown", (r) => this.handleKeydown(r)), this.eventListener.listen("paste", (r) => {
      var o;
      return this.handleInsert(r, ((o = r.clipboardData) === null || o === void 0 ? void 0 : o.getData("text/plain")) || "");
    })), this.eventListener.listen("input", () => {
      this.ensureValueFitsMask(), this.updateHistory(this.elementState);
    });
  }
  get elementState() {
    const {
      value: e,
      selectionStart: n,
      selectionEnd: r
    } = this.element;
    return {
      value: e,
      selection: [n || 0, r || 0]
    };
  }
  get maxLength() {
    const {
      maxLength: e
    } = this.element;
    return e === -1 ? 1 / 0 : e;
  }
  destroy() {
    this.eventListener.destroy(), this.teardowns.forEach((e) => e == null ? void 0 : e());
  }
  updateElementState({
    value: e,
    selection: n
  }, r = {
    inputType: "insertText",
    data: null
  }) {
    const o = this.elementState.value;
    this.updateValue(e), this.updateSelectionRange(n), o !== e && this.dispatchInputEvent(r);
  }
  updateSelectionRange([e, n]) {
    var r, o;
    (this.element.selectionStart !== e || this.element.selectionEnd !== n) && ((o = (r = this.element).setSelectionRange) === null || o === void 0 || o.call(r, e, n));
  }
  updateValue(e) {
    this.element.value = e;
  }
  ensureValueFitsMask() {
    this.updateElementState(d9(this.elementState, this.options));
  }
  dispatchInputEvent(e = {
    inputType: "insertText",
    data: null
  }) {
    const n = typeof window < "u" ? window : globalThis;
    n != null && n.InputEvent && this.element.dispatchEvent(new InputEvent("input", Object.assign(Object.assign({}, e), {
      bubbles: !0,
      cancelable: !1
    })));
  }
  handleKeydown(e) {
    const n = e.key, r = n === "Delete";
    switch (n) {
      case "Backspace":
      case "Delete":
        return this.handleDelete({
          event: e,
          isForward: r,
          selection: Ed(this.elementState, r)
        });
      case "Enter":
        return this.handleEnter(e);
    }
    l9(e) && this.handleInsert(e, n);
  }
  handleDelete({
    event: e,
    selection: n,
    isForward: r,
    force: o = !1
  }) {
    const i = {
      value: this.elementState.value,
      selection: n
    }, [s, a] = i.selection, {
      elementState: l
    } = this.preprocessor({
      elementState: i,
      data: ""
    }, r ? "deleteForward" : "deleteBackward"), c = new Ta(l, this.options), [u, d] = l.selection;
    c.deleteCharacters([u, d]);
    const f = this.postprocessor(c, i);
    if (i.value.slice(0, s) + i.value.slice(a) === f.value && !o)
      return;
    if (e.preventDefault(), J3(i, l, c, f))
      return this.updateSelectionRange(r ? [d, d] : [u, u]);
    const p = r ? "deleteContentForward" : "deleteContentBackward";
    this.updateElementState(f, {
      inputType: "inputType" in e ? e.inputType : p,
      data: null
    }), this.updateHistory(f);
  }
  handleInsert(e, n) {
    const r = this.elementState, {
      elementState: o,
      data: i = n
    } = this.preprocessor({
      data: n,
      elementState: r
    }, "insert"), s = new Ta(o, this.options);
    try {
      s.addCharacters(o.selection, i);
    } catch {
      return e.preventDefault();
    }
    const [a, l] = o.selection, c = o.value.slice(0, a) + n + o.value.slice(l), u = this.postprocessor(s, r);
    if (u.value.length > this.maxLength)
      return e.preventDefault();
    c !== u.value && (e.preventDefault(), this.updateElementState(u, {
      data: n,
      inputType: "inputType" in e ? e.inputType : "insertText"
    }), this.updateHistory(u));
  }
  handleEnter(e) {
    this.isTextArea && this.handleInsert(e, `
`);
  }
}
const h9 = /* @__PURE__ */ new Date("0001-01-01"), p9 = /* @__PURE__ */ new Date("9999-12-31"), g9 = "–", m9 = "—", v9 = "-", b9 = "−", y9 = [v9, g9, m9, b9], w9 = [":", "."];
function Da(t, e, n) {
  const r = Math.min(Number(n), Math.max(Number(e), Number(t)));
  return t instanceof Date ? new Date(r) : r;
}
const jp = (t) => {
  var e, n, r;
  return {
    day: ((e = t.match(/d/g)) === null || e === void 0 ? void 0 : e.length) || 0,
    month: ((n = t.match(/m/g)) === null || n === void 0 ? void 0 : n.length) || 0,
    year: ((r = t.match(/y/g)) === null || r === void 0 ? void 0 : r.length) || 0
  };
};
function x9(t) {
  return {
    day: String(t.getDate()).padStart(2, "0"),
    month: String(t.getMonth() + 1).padStart(2, "0"),
    year: String(t.getFullYear()).padStart(4, "0"),
    hours: String(t.getHours()).padStart(2, "0"),
    minutes: String(t.getMinutes()).padStart(2, "0"),
    seconds: String(t.getSeconds()).padStart(2, "0"),
    milliseconds: String(t.getMilliseconds()).padStart(3, "0")
  };
}
function _9(t, e) {
  return t.length < e.length ? !1 : t.split(/\D/).every((n) => !n.match(/^0+$/));
}
function zp(t, e, n) {
  const r = e.replace(/\W/g, "").length;
  return t.replace(n, "").match(new RegExp(`(\\D*\\d[^\\d\\s]*){1,${r}}`, "g")) || [];
}
function Up(t) {
  return t.reduce((e, [n, r]) => Object.assign(Object.assign({}, e), {
    [n]: r
  }), {});
}
function Yp(t, e) {
  const n = e.replace(/[^dmy]/g, ""), r = t.replace(/\D+/g, ""), o = {
    day: r.slice(n.indexOf("d"), n.lastIndexOf("d") + 1),
    month: r.slice(n.indexOf("m"), n.lastIndexOf("m") + 1),
    year: r.slice(n.indexOf("y"), n.lastIndexOf("y") + 1)
  };
  return Up(Object.entries(o).filter(([i, s]) => !!s).sort(([i], [s]) => e.toLowerCase().indexOf(i[0]) > e.toLowerCase().indexOf(s[0]) ? 1 : -1));
}
function C9(t, e) {
  var n, r, o, i, s, a, l;
  const c = ((n = t.year) === null || n === void 0 ? void 0 : n.length) === 2 ? `20${t.year}` : t.year, u = new Date(Number(c ?? "0"), Number((r = t.month) !== null && r !== void 0 ? r : "1") - 1, Number((o = t.day) !== null && o !== void 0 ? o : "1"), Number((i = e == null ? void 0 : e.hours) !== null && i !== void 0 ? i : "0"), Number((s = e == null ? void 0 : e.minutes) !== null && s !== void 0 ? s : "0"), Number((a = e == null ? void 0 : e.seconds) !== null && a !== void 0 ? a : "0"), Number((l = e == null ? void 0 : e.milliseconds) !== null && l !== void 0 ? l : "0"));
  return u.setFullYear(Number(c ?? "0")), u;
}
const E9 = ", ";
function Yi({
  day: t,
  month: e,
  year: n,
  hours: r,
  minutes: o,
  seconds: i,
  milliseconds: s
}, a, l) {
  var c;
  const u = ((c = a.match(/y/g)) === null || c === void 0 ? void 0 : c.length) === 2 ? n == null ? void 0 : n.slice(-2) : n;
  return (a + (l ? E9 + l : "")).replace(/d+/g, t ?? "").replace(/m+/g, e ?? "").replace(/y+/g, u ?? "").replace(/H+/g, r ?? "").replace(/MSS/g, s ?? "").replace(/M+/g, o ?? "").replace(/S+/g, i ?? "").replace(/^\D+/g, "").replace(/\D+$/g, "");
}
function $a(t, e, n = 0) {
  return Number(t.padEnd(e.length, "0")) <= Number(e) ? {
    validatedSegmentValue: t,
    prefixedZeroesCount: n
  } : t.endsWith("0") ? $a(`0${t.slice(0, e.length - 1)}`, e, n + 1) : $a(`${t.slice(0, e.length - 1)}0`, e, n);
}
const M9 = {
  day: 31,
  month: 12,
  year: 9999
};
function k9({
  dateString: t,
  dateModeTemplate: e,
  offset: n,
  selection: [r, o]
}) {
  const i = Yp(t, e), s = Object.entries(i), a = {};
  let l = 0;
  for (const [d, f] of s) {
    const h = Yi(a, e), p = M9[d], g = h.length && 1, m = n + h.length + g + jp(e)[d], b = m >= r && m === o;
    if (b && Number(f) > Number(p))
      return {
        validatedDateString: "",
        updatedSelection: [r, o]
      };
    if (b && Number(f) < 1)
      return {
        validatedDateString: "",
        updatedSelection: [r, o]
      };
    const {
      validatedSegmentValue: v,
      prefixedZeroesCount: _
    } = $a(f, `${p}`);
    l += _, a[d] = v;
  }
  const c = Yi(a, e), u = c.length - t.length;
  return {
    validatedDateString: c,
    updatedSelection: [r + l + u, o + l + u]
  };
}
const Kp = /[\\^$.*+?()[\]{}|]/g, O9 = RegExp(Kp.source);
function Gp(t) {
  return t && O9.test(t) ? t.replace(Kp, "\\$&") : t;
}
function S9({
  activeElement: t
}) {
  if (!(t != null && t.shadowRoot))
    return t;
  let e = t.shadowRoot.activeElement;
  for (; e != null && e.shadowRoot; )
    e = e.shadowRoot.activeElement;
  return e;
}
function P9(t, e) {
  const n = jp(e);
  return Up(Object.entries(t).map(([r, o]) => {
    const i = n[r];
    return [r, o.length === i && o.match(/^0+$/) ? "1".padStart(i, "0") : o];
  }));
}
function I9({
  dateModeTemplate: t,
  min: e = h9,
  max: n = p9,
  rangeSeparator: r = "",
  dateSegmentSeparator: o = "."
}) {
  return ({
    value: i,
    selection: s
  }) => {
    const a = r && i.endsWith(r), l = zp(i, t, r);
    let c = "";
    for (const u of l) {
      c += c ? r : "";
      const d = Yp(u, t);
      if (!_9(u, t)) {
        const p = P9(d, t), g = Yi(p, t), m = u.endsWith(o) ? o : "";
        c += g + m;
        continue;
      }
      const f = C9(d), h = Da(f, e, n);
      c += Yi(x9(h), t);
    }
    return {
      selection: s,
      value: c + (a ? r : "")
    };
  };
}
function T9({
  dateModeTemplate: t,
  dateSegmentsSeparator: e,
  rangeSeparator: n = ""
}) {
  return ({
    elementState: r,
    data: o
  }) => {
    const {
      value: i,
      selection: s
    } = r;
    if (o === e)
      return {
        elementState: r,
        data: s[0] === i.length ? o : ""
      };
    if (y9.includes(o))
      return {
        elementState: r,
        data: n
      };
    const a = o.replace(new RegExp(`[^\\d${Gp(e)}${n}]`, "g"), "");
    if (!a)
      return {
        elementState: r,
        data: ""
      };
    const [l, c] = s;
    let u = c + o.length;
    const d = i.slice(0, l) + a + i.slice(u), f = zp(d, t, n);
    let h = "";
    const p = !!n && d.includes(n);
    for (const m of f) {
      const {
        validatedDateString: b,
        updatedSelection: v
      } = k9({
        dateString: m,
        dateModeTemplate: t,
        offset: h ? h.length + n.length : 0,
        selection: [l, u]
      });
      if (m && !b)
        return {
          elementState: r,
          data: ""
        };
      u = v[1], h += p && h ? n + b : b;
    }
    const g = h.slice(l, u);
    return {
      elementState: {
        selection: s,
        value: h.slice(0, l) + g.split(e).map((m) => "0".repeat(m.length)).join(e) + h.slice(u)
      },
      data: g
    };
  };
}
function D9(t) {
  return (e) => {
    const n = e.ownerDocument;
    let r = 0;
    const o = () => r++, i = () => r--, s = () => {
      if (S9(n) !== e)
        return;
      if (r)
        return n.addEventListener("mouseup", s, {
          once: !0,
          passive: !0
        });
      const a = e.selectionStart || 0, l = e.selectionEnd || 0, [c, u] = t(e.value, [a, l]);
      (c > a || u < l) && e.setSelectionRange(Da(a, c, u), Da(l, c, u));
    };
    return n.addEventListener("selectionchange", s, {
      passive: !0
    }), n.addEventListener("mousedown", o, {
      passive: !0
    }), n.addEventListener("mouseup", i, {
      passive: !0
    }), () => {
      n.removeEventListener("selectionchange", s), n.removeEventListener("mousedown", o), n.removeEventListener("mouseup", i);
    };
  };
}
function Sd(t, e, n) {
  return (r, o) => {
    const i = () => e(r, o);
    return r.addEventListener(t, i, n), () => r.removeEventListener(t, i, n);
  };
}
function $9(t, e = !1) {
  const n = (i) => {
    for (let s = i.length - 1; s >= 0; s--)
      if (i[s] !== t[s])
        return i.slice(0, s + 1);
    return "";
  }, r = [D9((i) => [0, n(i).length])];
  let o = !1;
  if (e) {
    const i = Sd("focus", (a) => {
      o = !0, a.value += t.slice(a.value.length), a.dispatchEvent(new Event("input"));
    }, {
      capture: !0
    }), s = Sd("blur", (a) => {
      o = !1, a.value = n(a.value), a.dispatchEvent(new Event("input"));
    }, {
      capture: !0
    });
    r.push(i, s);
  }
  return {
    plugins: r,
    removePlaceholder: n,
    preprocessors: [({
      elementState: i,
      data: s
    }) => {
      const {
        value: a,
        selection: l
      } = i;
      return {
        elementState: {
          selection: l,
          value: n(a)
        },
        data: s
      };
    }],
    postprocessors: [({
      value: i,
      selection: s
    }, a) => a.value && (o || !e) ? {
      value: i + t.slice(i.length),
      selection: s
    } : {
      value: i,
      selection: s
    }]
  };
}
function N9() {
  return ({
    elementState: t
  }, e) => {
    const {
      value: n,
      selection: r
    } = t;
    if (!n || R9(n, r))
      return {
        elementState: t
      };
    const [o, i] = r, s = n.slice(o, i).replace(/\d/g, "0"), a = n.slice(0, o) + s + n.slice(i);
    return e === "validation" || e === "insert" && o === i ? {
      elementState: {
        selection: r,
        value: a
      }
    } : {
      elementState: {
        selection: e === "deleteBackward" || e === "insert" ? [o, o] : [i, i],
        value: a
      }
    };
  };
}
function R9(t, [e, n]) {
  return n === t.length;
}
function A9({
  mode: t,
  separator: e = ".",
  max: n,
  min: r
}) {
  const o = t.split("/").join(e);
  return Object.assign(Object.assign({}, gs), {
    mask: Array.from(o).map((i) => i === e ? i : /\d/),
    overwriteMode: "replace",
    preprocessors: [N9(), T9({
      dateModeTemplate: o,
      dateSegmentsSeparator: e
    })],
    postprocessors: [I9({
      min: r,
      max: n,
      dateModeTemplate: o,
      dateSegmentSeparator: e
    })]
  });
}
new RegExp(`[${w9.map(Gp).join("")}]$`);
const L9 = typeof window < "u" ? Ji : ue, F9 = ({
  options: t = gs,
  elementPredicate: e = Z3
} = {}) => {
  const [n, r] = ye(null), o = pe((i) => {
    r(i);
  }, []);
  return L9(() => {
    if (!n)
      return;
    const i = new f9(e(n), t);
    return () => {
      i.destroy();
    };
  }, [t, n, e]), o;
};
let js = 0;
function qp() {
  ue(() => {
    var t, e;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (t = n[0]) !== null && t !== void 0 ? t : Pd()), document.body.insertAdjacentElement("beforeend", (e = n[1]) !== null && e !== void 0 ? e : Pd()), js++, () => {
      js === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), js--;
    };
  }, []);
}
function Pd() {
  const t = document.createElement("span");
  return t.setAttribute("data-radix-focus-guard", ""), t.tabIndex = 0, t.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", t;
}
const zs = "focusScope.autoFocusOnMount", Us = "focusScope.autoFocusOnUnmount", Id = {
  bubbles: !1,
  cancelable: !0
}, V9 = /* @__PURE__ */ de((t, e) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: o, onUnmountAutoFocus: i, ...s } = t, [a, l] = ye(null), c = pt(o), u = pt(i), d = ae(null), f = et(
    e,
    (g) => l(g)
  ), h = ae({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  ue(() => {
    if (r) {
      let g = function(_) {
        if (h.paused || !a)
          return;
        const x = _.target;
        a.contains(x) ? d.current = x : kn(d.current, {
          select: !0
        });
      }, m = function(_) {
        if (h.paused || !a)
          return;
        const x = _.relatedTarget;
        x !== null && (a.contains(x) || kn(d.current, {
          select: !0
        }));
      }, b = function(_) {
        const x = document.activeElement;
        for (const y of _)
          y.removedNodes.length > 0 && (a != null && a.contains(x) || kn(a));
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", m);
      const v = new MutationObserver(b);
      return a && v.observe(a, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", m), v.disconnect();
      };
    }
  }, [
    r,
    a,
    h.paused
  ]), ue(() => {
    if (a) {
      Dd.add(h);
      const g = document.activeElement;
      if (!a.contains(g)) {
        const b = new CustomEvent(zs, Id);
        a.addEventListener(zs, c), a.dispatchEvent(b), b.defaultPrevented || (W9(U9(Xp(a)), {
          select: !0
        }), document.activeElement === g && kn(a));
      }
      return () => {
        a.removeEventListener(zs, c), setTimeout(() => {
          const b = new CustomEvent(Us, Id);
          a.addEventListener(Us, u), a.dispatchEvent(b), b.defaultPrevented || kn(g ?? document.body, {
            select: !0
          }), a.removeEventListener(Us, u), Dd.remove(h);
        }, 0);
      };
    }
  }, [
    a,
    c,
    u,
    h
  ]);
  const p = pe((g) => {
    if (!n && !r || h.paused)
      return;
    const m = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, b = document.activeElement;
    if (m && b) {
      const v = g.currentTarget, [_, x] = H9(v);
      _ && x ? !g.shiftKey && b === x ? (g.preventDefault(), n && kn(_, {
        select: !0
      })) : g.shiftKey && b === _ && (g.preventDefault(), n && kn(x, {
        select: !0
      })) : b === v && g.preventDefault();
    }
  }, [
    n,
    r,
    h.paused
  ]);
  return /* @__PURE__ */ L(je.div, ne({
    tabIndex: -1
  }, s, {
    ref: f,
    onKeyDown: p
  }));
});
function W9(t, { select: e = !1 } = {}) {
  const n = document.activeElement;
  for (const r of t)
    if (kn(r, {
      select: e
    }), document.activeElement !== n)
      return;
}
function H9(t) {
  const e = Xp(t), n = Td(e, t), r = Td(e.reverse(), t);
  return [
    n,
    r
  ];
}
function Xp(t) {
  const e = [], n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    e.push(n.currentNode);
  return e;
}
function Td(t, e) {
  for (const n of t)
    if (!B9(n, {
      upTo: e
    }))
      return n;
}
function B9(t, { upTo: e }) {
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  for (; t; ) {
    if (e !== void 0 && t === e)
      return !1;
    if (getComputedStyle(t).display === "none")
      return !0;
    t = t.parentElement;
  }
  return !1;
}
function j9(t) {
  return t instanceof HTMLInputElement && "select" in t;
}
function kn(t, { select: e = !1 } = {}) {
  if (t && t.focus) {
    const n = document.activeElement;
    t.focus({
      preventScroll: !0
    }), t !== n && j9(t) && e && t.select();
  }
}
const Dd = z9();
function z9() {
  let t = [];
  return {
    add(e) {
      const n = t[0];
      e !== n && (n == null || n.pause()), t = $d(t, e), t.unshift(e);
    },
    remove(e) {
      var n;
      t = $d(t, e), (n = t[0]) === null || n === void 0 || n.resume();
    }
  };
}
function $d(t, e) {
  const n = [
    ...t
  ], r = n.indexOf(e);
  return r !== -1 && n.splice(r, 1), n;
}
function U9(t) {
  return t.filter(
    (e) => e.tagName !== "A"
  );
}
var Y9 = function(t) {
  if (typeof document > "u")
    return null;
  var e = Array.isArray(t) ? t[0] : t;
  return e.ownerDocument.body;
}, vr = /* @__PURE__ */ new WeakMap(), ti = /* @__PURE__ */ new WeakMap(), ni = {}, Ys = 0, Zp = function(t) {
  return t && (t.host || Zp(t.parentNode));
}, K9 = function(t, e) {
  return e.map(function(n) {
    if (t.contains(n))
      return n;
    var r = Zp(n);
    return r && t.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", t, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, G9 = function(t, e, n, r) {
  var o = K9(e, Array.isArray(t) ? t : [t]);
  ni[n] || (ni[n] = /* @__PURE__ */ new WeakMap());
  var i = ni[n], s = [], a = /* @__PURE__ */ new Set(), l = new Set(o), c = function(d) {
    !d || a.has(d) || (a.add(d), c(d.parentNode));
  };
  o.forEach(c);
  var u = function(d) {
    !d || l.has(d) || Array.prototype.forEach.call(d.children, function(f) {
      if (a.has(f))
        u(f);
      else {
        var h = f.getAttribute(r), p = h !== null && h !== "false", g = (vr.get(f) || 0) + 1, m = (i.get(f) || 0) + 1;
        vr.set(f, g), i.set(f, m), s.push(f), g === 1 && p && ti.set(f, !0), m === 1 && f.setAttribute(n, "true"), p || f.setAttribute(r, "true");
      }
    });
  };
  return u(e), a.clear(), Ys++, function() {
    s.forEach(function(d) {
      var f = vr.get(d) - 1, h = i.get(d) - 1;
      vr.set(d, f), i.set(d, h), f || (ti.has(d) || d.removeAttribute(r), ti.delete(d)), h || d.removeAttribute(n);
    }), Ys--, Ys || (vr = /* @__PURE__ */ new WeakMap(), vr = /* @__PURE__ */ new WeakMap(), ti = /* @__PURE__ */ new WeakMap(), ni = {});
  };
}, Qp = function(t, e, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(t) ? t : [t]), o = e || Y9(t);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), G9(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, yt = function() {
  return yt = Object.assign || function(e) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
    }
    return e;
  }, yt.apply(this, arguments);
};
function Jp(t, e) {
  var n = {};
  for (var r in t)
    Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(t); o < r.length; o++)
      e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[o]) && (n[r[o]] = t[r[o]]);
  return n;
}
function q9(t, e, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = e.length, i; r < o; r++)
      (i || !(r in e)) && (i || (i = Array.prototype.slice.call(e, 0, r)), i[r] = e[r]);
  return t.concat(i || Array.prototype.slice.call(e));
}
var yi = "right-scroll-bar-position", wi = "width-before-scroll-bar", X9 = "with-scroll-bars-hidden", Z9 = "--removed-body-scroll-bar-size";
function Q9(t, e) {
  return typeof t == "function" ? t(e) : t && (t.current = e), t;
}
function J9(t, e) {
  var n = ye(function() {
    return {
      // value
      value: t,
      // last callback
      callback: e,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = e, n.facade;
}
function eE(t, e) {
  return J9(e || null, function(n) {
    return t.forEach(function(r) {
      return Q9(r, n);
    });
  });
}
function tE(t) {
  return t;
}
function nE(t, e) {
  e === void 0 && (e = tE);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : t;
    },
    useMedium: function(i) {
      var s = e(i, r);
      return n.push(s), function() {
        n = n.filter(function(a) {
          return a !== s;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var s = n;
        n = [], s.forEach(i);
      }
      n = {
        push: function(a) {
          return i(a);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var s = [];
      if (n.length) {
        var a = n;
        n = [], a.forEach(i), s = n;
      }
      var l = function() {
        var u = s;
        s = [], u.forEach(i);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), n = {
        push: function(u) {
          s.push(u), c();
        },
        filter: function(u) {
          return s = s.filter(u), n;
        }
      };
    }
  };
  return o;
}
function rE(t) {
  t === void 0 && (t = {});
  var e = nE(null);
  return e.options = yt({ async: !0, ssr: !1 }, t), e;
}
var eg = function(t) {
  var e = t.sideCar, n = Jp(t, ["sideCar"]);
  if (!e)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = e.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return C.createElement(r, yt({}, n));
};
eg.isSideCarExport = !0;
function oE(t, e) {
  return t.useMedium(e), eg;
}
var tg = rE(), Ks = function() {
}, vs = C.forwardRef(function(t, e) {
  var n = C.useRef(null), r = C.useState({
    onScrollCapture: Ks,
    onWheelCapture: Ks,
    onTouchMoveCapture: Ks
  }), o = r[0], i = r[1], s = t.forwardProps, a = t.children, l = t.className, c = t.removeScrollBar, u = t.enabled, d = t.shards, f = t.sideCar, h = t.noIsolation, p = t.inert, g = t.allowPinchZoom, m = t.as, b = m === void 0 ? "div" : m, v = Jp(t, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), _ = f, x = eE([n, e]), y = yt(yt({}, v), o);
  return C.createElement(
    C.Fragment,
    null,
    u && C.createElement(_, { sideCar: tg, removeScrollBar: c, shards: d, noIsolation: h, inert: p, setCallbacks: i, allowPinchZoom: !!g, lockRef: n }),
    s ? C.cloneElement(C.Children.only(a), yt(yt({}, y), { ref: x })) : C.createElement(b, yt({}, y, { className: l, ref: x }), a)
  );
});
vs.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
vs.classNames = {
  fullWidth: wi,
  zeroRight: yi
};
var Nd, iE = function() {
  if (Nd)
    return Nd;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function sE() {
  if (!document)
    return null;
  var t = document.createElement("style");
  t.type = "text/css";
  var e = iE();
  return e && t.setAttribute("nonce", e), t;
}
function aE(t, e) {
  t.styleSheet ? t.styleSheet.cssText = e : t.appendChild(document.createTextNode(e));
}
function lE(t) {
  var e = document.head || document.getElementsByTagName("head")[0];
  e.appendChild(t);
}
var cE = function() {
  var t = 0, e = null;
  return {
    add: function(n) {
      t == 0 && (e = sE()) && (aE(e, n), lE(e)), t++;
    },
    remove: function() {
      t--, !t && e && (e.parentNode && e.parentNode.removeChild(e), e = null);
    }
  };
}, uE = function() {
  var t = cE();
  return function(e, n) {
    C.useEffect(function() {
      return t.add(e), function() {
        t.remove();
      };
    }, [e && n]);
  };
}, ng = function() {
  var t = uE(), e = function(n) {
    var r = n.styles, o = n.dynamic;
    return t(r, o), null;
  };
  return e;
}, dE = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Gs = function(t) {
  return parseInt(t || "", 10) || 0;
}, fE = function(t) {
  var e = window.getComputedStyle(document.body), n = e[t === "padding" ? "paddingLeft" : "marginLeft"], r = e[t === "padding" ? "paddingTop" : "marginTop"], o = e[t === "padding" ? "paddingRight" : "marginRight"];
  return [Gs(n), Gs(r), Gs(o)];
}, hE = function(t) {
  if (t === void 0 && (t = "margin"), typeof window > "u")
    return dE;
  var e = fE(t), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: e[0],
    top: e[1],
    right: e[2],
    gap: Math.max(0, r - n + e[2] - e[0])
  };
}, pE = ng(), gE = function(t, e, n, r) {
  var o = t.left, i = t.top, s = t.right, a = t.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(X9, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(a, "px ").concat(r, `;
  }
  body {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    e && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(a, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(a, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(yi, ` {
    right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(wi, ` {
    margin-right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(yi, " .").concat(yi, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(wi, " .").concat(wi, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body {
    `).concat(Z9, ": ").concat(a, `px;
  }
`);
}, mE = function(t) {
  var e = t.noRelative, n = t.noImportant, r = t.gapMode, o = r === void 0 ? "margin" : r, i = C.useMemo(function() {
    return hE(o);
  }, [o]);
  return C.createElement(pE, { styles: gE(i, !e, o, n ? "" : "!important") });
}, Na = !1;
if (typeof window < "u")
  try {
    var ri = Object.defineProperty({}, "passive", {
      get: function() {
        return Na = !0, !0;
      }
    });
    window.addEventListener("test", ri, ri), window.removeEventListener("test", ri, ri);
  } catch {
    Na = !1;
  }
var br = Na ? { passive: !1 } : !1, vE = function(t) {
  return t.tagName === "TEXTAREA";
}, rg = function(t, e) {
  var n = window.getComputedStyle(t);
  return (
    // not-not-scrollable
    n[e] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !vE(t) && n[e] === "visible")
  );
}, bE = function(t) {
  return rg(t, "overflowY");
}, yE = function(t) {
  return rg(t, "overflowX");
}, Rd = function(t, e) {
  var n = e;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var r = og(t, n);
    if (r) {
      var o = ig(t, n), i = o[1], s = o[2];
      if (i > s)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, wE = function(t) {
  var e = t.scrollTop, n = t.scrollHeight, r = t.clientHeight;
  return [
    e,
    n,
    r
  ];
}, xE = function(t) {
  var e = t.scrollLeft, n = t.scrollWidth, r = t.clientWidth;
  return [
    e,
    n,
    r
  ];
}, og = function(t, e) {
  return t === "v" ? bE(e) : yE(e);
}, ig = function(t, e) {
  return t === "v" ? wE(e) : xE(e);
}, _E = function(t, e) {
  return t === "h" && e === "rtl" ? -1 : 1;
}, CE = function(t, e, n, r, o) {
  var i = _E(t, window.getComputedStyle(e).direction), s = i * r, a = n.target, l = e.contains(a), c = !1, u = s > 0, d = 0, f = 0;
  do {
    var h = ig(t, a), p = h[0], g = h[1], m = h[2], b = g - m - i * p;
    (p || b) && og(t, a) && (d += b, f += p), a = a.parentNode;
  } while (
    // portaled content
    !l && a !== document.body || // self content
    l && (e.contains(a) || e === a)
  );
  return (u && (o && d === 0 || !o && s > d) || !u && (o && f === 0 || !o && -s > f)) && (c = !0), c;
}, oi = function(t) {
  return "changedTouches" in t ? [t.changedTouches[0].clientX, t.changedTouches[0].clientY] : [0, 0];
}, Ad = function(t) {
  return [t.deltaX, t.deltaY];
}, Ld = function(t) {
  return t && "current" in t ? t.current : t;
}, EE = function(t, e) {
  return t[0] === e[0] && t[1] === e[1];
}, ME = function(t) {
  return `
  .block-interactivity-`.concat(t, ` {pointer-events: none;}
  .allow-interactivity-`).concat(t, ` {pointer-events: all;}
`);
}, kE = 0, yr = [];
function OE(t) {
  var e = C.useRef([]), n = C.useRef([0, 0]), r = C.useRef(), o = C.useState(kE++)[0], i = C.useState(function() {
    return ng();
  })[0], s = C.useRef(t);
  C.useEffect(function() {
    s.current = t;
  }, [t]), C.useEffect(function() {
    if (t.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var g = q9([t.lockRef.current], (t.shards || []).map(Ld), !0).filter(Boolean);
      return g.forEach(function(m) {
        return m.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), g.forEach(function(m) {
          return m.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [t.inert, t.lockRef.current, t.shards]);
  var a = C.useCallback(function(g, m) {
    if ("touches" in g && g.touches.length === 2)
      return !s.current.allowPinchZoom;
    var b = oi(g), v = n.current, _ = "deltaX" in g ? g.deltaX : v[0] - b[0], x = "deltaY" in g ? g.deltaY : v[1] - b[1], y, M = g.target, k = Math.abs(_) > Math.abs(x) ? "h" : "v";
    if ("touches" in g && k === "h" && M.type === "range")
      return !1;
    var O = Rd(k, M);
    if (!O)
      return !0;
    if (O ? y = k : (y = k === "v" ? "h" : "v", O = Rd(k, M)), !O)
      return !1;
    if (!r.current && "changedTouches" in g && (_ || x) && (r.current = y), !y)
      return !0;
    var S = r.current || y;
    return CE(S, m, g, S === "h" ? _ : x, !0);
  }, []), l = C.useCallback(function(g) {
    var m = g;
    if (!(!yr.length || yr[yr.length - 1] !== i)) {
      var b = "deltaY" in m ? Ad(m) : oi(m), v = e.current.filter(function(y) {
        return y.name === m.type && y.target === m.target && EE(y.delta, b);
      })[0];
      if (v && v.should) {
        m.cancelable && m.preventDefault();
        return;
      }
      if (!v) {
        var _ = (s.current.shards || []).map(Ld).filter(Boolean).filter(function(y) {
          return y.contains(m.target);
        }), x = _.length > 0 ? a(m, _[0]) : !s.current.noIsolation;
        x && m.cancelable && m.preventDefault();
      }
    }
  }, []), c = C.useCallback(function(g, m, b, v) {
    var _ = { name: g, delta: m, target: b, should: v };
    e.current.push(_), setTimeout(function() {
      e.current = e.current.filter(function(x) {
        return x !== _;
      });
    }, 1);
  }, []), u = C.useCallback(function(g) {
    n.current = oi(g), r.current = void 0;
  }, []), d = C.useCallback(function(g) {
    c(g.type, Ad(g), g.target, a(g, t.lockRef.current));
  }, []), f = C.useCallback(function(g) {
    c(g.type, oi(g), g.target, a(g, t.lockRef.current));
  }, []);
  C.useEffect(function() {
    return yr.push(i), t.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", l, br), document.addEventListener("touchmove", l, br), document.addEventListener("touchstart", u, br), function() {
      yr = yr.filter(function(g) {
        return g !== i;
      }), document.removeEventListener("wheel", l, br), document.removeEventListener("touchmove", l, br), document.removeEventListener("touchstart", u, br);
    };
  }, []);
  var h = t.removeScrollBar, p = t.inert;
  return C.createElement(
    C.Fragment,
    null,
    p ? C.createElement(i, { styles: ME(o) }) : null,
    h ? C.createElement(mE, { gapMode: "margin" }) : null
  );
}
const SE = oE(tg, OE);
var sg = C.forwardRef(function(t, e) {
  return C.createElement(vs, yt({}, t, { ref: e, sideCar: SE }));
});
sg.classNames = vs.classNames;
const ag = sg, lg = "Popover", [cg, t8] = an(lg, [
  ns
]), $o = ns(), [PE, jn] = cg(lg), IE = (t) => {
  const { __scopePopover: e, children: n, open: r, defaultOpen: o, onOpenChange: i, modal: s = !1 } = t, a = $o(e), l = ae(null), [c, u] = ye(!1), [d = !1, f] = Hn({
    prop: r,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ L(Yf, a, /* @__PURE__ */ L(PE, {
    scope: e,
    contentId: fo(),
    triggerRef: l,
    open: d,
    onOpenChange: f,
    onOpenToggle: pe(
      () => f(
        (h) => !h
      ),
      [
        f
      ]
    ),
    hasCustomAnchor: c,
    onCustomAnchorAdd: pe(
      () => u(!0),
      []
    ),
    onCustomAnchorRemove: pe(
      () => u(!1),
      []
    ),
    modal: s
  }, n));
}, TE = "PopoverAnchor", DE = /* @__PURE__ */ de((t, e) => {
  const { __scopePopover: n, ...r } = t, o = jn(TE, n), i = $o(n), { onCustomAnchorAdd: s, onCustomAnchorRemove: a } = o;
  return ue(() => (s(), () => a()), [
    s,
    a
  ]), /* @__PURE__ */ L(cl, ne({}, i, r, {
    ref: e
  }));
}), $E = "PopoverTrigger", NE = /* @__PURE__ */ de((t, e) => {
  const { __scopePopover: n, ...r } = t, o = jn($E, n), i = $o(n), s = et(e, o.triggerRef), a = /* @__PURE__ */ L(je.button, ne({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": o.open,
    "aria-controls": o.contentId,
    "data-state": fg(o.open)
  }, r, {
    ref: s,
    onClick: be(t.onClick, o.onOpenToggle)
  }));
  return o.hasCustomAnchor ? a : /* @__PURE__ */ L(cl, ne({
    asChild: !0
  }, i), a);
}), ug = "PopoverPortal", [RE, AE] = cg(ug, {
  forceMount: void 0
}), LE = (t) => {
  const { __scopePopover: e, forceMount: n, children: r, container: o } = t, i = jn(ug, e);
  return /* @__PURE__ */ L(RE, {
    scope: e,
    forceMount: n
  }, /* @__PURE__ */ L(cr, {
    present: n || i.open
  }, /* @__PURE__ */ L(ul, {
    asChild: !0,
    container: o
  }, r)));
}, _o = "PopoverContent", FE = /* @__PURE__ */ de((t, e) => {
  const n = AE(_o, t.__scopePopover), { forceMount: r = n.forceMount, ...o } = t, i = jn(_o, t.__scopePopover);
  return /* @__PURE__ */ L(cr, {
    present: r || i.open
  }, i.modal ? /* @__PURE__ */ L(VE, ne({}, o, {
    ref: e
  })) : /* @__PURE__ */ L(WE, ne({}, o, {
    ref: e
  })));
}), VE = /* @__PURE__ */ de((t, e) => {
  const n = jn(_o, t.__scopePopover), r = ae(null), o = et(e, r), i = ae(!1);
  return ue(() => {
    const s = r.current;
    if (s)
      return Qp(s);
  }, []), /* @__PURE__ */ L(ag, {
    as: Rt,
    allowPinchZoom: !0
  }, /* @__PURE__ */ L(dg, ne({}, t, {
    ref: o,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: be(t.onCloseAutoFocus, (s) => {
      var a;
      s.preventDefault(), i.current || (a = n.triggerRef.current) === null || a === void 0 || a.focus();
    }),
    onPointerDownOutside: be(t.onPointerDownOutside, (s) => {
      const a = s.detail.originalEvent, l = a.button === 0 && a.ctrlKey === !0, c = a.button === 2 || l;
      i.current = c;
    }, {
      checkForDefaultPrevented: !1
    }),
    onFocusOutside: be(
      t.onFocusOutside,
      (s) => s.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), WE = /* @__PURE__ */ de((t, e) => {
  const n = jn(_o, t.__scopePopover), r = ae(!1), o = ae(!1);
  return /* @__PURE__ */ L(dg, ne({}, t, {
    ref: e,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (i) => {
      var s;
      if ((s = t.onCloseAutoFocus) === null || s === void 0 || s.call(t, i), !i.defaultPrevented) {
        var a;
        r.current || (a = n.triggerRef.current) === null || a === void 0 || a.focus(), i.preventDefault();
      }
      r.current = !1, o.current = !1;
    },
    onInteractOutside: (i) => {
      var s, a;
      (s = t.onInteractOutside) === null || s === void 0 || s.call(t, i), i.defaultPrevented || (r.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
      const l = i.target;
      ((a = n.triggerRef.current) === null || a === void 0 ? void 0 : a.contains(l)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
    }
  }));
}), dg = /* @__PURE__ */ de((t, e) => {
  const { __scopePopover: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: i, disableOutsidePointerEvents: s, onEscapeKeyDown: a, onPointerDownOutside: l, onFocusOutside: c, onInteractOutside: u, ...d } = t, f = jn(_o, n), h = $o(n);
  return qp(), /* @__PURE__ */ L(V9, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i
  }, /* @__PURE__ */ L(Of, {
    asChild: !0,
    disableOutsidePointerEvents: s,
    onInteractOutside: u,
    onEscapeKeyDown: a,
    onPointerDownOutside: l,
    onFocusOutside: c,
    onDismiss: () => f.onOpenChange(!1)
  }, /* @__PURE__ */ L(Kf, ne({
    "data-state": fg(f.open),
    role: "dialog",
    id: f.contentId
  }, h, d, {
    ref: e,
    style: {
      ...d.style,
      "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
      "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
      "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }))));
}), HE = "PopoverClose", BE = /* @__PURE__ */ de((t, e) => {
  const { __scopePopover: n, ...r } = t, o = jn(HE, n);
  return /* @__PURE__ */ L(je.button, ne({
    type: "button"
  }, r, {
    ref: e,
    onClick: be(
      t.onClick,
      () => o.onOpenChange(!1)
    )
  }));
}), jE = /* @__PURE__ */ de((t, e) => {
  const { __scopePopover: n, ...r } = t, o = $o(n);
  return /* @__PURE__ */ L(Gf, ne({}, o, r, {
    ref: e
  }));
});
function fg(t) {
  return t ? "open" : "closed";
}
const hg = IE, zE = DE, pg = NE, gg = LE, mg = FE, UE = BE, YE = jE, KE = ({
  name: t,
  id: e,
  className: n,
  selected: r,
  onSelect: o,
  disablePortal: i = !1,
  fromDate: s,
  toDate: a
}) => {
  const [l, c] = C.useState(!1), { inputRef: u, inputProps: d, setInputValue: f, month: h, setMonth: p } = It(
    {
      onSelect: o,
      selected: r,
      fromDate: s,
      toDate: a
    }
  ), g = (b) => {
    b ? (o(lt(b, It.valueFormatString)), c(!1)) : (o(""), f(""));
  }, m = i ? C.Fragment : gg;
  return /* @__PURE__ */ B(hg, { open: l, onOpenChange: c, children: [
    /* @__PURE__ */ w(zE, { asChild: !0, children: /* @__PURE__ */ w(
      XE,
      {
        ref: u,
        icon: /* @__PURE__ */ w(pg, { className: "pointer-events-auto -m-1 rounded p-1 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500", children: /* @__PURE__ */ w(d5, { className: "h-5 w-5" }) }),
        className: n,
        id: e,
        name: t,
        ...d
      }
    ) }),
    /* @__PURE__ */ w(m, { children: /* @__PURE__ */ w(
      mg,
      {
        className: "z-10",
        side: "bottom",
        sideOffset: 4,
        collisionPadding: 4,
        children: /* @__PURE__ */ w(
          Hp,
          {
            mode: "single",
            className: "shadow-3",
            initialFocus: !0,
            onSelect: g,
            selected: r ? wr(r, It.valueFormatString, /* @__PURE__ */ new Date()) : void 0,
            month: h,
            onMonthChange: p,
            fromDate: s,
            toDate: a
          }
        )
      }
    ) })
  ] });
};
KE.displayName = "DatePicker";
const ii = A9({
  mode: "dd/mm/yyyy",
  separator: "-"
}), { plugins: GE, ...Fd } = $9(
  "dd-mm-yyyy",
  !0
), qE = {
  ...ii,
  plugins: GE.concat(ii.plugins || []),
  preprocessors: [
    // Always put it BEFORE all other preprocessors
    ...Fd.preprocessors,
    ...ii.preprocessors
  ],
  postprocessors: [
    ...ii.postprocessors,
    // Always put it AFTER all other postprocessors
    ...Fd.postprocessors
  ]
}, It = ({
  selected: t,
  onSelect: e,
  fromDate: n,
  toDate: r
}) => {
  const [o, i] = C.useState(""), [s, a] = C.useState(), l = F9({ options: qE });
  return C.useEffect(() => {
    t && (a(wr(t, It.valueFormatString, /* @__PURE__ */ new Date())), i(
      lt(
        wr(t, It.valueFormatString, /* @__PURE__ */ new Date()),
        It.inputFormatString
      )
    ));
  }, [t]), {
    inputRef: l,
    setInputValue: i,
    month: s,
    setMonth: a,
    inputProps: {
      value: o,
      onBlur: (c) => {
        if (!c.target.value) {
          e == null || e(""), a(/* @__PURE__ */ new Date());
          return;
        }
        const u = wr(
          c.target.value,
          It.inputFormatString,
          /* @__PURE__ */ new Date()
        ), d = n && Dt(n, u) > 0, f = r && Dt(u, r) > 0;
        if (!Sl(u) || d || f) {
          i(
            t ? lt(
              wr(t, It.valueFormatString, /* @__PURE__ */ new Date()),
              It.inputFormatString
            ) : ""
          );
          return;
        }
        e == null || e(lt(u, It.valueFormatString)), a(u);
      },
      onChange: () => {
      },
      onInput: (c) => i(c.currentTarget.value)
    }
  };
};
It.valueFormatString = "yyyy-MM-dd";
It.inputFormatString = "dd-MM-yyyy";
const XE = C.forwardRef(({ className: t, icon: e, ...n }, r) => /* @__PURE__ */ w(
  mp,
  {
    ref: r,
    containerClassName: t,
    icon: e,
    type: "text",
    placeholder: "dd-mm-yyyy",
    ...n
  }
)), ZE = hg, QE = pg, JE = UE, n8 = YE, e4 = I.forwardRef(({ children: t, ...e }, n) => /* @__PURE__ */ w(gg, { children: /* @__PURE__ */ w(mg, { ...e, ref: n, children: t }) }));
function t4(t, e, n = []) {
  C.useEffect(() => {
    const r = setTimeout(() => {
      t();
    }, e);
    return () => {
      clearTimeout(r);
    };
  }, [e, ...n]);
}
const vg = C.createContext(null), wn = () => {
  const t = C.useContext(vg);
  if (!t)
    throw new Error(
      "useDropdownSearchContext must be used within <DropdownSearch />"
    );
  return t;
};
function nn(t, e) {
  if (t == null)
    return {};
  var n = {}, r = Object.keys(t), o, i;
  for (i = 0; i < r.length; i++)
    o = r[i], !(e.indexOf(o) >= 0) && (n[o] = t[o]);
  return n;
}
function ve() {
  return ve = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, ve.apply(this, arguments);
}
function Vd(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Ra(t, e) {
  return Ra = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, Ra(t, e);
}
function n4(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, Ra(t, e);
}
var Aa = { exports: {} }, si = { exports: {} }, De = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wd;
function r4() {
  if (Wd)
    return De;
  Wd = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, o = t ? Symbol.for("react.strict_mode") : 60108, i = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, a = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, d = t ? Symbol.for("react.suspense") : 60113, f = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, p = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, m = t ? Symbol.for("react.fundamental") : 60117, b = t ? Symbol.for("react.responder") : 60118, v = t ? Symbol.for("react.scope") : 60119;
  function _(y) {
    if (typeof y == "object" && y !== null) {
      var M = y.$$typeof;
      switch (M) {
        case e:
          switch (y = y.type, y) {
            case l:
            case c:
            case r:
            case i:
            case o:
            case d:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case a:
                case u:
                case p:
                case h:
                case s:
                  return y;
                default:
                  return M;
              }
          }
        case n:
          return M;
      }
    }
  }
  function x(y) {
    return _(y) === c;
  }
  return De.AsyncMode = l, De.ConcurrentMode = c, De.ContextConsumer = a, De.ContextProvider = s, De.Element = e, De.ForwardRef = u, De.Fragment = r, De.Lazy = p, De.Memo = h, De.Portal = n, De.Profiler = i, De.StrictMode = o, De.Suspense = d, De.isAsyncMode = function(y) {
    return x(y) || _(y) === l;
  }, De.isConcurrentMode = x, De.isContextConsumer = function(y) {
    return _(y) === a;
  }, De.isContextProvider = function(y) {
    return _(y) === s;
  }, De.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === e;
  }, De.isForwardRef = function(y) {
    return _(y) === u;
  }, De.isFragment = function(y) {
    return _(y) === r;
  }, De.isLazy = function(y) {
    return _(y) === p;
  }, De.isMemo = function(y) {
    return _(y) === h;
  }, De.isPortal = function(y) {
    return _(y) === n;
  }, De.isProfiler = function(y) {
    return _(y) === i;
  }, De.isStrictMode = function(y) {
    return _(y) === o;
  }, De.isSuspense = function(y) {
    return _(y) === d;
  }, De.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === r || y === c || y === i || y === o || y === d || y === f || typeof y == "object" && y !== null && (y.$$typeof === p || y.$$typeof === h || y.$$typeof === s || y.$$typeof === a || y.$$typeof === u || y.$$typeof === m || y.$$typeof === b || y.$$typeof === v || y.$$typeof === g);
  }, De.typeOf = _, De;
}
var $e = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Hd;
function o4() {
  return Hd || (Hd = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, o = t ? Symbol.for("react.strict_mode") : 60108, i = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, a = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, d = t ? Symbol.for("react.suspense") : 60113, f = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, p = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, m = t ? Symbol.for("react.fundamental") : 60117, b = t ? Symbol.for("react.responder") : 60118, v = t ? Symbol.for("react.scope") : 60119;
    function _(G) {
      return typeof G == "string" || typeof G == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      G === r || G === c || G === i || G === o || G === d || G === f || typeof G == "object" && G !== null && (G.$$typeof === p || G.$$typeof === h || G.$$typeof === s || G.$$typeof === a || G.$$typeof === u || G.$$typeof === m || G.$$typeof === b || G.$$typeof === v || G.$$typeof === g);
    }
    function x(G) {
      if (typeof G == "object" && G !== null) {
        var we = G.$$typeof;
        switch (we) {
          case e:
            var Pe = G.type;
            switch (Pe) {
              case l:
              case c:
              case r:
              case i:
              case o:
              case d:
                return Pe;
              default:
                var Re = Pe && Pe.$$typeof;
                switch (Re) {
                  case a:
                  case u:
                  case p:
                  case h:
                  case s:
                    return Re;
                  default:
                    return we;
                }
            }
          case n:
            return we;
        }
      }
    }
    var y = l, M = c, k = a, O = s, S = e, D = u, P = r, N = p, T = h, U = n, R = i, Y = o, V = d, z = !1;
    function ee(G) {
      return z || (z = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), $(G) || x(G) === l;
    }
    function $(G) {
      return x(G) === c;
    }
    function F(G) {
      return x(G) === a;
    }
    function te(G) {
      return x(G) === s;
    }
    function J(G) {
      return typeof G == "object" && G !== null && G.$$typeof === e;
    }
    function re(G) {
      return x(G) === u;
    }
    function j(G) {
      return x(G) === r;
    }
    function A(G) {
      return x(G) === p;
    }
    function W(G) {
      return x(G) === h;
    }
    function H(G) {
      return x(G) === n;
    }
    function q(G) {
      return x(G) === i;
    }
    function oe(G) {
      return x(G) === o;
    }
    function Z(G) {
      return x(G) === d;
    }
    $e.AsyncMode = y, $e.ConcurrentMode = M, $e.ContextConsumer = k, $e.ContextProvider = O, $e.Element = S, $e.ForwardRef = D, $e.Fragment = P, $e.Lazy = N, $e.Memo = T, $e.Portal = U, $e.Profiler = R, $e.StrictMode = Y, $e.Suspense = V, $e.isAsyncMode = ee, $e.isConcurrentMode = $, $e.isContextConsumer = F, $e.isContextProvider = te, $e.isElement = J, $e.isForwardRef = re, $e.isFragment = j, $e.isLazy = A, $e.isMemo = W, $e.isPortal = H, $e.isProfiler = q, $e.isStrictMode = oe, $e.isSuspense = Z, $e.isValidElementType = _, $e.typeOf = x;
  }()), $e;
}
var Bd;
function bg() {
  return Bd || (Bd = 1, process.env.NODE_ENV === "production" ? si.exports = r4() : si.exports = o4()), si.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var qs, jd;
function i4() {
  if (jd)
    return qs;
  jd = 1;
  var t = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var s = {}, a = 0; a < 10; a++)
        s["_" + String.fromCharCode(a)] = a;
      var l = Object.getOwnPropertyNames(s).map(function(u) {
        return s[u];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        c[u] = u;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return qs = o() ? Object.assign : function(i, s) {
    for (var a, l = r(i), c, u = 1; u < arguments.length; u++) {
      a = Object(arguments[u]);
      for (var d in a)
        e.call(a, d) && (l[d] = a[d]);
      if (t) {
        c = t(a);
        for (var f = 0; f < c.length; f++)
          n.call(a, c[f]) && (l[c[f]] = a[c[f]]);
      }
    }
    return l;
  }, qs;
}
var Xs, zd;
function jl() {
  if (zd)
    return Xs;
  zd = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Xs = t, Xs;
}
var Zs, Ud;
function yg() {
  return Ud || (Ud = 1, Zs = Function.call.bind(Object.prototype.hasOwnProperty)), Zs;
}
var Qs, Yd;
function s4() {
  if (Yd)
    return Qs;
  Yd = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = jl(), n = {}, r = yg();
    t = function(i) {
      var s = "Warning: " + i;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function o(i, s, a, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in i)
        if (r(i, u)) {
          var d;
          try {
            if (typeof i[u] != "function") {
              var f = Error(
                (l || "React class") + ": " + a + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            d = i[u](s, u, l, a, null, e);
          } catch (p) {
            d = p;
          }
          if (d && !(d instanceof Error) && t(
            (l || "React class") + ": type specification of " + a + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in n)) {
            n[d.message] = !0;
            var h = c ? c() : "";
            t(
              "Failed " + a + " type: " + d.message + (h ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Qs = o, Qs;
}
var Js, Kd;
function a4() {
  if (Kd)
    return Js;
  Kd = 1;
  var t = bg(), e = i4(), n = jl(), r = yg(), o = s4(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(a) {
    var l = "Warning: " + a;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return Js = function(a, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function d($) {
      var F = $ && (c && $[c] || $[u]);
      if (typeof F == "function")
        return F;
    }
    var f = "<<anonymous>>", h = {
      array: b("array"),
      bigint: b("bigint"),
      bool: b("boolean"),
      func: b("function"),
      number: b("number"),
      object: b("object"),
      string: b("string"),
      symbol: b("symbol"),
      any: v(),
      arrayOf: _,
      element: x(),
      elementType: y(),
      instanceOf: M,
      node: D(),
      objectOf: O,
      oneOf: k,
      oneOfType: S,
      shape: N,
      exact: T
    };
    function p($, F) {
      return $ === F ? $ !== 0 || 1 / $ === 1 / F : $ !== $ && F !== F;
    }
    function g($, F) {
      this.message = $, this.data = F && typeof F == "object" ? F : {}, this.stack = "";
    }
    g.prototype = Error.prototype;
    function m($) {
      if (process.env.NODE_ENV !== "production")
        var F = {}, te = 0;
      function J(j, A, W, H, q, oe, Z) {
        if (H = H || f, oe = oe || W, Z !== n) {
          if (l) {
            var G = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw G.name = "Invariant Violation", G;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var we = H + ":" + W;
            !F[we] && // Avoid spamming the console because they are often not actionable except for lib authors
            te < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + oe + "` prop on `" + H + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), F[we] = !0, te++);
          }
        }
        return A[W] == null ? j ? A[W] === null ? new g("The " + q + " `" + oe + "` is marked as required " + ("in `" + H + "`, but its value is `null`.")) : new g("The " + q + " `" + oe + "` is marked as required in " + ("`" + H + "`, but its value is `undefined`.")) : null : $(A, W, H, q, oe);
      }
      var re = J.bind(null, !1);
      return re.isRequired = J.bind(null, !0), re;
    }
    function b($) {
      function F(te, J, re, j, A, W) {
        var H = te[J], q = Y(H);
        if (q !== $) {
          var oe = V(H);
          return new g(
            "Invalid " + j + " `" + A + "` of type " + ("`" + oe + "` supplied to `" + re + "`, expected ") + ("`" + $ + "`."),
            { expectedType: $ }
          );
        }
        return null;
      }
      return m(F);
    }
    function v() {
      return m(s);
    }
    function _($) {
      function F(te, J, re, j, A) {
        if (typeof $ != "function")
          return new g("Property `" + A + "` of component `" + re + "` has invalid PropType notation inside arrayOf.");
        var W = te[J];
        if (!Array.isArray(W)) {
          var H = Y(W);
          return new g("Invalid " + j + " `" + A + "` of type " + ("`" + H + "` supplied to `" + re + "`, expected an array."));
        }
        for (var q = 0; q < W.length; q++) {
          var oe = $(W, q, re, j, A + "[" + q + "]", n);
          if (oe instanceof Error)
            return oe;
        }
        return null;
      }
      return m(F);
    }
    function x() {
      function $(F, te, J, re, j) {
        var A = F[te];
        if (!a(A)) {
          var W = Y(A);
          return new g("Invalid " + re + " `" + j + "` of type " + ("`" + W + "` supplied to `" + J + "`, expected a single ReactElement."));
        }
        return null;
      }
      return m($);
    }
    function y() {
      function $(F, te, J, re, j) {
        var A = F[te];
        if (!t.isValidElementType(A)) {
          var W = Y(A);
          return new g("Invalid " + re + " `" + j + "` of type " + ("`" + W + "` supplied to `" + J + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return m($);
    }
    function M($) {
      function F(te, J, re, j, A) {
        if (!(te[J] instanceof $)) {
          var W = $.name || f, H = ee(te[J]);
          return new g("Invalid " + j + " `" + A + "` of type " + ("`" + H + "` supplied to `" + re + "`, expected ") + ("instance of `" + W + "`."));
        }
        return null;
      }
      return m(F);
    }
    function k($) {
      if (!Array.isArray($))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), s;
      function F(te, J, re, j, A) {
        for (var W = te[J], H = 0; H < $.length; H++)
          if (p(W, $[H]))
            return null;
        var q = JSON.stringify($, function(Z, G) {
          var we = V(G);
          return we === "symbol" ? String(G) : G;
        });
        return new g("Invalid " + j + " `" + A + "` of value `" + String(W) + "` " + ("supplied to `" + re + "`, expected one of " + q + "."));
      }
      return m(F);
    }
    function O($) {
      function F(te, J, re, j, A) {
        if (typeof $ != "function")
          return new g("Property `" + A + "` of component `" + re + "` has invalid PropType notation inside objectOf.");
        var W = te[J], H = Y(W);
        if (H !== "object")
          return new g("Invalid " + j + " `" + A + "` of type " + ("`" + H + "` supplied to `" + re + "`, expected an object."));
        for (var q in W)
          if (r(W, q)) {
            var oe = $(W, q, re, j, A + "." + q, n);
            if (oe instanceof Error)
              return oe;
          }
        return null;
      }
      return m(F);
    }
    function S($) {
      if (!Array.isArray($))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var F = 0; F < $.length; F++) {
        var te = $[F];
        if (typeof te != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + z(te) + " at index " + F + "."
          ), s;
      }
      function J(re, j, A, W, H) {
        for (var q = [], oe = 0; oe < $.length; oe++) {
          var Z = $[oe], G = Z(re, j, A, W, H, n);
          if (G == null)
            return null;
          G.data && r(G.data, "expectedType") && q.push(G.data.expectedType);
        }
        var we = q.length > 0 ? ", expected one of type [" + q.join(", ") + "]" : "";
        return new g("Invalid " + W + " `" + H + "` supplied to " + ("`" + A + "`" + we + "."));
      }
      return m(J);
    }
    function D() {
      function $(F, te, J, re, j) {
        return U(F[te]) ? null : new g("Invalid " + re + " `" + j + "` supplied to " + ("`" + J + "`, expected a ReactNode."));
      }
      return m($);
    }
    function P($, F, te, J, re) {
      return new g(
        ($ || "React class") + ": " + F + " type `" + te + "." + J + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + re + "`."
      );
    }
    function N($) {
      function F(te, J, re, j, A) {
        var W = te[J], H = Y(W);
        if (H !== "object")
          return new g("Invalid " + j + " `" + A + "` of type `" + H + "` " + ("supplied to `" + re + "`, expected `object`."));
        for (var q in $) {
          var oe = $[q];
          if (typeof oe != "function")
            return P(re, j, A, q, V(oe));
          var Z = oe(W, q, re, j, A + "." + q, n);
          if (Z)
            return Z;
        }
        return null;
      }
      return m(F);
    }
    function T($) {
      function F(te, J, re, j, A) {
        var W = te[J], H = Y(W);
        if (H !== "object")
          return new g("Invalid " + j + " `" + A + "` of type `" + H + "` " + ("supplied to `" + re + "`, expected `object`."));
        var q = e({}, te[J], $);
        for (var oe in q) {
          var Z = $[oe];
          if (r($, oe) && typeof Z != "function")
            return P(re, j, A, oe, V(Z));
          if (!Z)
            return new g(
              "Invalid " + j + " `" + A + "` key `" + oe + "` supplied to `" + re + "`.\nBad object: " + JSON.stringify(te[J], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys($), null, "  ")
            );
          var G = Z(W, oe, re, j, A + "." + oe, n);
          if (G)
            return G;
        }
        return null;
      }
      return m(F);
    }
    function U($) {
      switch (typeof $) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !$;
        case "object":
          if (Array.isArray($))
            return $.every(U);
          if ($ === null || a($))
            return !0;
          var F = d($);
          if (F) {
            var te = F.call($), J;
            if (F !== $.entries) {
              for (; !(J = te.next()).done; )
                if (!U(J.value))
                  return !1;
            } else
              for (; !(J = te.next()).done; ) {
                var re = J.value;
                if (re && !U(re[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function R($, F) {
      return $ === "symbol" ? !0 : F ? F["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && F instanceof Symbol : !1;
    }
    function Y($) {
      var F = typeof $;
      return Array.isArray($) ? "array" : $ instanceof RegExp ? "object" : R(F, $) ? "symbol" : F;
    }
    function V($) {
      if (typeof $ > "u" || $ === null)
        return "" + $;
      var F = Y($);
      if (F === "object") {
        if ($ instanceof Date)
          return "date";
        if ($ instanceof RegExp)
          return "regexp";
      }
      return F;
    }
    function z($) {
      var F = V($);
      switch (F) {
        case "array":
        case "object":
          return "an " + F;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + F;
        default:
          return F;
      }
    }
    function ee($) {
      return !$.constructor || !$.constructor.name ? f : $.constructor.name;
    }
    return h.checkPropTypes = o, h.resetWarningCache = o.resetWarningCache, h.PropTypes = h, h;
  }, Js;
}
var ea, Gd;
function l4() {
  if (Gd)
    return ea;
  Gd = 1;
  var t = jl();
  function e() {
  }
  function n() {
  }
  return n.resetWarningCache = e, ea = function() {
    function r(s, a, l, c, u, d) {
      if (d !== t) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: e
    };
    return i.PropTypes = i, i;
  }, ea;
}
if (process.env.NODE_ENV !== "production") {
  var c4 = bg(), u4 = !0;
  Aa.exports = a4()(c4.isElement, u4);
} else
  Aa.exports = l4()();
var d4 = Aa.exports;
const X = /* @__PURE__ */ sv(d4);
var La = { exports: {} }, We = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qd;
function f4() {
  if (qd)
    return We;
  qd = 1;
  var t = 60103, e = 60106, n = 60107, r = 60108, o = 60114, i = 60109, s = 60110, a = 60112, l = 60113, c = 60120, u = 60115, d = 60116, f = 60121, h = 60122, p = 60117, g = 60129, m = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var b = Symbol.for;
    t = b("react.element"), e = b("react.portal"), n = b("react.fragment"), r = b("react.strict_mode"), o = b("react.profiler"), i = b("react.provider"), s = b("react.context"), a = b("react.forward_ref"), l = b("react.suspense"), c = b("react.suspense_list"), u = b("react.memo"), d = b("react.lazy"), f = b("react.block"), h = b("react.server.block"), p = b("react.fundamental"), g = b("react.debug_trace_mode"), m = b("react.legacy_hidden");
  }
  function v(T) {
    if (typeof T == "object" && T !== null) {
      var U = T.$$typeof;
      switch (U) {
        case t:
          switch (T = T.type, T) {
            case n:
            case o:
            case r:
            case l:
            case c:
              return T;
            default:
              switch (T = T && T.$$typeof, T) {
                case s:
                case a:
                case d:
                case u:
                case i:
                  return T;
                default:
                  return U;
              }
          }
        case e:
          return U;
      }
    }
  }
  var _ = i, x = t, y = a, M = n, k = d, O = u, S = e, D = o, P = r, N = l;
  return We.ContextConsumer = s, We.ContextProvider = _, We.Element = x, We.ForwardRef = y, We.Fragment = M, We.Lazy = k, We.Memo = O, We.Portal = S, We.Profiler = D, We.StrictMode = P, We.Suspense = N, We.isAsyncMode = function() {
    return !1;
  }, We.isConcurrentMode = function() {
    return !1;
  }, We.isContextConsumer = function(T) {
    return v(T) === s;
  }, We.isContextProvider = function(T) {
    return v(T) === i;
  }, We.isElement = function(T) {
    return typeof T == "object" && T !== null && T.$$typeof === t;
  }, We.isForwardRef = function(T) {
    return v(T) === a;
  }, We.isFragment = function(T) {
    return v(T) === n;
  }, We.isLazy = function(T) {
    return v(T) === d;
  }, We.isMemo = function(T) {
    return v(T) === u;
  }, We.isPortal = function(T) {
    return v(T) === e;
  }, We.isProfiler = function(T) {
    return v(T) === o;
  }, We.isStrictMode = function(T) {
    return v(T) === r;
  }, We.isSuspense = function(T) {
    return v(T) === l;
  }, We.isValidElementType = function(T) {
    return typeof T == "string" || typeof T == "function" || T === n || T === o || T === g || T === r || T === l || T === c || T === m || typeof T == "object" && T !== null && (T.$$typeof === d || T.$$typeof === u || T.$$typeof === i || T.$$typeof === s || T.$$typeof === a || T.$$typeof === p || T.$$typeof === f || T[0] === h);
  }, We.typeOf = v, We;
}
var He = {};
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xd;
function h4() {
  return Xd || (Xd = 1, process.env.NODE_ENV !== "production" && function() {
    var t = 60103, e = 60106, n = 60107, r = 60108, o = 60114, i = 60109, s = 60110, a = 60112, l = 60113, c = 60120, u = 60115, d = 60116, f = 60121, h = 60122, p = 60117, g = 60129, m = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var b = Symbol.for;
      t = b("react.element"), e = b("react.portal"), n = b("react.fragment"), r = b("react.strict_mode"), o = b("react.profiler"), i = b("react.provider"), s = b("react.context"), a = b("react.forward_ref"), l = b("react.suspense"), c = b("react.suspense_list"), u = b("react.memo"), d = b("react.lazy"), f = b("react.block"), h = b("react.server.block"), p = b("react.fundamental"), b("react.scope"), b("react.opaque.id"), g = b("react.debug_trace_mode"), b("react.offscreen"), m = b("react.legacy_hidden");
    }
    var v = !1;
    function _(Z) {
      return !!(typeof Z == "string" || typeof Z == "function" || Z === n || Z === o || Z === g || Z === r || Z === l || Z === c || Z === m || v || typeof Z == "object" && Z !== null && (Z.$$typeof === d || Z.$$typeof === u || Z.$$typeof === i || Z.$$typeof === s || Z.$$typeof === a || Z.$$typeof === p || Z.$$typeof === f || Z[0] === h));
    }
    function x(Z) {
      if (typeof Z == "object" && Z !== null) {
        var G = Z.$$typeof;
        switch (G) {
          case t:
            var we = Z.type;
            switch (we) {
              case n:
              case o:
              case r:
              case l:
              case c:
                return we;
              default:
                var Pe = we && we.$$typeof;
                switch (Pe) {
                  case s:
                  case a:
                  case d:
                  case u:
                  case i:
                    return Pe;
                  default:
                    return G;
                }
            }
          case e:
            return G;
        }
      }
    }
    var y = s, M = i, k = t, O = a, S = n, D = d, P = u, N = e, T = o, U = r, R = l, Y = !1, V = !1;
    function z(Z) {
      return Y || (Y = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function ee(Z) {
      return V || (V = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function $(Z) {
      return x(Z) === s;
    }
    function F(Z) {
      return x(Z) === i;
    }
    function te(Z) {
      return typeof Z == "object" && Z !== null && Z.$$typeof === t;
    }
    function J(Z) {
      return x(Z) === a;
    }
    function re(Z) {
      return x(Z) === n;
    }
    function j(Z) {
      return x(Z) === d;
    }
    function A(Z) {
      return x(Z) === u;
    }
    function W(Z) {
      return x(Z) === e;
    }
    function H(Z) {
      return x(Z) === o;
    }
    function q(Z) {
      return x(Z) === r;
    }
    function oe(Z) {
      return x(Z) === l;
    }
    He.ContextConsumer = y, He.ContextProvider = M, He.Element = k, He.ForwardRef = O, He.Fragment = S, He.Lazy = D, He.Memo = P, He.Portal = N, He.Profiler = T, He.StrictMode = U, He.Suspense = R, He.isAsyncMode = z, He.isConcurrentMode = ee, He.isContextConsumer = $, He.isContextProvider = F, He.isElement = te, He.isForwardRef = J, He.isFragment = re, He.isLazy = j, He.isMemo = A, He.isPortal = W, He.isProfiler = H, He.isStrictMode = q, He.isSuspense = oe, He.isValidElementType = _, He.typeOf = x;
  }()), He;
}
process.env.NODE_ENV === "production" ? La.exports = f4() : La.exports = h4();
var Zd = La.exports;
let Qd = (t) => typeof t == "object" && t != null && t.nodeType === 1, Jd = (t, e) => (!e || t !== "hidden") && t !== "visible" && t !== "clip", ta = (t, e) => {
  if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
    let n = getComputedStyle(t, null);
    return Jd(n.overflowY, e) || Jd(n.overflowX, e) || ((r) => {
      let o = ((i) => {
        if (!i.ownerDocument || !i.ownerDocument.defaultView)
          return null;
        try {
          return i.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(r);
      return !!o && (o.clientHeight < r.scrollHeight || o.clientWidth < r.scrollWidth);
    })(t);
  }
  return !1;
}, ai = (t, e, n, r, o, i, s, a) => i < t && s > e || i > t && s < e ? 0 : i <= t && a <= n || s >= e && a >= n ? i - t - r : s > e && a < n || i < t && a > n ? s - e + o : 0, p4 = (t) => {
  let e = t.parentElement;
  return e ?? (t.getRootNode().host || null);
};
var g4 = (t, e) => {
  var n, r, o, i, s, a;
  if (typeof document > "u")
    return [];
  let { scrollMode: l, block: c, inline: u, boundary: d, skipOverflowHiddenElements: f } = e, h = typeof d == "function" ? d : (U) => U !== d;
  if (!Qd(t))
    throw new TypeError("Invalid target");
  let p = document.scrollingElement || document.documentElement, g = [], m = t;
  for (; Qd(m) && h(m); ) {
    if (m = p4(m), m === p) {
      g.push(m);
      break;
    }
    m != null && m === document.body && ta(m) && !ta(document.documentElement) || m != null && ta(m, f) && g.push(m);
  }
  let b = (r = (n = window.visualViewport) == null ? void 0 : n.width) != null ? r : innerWidth, v = (i = (o = window.visualViewport) == null ? void 0 : o.height) != null ? i : innerHeight, _ = (s = window.scrollX) != null ? s : pageXOffset, x = (a = window.scrollY) != null ? a : pageYOffset, { height: y, width: M, top: k, right: O, bottom: S, left: D } = t.getBoundingClientRect(), P = c === "start" || c === "nearest" ? k : c === "end" ? S : k + y / 2, N = u === "center" ? D + M / 2 : u === "end" ? O : D, T = [];
  for (let U = 0; U < g.length; U++) {
    let R = g[U], { height: Y, width: V, top: z, right: ee, bottom: $, left: F } = R.getBoundingClientRect();
    if (l === "if-needed" && k >= 0 && D >= 0 && S <= v && O <= b && k >= z && S <= $ && D >= F && O <= ee)
      return T;
    let te = getComputedStyle(R), J = parseInt(te.borderLeftWidth, 10), re = parseInt(te.borderTopWidth, 10), j = parseInt(te.borderRightWidth, 10), A = parseInt(te.borderBottomWidth, 10), W = 0, H = 0, q = "offsetWidth" in R ? R.offsetWidth - R.clientWidth - J - j : 0, oe = "offsetHeight" in R ? R.offsetHeight - R.clientHeight - re - A : 0, Z = "offsetWidth" in R ? R.offsetWidth === 0 ? 0 : V / R.offsetWidth : 0, G = "offsetHeight" in R ? R.offsetHeight === 0 ? 0 : Y / R.offsetHeight : 0;
    if (p === R)
      W = c === "start" ? P : c === "end" ? P - v : c === "nearest" ? ai(x, x + v, v, re, A, x + P, x + P + y, y) : P - v / 2, H = u === "start" ? N : u === "center" ? N - b / 2 : u === "end" ? N - b : ai(_, _ + b, b, J, j, _ + N, _ + N + M, M), W = Math.max(0, W + x), H = Math.max(0, H + _);
    else {
      W = c === "start" ? P - z - re : c === "end" ? P - $ + A + oe : c === "nearest" ? ai(z, $, Y, re, A + oe, P, P + y, y) : P - (z + Y / 2) + oe / 2, H = u === "start" ? N - F - J : u === "center" ? N - (F + V / 2) + q / 2 : u === "end" ? N - ee + j + q : ai(F, ee, V, J, j + q, N, N + M, M);
      let { scrollLeft: we, scrollTop: Pe } = R;
      W = Math.max(0, Math.min(Pe + W / G, R.scrollHeight - Y / G + oe)), H = Math.max(0, Math.min(we + H / Z, R.scrollWidth - V / Z + q)), P += Pe - W, N += we - H;
    }
    T.push({ el: R, top: W, left: H });
  }
  return T;
}, m4 = 0;
function ef(t) {
  return typeof t == "function" ? t : Tt;
}
function Tt() {
}
function wg(t, e) {
  if (t) {
    var n = g4(t, {
      boundary: e,
      block: "nearest",
      scrollMode: "if-needed"
    });
    n.forEach(function(r) {
      var o = r.el, i = r.top, s = r.left;
      o.scrollTop = i, o.scrollLeft = s;
    });
  }
}
function tf(t, e, n) {
  var r = t === e || e instanceof n.Node && t.contains && t.contains(e);
  return r;
}
function zl(t, e) {
  var n;
  function r() {
    n && clearTimeout(n);
  }
  function o() {
    for (var i = arguments.length, s = new Array(i), a = 0; a < i; a++)
      s[a] = arguments[a];
    r(), n = setTimeout(function() {
      n = null, t.apply(void 0, s);
    }, e);
  }
  return o.cancel = r, o;
}
function rt() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return function(r) {
    for (var o = arguments.length, i = new Array(o > 1 ? o - 1 : 0), s = 1; s < o; s++)
      i[s - 1] = arguments[s];
    return e.some(function(a) {
      return a && a.apply(void 0, [r].concat(i)), r.preventDownshiftDefault || r.hasOwnProperty("nativeEvent") && r.nativeEvent.preventDownshiftDefault;
    });
  };
}
function xr() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return function(r) {
    e.forEach(function(o) {
      typeof o == "function" ? o(r) : o && (o.current = r);
    });
  };
}
function xg() {
  return String(m4++);
}
function _g(t) {
  var e = t.isOpen, n = t.resultCount, r = t.previousResultCount;
  return e ? n ? n !== r ? n + " result" + (n === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter key to select." : "" : "No results are available." : "";
}
function nf(t, e) {
  return t = Array.isArray(t) ? (
    /* istanbul ignore next (preact) */
    t[0]
  ) : t, !t && e ? e : t;
}
function Cg(t) {
  return typeof t.type == "string";
}
function Eg(t) {
  return t.props;
}
function v4(t, e) {
  console.error('The property "' + e + '" is required in "' + t + '"');
}
var b4 = ["highlightedIndex", "inputValue", "isOpen", "selectedItem", "type"];
function li(t) {
  t === void 0 && (t = {});
  var e = {};
  return b4.forEach(function(n) {
    t.hasOwnProperty(n) && (e[n] = t[n]);
  }), e;
}
function Ki(t, e) {
  return Object.keys(t).reduce(function(n, r) {
    return n[r] = Gi(e, r) ? e[r] : t[r], n;
  }, {});
}
function Gi(t, e) {
  return t[e] !== void 0;
}
function Fa(t) {
  var e = t.key, n = t.keyCode;
  return n >= 37 && n <= 40 && e.indexOf("Arrow") !== 0 ? "Arrow" + e : e;
}
function y4(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function er(t, e, n, r, o) {
  o === void 0 && (o = !1);
  var i = n.length;
  if (i === 0)
    return -1;
  var s = i - 1;
  (typeof t != "number" || t < 0 || t > s) && (t = e > 0 ? -1 : s + 1);
  var a = t + e;
  a < 0 ? a = o ? s : 0 : a > s && (a = o ? 0 : s);
  var l = $r(a, e < 0, n, r, o);
  return l === -1 ? t >= i ? -1 : t : l;
}
function $r(t, e, n, r, o) {
  o === void 0 && (o = !1);
  var i = n.length;
  if (e) {
    for (var s = t; s >= 0; s--)
      if (!r(n[s], s))
        return s;
  } else
    for (var a = t; a < i; a++)
      if (!r(n[a], a))
        return a;
  return o ? $r(e ? i - 1 : 0, e, n, r) : -1;
}
function qi(t, e, n, r) {
  return r === void 0 && (r = !0), e.some(function(o) {
    return o && (tf(o, t, n) || r && tf(o, n.document.activeElement, n));
  });
}
var Ul = Tt;
process.env.NODE_ENV !== "production" && (Ul = function(e, n, r) {
  var o = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
  Object.keys(e).forEach(function(i) {
    n[i] !== void 0 && r[i] === void 0 ? console.error('downshift: A component has changed the controlled prop "' + i + '" to be uncontrolled. ' + o) : n[i] === void 0 && r[i] !== void 0 && console.error('downshift: A component has changed the uncontrolled prop "' + i + '" to be controlled. ' + o);
  });
});
var w4 = zl(function(t) {
  kg(t).textContent = "";
}, 500);
function Mg(t, e) {
  var n = kg(e);
  t && (n.textContent = t, w4(e));
}
function kg(t) {
  t === void 0 && (t = document);
  var e = t.getElementById("a11y-status-message");
  return e || (e = t.createElement("div"), e.setAttribute("id", "a11y-status-message"), e.setAttribute("role", "status"), e.setAttribute("aria-live", "polite"), e.setAttribute("aria-relevant", "additions text"), Object.assign(e.style, {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px"
  }), t.body.appendChild(e), e);
}
var Og = process.env.NODE_ENV !== "production" ? "__autocomplete_unknown__" : 0, Sg = process.env.NODE_ENV !== "production" ? "__autocomplete_mouseup__" : 1, Pg = process.env.NODE_ENV !== "production" ? "__autocomplete_item_mouseenter__" : 2, xi = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_up__" : 3, _i = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_down__" : 4, Ig = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_escape__" : 5, Tg = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_enter__" : 6, Dg = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_home__" : 7, $g = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_end__" : 8, Ng = process.env.NODE_ENV !== "production" ? "__autocomplete_click_item__" : 9, Rg = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_input__" : 10, Ag = process.env.NODE_ENV !== "production" ? "__autocomplete_change_input__" : 11, Lg = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_space_button__" : 12, Va = process.env.NODE_ENV !== "production" ? "__autocomplete_click_button__" : 13, Fg = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_button__" : 14, Vg = process.env.NODE_ENV !== "production" ? "__autocomplete_controlled_prop_updated_selected_item__" : 15, Wg = process.env.NODE_ENV !== "production" ? "__autocomplete_touchend__" : 16, x4 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  unknown: Og,
  mouseUp: Sg,
  itemMouseEnter: Pg,
  keyDownArrowUp: xi,
  keyDownArrowDown: _i,
  keyDownEscape: Ig,
  keyDownEnter: Tg,
  keyDownHome: Dg,
  keyDownEnd: $g,
  clickItem: Ng,
  blurInput: Rg,
  changeInput: Ag,
  keyDownSpaceButton: Lg,
  clickButton: Va,
  blurButton: Fg,
  controlledPropUpdatedSelectedItem: Vg,
  touchEnd: Wg
}), _4 = ["refKey", "ref"], C4 = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"], E4 = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"], M4 = ["refKey", "ref"], k4 = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"], O4 = /* @__PURE__ */ function() {
  var t = /* @__PURE__ */ function(e) {
    n4(n, e);
    function n(o) {
      var i;
      i = e.call(this, o) || this, i.id = i.props.id || "downshift-" + xg(), i.menuId = i.props.menuId || i.id + "-menu", i.labelId = i.props.labelId || i.id + "-label", i.inputId = i.props.inputId || i.id + "-input", i.getItemId = i.props.getItemId || function(v) {
        return i.id + "-item-" + v;
      }, i.input = null, i.items = [], i.itemCount = null, i.previousResultCount = 0, i.timeoutIds = [], i.internalSetTimeout = function(v, _) {
        var x = setTimeout(function() {
          i.timeoutIds = i.timeoutIds.filter(function(y) {
            return y !== x;
          }), v();
        }, _);
        i.timeoutIds.push(x);
      }, i.setItemCount = function(v) {
        i.itemCount = v;
      }, i.unsetItemCount = function() {
        i.itemCount = null;
      }, i.isItemDisabled = function(v, _) {
        var x = i.getItemNodeFromIndex(_);
        return x && x.hasAttribute("disabled");
      }, i.setHighlightedIndex = function(v, _) {
        v === void 0 && (v = i.props.defaultHighlightedIndex), _ === void 0 && (_ = {}), _ = li(_), i.internalSetState(ve({
          highlightedIndex: v
        }, _));
      }, i.clearSelection = function(v) {
        i.internalSetState({
          selectedItem: null,
          inputValue: "",
          highlightedIndex: i.props.defaultHighlightedIndex,
          isOpen: i.props.defaultIsOpen
        }, v);
      }, i.selectItem = function(v, _, x) {
        _ = li(_), i.internalSetState(ve({
          isOpen: i.props.defaultIsOpen,
          highlightedIndex: i.props.defaultHighlightedIndex,
          selectedItem: v,
          inputValue: i.props.itemToString(v)
        }, _), x);
      }, i.selectItemAtIndex = function(v, _, x) {
        var y = i.items[v];
        y != null && i.selectItem(y, _, x);
      }, i.selectHighlightedItem = function(v, _) {
        return i.selectItemAtIndex(i.getState().highlightedIndex, v, _);
      }, i.internalSetState = function(v, _) {
        var x, y, M = {}, k = typeof v == "function";
        return !k && v.hasOwnProperty("inputValue") && i.props.onInputValueChange(v.inputValue, ve({}, i.getStateAndHelpers(), v)), i.setState(function(O) {
          O = i.getState(O);
          var S = k ? v(O) : v;
          S = i.props.stateReducer(O, S), x = S.hasOwnProperty("selectedItem");
          var D = {};
          return x && S.selectedItem !== O.selectedItem && (y = S.selectedItem), S.type = S.type || Og, Object.keys(S).forEach(function(P) {
            O[P] !== S[P] && (M[P] = S[P]), P !== "type" && (S[P], Gi(i.props, P) || (D[P] = S[P]));
          }), k && S.hasOwnProperty("inputValue") && i.props.onInputValueChange(S.inputValue, ve({}, i.getStateAndHelpers(), S)), D;
        }, function() {
          ef(_)();
          var O = Object.keys(M).length > 1;
          O && i.props.onStateChange(M, i.getStateAndHelpers()), x && i.props.onSelect(v.selectedItem, i.getStateAndHelpers()), y !== void 0 && i.props.onChange(y, i.getStateAndHelpers()), i.props.onUserAction(M, i.getStateAndHelpers());
        });
      }, i.rootRef = function(v) {
        return i._rootNode = v;
      }, i.getRootProps = function(v, _) {
        var x, y = v === void 0 ? {} : v, M = y.refKey, k = M === void 0 ? "ref" : M, O = y.ref, S = nn(y, _4), D = _ === void 0 ? {} : _, P = D.suppressRefError, N = P === void 0 ? !1 : P;
        i.getRootProps.called = !0, i.getRootProps.refKey = k, i.getRootProps.suppressRefError = N;
        var T = i.getState(), U = T.isOpen;
        return ve((x = {}, x[k] = xr(O, i.rootRef), x.role = "combobox", x["aria-expanded"] = U, x["aria-haspopup"] = "listbox", x["aria-owns"] = U ? i.menuId : void 0, x["aria-labelledby"] = i.labelId, x), S);
      }, i.keyDownHandlers = {
        ArrowDown: function(_) {
          var x = this;
          if (_.preventDefault(), this.getState().isOpen) {
            var y = _.shiftKey ? 5 : 1;
            this.moveHighlightedIndex(y, {
              type: _i
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: _i
            }, function() {
              var M = x.getItemCount();
              if (M > 0) {
                var k = x.getState(), O = k.highlightedIndex, S = er(O, 1, {
                  length: M
                }, x.isItemDisabled, !0);
                x.setHighlightedIndex(S, {
                  type: _i
                });
              }
            });
        },
        ArrowUp: function(_) {
          var x = this;
          if (_.preventDefault(), this.getState().isOpen) {
            var y = _.shiftKey ? -5 : -1;
            this.moveHighlightedIndex(y, {
              type: xi
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: xi
            }, function() {
              var M = x.getItemCount();
              if (M > 0) {
                var k = x.getState(), O = k.highlightedIndex, S = er(O, -1, {
                  length: M
                }, x.isItemDisabled, !0);
                x.setHighlightedIndex(S, {
                  type: xi
                });
              }
            });
        },
        Enter: function(_) {
          if (_.which !== 229) {
            var x = this.getState(), y = x.isOpen, M = x.highlightedIndex;
            if (y && M != null) {
              _.preventDefault();
              var k = this.items[M], O = this.getItemNodeFromIndex(M);
              if (k == null || O && O.hasAttribute("disabled"))
                return;
              this.selectHighlightedItem({
                type: Tg
              });
            }
          }
        },
        Escape: function(_) {
          _.preventDefault(), this.reset(ve({
            type: Ig
          }, !this.state.isOpen && {
            selectedItem: null,
            inputValue: ""
          }));
        }
      }, i.buttonKeyDownHandlers = ve({}, i.keyDownHandlers, {
        " ": function(_) {
          _.preventDefault(), this.toggleMenu({
            type: Lg
          });
        }
      }), i.inputKeyDownHandlers = ve({}, i.keyDownHandlers, {
        Home: function(_) {
          var x = this.getState(), y = x.isOpen;
          if (y) {
            _.preventDefault();
            var M = this.getItemCount();
            if (!(M <= 0 || !y)) {
              var k = $r(0, !1, {
                length: M
              }, this.isItemDisabled);
              this.setHighlightedIndex(k, {
                type: Dg
              });
            }
          }
        },
        End: function(_) {
          var x = this.getState(), y = x.isOpen;
          if (y) {
            _.preventDefault();
            var M = this.getItemCount();
            if (!(M <= 0 || !y)) {
              var k = $r(M - 1, !0, {
                length: M
              }, this.isItemDisabled);
              this.setHighlightedIndex(k, {
                type: $g
              });
            }
          }
        }
      }), i.getToggleButtonProps = function(v) {
        var _ = v === void 0 ? {} : v, x = _.onClick;
        _.onPress;
        var y = _.onKeyDown, M = _.onKeyUp, k = _.onBlur, O = nn(_, C4), S = i.getState(), D = S.isOpen, P = {
          onClick: rt(x, i.buttonHandleClick),
          onKeyDown: rt(y, i.buttonHandleKeyDown),
          onKeyUp: rt(M, i.buttonHandleKeyUp),
          onBlur: rt(k, i.buttonHandleBlur)
        }, N = O.disabled ? {} : P;
        return ve({
          type: "button",
          role: "button",
          "aria-label": D ? "close menu" : "open menu",
          "aria-haspopup": !0,
          "data-toggle": !0
        }, N, O);
      }, i.buttonHandleKeyUp = function(v) {
        v.preventDefault();
      }, i.buttonHandleKeyDown = function(v) {
        var _ = Fa(v);
        i.buttonKeyDownHandlers[_] && i.buttonKeyDownHandlers[_].call(Vd(i), v);
      }, i.buttonHandleClick = function(v) {
        v.preventDefault(), i.props.environment.document.activeElement === i.props.environment.document.body && v.target.focus(), process.env.NODE_ENV === "test" ? i.toggleMenu({
          type: Va
        }) : i.internalSetTimeout(function() {
          return i.toggleMenu({
            type: Va
          });
        });
      }, i.buttonHandleBlur = function(v) {
        var _ = v.target;
        i.internalSetTimeout(function() {
          !i.isMouseDown && (i.props.environment.document.activeElement == null || i.props.environment.document.activeElement.id !== i.inputId) && i.props.environment.document.activeElement !== _ && i.reset({
            type: Fg
          });
        });
      }, i.getLabelProps = function(v) {
        return ve({
          htmlFor: i.inputId,
          id: i.labelId
        }, v);
      }, i.getInputProps = function(v) {
        var _ = v === void 0 ? {} : v, x = _.onKeyDown, y = _.onBlur, M = _.onChange, k = _.onInput;
        _.onChangeText;
        var O = nn(_, E4), S, D = {};
        S = "onChange";
        var P = i.getState(), N = P.inputValue, T = P.isOpen, U = P.highlightedIndex;
        if (!O.disabled) {
          var R;
          D = (R = {}, R[S] = rt(M, k, i.inputHandleChange), R.onKeyDown = rt(x, i.inputHandleKeyDown), R.onBlur = rt(y, i.inputHandleBlur), R);
        }
        return ve({
          "aria-autocomplete": "list",
          "aria-activedescendant": T && typeof U == "number" && U >= 0 ? i.getItemId(U) : void 0,
          "aria-controls": T ? i.menuId : void 0,
          "aria-labelledby": O && O["aria-label"] ? void 0 : i.labelId,
          // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
          // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
          autoComplete: "off",
          value: N,
          id: i.inputId
        }, D, O);
      }, i.inputHandleKeyDown = function(v) {
        var _ = Fa(v);
        _ && i.inputKeyDownHandlers[_] && i.inputKeyDownHandlers[_].call(Vd(i), v);
      }, i.inputHandleChange = function(v) {
        i.internalSetState({
          type: Ag,
          isOpen: !0,
          inputValue: v.target.value,
          highlightedIndex: i.props.defaultHighlightedIndex
        });
      }, i.inputHandleBlur = function() {
        i.internalSetTimeout(function() {
          var v = i.props.environment.document && !!i.props.environment.document.activeElement && !!i.props.environment.document.activeElement.dataset && i.props.environment.document.activeElement.dataset.toggle && i._rootNode && i._rootNode.contains(i.props.environment.document.activeElement);
          !i.isMouseDown && !v && i.reset({
            type: Rg
          });
        });
      }, i.menuRef = function(v) {
        i._menuNode = v;
      }, i.getMenuProps = function(v, _) {
        var x, y = v === void 0 ? {} : v, M = y.refKey, k = M === void 0 ? "ref" : M, O = y.ref, S = nn(y, M4), D = _ === void 0 ? {} : _, P = D.suppressRefError, N = P === void 0 ? !1 : P;
        return i.getMenuProps.called = !0, i.getMenuProps.refKey = k, i.getMenuProps.suppressRefError = N, ve((x = {}, x[k] = xr(O, i.menuRef), x.role = "listbox", x["aria-labelledby"] = S && S["aria-label"] ? void 0 : i.labelId, x.id = i.menuId, x), S);
      }, i.getItemProps = function(v) {
        var _, x = v === void 0 ? {} : v, y = x.onMouseMove, M = x.onMouseDown, k = x.onClick;
        x.onPress;
        var O = x.index, S = x.item, D = S === void 0 ? process.env.NODE_ENV === "production" ? (
          /* istanbul ignore next */
          void 0
        ) : v4("getItemProps", "item") : S, P = nn(x, k4);
        O === void 0 ? (i.items.push(D), O = i.items.indexOf(D)) : i.items[O] = D;
        var N = "onClick", T = k, U = (_ = {
          // onMouseMove is used over onMouseEnter here. onMouseMove
          // is only triggered on actual mouse movement while onMouseEnter
          // can fire on DOM changes, interrupting keyboard navigation
          onMouseMove: rt(y, function() {
            O !== i.getState().highlightedIndex && (i.setHighlightedIndex(O, {
              type: Pg
            }), i.avoidScrolling = !0, i.internalSetTimeout(function() {
              return i.avoidScrolling = !1;
            }, 250));
          }),
          onMouseDown: rt(M, function(Y) {
            Y.preventDefault();
          })
        }, _[N] = rt(T, function() {
          i.selectItemAtIndex(O, {
            type: Ng
          });
        }), _), R = P.disabled ? {
          onMouseDown: U.onMouseDown
        } : U;
        return ve({
          id: i.getItemId(O),
          role: "option",
          "aria-selected": i.getState().highlightedIndex === O
        }, R, P);
      }, i.clearItems = function() {
        i.items = [];
      }, i.reset = function(v, _) {
        v === void 0 && (v = {}), v = li(v), i.internalSetState(function(x) {
          var y = x.selectedItem;
          return ve({
            isOpen: i.props.defaultIsOpen,
            highlightedIndex: i.props.defaultHighlightedIndex,
            inputValue: i.props.itemToString(y)
          }, v);
        }, _);
      }, i.toggleMenu = function(v, _) {
        v === void 0 && (v = {}), v = li(v), i.internalSetState(function(x) {
          var y = x.isOpen;
          return ve({
            isOpen: !y
          }, y && {
            highlightedIndex: i.props.defaultHighlightedIndex
          }, v);
        }, function() {
          var x = i.getState(), y = x.isOpen, M = x.highlightedIndex;
          y && i.getItemCount() > 0 && typeof M == "number" && i.setHighlightedIndex(M, v), ef(_)();
        });
      }, i.openMenu = function(v) {
        i.internalSetState({
          isOpen: !0
        }, v);
      }, i.closeMenu = function(v) {
        i.internalSetState({
          isOpen: !1
        }, v);
      }, i.updateStatus = zl(function() {
        var v = i.getState(), _ = i.items[v.highlightedIndex], x = i.getItemCount(), y = i.props.getA11yStatusMessage(ve({
          itemToString: i.props.itemToString,
          previousResultCount: i.previousResultCount,
          resultCount: x,
          highlightedItem: _
        }, v));
        i.previousResultCount = x, Mg(y, i.props.environment.document);
      }, 200);
      var s = i.props, a = s.defaultHighlightedIndex, l = s.initialHighlightedIndex, c = l === void 0 ? a : l, u = s.defaultIsOpen, d = s.initialIsOpen, f = d === void 0 ? u : d, h = s.initialInputValue, p = h === void 0 ? "" : h, g = s.initialSelectedItem, m = g === void 0 ? null : g, b = i.getState({
        highlightedIndex: c,
        isOpen: f,
        inputValue: p,
        selectedItem: m
      });
      return b.selectedItem != null && i.props.initialInputValue === void 0 && (b.inputValue = i.props.itemToString(b.selectedItem)), i.state = b, i;
    }
    var r = n.prototype;
    return r.internalClearTimeouts = function() {
      this.timeoutIds.forEach(function(i) {
        clearTimeout(i);
      }), this.timeoutIds = [];
    }, r.getState = function(i) {
      return i === void 0 && (i = this.state), Ki(i, this.props);
    }, r.getItemCount = function() {
      var i = this.items.length;
      return this.itemCount != null ? i = this.itemCount : this.props.itemCount !== void 0 && (i = this.props.itemCount), i;
    }, r.getItemNodeFromIndex = function(i) {
      return this.props.environment.document.getElementById(this.getItemId(i));
    }, r.scrollHighlightedItemIntoView = function() {
      {
        var i = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(i, this._menuNode);
      }
    }, r.moveHighlightedIndex = function(i, s) {
      var a = this.getItemCount(), l = this.getState(), c = l.highlightedIndex;
      if (a > 0) {
        var u = er(c, i, {
          length: a
        }, this.isItemDisabled, !0);
        this.setHighlightedIndex(u, s);
      }
    }, r.getStateAndHelpers = function() {
      var i = this.getState(), s = i.highlightedIndex, a = i.inputValue, l = i.selectedItem, c = i.isOpen, u = this.props.itemToString, d = this.id, f = this.getRootProps, h = this.getToggleButtonProps, p = this.getLabelProps, g = this.getMenuProps, m = this.getInputProps, b = this.getItemProps, v = this.openMenu, _ = this.closeMenu, x = this.toggleMenu, y = this.selectItem, M = this.selectItemAtIndex, k = this.selectHighlightedItem, O = this.setHighlightedIndex, S = this.clearSelection, D = this.clearItems, P = this.reset, N = this.setItemCount, T = this.unsetItemCount, U = this.internalSetState;
      return {
        // prop getters
        getRootProps: f,
        getToggleButtonProps: h,
        getLabelProps: p,
        getMenuProps: g,
        getInputProps: m,
        getItemProps: b,
        // actions
        reset: P,
        openMenu: v,
        closeMenu: _,
        toggleMenu: x,
        selectItem: y,
        selectItemAtIndex: M,
        selectHighlightedItem: k,
        setHighlightedIndex: O,
        clearSelection: S,
        clearItems: D,
        setItemCount: N,
        unsetItemCount: T,
        setState: U,
        // props
        itemToString: u,
        // derived
        id: d,
        // state
        highlightedIndex: s,
        inputValue: a,
        isOpen: c,
        selectedItem: l
      };
    }, r.componentDidMount = function() {
      var i = this;
      process.env.NODE_ENV !== "production" && this.getMenuProps.called && !this.getMenuProps.suppressRefError && rf(this._menuNode, this.getMenuProps);
      {
        var s = function() {
          i.isMouseDown = !0;
        }, a = function(h) {
          i.isMouseDown = !1;
          var p = qi(h.target, [i._rootNode, i._menuNode], i.props.environment);
          !p && i.getState().isOpen && i.reset({
            type: Sg
          }, function() {
            return i.props.onOuterClick(i.getStateAndHelpers());
          });
        }, l = function() {
          i.isTouchMove = !1;
        }, c = function() {
          i.isTouchMove = !0;
        }, u = function(h) {
          var p = qi(h.target, [i._rootNode, i._menuNode], i.props.environment, !1);
          !i.isTouchMove && !p && i.getState().isOpen && i.reset({
            type: Wg
          }, function() {
            return i.props.onOuterClick(i.getStateAndHelpers());
          });
        }, d = this.props.environment;
        d.addEventListener("mousedown", s), d.addEventListener("mouseup", a), d.addEventListener("touchstart", l), d.addEventListener("touchmove", c), d.addEventListener("touchend", u), this.cleanup = function() {
          i.internalClearTimeouts(), i.updateStatus.cancel(), d.removeEventListener("mousedown", s), d.removeEventListener("mouseup", a), d.removeEventListener("touchstart", l), d.removeEventListener("touchmove", c), d.removeEventListener("touchend", u);
        };
      }
    }, r.shouldScroll = function(i, s) {
      var a = this.props.highlightedIndex === void 0 ? this.getState() : this.props, l = a.highlightedIndex, c = s.highlightedIndex === void 0 ? i : s, u = c.highlightedIndex, d = l && this.getState().isOpen && !i.isOpen, f = l !== u;
      return d || f;
    }, r.componentDidUpdate = function(i, s) {
      process.env.NODE_ENV !== "production" && (Ul(this.state, i, this.props), this.getMenuProps.called && !this.getMenuProps.suppressRefError && rf(this._menuNode, this.getMenuProps)), Gi(this.props, "selectedItem") && this.props.selectedItemChanged(i.selectedItem, this.props.selectedItem) && this.internalSetState({
        type: Vg,
        inputValue: this.props.itemToString(this.props.selectedItem)
      }), !this.avoidScrolling && this.shouldScroll(s, i) && this.scrollHighlightedItemIntoView(), this.updateStatus();
    }, r.componentWillUnmount = function() {
      this.cleanup();
    }, r.render = function() {
      var i = nf(this.props.children, Tt);
      this.clearItems(), this.getRootProps.called = !1, this.getRootProps.refKey = void 0, this.getRootProps.suppressRefError = void 0, this.getMenuProps.called = !1, this.getMenuProps.refKey = void 0, this.getMenuProps.suppressRefError = void 0, this.getLabelProps.called = !1, this.getInputProps.called = !1;
      var s = nf(i(this.getStateAndHelpers()));
      if (!s)
        return null;
      if (this.getRootProps.called || this.props.suppressRefError)
        return process.env.NODE_ENV !== "production" && !this.getRootProps.suppressRefError && !this.props.suppressRefError && S4(s, this.getRootProps), s;
      if (Cg(s))
        return /* @__PURE__ */ Qi(s, this.getRootProps(Eg(s)));
      if (process.env.NODE_ENV !== "production")
        throw new Error("downshift: If you return a non-DOM element, you must apply the getRootProps function");
    }, n;
  }(ov);
  return t.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: !1,
    getA11yStatusMessage: _g,
    itemToString: function(n) {
      return n == null ? "" : (process.env.NODE_ENV !== "production" && y4(n) && !n.hasOwnProperty("toString") && console.warn("downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.", "The object that was passed:", n), String(n));
    },
    onStateChange: Tt,
    onInputValueChange: Tt,
    onUserAction: Tt,
    onChange: Tt,
    onSelect: Tt,
    onOuterClick: Tt,
    selectedItemChanged: function(n, r) {
      return n !== r;
    },
    environment: (
      /* istanbul ignore next (ssr) */
      typeof window > "u" ? {} : window
    ),
    stateReducer: function(n, r) {
      return r;
    },
    suppressRefError: !1,
    scrollIntoView: wg
  }, t.stateChangeTypes = x4, t;
}();
process.env.NODE_ENV !== "production" && (O4.propTypes = {
  children: X.func,
  defaultHighlightedIndex: X.number,
  defaultIsOpen: X.bool,
  initialHighlightedIndex: X.number,
  initialSelectedItem: X.any,
  initialInputValue: X.string,
  initialIsOpen: X.bool,
  getA11yStatusMessage: X.func,
  itemToString: X.func,
  onChange: X.func,
  onSelect: X.func,
  onStateChange: X.func,
  onInputValueChange: X.func,
  onUserAction: X.func,
  onOuterClick: X.func,
  selectedItemChanged: X.func,
  stateReducer: X.func,
  itemCount: X.number,
  id: X.string,
  environment: X.shape({
    addEventListener: X.func.isRequired,
    removeEventListener: X.func.isRequired,
    document: X.shape({
      createElement: X.func.isRequired,
      getElementById: X.func.isRequired,
      activeElement: X.any.isRequired,
      body: X.any.isRequired
    }).isRequired,
    Node: X.func.isRequired
  }),
  suppressRefError: X.bool,
  scrollIntoView: X.func,
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components
  /* eslint-disable react/no-unused-prop-types */
  selectedItem: X.any,
  isOpen: X.bool,
  inputValue: X.string,
  highlightedIndex: X.number,
  labelId: X.string,
  inputId: X.string,
  menuId: X.string,
  getItemId: X.func
  /* eslint-enable react/no-unused-prop-types */
});
function rf(t, e) {
  var n = e.refKey;
  t || console.error('downshift: The ref prop "' + n + '" from getMenuProps was not applied correctly on your menu element.');
}
function S4(t, e) {
  var n = e.refKey, r = n !== "ref", o = !Cg(t);
  o && !r && !Zd.isForwardRef(t) ? console.error("downshift: You returned a non-DOM element. You must specify a refKey in getRootProps") : !o && r && console.error('downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified "' + n + '"'), !Zd.isForwardRef(t) && !Eg(t)[n] && console.error('downshift: You must apply the ref prop "' + n + '" from getRootProps onto your root element.');
}
var P4 = ["isInitialMount", "highlightedIndex", "items", "environment"], Hg = {
  highlightedIndex: -1,
  isOpen: !1,
  selectedItem: null,
  inputValue: ""
};
function I4(t, e, n) {
  var r = t.props, o = t.type, i = {};
  Object.keys(e).forEach(function(s) {
    T4(s, t, e, n), n[s] !== e[s] && (i[s] = n[s]);
  }), r.onStateChange && Object.keys(i).length && r.onStateChange(ve({
    type: o
  }, i));
}
function T4(t, e, n, r) {
  var o = e.props, i = e.type, s = "on" + Yl(t) + "Change";
  o[s] && r[t] !== void 0 && r[t] !== n[t] && o[s](ve({
    type: i
  }, r));
}
function D4(t, e) {
  return e.changes;
}
function $4(t) {
  var e = t.selectedItem, n = t.itemToString;
  return e ? n(e) + " has been selected." : "";
}
var N4 = zl(function(t, e) {
  Mg(t(), e);
}, 200), R4 = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? Ji : ue, A4 = "useId" in I ? function(e) {
  var n = e.id, r = e.labelId, o = e.menuId, i = e.getItemId, s = e.toggleButtonId, a = e.inputId, l = "downshift-" + I.useId();
  n || (n = l);
  var c = ae({
    labelId: r || n + "-label",
    menuId: o || n + "-menu",
    getItemId: i || function(u) {
      return n + "-item-" + u;
    },
    toggleButtonId: s || n + "-toggle-button",
    inputId: a || n + "-input"
  });
  return c.current;
} : function(e) {
  var n = e.id, r = n === void 0 ? "downshift-" + xg() : n, o = e.labelId, i = e.menuId, s = e.getItemId, a = e.toggleButtonId, l = e.inputId, c = ae({
    labelId: o || r + "-label",
    menuId: i || r + "-menu",
    getItemId: s || function(u) {
      return r + "-item-" + u;
    },
    toggleButtonId: a || r + "-toggle-button",
    inputId: l || r + "-input"
  });
  return c.current;
};
function L4(t, e, n, r) {
  var o, i;
  if (t === void 0) {
    if (e === void 0)
      throw new Error(r);
    o = n[e], i = e;
  } else
    i = e === void 0 ? n.indexOf(t) : e, o = t;
  return [o, i];
}
function F4(t) {
  return t ? String(t) : "";
}
function Yl(t) {
  return "" + t.slice(0, 1).toUpperCase() + t.slice(1);
}
function Bg(t) {
  var e = ae(t);
  return e.current = t, e;
}
function V4(t, e, n) {
  var r = ae(), o = ae(), i = pe(function(f, h) {
    o.current = h, f = Ki(f, h.props);
    var p = t(f, h), g = h.props.stateReducer(f, ve({}, h, {
      changes: p
    }));
    return g;
  }, [t]), s = mf(i, e), a = s[0], l = s[1], c = Bg(n), u = pe(function(f) {
    return l(ve({
      props: c.current
    }, f));
  }, [c]), d = o.current;
  return ue(function() {
    d && r.current && r.current !== a && I4(d, Ki(r.current, d.props), a), r.current = a;
  }, [a, n, d]), [a, u];
}
var co = {
  itemToString: F4,
  stateReducer: D4,
  getA11ySelectionMessage: $4,
  scrollIntoView: wg,
  environment: (
    /* istanbul ignore next (ssr) */
    typeof window > "u" ? {} : window
  )
};
function rn(t, e, n) {
  n === void 0 && (n = Hg);
  var r = t["default" + Yl(e)];
  return r !== void 0 ? r : n[e];
}
function no(t, e, n) {
  n === void 0 && (n = Hg);
  var r = t[e];
  if (r !== void 0)
    return r;
  var o = t["initial" + Yl(e)];
  return o !== void 0 ? o : rn(t, e, n);
}
function W4(t) {
  var e = no(t, "selectedItem"), n = no(t, "isOpen"), r = no(t, "highlightedIndex"), o = no(t, "inputValue");
  return {
    highlightedIndex: r < 0 && e && n ? t.items.indexOf(e) : r,
    isOpen: n,
    selectedItem: e,
    inputValue: o
  };
}
function uo(t, e, n) {
  var r = t.items, o = t.initialHighlightedIndex, i = t.defaultHighlightedIndex, s = e.selectedItem, a = e.highlightedIndex;
  return r.length === 0 ? -1 : o !== void 0 && a === o ? o : i !== void 0 ? i : s ? r.indexOf(s) : n === 0 ? -1 : n < 0 ? r.length - 1 : 0;
}
function H4(t, e, n, r) {
  var o = ae({
    isMouseDown: !1,
    isTouchMove: !1
  });
  return ue(function() {
    if ((n == null ? void 0 : n.addEventListener) != null) {
      var i = function() {
        o.current.isMouseDown = !0;
      }, s = function(d) {
        o.current.isMouseDown = !1, t && !qi(d.target, e.map(function(f) {
          return f.current;
        }), n) && r();
      }, a = function() {
        o.current.isTouchMove = !1;
      }, l = function() {
        o.current.isTouchMove = !0;
      }, c = function(d) {
        t && !o.current.isTouchMove && !qi(d.target, e.map(function(f) {
          return f.current;
        }), n, !1) && r();
      };
      return n.addEventListener("mousedown", i), n.addEventListener("mouseup", s), n.addEventListener("touchstart", a), n.addEventListener("touchmove", l), n.addEventListener("touchend", c), function() {
        n.removeEventListener("mousedown", i), n.removeEventListener("mouseup", s), n.removeEventListener("touchstart", a), n.removeEventListener("touchmove", l), n.removeEventListener("touchend", c);
      };
    }
  }, [t, n]), o;
}
var jg = function() {
  return Tt;
};
process.env.NODE_ENV !== "production" && (jg = function() {
  for (var e = ae(!0), n = arguments.length, r = new Array(n), o = 0; o < n; o++)
    r[o] = arguments[o];
  var i = ae(r.reduce(function(a, l) {
    return a[l] = {}, a;
  }, {}));
  ue(function() {
    Object.keys(i.current).forEach(function(a) {
      var l = i.current[a];
      if (e.current && !Object.keys(l).length) {
        console.error("downshift: You forgot to call the " + a + " getter function on your component / element.");
        return;
      }
      var c = l.suppressRefError, u = l.refKey, d = l.elementRef;
      (!d || !d.current) && !c && console.error('downshift: The ref prop "' + u + '" from ' + a + " was not applied correctly on your element.");
    }), e.current = !1;
  });
  var s = pe(function(a, l, c, u) {
    i.current[a] = {
      suppressRefError: l,
      refKey: c,
      elementRef: u
    };
  }, []);
  return s;
});
function of(t, e, n) {
  var r = n.isInitialMount, o = n.highlightedIndex, i = n.items, s = n.environment, a = nn(n, P4);
  ue(function() {
    r || N4(function() {
      return t(ve({
        highlightedIndex: o,
        highlightedItem: i[o],
        resultCount: i.length
      }, a));
    }, s.document);
  }, e);
}
function B4(t) {
  var e = t.highlightedIndex, n = t.isOpen, r = t.itemRefs, o = t.getItemNodeFromIndex, i = t.menuElement, s = t.scrollIntoView, a = ae(!0);
  return R4(function() {
    e < 0 || !n || !Object.keys(r.current).length || (a.current === !1 ? a.current = !0 : s(o(e), i));
  }, [e]), a;
}
var zg = Tt;
process.env.NODE_ENV !== "production" && (zg = function(e) {
  var n = e.isInitialMount, r = e.props, o = e.state, i = ae(r);
  ue(function() {
    n || (Ul(o, i.current, r), i.current = r);
  }, [o, r, n]);
});
function sf(t, e, n) {
  var r;
  n === void 0 && (n = !0);
  var o = ((r = t.items) == null ? void 0 : r.length) && e >= 0;
  return ve({
    isOpen: !1,
    highlightedIndex: -1
  }, o && ve({
    selectedItem: t.items[e],
    isOpen: rn(t, "isOpen"),
    highlightedIndex: rn(t, "highlightedIndex")
  }, n && {
    inputValue: t.itemToString(t.items[e])
  }));
}
var Ug = {
  environment: X.shape({
    addEventListener: X.func.isRequired,
    removeEventListener: X.func.isRequired,
    document: X.shape({
      createElement: X.func.isRequired,
      getElementById: X.func.isRequired,
      activeElement: X.any.isRequired,
      body: X.any.isRequired
    }).isRequired,
    Node: X.func.isRequired
  }),
  itemToString: X.func,
  stateReducer: X.func
}, Yg = ve({}, Ug, {
  getA11yStatusMessage: X.func,
  highlightedIndex: X.number,
  defaultHighlightedIndex: X.number,
  initialHighlightedIndex: X.number,
  isOpen: X.bool,
  defaultIsOpen: X.bool,
  initialIsOpen: X.bool,
  selectedItem: X.any,
  initialSelectedItem: X.any,
  defaultSelectedItem: X.any,
  id: X.string,
  labelId: X.string,
  menuId: X.string,
  getItemId: X.func,
  toggleButtonId: X.string,
  onSelectedItemChange: X.func,
  onHighlightedIndexChange: X.func,
  onStateChange: X.func,
  onIsOpenChange: X.func,
  scrollIntoView: X.func
});
function j4(t, e, n) {
  var r = e.type, o = e.props, i;
  switch (r) {
    case n.ItemMouseMove:
      i = {
        highlightedIndex: e.disabled ? -1 : e.index
      };
      break;
    case n.MenuMouseLeave:
      i = {
        highlightedIndex: -1
      };
      break;
    case n.ToggleButtonClick:
    case n.FunctionToggleMenu:
      i = {
        isOpen: !t.isOpen,
        highlightedIndex: t.isOpen ? -1 : uo(o, t, 0)
      };
      break;
    case n.FunctionOpenMenu:
      i = {
        isOpen: !0,
        highlightedIndex: uo(o, t, 0)
      };
      break;
    case n.FunctionCloseMenu:
      i = {
        isOpen: !1
      };
      break;
    case n.FunctionSetHighlightedIndex:
      i = {
        highlightedIndex: e.highlightedIndex
      };
      break;
    case n.FunctionSetInputValue:
      i = {
        inputValue: e.inputValue
      };
      break;
    case n.FunctionReset:
      i = {
        highlightedIndex: rn(o, "highlightedIndex"),
        isOpen: rn(o, "isOpen"),
        selectedItem: rn(o, "selectedItem"),
        inputValue: rn(o, "inputValue")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return ve({}, t, i);
}
yt(yt({}, Yg), { items: X.array.isRequired, isItemDisabled: X.func, getA11ySelectionMessage: X.func });
function z4(t) {
  var e = t.isOpen, n = t.resultCount, r = t.previousResultCount;
  return e ? n ? n !== r ? "".concat(n, " result").concat(n === 1 ? " is" : "s are", " available, use up and down arrow keys to navigate. Press Enter or Space Bar keys to select.") : "" : "No results are available." : "";
}
yt(yt({}, co), { getA11yStatusMessage: z4, isItemDisabled: function() {
  return !1;
} });
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
var Kl = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_down__" : 0, Gl = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_up__" : 1, ql = process.env.NODE_ENV !== "production" ? "__input_keydown_escape__" : 2, Xl = process.env.NODE_ENV !== "production" ? "__input_keydown_home__" : 3, Zl = process.env.NODE_ENV !== "production" ? "__input_keydown_end__" : 4, Ql = process.env.NODE_ENV !== "production" ? "__input_keydown_page_up__" : 5, Jl = process.env.NODE_ENV !== "production" ? "__input_keydown_page_down__" : 6, ec = process.env.NODE_ENV !== "production" ? "__input_keydown_enter__" : 7, tc = process.env.NODE_ENV !== "production" ? "__input_change__" : 8, Xi = process.env.NODE_ENV !== "production" ? "__input_blur__" : 9, nc = process.env.NODE_ENV !== "production" ? "__input_click__" : 10, Kg = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 11, Gg = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 12, rc = process.env.NODE_ENV !== "production" ? "__item_click__" : 13, qg = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 14, Xg = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 15, Zg = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 16, Qg = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 17, Jg = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 18, oc = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 19, em = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 20, tm = process.env.NODE_ENV !== "production" ? "__function_reset__" : 21, ic = process.env.NODE_ENV !== "production" ? "__controlled_prop_updated_selected_item__" : 22, nm = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  InputKeyDownArrowDown: Kl,
  InputKeyDownArrowUp: Gl,
  InputKeyDownEscape: ql,
  InputKeyDownHome: Xl,
  InputKeyDownEnd: Zl,
  InputKeyDownPageUp: Ql,
  InputKeyDownPageDown: Jl,
  InputKeyDownEnter: ec,
  InputChange: tc,
  InputBlur: Xi,
  InputClick: nc,
  MenuMouseLeave: Kg,
  ItemMouseMove: Gg,
  ItemClick: rc,
  ToggleButtonClick: qg,
  FunctionToggleMenu: Xg,
  FunctionOpenMenu: Zg,
  FunctionCloseMenu: Qg,
  FunctionSetHighlightedIndex: Jg,
  FunctionSelectItem: oc,
  FunctionSetInputValue: em,
  FunctionReset: tm,
  ControlledPropUpdatedSelectedItem: ic
});
function U4(t) {
  var e = W4(t), n = e.selectedItem, r = e.inputValue;
  return r === "" && n && t.defaultInputValue === void 0 && t.initialInputValue === void 0 && t.inputValue === void 0 && (r = t.itemToString(n)), ve({}, e, {
    inputValue: r
  });
}
var Y4 = ve({}, Yg, {
  items: X.array.isRequired,
  isItemDisabled: X.func,
  selectedItemChanged: X.func,
  getA11ySelectionMessage: X.func,
  inputValue: X.string,
  defaultInputValue: X.string,
  initialInputValue: X.string,
  inputId: X.string,
  onInputValueChange: X.func
});
function K4(t, e, n) {
  var r = ae(), o = V4(t, e, n), i = o[0], s = o[1];
  return ue(function() {
    Gi(n, "selectedItem") && (n.selectedItemChanged(r.current, n.selectedItem) && s({
      type: ic,
      inputValue: n.itemToString(n.selectedItem)
    }), r.current = i.selectedItem === r.current ? n.selectedItem : i.selectedItem);
  }, [i.selectedItem, n.selectedItem]), [Ki(i, n), s];
}
var rm = Tt;
process.env.NODE_ENV !== "production" && (rm = function(e, n) {
  X.checkPropTypes(Y4, e, "prop", n.name);
});
var G4 = ve({}, co, {
  selectedItemChanged: function(e, n) {
    return e !== n;
  },
  getA11yStatusMessage: _g,
  isItemDisabled: function() {
    return !1;
  }
});
function q4(t, e) {
  var n, r = e.type, o = e.props, i = e.altKey, s;
  switch (r) {
    case rc:
      s = {
        isOpen: rn(o, "isOpen"),
        highlightedIndex: rn(o, "highlightedIndex"),
        selectedItem: o.items[e.index],
        inputValue: o.itemToString(o.items[e.index])
      };
      break;
    case Kl:
      t.isOpen ? s = {
        highlightedIndex: er(t.highlightedIndex, 1, o.items, o.isItemDisabled, !0)
      } : s = {
        highlightedIndex: i && t.selectedItem == null ? -1 : uo(o, t, 1),
        isOpen: o.items.length >= 0
      };
      break;
    case Gl:
      t.isOpen ? i ? s = sf(o, t.highlightedIndex) : s = {
        highlightedIndex: er(t.highlightedIndex, -1, o.items, o.isItemDisabled, !0)
      } : s = {
        highlightedIndex: uo(o, t, -1),
        isOpen: o.items.length >= 0
      };
      break;
    case ec:
      s = sf(o, t.highlightedIndex);
      break;
    case ql:
      s = ve({
        isOpen: !1,
        highlightedIndex: -1
      }, !t.isOpen && {
        selectedItem: null,
        inputValue: ""
      });
      break;
    case Ql:
      s = {
        highlightedIndex: er(t.highlightedIndex, -10, o.items, o.isItemDisabled, !0)
      };
      break;
    case Jl:
      s = {
        highlightedIndex: er(t.highlightedIndex, 10, o.items, o.isItemDisabled, !0)
      };
      break;
    case Xl:
      s = {
        highlightedIndex: $r(0, !1, o.items, o.isItemDisabled)
      };
      break;
    case Zl:
      s = {
        highlightedIndex: $r(o.items.length - 1, !0, o.items, o.isItemDisabled)
      };
      break;
    case Xi:
      s = ve({
        isOpen: !1,
        highlightedIndex: -1
      }, t.highlightedIndex >= 0 && ((n = o.items) == null ? void 0 : n.length) && e.selectItem && {
        selectedItem: o.items[t.highlightedIndex],
        inputValue: o.itemToString(o.items[t.highlightedIndex])
      });
      break;
    case tc:
      s = {
        isOpen: !0,
        highlightedIndex: rn(o, "highlightedIndex"),
        inputValue: e.inputValue
      };
      break;
    case nc:
      s = {
        isOpen: !t.isOpen,
        highlightedIndex: t.isOpen ? -1 : uo(o, t, 0)
      };
      break;
    case oc:
      s = {
        selectedItem: e.selectedItem,
        inputValue: o.itemToString(e.selectedItem)
      };
      break;
    case ic:
      s = {
        inputValue: e.inputValue
      };
      break;
    default:
      return j4(t, e, nm);
  }
  return ve({}, t, s);
}
var X4 = ["onMouseLeave", "refKey", "ref"], Z4 = ["item", "index", "refKey", "ref", "onMouseMove", "onMouseDown", "onClick", "onPress", "disabled"], Q4 = ["onClick", "onPress", "refKey", "ref"], J4 = ["onKeyDown", "onChange", "onInput", "onBlur", "onChangeText", "onClick", "refKey", "ref"];
ot.stateChangeTypes = nm;
function ot(t) {
  t === void 0 && (t = {}), rm(t, ot);
  var e = ve({}, G4, t), n = e.items, r = e.scrollIntoView, o = e.environment, i = e.getA11yStatusMessage, s = e.getA11ySelectionMessage, a = e.itemToString, l = U4(e), c = K4(q4, l, e), u = c[0], d = c[1], f = u.isOpen, h = u.highlightedIndex, p = u.selectedItem, g = u.inputValue, m = ae(null), b = ae({}), v = ae(null), _ = ae(null), x = ae(!0), y = A4(e), M = ae(), k = Bg({
    state: u,
    props: e
  }), O = pe(function(j) {
    return b.current[y.getItemId(j)];
  }, [y]);
  of(i, [f, h, g, n], ve({
    isInitialMount: x.current,
    previousResultCount: M.current,
    items: n,
    environment: o,
    itemToString: a
  }, u)), of(s, [p], ve({
    isInitialMount: x.current,
    previousResultCount: M.current,
    items: n,
    environment: o,
    itemToString: a
  }, u));
  var S = B4({
    menuElement: m.current,
    highlightedIndex: h,
    isOpen: f,
    itemRefs: b,
    scrollIntoView: r,
    getItemNodeFromIndex: O
  });
  zg({
    isInitialMount: x.current,
    props: e,
    state: u
  }), ue(function() {
    var j = no(e, "isOpen");
    j && v.current && v.current.focus();
  }, []), ue(function() {
    x.current || (M.current = n.length);
  });
  var D = H4(f, [v, m, _], o, function() {
    d({
      type: Xi,
      selectItem: !1
    });
  }), P = jg("getInputProps", "getMenuProps");
  ue(function() {
    return x.current = !1, function() {
      x.current = !0;
    };
  }, []), ue(function() {
    var j;
    if (!f)
      b.current = {};
    else if (((j = o.document) == null ? void 0 : j.activeElement) !== v.current) {
      var A;
      v == null || (A = v.current) == null || A.focus();
    }
  }, [f, o]);
  var N = Rn(function() {
    return {
      ArrowDown: function(A) {
        A.preventDefault(), d({
          type: Kl,
          altKey: A.altKey
        });
      },
      ArrowUp: function(A) {
        A.preventDefault(), d({
          type: Gl,
          altKey: A.altKey
        });
      },
      Home: function(A) {
        k.current.state.isOpen && (A.preventDefault(), d({
          type: Xl
        }));
      },
      End: function(A) {
        k.current.state.isOpen && (A.preventDefault(), d({
          type: Zl
        }));
      },
      Escape: function(A) {
        var W = k.current.state;
        (W.isOpen || W.inputValue || W.selectedItem || W.highlightedIndex > -1) && (A.preventDefault(), d({
          type: ql
        }));
      },
      Enter: function(A) {
        var W = k.current.state;
        !W.isOpen || A.which === 229 || (A.preventDefault(), d({
          type: ec
        }));
      },
      PageUp: function(A) {
        k.current.state.isOpen && (A.preventDefault(), d({
          type: Ql
        }));
      },
      PageDown: function(A) {
        k.current.state.isOpen && (A.preventDefault(), d({
          type: Jl
        }));
      }
    };
  }, [d, k]), T = pe(function(j) {
    return ve({
      id: y.labelId,
      htmlFor: y.inputId
    }, j);
  }, [y]), U = pe(function(j, A) {
    var W, H = j === void 0 ? {} : j, q = H.onMouseLeave, oe = H.refKey, Z = oe === void 0 ? "ref" : oe, G = H.ref, we = nn(H, X4), Pe = A === void 0 ? {} : A, Re = Pe.suppressRefError, ct = Re === void 0 ? !1 : Re;
    return P("getMenuProps", ct, Z, m), ve((W = {}, W[Z] = xr(G, function(ut) {
      m.current = ut;
    }), W.id = y.menuId, W.role = "listbox", W["aria-labelledby"] = we && we["aria-label"] ? void 0 : "" + y.labelId, W.onMouseLeave = rt(q, function() {
      d({
        type: Kg
      });
    }), W), we);
  }, [d, P, y]), R = pe(function(j) {
    var A, W, H = j === void 0 ? {} : j, q = H.item, oe = H.index, Z = H.refKey, G = Z === void 0 ? "ref" : Z, we = H.ref, Pe = H.onMouseMove, Re = H.onMouseDown, ct = H.onClick;
    H.onPress;
    var ut = H.disabled, Gt = nn(H, Z4);
    ut !== void 0 && console.warn('Passing "disabled" as an argument to getItemProps is not supported anymore. Please use the isItemDisabled prop from useCombobox.');
    var gt = k.current, xt = gt.props, at = gt.state, xn = L4(q, oe, xt.items, "Pass either item or index to getItemProps!"), Fr = xn[0], Wt = xn[1], _n = xt.isItemDisabled(Fr, Wt), fr = "onClick", qt = ct, Xt = function() {
      Wt !== at.highlightedIndex && (S.current = !1, d({
        type: Gg,
        index: Wt,
        disabled: _n
      }));
    }, Zt = function() {
      d({
        type: rc,
        index: Wt
      });
    }, Ht = function(ys) {
      return ys.preventDefault();
    };
    return ve((A = {}, A[G] = xr(we, function(dt) {
      dt && (b.current[y.getItemId(Wt)] = dt);
    }), A["aria-disabled"] = _n, A["aria-selected"] = "" + (Wt === at.highlightedIndex), A.id = y.getItemId(Wt), A.role = "option", A), !_n && (W = {}, W[fr] = rt(qt, Zt), W), {
      onMouseMove: rt(Pe, Xt),
      onMouseDown: rt(Re, Ht)
    }, Gt);
  }, [d, k, S, y]), Y = pe(function(j) {
    var A, W = j === void 0 ? {} : j, H = W.onClick;
    W.onPress;
    var q = W.refKey, oe = q === void 0 ? "ref" : q, Z = W.ref, G = nn(W, Q4), we = k.current.state, Pe = function() {
      d({
        type: qg
      });
    };
    return ve((A = {}, A[oe] = xr(Z, function(Re) {
      _.current = Re;
    }), A["aria-controls"] = y.menuId, A["aria-expanded"] = we.isOpen, A.id = y.toggleButtonId, A.tabIndex = -1, A), !G.disabled && ve({}, {
      onClick: rt(H, Pe)
    }), G);
  }, [d, k, y]), V = pe(function(j, A) {
    var W, H = j === void 0 ? {} : j, q = H.onKeyDown, oe = H.onChange, Z = H.onInput, G = H.onBlur;
    H.onChangeText;
    var we = H.onClick, Pe = H.refKey, Re = Pe === void 0 ? "ref" : Pe, ct = H.ref, ut = nn(H, J4), Gt = A === void 0 ? {} : A, gt = Gt.suppressRefError, xt = gt === void 0 ? !1 : gt;
    P("getInputProps", xt, Re, v);
    var at = k.current.state, xn = function(Ht) {
      var dt = Fa(Ht);
      dt && N[dt] && N[dt](Ht);
    }, Fr = function(Ht) {
      d({
        type: tc,
        inputValue: Ht.target.value
      });
    }, Wt = function(Ht) {
      if (at.isOpen && !D.current.isMouseDown) {
        var dt = Ht.relatedTarget === null && o.document.activeElement !== o.document.body;
        d({
          type: Xi,
          selectItem: !dt
        });
      }
    }, _n = function() {
      d({
        type: nc
      });
    }, fr = "onChange", qt = {};
    if (!ut.disabled) {
      var Xt;
      qt = (Xt = {}, Xt[fr] = rt(oe, Z, Fr), Xt.onKeyDown = rt(q, xn), Xt.onBlur = rt(G, Wt), Xt.onClick = rt(we, _n), Xt);
    }
    return ve((W = {}, W[Re] = xr(ct, function(Zt) {
      v.current = Zt;
    }), W["aria-activedescendant"] = at.isOpen && at.highlightedIndex > -1 ? y.getItemId(at.highlightedIndex) : "", W["aria-autocomplete"] = "list", W["aria-controls"] = y.menuId, W["aria-expanded"] = at.isOpen, W["aria-labelledby"] = ut && ut["aria-label"] ? void 0 : y.labelId, W.autoComplete = "off", W.id = y.inputId, W.role = "combobox", W.value = at.inputValue, W), qt, ut);
  }, [P, k, y, N, d, D, o]), z = pe(function() {
    d({
      type: Xg
    });
  }, [d]), ee = pe(function() {
    d({
      type: Qg
    });
  }, [d]), $ = pe(function() {
    d({
      type: Zg
    });
  }, [d]), F = pe(function(j) {
    d({
      type: Jg,
      highlightedIndex: j
    });
  }, [d]), te = pe(function(j) {
    d({
      type: oc,
      selectedItem: j
    });
  }, [d]), J = pe(function(j) {
    d({
      type: em,
      inputValue: j
    });
  }, [d]), re = pe(function() {
    d({
      type: tm
    });
  }, [d]);
  return {
    // prop getters.
    getItemProps: R,
    getLabelProps: T,
    getMenuProps: U,
    getInputProps: V,
    getToggleButtonProps: Y,
    // actions.
    toggleMenu: z,
    openMenu: $,
    closeMenu: ee,
    setHighlightedIndex: F,
    setInputValue: J,
    selectItem: te,
    reset: re,
    // state.
    highlightedIndex: h,
    isOpen: f,
    selectedItem: p,
    inputValue: g
  };
}
function eM(t) {
  var e = t.removedSelectedItem, n = t.itemToString;
  return n(e) + " has been removed.";
}
ve({}, Ug, {
  selectedItems: X.array,
  initialSelectedItems: X.array,
  defaultSelectedItems: X.array,
  getA11yRemovalMessage: X.func,
  activeIndex: X.number,
  initialActiveIndex: X.number,
  defaultActiveIndex: X.number,
  onActiveIndexChange: X.func,
  onSelectedItemsChange: X.func,
  keyNavigationNext: X.string,
  keyNavigationPrevious: X.string
});
co.itemToString, co.stateReducer, co.environment;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
function Zr(t, e, n) {
  let r = n.initialDeps ?? [], o;
  return () => {
    var i, s, a, l;
    let c;
    n.key && ((i = n.debug) != null && i.call(n)) && (c = Date.now());
    const u = t();
    if (!(u.length !== r.length || u.some((h, p) => r[p] !== h)))
      return o;
    r = u;
    let f;
    if (n.key && ((s = n.debug) != null && s.call(n)) && (f = Date.now()), o = e(...u), n.key && ((a = n.debug) != null && a.call(n))) {
      const h = Math.round((Date.now() - c) * 100) / 100, p = Math.round((Date.now() - f) * 100) / 100, g = p / 16, m = (b, v) => {
        for (b = String(b); b.length < v; )
          b = " " + b;
        return b;
      };
      console.info(
        `%c⏱ ${m(p, 5)} /${m(h, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * g, 120)
        )}deg 100% 31%);`,
        n == null ? void 0 : n.key
      );
    }
    return (l = n == null ? void 0 : n.onChange) == null || l.call(n, o), o;
  };
}
function na(t, e) {
  if (t === void 0)
    throw new Error(`Unexpected undefined${e ? `: ${e}` : ""}`);
  return t;
}
const tM = (t, e) => Math.abs(t - e) < 1, nM = (t, e, n) => {
  let r;
  return function(...o) {
    t.clearTimeout(r), r = t.setTimeout(() => e.apply(this, o), n);
  };
}, rM = (t) => t, oM = (t) => {
  const e = Math.max(t.startIndex - t.overscan, 0), n = Math.min(t.endIndex + t.overscan, t.count - 1), r = [];
  for (let o = e; o <= n; o++)
    r.push(o);
  return r;
}, iM = (t, e) => {
  const n = t.scrollElement;
  if (!n)
    return;
  const r = t.targetWindow;
  if (!r)
    return;
  const o = (s) => {
    const { width: a, height: l } = s;
    e({ width: Math.round(a), height: Math.round(l) });
  };
  if (o(n.getBoundingClientRect()), !r.ResizeObserver)
    return () => {
    };
  const i = new r.ResizeObserver((s) => {
    const a = s[0];
    if (a != null && a.borderBoxSize) {
      const l = a.borderBoxSize[0];
      if (l) {
        o({ width: l.inlineSize, height: l.blockSize });
        return;
      }
    }
    o(n.getBoundingClientRect());
  });
  return i.observe(n, { box: "border-box" }), () => {
    i.unobserve(n);
  };
}, af = {
  passive: !0
}, sM = typeof window > "u" ? !0 : "onscrollend" in window, aM = (t, e) => {
  const n = t.scrollElement;
  if (!n)
    return;
  const r = t.targetWindow;
  if (!r)
    return;
  let o = 0;
  const i = sM ? () => {
  } : nM(
    r,
    () => {
      e(o, !1);
    },
    t.options.isScrollingResetDelay
  ), s = (c) => () => {
    o = n[t.options.horizontal ? "scrollLeft" : "scrollTop"], i(), e(o, c);
  }, a = s(!0), l = s(!1);
  return l(), n.addEventListener("scroll", a, af), n.addEventListener("scrollend", l, af), () => {
    n.removeEventListener("scroll", a), n.removeEventListener("scrollend", l);
  };
}, lM = (t, e, n) => {
  if (e != null && e.borderBoxSize) {
    const r = e.borderBoxSize[0];
    if (r)
      return Math.round(
        r[n.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return Math.round(
    t.getBoundingClientRect()[n.options.horizontal ? "width" : "height"]
  );
}, cM = (t, {
  adjustments: e = 0,
  behavior: n
}, r) => {
  var o, i;
  const s = t + e;
  (i = (o = r.scrollElement) == null ? void 0 : o.scrollTo) == null || i.call(o, {
    [r.options.horizontal ? "left" : "top"]: s,
    behavior: n
  });
};
class uM {
  constructor(e) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let n = null;
      const r = () => n || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : n = new this.targetWindow.ResizeObserver((o) => {
        o.forEach((i) => {
          this._measureElement(i.target, i);
        });
      }));
      return {
        disconnect: () => {
          var o;
          return (o = r()) == null ? void 0 : o.disconnect();
        },
        observe: (o) => {
          var i;
          return (i = r()) == null ? void 0 : i.observe(o, { box: "border-box" });
        },
        unobserve: (o) => {
          var i;
          return (i = r()) == null ? void 0 : i.unobserve(o);
        }
      };
    })(), this.range = null, this.setOptions = (n) => {
      Object.entries(n).forEach(([r, o]) => {
        typeof o > "u" && delete n[r];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: rM,
        rangeExtractor: oM,
        onChange: () => {
        },
        measureElement: lM,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        ...n
      };
    }, this.notify = (n, r) => {
      var o, i;
      const { startIndex: s, endIndex: a } = this.range ?? {
        startIndex: void 0,
        endIndex: void 0
      }, l = this.calculateRange();
      (n || s !== (l == null ? void 0 : l.startIndex) || a !== (l == null ? void 0 : l.endIndex)) && ((i = (o = this.options).onChange) == null || i.call(o, this, r));
    }, this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((n) => n()), this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.observer.disconnect(), this.elementsCache.clear();
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var n;
      const r = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== r) {
        if (this.cleanup(), !r) {
          this.notify(!1, !1);
          return;
        }
        this.scrollElement = r, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((n = this.scrollElement) == null ? void 0 : n.window) ?? null, this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        }), this.unsubs.push(
          this.options.observeElementRect(this, (o) => {
            this.scrollRect = o, this.notify(!1, !1);
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (o, i) => {
            this.scrollAdjustments = 0, this.scrollDirection = i ? this.getScrollOffset() < o ? "forward" : "backward" : null, this.scrollOffset = o;
            const s = this.isScrolling;
            this.isScrolling = i, this.notify(s !== i, i);
          })
        );
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (n, r) => {
      const o = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
      for (let s = r - 1; s >= 0; s--) {
        const a = n[s];
        if (o.has(a.lane))
          continue;
        const l = i.get(
          a.lane
        );
        if (l == null || a.end > l.end ? i.set(a.lane, a) : a.end < l.end && o.set(a.lane, !0), o.size === this.options.lanes)
          break;
      }
      return i.size === this.options.lanes ? Array.from(i.values()).sort((s, a) => s.end === a.end ? s.index - a.index : s.end - a.end)[0] : void 0;
    }, this.getMeasurementOptions = Zr(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled
      ],
      (n, r, o, i, s) => (this.pendingMeasuredCacheIndexes = [], {
        count: n,
        paddingStart: r,
        scrollMargin: o,
        getItemKey: i,
        enabled: s
      }),
      {
        key: !1
      }
    ), this.getMeasurements = Zr(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: n, paddingStart: r, scrollMargin: o, getItemKey: i, enabled: s }, a) => {
        var l;
        if (!s)
          return this.measurementsCache = [], this.itemSizeCache.clear(), [];
        this.measurementsCache.length === 0 && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((d) => {
          this.itemSizeCache.set(d.key, d.size);
        }));
        const c = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const u = this.measurementsCache.slice(0, c);
        for (let d = c; d < n; d++) {
          let f = (l = this.measurementsCache[d]) == null ? void 0 : l.measureElement;
          f || (f = (x) => {
            const y = i(d), M = this.elementsCache.get(y);
            if (!x) {
              M && (this.observer.unobserve(M), this.elementsCache.delete(y));
              return;
            }
            M !== x && (M && this.observer.unobserve(M), this.observer.observe(x), this.elementsCache.set(y, x)), x.isConnected && this.resizeItem(
              d,
              this.options.measureElement(x, void 0, this)
            );
          });
          const h = i(d), p = this.options.lanes === 1 ? u[d - 1] : this.getFurthestMeasurement(u, d), g = p ? p.end + this.options.gap : r + o, m = a.get(h), b = typeof m == "number" ? m : this.options.estimateSize(d), v = g + b, _ = p ? p.lane : d % this.options.lanes;
          u[d] = {
            index: d,
            start: g,
            size: b,
            end: v,
            key: h,
            lane: _,
            measureElement: f
          };
        }
        return this.measurementsCache = u, u;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = Zr(
      () => [this.getMeasurements(), this.getSize(), this.getScrollOffset()],
      (n, r, o) => this.range = n.length > 0 && r > 0 ? dM({
        measurements: n,
        outerSize: r,
        scrollOffset: o
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getIndexes = Zr(
      () => [
        this.options.rangeExtractor,
        this.calculateRange(),
        this.options.overscan,
        this.options.count
      ],
      (n, r, o, i) => r === null ? [] : n({
        startIndex: r.startIndex,
        endIndex: r.endIndex,
        overscan: o,
        count: i
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (n) => {
      const r = this.options.indexAttribute, o = n.getAttribute(r);
      return o ? parseInt(o, 10) : (console.warn(
        `Missing attribute name '${r}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (n, r) => {
      const o = this.indexFromElement(n), i = this.getMeasurements()[o];
      if (!i || !n.isConnected) {
        this.elementsCache.forEach((a, l) => {
          a === n && (this.observer.unobserve(n), this.elementsCache.delete(l));
        });
        return;
      }
      const s = this.elementsCache.get(i.key);
      s !== n && (s && this.observer.unobserve(s), this.observer.observe(n), this.elementsCache.set(i.key, n)), this.resizeItem(o, this.options.measureElement(n, r, this));
    }, this.resizeItem = (n, r) => {
      const o = this.getMeasurements()[n];
      if (!o)
        return;
      const i = this.itemSizeCache.get(o.key) ?? o.size, s = r - i;
      s !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(o, s, this) : o.start < this.getScrollOffset() + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", s), this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += s,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(o.index), this.itemSizeCache = new Map(this.itemSizeCache.set(o.key, r)), this.notify(!0, !1));
    }, this.measureElement = (n) => {
      n && this._measureElement(n, void 0);
    }, this.getVirtualItems = Zr(
      () => [this.getIndexes(), this.getMeasurements()],
      (n, r) => {
        const o = [];
        for (let i = 0, s = n.length; i < s; i++) {
          const a = n[i], l = r[a];
          o.push(l);
        }
        return o;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getIndexes",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (n) => {
      const r = this.getMeasurements();
      if (r.length !== 0)
        return na(
          r[om(
            0,
            r.length - 1,
            (o) => na(r[o]).start,
            n
          )]
        );
    }, this.getOffsetForAlignment = (n, r) => {
      const o = this.getSize(), i = this.getScrollOffset();
      r === "auto" && (n <= i ? r = "start" : n >= i + o ? r = "end" : r = "start"), r === "start" ? n = n : r === "end" ? n = n - o : r === "center" && (n = n - o / 2);
      const s = this.options.horizontal ? "scrollWidth" : "scrollHeight", l = (this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[s] : this.scrollElement[s] : 0) - o;
      return Math.max(Math.min(l, n), 0);
    }, this.getOffsetForIndex = (n, r = "auto") => {
      n = Math.max(0, Math.min(n, this.options.count - 1));
      const o = this.getMeasurements()[n];
      if (!o)
        return;
      const i = this.getSize(), s = this.getScrollOffset();
      if (r === "auto")
        if (o.end >= s + i - this.options.scrollPaddingEnd)
          r = "end";
        else if (o.start <= s + this.options.scrollPaddingStart)
          r = "start";
        else
          return [s, r];
      const a = r === "end" ? o.end + this.options.scrollPaddingEnd : o.start - this.options.scrollPaddingStart;
      return [this.getOffsetForAlignment(a, r), r];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.cancelScrollToIndex = () => {
      this.scrollToIndexTimeoutId !== null && this.targetWindow && (this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId), this.scrollToIndexTimeoutId = null);
    }, this.scrollToOffset = (n, { align: r = "start", behavior: o } = {}) => {
      this.cancelScrollToIndex(), o === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(n, r), {
        adjustments: void 0,
        behavior: o
      });
    }, this.scrollToIndex = (n, { align: r = "auto", behavior: o } = {}) => {
      n = Math.max(0, Math.min(n, this.options.count - 1)), this.cancelScrollToIndex(), o === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      );
      const i = this.getOffsetForIndex(n, r);
      if (!i)
        return;
      const [s, a] = i;
      this._scrollToOffset(s, { adjustments: void 0, behavior: o }), o !== "smooth" && this.isDynamicMode() && this.targetWindow && (this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(() => {
        if (this.scrollToIndexTimeoutId = null, this.elementsCache.has(
          this.options.getItemKey(n)
        )) {
          const [c] = na(
            this.getOffsetForIndex(n, a)
          );
          tM(c, this.getScrollOffset()) || this.scrollToIndex(n, { align: a, behavior: o });
        } else
          this.scrollToIndex(n, { align: a, behavior: o });
      }));
    }, this.scrollBy = (n, { behavior: r } = {}) => {
      this.cancelScrollToIndex(), r === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + n, {
        adjustments: void 0,
        behavior: r
      });
    }, this.getTotalSize = () => {
      var n;
      const r = this.getMeasurements();
      let o;
      return r.length === 0 ? o = this.options.paddingStart : o = this.options.lanes === 1 ? ((n = r[r.length - 1]) == null ? void 0 : n.end) ?? 0 : Math.max(
        ...r.slice(-this.options.lanes).map((i) => i.end)
      ), o - this.options.scrollMargin + this.options.paddingEnd;
    }, this._scrollToOffset = (n, {
      adjustments: r,
      behavior: o
    }) => {
      this.options.scrollToFn(n, { behavior: o, adjustments: r }, this);
    }, this.measure = () => {
      var n, r;
      this.itemSizeCache = /* @__PURE__ */ new Map(), (r = (n = this.options).onChange) == null || r.call(n, this, !1);
    }, this.setOptions(e);
  }
}
const om = (t, e, n, r) => {
  for (; t <= e; ) {
    const o = (t + e) / 2 | 0, i = n(o);
    if (i < r)
      t = o + 1;
    else if (i > r)
      e = o - 1;
    else
      return o;
  }
  return t > 0 ? t - 1 : 0;
};
function dM({
  measurements: t,
  outerSize: e,
  scrollOffset: n
}) {
  const r = t.length - 1, i = om(0, r, (a) => t[a].start, n);
  let s = i;
  for (; s < r && t[s].end < n + e; )
    s++;
  return { startIndex: i, endIndex: s };
}
const fM = typeof document < "u" ? C.useLayoutEffect : C.useEffect;
function hM(t) {
  const e = C.useReducer(() => ({}), {})[1], n = {
    ...t,
    onChange: (o, i) => {
      var s;
      i ? Ua(e) : e(), (s = t.onChange) == null || s.call(t, o, i);
    }
  }, [r] = C.useState(
    () => new uM(n)
  );
  return r.setOptions(n), C.useEffect(() => r._didMount(), []), fM(() => r._willUpdate()), r;
}
function im(t) {
  return hM({
    observeElementRect: iM,
    observeElementOffset: aM,
    scrollToFn: cM,
    ...t
  });
}
function sm({
  items: t,
  inputValue: e,
  onInputValueChange: n,
  isItemDisabled: r
}) {
  const {
    isOpen: o,
    selected: i,
    onSelect: s,
    displayedValueKey: a,
    multiple: l,
    withConfirmation: c,
    setIsOpen: u,
    resettable: d = !0
  } = wn(), [f, h] = C.useState(i), p = C.useRef(null), g = im({
    count: t.length,
    getScrollElement: () => p.current,
    estimateSize: C.useCallback(() => 36, []),
    overscan: 5,
    paddingStart: 4,
    paddingEnd: 4,
    scrollPaddingEnd: 4,
    scrollPaddingStart: 4,
    gap: 2,
    getItemKey: C.useCallback((v) => t[v][0], [t]),
    enabled: o
  }), m = c ? f : i;
  return {
    ...ot({
      isOpen: !0,
      inputValue: e,
      onInputValueChange: ({ inputValue: v }) => n(v ?? ""),
      onIsOpenChange: ({ isOpen: v, type: _ }) => {
        _ !== ot.stateChangeTypes.InputBlur && u(!!v);
      },
      items: t,
      itemToString: (v) => v != null && v[1] ? a ? v[1][a] : v[1] : "",
      selectedItem: m,
      onSelectedItemChange: ({ selectedItem: v }) => {
        if (!l) {
          c ? h(v) : s(v);
          return;
        }
        const _ = m.findIndex(
          ([y]) => y === (v == null ? void 0 : v[0])
        ), x = c ? h : s;
        _ > 0 ? x([
          ...m.slice(0, _),
          ...m.slice(_ + 1)
        ]) : x(_ === 0 ? [...m.slice(1)] : [...m, v]);
      },
      ...r ? { isItemDisabled: r } : void 0,
      stateReducer: C.useMemo(
        () => l || c ? gM : pM({ resettable: d }),
        [l, c, d]
      ),
      scrollIntoView() {
      },
      onHighlightedIndexChange: ({ highlightedIndex: v, type: _ }) => {
        _ !== ot.stateChangeTypes.MenuMouseLeave && v !== void 0 && g.scrollToIndex(v);
      }
    }),
    selectedItem: m,
    resetSelectionBuffer: () => h([]),
    virtualizer: g,
    listRef: p
  };
}
const pM = ({ resettable: t }) => (e, n) => {
  var i;
  const { changes: r, type: o } = n;
  switch (o) {
    case ot.stateChangeTypes.ControlledPropUpdatedSelectedItem:
      return {
        ...r,
        inputValue: ""
        // reset input value on popover opening
      };
    case ot.stateChangeTypes.InputKeyDownEnter:
    case ot.stateChangeTypes.ItemClick:
      return t ? {
        ...r,
        selectedItem: ((i = e.selectedItem) == null ? void 0 : i[0]) === r.selectedItem[0] ? [] : r.selectedItem
      } : r;
    case ot.stateChangeTypes.InputBlur:
      return {
        ...r,
        selectedItem: e.selectedItem,
        // don't select on blur
        highlightedIndex: e.highlightedIndex,
        inputValue: e.inputValue
      };
    case ot.stateChangeTypes.InputClick:
      return {
        ...r,
        isOpen: !0
      };
    default:
      return r;
  }
}, gM = (t, e) => {
  const { changes: n, type: r } = e;
  switch (r) {
    case ot.stateChangeTypes.ControlledPropUpdatedSelectedItem:
      return {
        ...n,
        inputValue: t.inputValue || ""
      };
    case ot.stateChangeTypes.InputKeyDownEnter:
    case ot.stateChangeTypes.ItemClick:
      return {
        ...n,
        isOpen: !0,
        // keep dropdown open after selection
        highlightedIndex: t.highlightedIndex,
        // keep highlighted index position
        inputValue: t.inputValue
        // keep search query
      };
    case ot.stateChangeTypes.InputBlur:
      return {
        ...n,
        selectedItem: t.selectedItem,
        // don't select on blur
        highlightedIndex: t.highlightedIndex,
        inputValue: t.inputValue
      };
    case ot.stateChangeTypes.InputClick:
      return {
        ...n,
        isOpen: !0
      };
    default:
      return n;
  }
}, r8 = (t) => {
  var r;
  const [e, n] = C.useState(!1);
  return /* @__PURE__ */ w(
    vg.Provider,
    {
      value: {
        ...t,
        withConfirmation: t.withConfirmation,
        setIsOpen: n,
        isOpen: e
      },
      children: /* @__PURE__ */ B(ZE, { open: e, onOpenChange: n, children: [
        /* @__PURE__ */ w(mM, { ref: t.triggerRef }),
        /* @__PURE__ */ B(
          e4,
          {
            sideOffset: 6,
            collisionPadding: 10,
            ...t.contentProps,
            className: he(
              `line
            z-10
            flex max-h-[min(var(--radix-popover-content-available-height),26rem)]
             w-[var(--radix-popover-content-available-width)]
           max-w-[max(var(--radix-popover-trigger-width),_16rem)] flex-col overflow-hidden
          rounded-md
          bg-foundations-default py-1 shadow-2`,
              (r = t.contentProps) == null ? void 0 : r.className
            ),
            children: [
              t.options && /* @__PURE__ */ w(wM, {}),
              t.getOptions && /* @__PURE__ */ w(xM, {})
            ]
          }
        )
      ] })
    }
  );
}, mM = C.forwardRef(
  (t, e) => {
    const {
      selected: n,
      prefixText: r,
      prefixIcon: o,
      disabled: i,
      className: s,
      multiple: a,
      error: l,
      onBlur: c,
      displayedValue: u,
      CustomTrigger: d
    } = wn();
    return /* @__PURE__ */ B(
      QE,
      {
        ref: e,
        type: "button",
        role: "combobox",
        "aria-haspopup": "listbox",
        className: he(
          "flex w-full select-none items-center rounded-md border border-foundations-bold bg-foundations-default py-2 pl-3 pr-2 text-left text-sm text-foundations-subtle focus:border-info-bold focus:text-info focus:shadow-3 focus:outline-none focus:ring-1 focus:ring-info-bold disabled:cursor-not-allowed aria-expanded:border-info-bold aria-expanded:text-info aria-expanded:shadow-3 aria-expanded:ring-1 aria-expanded:ring-info-bold",
          !i && "group/drop-down hover:shadow-3",
          l && "border-danger-bold focus:border-danger-bold focus:ring-danger-bold [&:focus>svg]:!text-danger [&>svg]:text-danger",
          s
        ),
        disabled: i,
        onBlur: c,
        children: [
          d || /* @__PURE__ */ B(nt, { children: [
            r && /* @__PURE__ */ w("span", { className: "-my-2 mr-3 flex-shrink-0 border-r border-r-foundations-subtle py-2 pr-3 text-sm text-foundations-subtle", children: r }),
            o && /* @__PURE__ */ w(o, { className: "-ml-1 mr-3 h-5 w-5" }),
            /* @__PURE__ */ w(
              "span",
              {
                className: he(
                  "value min-w-0 flex-1 truncate text-sm text-foundations-subtle",
                  {
                    "text-foundations-bolder": a ? n.length : n == null ? void 0 : n[1]
                  }
                ),
                children: u ? u(n) : a ? /* @__PURE__ */ w(vM, {}) : /* @__PURE__ */ w(bM, {})
              }
            )
          ] }),
          /* @__PURE__ */ w(fp, { className: "ml-2 h-5 w-5 shrink-0 transition-transform group-aria-expanded/drop-down:rotate-180" })
        ]
      }
    );
  }
), vM = () => {
  const { label: t, selected: e, displayedValueKey: n } = wn();
  return e != null && e.length ? /* @__PURE__ */ w(nt, { children: e.map(
    ([r, o]) => n ? o[n] : o
  ).join(", ") }) : /* @__PURE__ */ w(nt, { children: t });
}, bM = () => {
  const { label: t, selected: e, displayedValueKey: n } = wn();
  return e != null && e[1] ? /* @__PURE__ */ w(nt, { children: n ? e[1][n] : e[1] }) : /* @__PURE__ */ w(nt, { children: t });
}, am = ({ errorMsg: t }) => /* @__PURE__ */ B("div", { className: "my-4 flex flex-col items-center space-y-4", children: [
  /* @__PURE__ */ w(gp, {}),
  /* @__PURE__ */ w("p", { className: "text-center text-sm text-foundations-subtle", children: t || "No matching data available" })
] }), yM = () => /* @__PURE__ */ w("div", { className: "my-4 flex flex-col items-center", children: /* @__PURE__ */ w(S5, {}) }), wM = () => {
  const {
    options: t = [],
    filterBy: e,
    displayedValueKey: n,
    onSelect: r,
    setIsOpen: o,
    ExtraBodyContent: i,
    searchTerm: s,
    onSearch: a,
    isItemDisabled: l
  } = wn(), [c, u] = C.useState(""), d = t.filter(([M, k]) => {
    var O;
    return e ? e(c, k) : n ? (O = k[n]) == null ? void 0 : O.toLowerCase().includes(c == null ? void 0 : c.toLowerCase()) : k == null ? void 0 : k.toLowerCase().includes(c == null ? void 0 : c.toLowerCase());
  }), {
    getLabelProps: f,
    getMenuProps: h,
    getInputProps: p,
    getItemProps: g,
    highlightedIndex: m,
    selectedItem: b,
    resetSelectionBuffer: v,
    listRef: _,
    virtualizer: x
  } = sm({
    items: d,
    inputValue: s ?? c,
    onInputValueChange: a ?? u,
    isItemDisabled: l
  }), y = x.getVirtualItems();
  return /* @__PURE__ */ B(nt, { children: [
    /* @__PURE__ */ w(lm, { getLabelProps: f, getInputProps: p }),
    i,
    /* @__PURE__ */ B(
      "ul",
      {
        className: "relative my-1 w-full  overflow-y-auto",
        ...h({
          ref: _,
          style: { maxHeight: 350 }
        }),
        children: [
          /* @__PURE__ */ w("li", { style: { height: x.getTotalSize() } }, "total-size"),
          y.length ? y.map((M) => /* @__PURE__ */ w(
            cm,
            {
              ref: x.measureElement,
              "data-index": M.index,
              "data-highlighted": m === M.index,
              option: d[M.index],
              getItemProps: g,
              index: M.index,
              selectedItem: b,
              style: {
                position: "absolute",
                top: 0,
                left: "0.5rem",
                width: "calc(100% - 1rem)",
                transform: `translateY(${M.start}px)`
              }
            },
            M.key
          )) : /* @__PURE__ */ w(am, {})
        ]
      }
    ),
    /* @__PURE__ */ w(
      um,
      {
        onReset: v,
        onApply: () => {
          r(b), o(!1);
        }
      }
    )
  ] });
}, xM = () => {
  const {
    getOptions: t,
    dependencies: e = [],
    onSelect: n,
    setIsOpen: r,
    ExtraBodyContent: o,
    parseGetOptionsError: i,
    isItemDisabled: s,
    selected: a,
    multiple: l,
    disableEmptySearch: c
  } = wn(), [u, d] = C.useState(""), [f, h] = C.useState(!0), [p, g] = C.useState(null), [m, b] = C.useState([]), v = C.useMemo(() => [
    ...l && a ? a.filter(
      (D) => {
        var P;
        return (P = D[1]) == null ? void 0 : P.toLowerCase().includes(u == null ? void 0 : u.toLowerCase());
      }
    ) : [],
    ...a ? m.filter(
      (D) => !a.some(
        (P) => P[0] === D[0]
      )
    ) : m
  ], [m]), {
    getLabelProps: _,
    getMenuProps: x,
    getInputProps: y,
    getItemProps: M,
    highlightedIndex: k,
    selectedItem: O,
    resetSelectionBuffer: S
  } = sm({
    items: v,
    inputValue: u,
    onInputValueChange: d,
    isItemDisabled: s
  });
  return t4(
    () => {
      if (c && u === "") {
        b([]), h(!1), g(null);
        return;
      }
      h(!0), t(u).then(b).catch((D) => {
        const P = i != null && i(D) || typeof D == "string" ? D : null;
        g(P || null);
      }).finally(() => h(!1));
    },
    500,
    [u, ...e]
  ), /* @__PURE__ */ B(nt, { children: [
    /* @__PURE__ */ w(lm, { getLabelProps: _, getInputProps: y }),
    o,
    /* @__PURE__ */ w(
      "ul",
      {
        className: "my-1 flex-1 space-y-1 overflow-y-auto px-2",
        ...x(),
        children: f ? /* @__PURE__ */ w(yM, {}) : v.length ? v.map((D, P) => /* @__PURE__ */ w(
          cm,
          {
            "data-highlighted": k === P,
            option: D,
            getItemProps: M,
            index: P,
            selectedItem: O
          },
          D[0]
        )) : /* @__PURE__ */ w(am, { errorMsg: p })
      }
    ),
    /* @__PURE__ */ w(
      um,
      {
        onReset: S,
        onApply: () => {
          n(O), r(!1);
        }
      }
    )
  ] });
}, lm = ({
  getLabelProps: t,
  getInputProps: e
}) => {
  const { label: n, name: r, placeholder: o = "Search" } = wn();
  return /* @__PURE__ */ B("div", { className: "px-4 pb-1 pt-3", children: [
    /* @__PURE__ */ B("div", { className: "flex items-center justify-between space-x-2", children: [
      /* @__PURE__ */ w(
        "label",
        {
          title: n,
          className: "select-none truncate font-medium text-foundations-bolder",
          ...t(),
          children: n
        }
      ),
      /* @__PURE__ */ w(JE, { className: "shrink-0 text-foundations-subtler hover:text-info focus:text-info focus:outline-none ", children: /* @__PURE__ */ w(x5, { className: "h-5 w-5" }) })
    ] }),
    /* @__PURE__ */ B("div", { className: "relative mt-3", children: [
      /* @__PURE__ */ w(
        "input",
        {
          className: "w-full rounded-md border border-foundations-bold bg-foundations-default py-1.5 pl-10 pr-2 text-foundations-bolder placeholder:text-foundations-subtle focus:border-info-bold focus:ring-1 focus:ring-info-bold",
          placeholder: o,
          ...e({ name: r })
        }
      ),
      /* @__PURE__ */ w("div", { className: "pointer-events-none absolute inset-y-0 left-0 inline-flex items-center pl-2", children: /* @__PURE__ */ w(w5, { className: "h-5 w-5 text-foundations-subtler " }) })
    ] })
  ] });
}, _M = Kt(
  "group flex items-center justify-between rounded p-2 text-sm text-foundations-bolder",
  {
    variants: {
      multiple: {
        true: "aria-disabled:cursor-not-allowed aria-disabled:text-foundations-subtler data-[highlighted=true]:bg-foundations-subtlest",
        false: "aria-disabled:cursor-not-allowed aria-disabled:text-foundations-subtler data-[highlighted=true]:bg-info-bold data-[highlighted=true]:data-[selected=true]:bg-info-bolder data-[selected=true]:bg-info-bold data-[highlighted=true]:text-foundations-inverse data-[selected=true]:text-foundations-inverse"
      }
    },
    defaultVariants: {
      multiple: !1
    }
  }
), cm = C.forwardRef(({ selectedItem: t, option: e, getItemProps: n, index: r, ...o }, i) => {
  const { multiple: s, renderOption: a } = wn(), [l, c] = e, u = s ? t == null ? void 0 : t.some(([d]) => d === l) : l === (t == null ? void 0 : t[0]);
  return /* @__PURE__ */ B(
    "li",
    {
      "data-selected": u,
      className: _M({ multiple: s }),
      ...n({ item: e, index: r, ref: i }),
      ...o,
      children: [
        /* @__PURE__ */ w("div", { className: "flex flex-1 items-center justify-between overflow-hidden", children: a ? a(c) : /* @__PURE__ */ B(nt, { children: [
          /* @__PURE__ */ w("span", { children: c }),
          !s && /* @__PURE__ */ w(Io, { className: "invisible h-5 w-5 flex-shrink-0 group-data-[selected=true]:visible" })
        ] }) }),
        s && /* @__PURE__ */ w(
          bp,
          {
            tabIndex: -1,
            checked: u,
            readOnly: !0,
            disabled: !0,
            className: "pointer-events-none flex-shrink-0 select-none"
          }
        )
      ]
    }
  );
}), um = ({
  onReset: t,
  onApply: e
}) => {
  const { withConfirmation: n, ExtraFooterAction: r } = wn();
  return n ? /* @__PURE__ */ B("div", { className: "border-t border-t-neutral-200 px-6 py-4", children: [
    r,
    /* @__PURE__ */ B("div", { className: "flex space-x-4", children: [
      /* @__PURE__ */ w(Mi, { variant: "secondary", onClick: t, className: "flex-1", children: "Reset" }),
      /* @__PURE__ */ w(Mi, { onClick: e, className: "flex-1", children: "Apply" })
    ] })
  ] }) : null;
}, dm = C.createContext(null), fm = () => {
  const t = C.useContext(dm);
  if (!t)
    throw new Error("useSelectContext must be used within <Select />");
  return t;
}, CM = (t) => {
  const [e, n] = C.useState(!1), [r, o] = C.useState(""), {
    selected: i,
    onSelect: s,
    options: a,
    placement: l = "bottom",
    className: c,
    contentClassName: u,
    displayedValueKey: d,
    filterBy: f
  } = t, h = C.useRef(!1), p = C.useMemo(() => h.current ? a.filter(([S, D]) => {
    if (typeof D == "string")
      return D.toLowerCase().includes(r == null ? void 0 : r.toLowerCase());
    if (f)
      return f(r, D);
    if (d)
      return D[d].toLowerCase().includes(r == null ? void 0 : r.toLowerCase());
  }) : a, [e, a, r, d]), g = C.useCallback(
    (S, D) => {
      var T;
      const { changes: P, type: N } = D;
      switch (N) {
        case ot.stateChangeTypes.InputKeyDownEscape:
        case ot.stateChangeTypes.InputBlur:
          return {
            ...P,
            selectedItem: S.selectedItem,
            inputValue: (T = S.selectedItem) != null && T[1] ? d ? S.selectedItem[1][d] : S.selectedItem[1] : ""
          };
        default:
          return P;
      }
    },
    [d]
  ), m = C.useRef(null), b = im({
    count: p.length,
    getScrollElement: () => m.current,
    estimateSize: C.useCallback(() => 36, []),
    overscan: 5,
    paddingStart: 4,
    paddingEnd: 4,
    scrollPaddingEnd: 4,
    scrollPaddingStart: 4,
    gap: 2,
    getItemKey: C.useCallback(
      (S) => {
        var D;
        return (D = p == null ? void 0 : p[S]) == null ? void 0 : D[0];
      },
      [p]
    ),
    enabled: e
  }), {
    getInputProps: v,
    getMenuProps: _,
    getItemProps: x,
    highlightedIndex: y,
    getToggleButtonProps: M
  } = ot({
    isOpen: e,
    onIsOpenChange: ({ isOpen: S, ...D }) => {
      h.current = !1, n(!!S);
    },
    onInputValueChange: ({ inputValue: S }) => {
      h.current = !0, o(S ?? "");
    },
    items: p,
    itemToString: (S) => S != null && S[1] ? d ? S[1][d] : S[1] : "",
    selectedItem: i,
    onSelectedItemChange: ({ selectedItem: S }) => {
      s(S);
    },
    stateReducer: g,
    scrollIntoView() {
    },
    onHighlightedIndexChange: ({ highlightedIndex: S, type: D }) => {
      D !== ot.stateChangeTypes.MenuMouseLeave && S !== void 0 && b.scrollToIndex(S);
    }
  }), { refs: k, floatingStyles: O } = al({
    open: e,
    placement: l,
    middleware: [
      el(6),
      Ja(),
      tl(),
      nl({
        apply: ({ elements: S, rects: D, availableWidth: P, availableHeight: N }) => {
          const { width: T, height: U } = D.reference, R = S.floating.style;
          R.setProperty("--available-width", `${P}px`), R.setProperty(
            "--available-height",
            `${N}px`
          ), R.setProperty("--trigger-width", `${T}px`), R.setProperty("--trigger-height", `${U}px`);
        },
        padding: 10
      })
    ],
    whileElementsMounted: sl
  });
  return /* @__PURE__ */ w(dm.Provider, { value: t, children: /* @__PURE__ */ B("div", { ref: k.setReference, className: c, children: [
    /* @__PURE__ */ w(
      hm,
      {
        getInputProps: v,
        getToggleButtonProps: M
      }
    ),
    /* @__PURE__ */ w(cp, { children: /* @__PURE__ */ w(
      "ul",
      {
        className: he(
          "z-50 max-h-[min(var(--available-height),_12.5rem)] w-[var(--available-width)] max-w-[max(var(--trigger-width),_18rem)] overflow-y-auto rounded-md bg-foundations-default shadow-2",
          !e && "hidden",
          u
        ),
        ..._({
          ref: vp([k.setFloating, m]),
          style: O
        }),
        children: t.options && /* @__PURE__ */ B(nt, { children: [
          /* @__PURE__ */ w(
            "li",
            {
              style: { height: b.getTotalSize() }
            },
            "total-size"
          ),
          /* @__PURE__ */ w(
            gm,
            {
              virtualizer: b,
              getItemProps: x,
              highlightedIndex: y,
              filteredOptions: p
            }
          )
        ] })
      }
    ) })
  ] }) });
};
CM.displayName = "Select";
const hm = ({
  getInputProps: t,
  getToggleButtonProps: e
}) => {
  const {
    selected: n,
    id: r,
    name: o,
    disabled: i,
    prefixText: s,
    prefixIcon: a,
    placeholder: l,
    inputClassName: c,
    onBlur: u,
    error: d,
    inputRef: f
  } = fm();
  return /* @__PURE__ */ B("div", { className: "relative", children: [
    /* @__PURE__ */ w(
      "input",
      {
        className: he(
          "peer w-full overflow-ellipsis rounded-md border border-foundations-bold bg-foundations-default p-2 pr-8 text-left text-sm text-foundations-subtle focus:border-info-bold focus:text-foundations-boldest focus:shadow-3 focus:outline-none focus:ring-1 focus:ring-info-bold disabled:cursor-not-allowed  disabled:border-foundations-subtle disabled:bg-foundations-subtelst-02 disabled:text-foundations-subtler aria-expanded:border-info-bold aria-expanded:shadow-3 aria-expanded:ring-1 aria-expanded:ring-info-bold",
          {
            "hover:shadow-3": !i,
            "text-foundations-boldest": n == null ? void 0 : n[1],
            "pl-9": a,
            "pl-16": s,
            "border-danger-bold focus:border-danger-bold focus:ring-danger-bold": d
          },
          c
        ),
        ...t({
          onBlur: u,
          disabled: i,
          placeholder: l,
          name: o,
          id: r,
          ref: f
        })
      }
    ),
    s && /* @__PURE__ */ w("span", { className: "pointer-events-none absolute inset-y-0 left-0 top-0 flex flex-shrink-0 items-center justify-center border-r border-r-foundations-bold px-3 text-sm text-foundations-subtle", children: s }),
    a && /* @__PURE__ */ w(a, { className: "pointer-events-none absolute left-2 top-1/2 h-5 w-5 -translate-y-1/2 text-foundations-subtler peer-focus:text-info peer-aria-expanded:text-info" }),
    /* @__PURE__ */ w(
      "button",
      {
        ...e({ disabled: i, type: "button" }),
        className: "absolute inset-y-0 right-2 flex flex-shrink-0 items-center justify-center text-foundations-subtler transition-transform disabled:cursor-not-allowed peer-focus:text-info peer-aria-expanded:rotate-180 peer-aria-expanded:text-info",
        children: /* @__PURE__ */ w(fp, { className: " h-5 w-5 " })
      }
    )
  ] });
};
hm.displayName = "SelectInput";
const pm = () => /* @__PURE__ */ B("div", { className: "my-4 flex flex-col items-center space-y-4 text-center", children: [
  /* @__PURE__ */ w(gp, {}),
  /* @__PURE__ */ w("p", { className: "text-sm text-foundations-subtle", children: "No matching data available" })
] });
pm.displayName = "EmptyOptions";
const gm = ({
  highlightedIndex: t,
  getItemProps: e,
  filteredOptions: n,
  virtualizer: r
}) => {
  const o = r.getVirtualItems();
  return /* @__PURE__ */ w(nt, { children: o.length ? o.map((i) => /* @__PURE__ */ w(
    mm,
    {
      ref: r.measureElement,
      "data-index": i.index,
      "data-highlighted": t === i.index,
      option: n[i.index],
      getItemProps: e,
      index: i.index,
      style: {
        position: "absolute",
        top: 0,
        left: "0.5rem",
        width: "calc(100% - 1rem)",
        transform: `translateY(${i.start}px)`
      }
    },
    i.key
  )) : /* @__PURE__ */ w(pm, {}) });
};
gm.displayName = "SelectOptions";
const EM = Kt(
  "group flex items-center justify-between rounded p-2 text-sm text-foundations-subtle",
  {
    variants: {
      multiple: {
        true: "data-[highlighted=true]:bg-foundations-subtlest",
        false: "data-[highlighted=true]:bg-info-bold data-[highlighted=true]:data-[selected=true]:bg-info-bolder data-[selected=true]:bg-info-bold data-[highlighted=true]:text-foundations-inverse data-[selected=true]:text-foundations-inverse"
      }
    },
    defaultVariants: {
      multiple: !1
    }
  }
), mm = C.forwardRef(({ option: t, getItemProps: e, index: n, ...r }, o) => {
  const { renderOption: i, selected: s } = fm(), [a, l] = t, c = a === (s == null ? void 0 : s[0]);
  return /* @__PURE__ */ w(
    "li",
    {
      "data-selected": c,
      className: EM(),
      ...e({
        item: t,
        index: n,
        ref: o
      }),
      ...r,
      children: /* @__PURE__ */ w("div", { className: "flex flex-1 items-center justify-between", children: i ? i(l, c) : /* @__PURE__ */ B(nt, { children: [
        /* @__PURE__ */ w("span", { children: l }),
        /* @__PURE__ */ w(Io, { className: "invisible h-5 w-5 group-data-[selected=true]:visible" })
      ] }) })
    }
  );
});
mm.displayName = "Option";
const MM = C.forwardRef(
  ({
    savedFileName: t = null,
    multiple: e = !1,
    accept: n,
    showAcceptedFilesHint: r = !0,
    label: o = "",
    hint: i = "",
    uploadingProgress: s = 0,
    uploadedFiles: a = [],
    onFilesChange: l,
    withUploadConfirmation: c = !1,
    onUploadConfirmed: u,
    isUploadButtonDisabled: d = !1,
    isUploadButtonLoading: f = !1,
    isUploadButtonTooltipDisabled: h = !1,
    uploadButtonTooltipText: p = ""
  }, g) => {
    var S;
    const m = s > 0 && s < 100, b = C.useMemo(
      () => `UploadFiles${o.split(" ").join("")}`,
      [o]
    ), [v, _] = C.useState(!1), x = C.useRef(null), y = a.length > 0 || !!t, M = C.useCallback(
      (D) => {
        var P;
        if (_(!1), (P = D.target.files) != null && P.length) {
          if (m)
            return;
          l([...D.target.files]);
        }
      },
      [l]
    ), k = C.useCallback(
      (D) => {
        D.preventDefault(), _(!0);
      },
      []
    ), O = C.useCallback(
      (D) => {
        D.preventDefault(), _(!1);
      },
      []
    );
    return /* @__PURE__ */ B(nt, { children: [
      o && /* @__PURE__ */ B(
        "label",
        {
          htmlFor: b,
          className: "mb-2 inline-flex items-center gap-2",
          children: [
            /* @__PURE__ */ w("span", { className: "block text-sm font-medium text-foundations-bold", children: o }),
            i && /* @__PURE__ */ w(ga, { delayDuration: 0, children: /* @__PURE__ */ w(
              rr,
              {
                variant: "dark",
                content: i,
                side: "top",
                size: "sm",
                collisionPadding: 4,
                children: /* @__PURE__ */ w("div", { className: "flex h-6 w-6 items-center justify-center rounded-full bg-neutral-100", children: /* @__PURE__ */ w(
                  y5,
                  {
                    width: 16,
                    height: 16,
                    className: " text-foundations-subtler"
                  }
                ) })
              }
            ) })
          ]
        }
      ),
      /* @__PURE__ */ B("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ B(
          "div",
          {
            ref: g,
            className: he(
              "relative flex w-full items-center justify-center gap-2 overflow-hidden rounded border border-dashed border-neutral-300 p-4 text-foundations-subtle transition-all duration-200",
              {
                "border-blue-500 bg-neutral-50 text-blue-500": v,
                "pointer-events-none border-solid border-blue-200": m,
                "pointer-events-none border-solid border-green-200": y,
                "p-2": c
              }
            ),
            children: [
              m ? /* @__PURE__ */ B(nt, { children: [
                /* @__PURE__ */ w(
                  dp,
                  {
                    variant: "primary",
                    value: s,
                    size: 26,
                    strokeWidth: 4,
                    strokeClassName: "stroke-neutral-800",
                    strokeLinecap: "square"
                  }
                ),
                /* @__PURE__ */ B("p", { className: "p-1 text-xs font-medium", children: [
                  "Uploading (",
                  s,
                  "%)"
                ] }),
                /* @__PURE__ */ w(
                  "div",
                  {
                    className: "absolute bottom-0 left-0 h-[5px] bg-blue-500",
                    style: { width: `${s}%` }
                  }
                )
              ] }) : /* @__PURE__ */ w(nt, { children: y ? /* @__PURE__ */ B(nt, { children: [
                /* @__PURE__ */ w("div", { className: "flex h-6 w-6 items-center justify-center rounded-full bg-green-100", children: /* @__PURE__ */ w(
                  Io,
                  {
                    width: 16,
                    height: 16,
                    className: "text-green-500"
                  }
                ) }),
                /* @__PURE__ */ w("p", { className: "p-1 text-xs font-medium", children: ((S = a[0]) == null ? void 0 : S.name) || t })
              ] }) : /* @__PURE__ */ B(nt, { children: [
                /* @__PURE__ */ w(
                  md,
                  {
                    width: 20,
                    height: 20,
                    className: "pointer-events-none text-foundations-subtle"
                  }
                ),
                /* @__PURE__ */ B("p", { className: "pointer-events-none p-1 text-xs font-medium", children: [
                  "Drop file or click here to",
                  " ",
                  c ? "browse" : "upload"
                ] })
              ] }) }),
              /* @__PURE__ */ w(
                "input",
                {
                  id: b,
                  className: "absolute inset-0 cursor-pointer opacity-0",
                  ref: x,
                  type: "file",
                  accept: n,
                  multiple: e,
                  onChange: M,
                  onDragEnter: k,
                  onDragLeave: O
                }
              )
            ]
          }
        ),
        c && /* @__PURE__ */ w(ga, { children: /* @__PURE__ */ w(
          rr,
          {
            content: p,
            disabled: !p || h,
            children: /* @__PURE__ */ w(
              Mi,
              {
                className: "disabled:pointer-events-auto",
                disabled: d,
                isLoading: f,
                onClick: () => u == null ? void 0 : u(a),
                children: "Upload"
              }
            )
          }
        ) })
      ] }),
      n && r && /* @__PURE__ */ B("p", { className: "mt-[6px] text-xs text-foundations-subtle", children: [
        "Supported file types: ",
        n.split(",").join(" ")
      ] }),
      y && /* @__PURE__ */ B(
        "button",
        {
          type: "button",
          className: "flex items-center justify-center gap-2 px-4 py-[6px] text-foundations-subtle",
          onClick: () => {
            var D;
            return (D = x.current) == null ? void 0 : D.click();
          },
          children: [
            /* @__PURE__ */ w(md, { width: 20, height: 20 }),
            /* @__PURE__ */ w("span", { className: "text-xs font-medium", children: c ? "Browse files" : "Re-upload file" })
          ]
        }
      )
    ] });
  }
);
MM.displayName = "UploadArea";
const Wa = "dismissableLayer.update", kM = "dismissableLayer.pointerDownOutside", OM = "dismissableLayer.focusOutside";
let lf;
const SM = /* @__PURE__ */ Nt({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), PM = /* @__PURE__ */ de((t, e) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: o, onPointerDownOutside: i, onFocusOutside: s, onInteractOutside: a, onDismiss: l, ...c } = t, u = Yt(SM), [d, f] = ye(null), h = (n = d == null ? void 0 : d.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, p] = ye({}), g = et(
    e,
    (O) => f(O)
  ), m = Array.from(u.layers), [b] = [
    ...u.layersWithOutsidePointerEventsDisabled
  ].slice(-1), v = m.indexOf(b), _ = d ? m.indexOf(d) : -1, x = u.layersWithOutsidePointerEventsDisabled.size > 0, y = _ >= v, M = IM((O) => {
    const S = O.target, D = [
      ...u.branches
    ].some(
      (P) => P.contains(S)
    );
    !y || D || (i == null || i(O), a == null || a(O), O.defaultPrevented || l == null || l());
  }, h), k = TM((O) => {
    const S = O.target;
    [
      ...u.branches
    ].some(
      (P) => P.contains(S)
    ) || (s == null || s(O), a == null || a(O), O.defaultPrevented || l == null || l());
  }, h);
  return kf((O) => {
    _ === u.layers.size - 1 && (o == null || o(O), !O.defaultPrevented && l && (O.preventDefault(), l()));
  }, h), ue(() => {
    if (d)
      return r && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (lf = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), cf(), () => {
        r && u.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = lf);
      };
  }, [
    d,
    h,
    r,
    u
  ]), ue(() => () => {
    d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), cf());
  }, [
    d,
    u
  ]), ue(() => {
    const O = () => p({});
    return document.addEventListener(Wa, O), () => document.removeEventListener(Wa, O);
  }, []), /* @__PURE__ */ L(je.div, ne({}, c, {
    ref: g,
    style: {
      pointerEvents: x ? y ? "auto" : "none" : void 0,
      ...t.style
    },
    onFocusCapture: be(t.onFocusCapture, k.onFocusCapture),
    onBlurCapture: be(t.onBlurCapture, k.onBlurCapture),
    onPointerDownCapture: be(t.onPointerDownCapture, M.onPointerDownCapture)
  }));
});
function IM(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = pt(t), r = ae(!1), o = ae(() => {
  });
  return ue(() => {
    const i = (a) => {
      if (a.target && !r.current) {
        let c = function() {
          vm(kM, n, l, {
            discrete: !0
          });
        };
        const l = {
          originalEvent: a
        };
        a.pointerType === "touch" ? (e.removeEventListener("click", o.current), o.current = c, e.addEventListener("click", o.current, {
          once: !0
        })) : c();
      } else
        e.removeEventListener("click", o.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      e.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(s), e.removeEventListener("pointerdown", i), e.removeEventListener("click", o.current);
    };
  }, [
    e,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function TM(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = pt(t), r = ae(!1);
  return ue(() => {
    const o = (i) => {
      i.target && !r.current && vm(OM, n, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", o), () => e.removeEventListener("focusin", o);
  }, [
    e,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function cf() {
  const t = new CustomEvent(Wa);
  document.dispatchEvent(t);
}
function vm(t, e, n, { discrete: r }) {
  const o = n.originalEvent.target, i = new CustomEvent(t, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  e && o.addEventListener(t, e, {
    once: !0
  }), r ? qa(o, i) : o.dispatchEvent(i);
}
const ra = "focusScope.autoFocusOnMount", oa = "focusScope.autoFocusOnUnmount", uf = {
  bubbles: !1,
  cancelable: !0
}, DM = /* @__PURE__ */ de((t, e) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: o, onUnmountAutoFocus: i, ...s } = t, [a, l] = ye(null), c = pt(o), u = pt(i), d = ae(null), f = et(
    e,
    (g) => l(g)
  ), h = ae({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  ue(() => {
    if (r) {
      let g = function(_) {
        if (h.paused || !a)
          return;
        const x = _.target;
        a.contains(x) ? d.current = x : On(d.current, {
          select: !0
        });
      }, m = function(_) {
        if (h.paused || !a)
          return;
        const x = _.relatedTarget;
        x !== null && (a.contains(x) || On(d.current, {
          select: !0
        }));
      }, b = function(_) {
        if (document.activeElement === document.body)
          for (const y of _)
            y.removedNodes.length > 0 && On(a);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", m);
      const v = new MutationObserver(b);
      return a && v.observe(a, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", m), v.disconnect();
      };
    }
  }, [
    r,
    a,
    h.paused
  ]), ue(() => {
    if (a) {
      ff.add(h);
      const g = document.activeElement;
      if (!a.contains(g)) {
        const b = new CustomEvent(ra, uf);
        a.addEventListener(ra, c), a.dispatchEvent(b), b.defaultPrevented || ($M(FM(bm(a)), {
          select: !0
        }), document.activeElement === g && On(a));
      }
      return () => {
        a.removeEventListener(ra, c), setTimeout(() => {
          const b = new CustomEvent(oa, uf);
          a.addEventListener(oa, u), a.dispatchEvent(b), b.defaultPrevented || On(g ?? document.body, {
            select: !0
          }), a.removeEventListener(oa, u), ff.remove(h);
        }, 0);
      };
    }
  }, [
    a,
    c,
    u,
    h
  ]);
  const p = pe((g) => {
    if (!n && !r || h.paused)
      return;
    const m = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, b = document.activeElement;
    if (m && b) {
      const v = g.currentTarget, [_, x] = NM(v);
      _ && x ? !g.shiftKey && b === x ? (g.preventDefault(), n && On(_, {
        select: !0
      })) : g.shiftKey && b === _ && (g.preventDefault(), n && On(x, {
        select: !0
      })) : b === v && g.preventDefault();
    }
  }, [
    n,
    r,
    h.paused
  ]);
  return /* @__PURE__ */ L(je.div, ne({
    tabIndex: -1
  }, s, {
    ref: f,
    onKeyDown: p
  }));
});
function $M(t, { select: e = !1 } = {}) {
  const n = document.activeElement;
  for (const r of t)
    if (On(r, {
      select: e
    }), document.activeElement !== n)
      return;
}
function NM(t) {
  const e = bm(t), n = df(e, t), r = df(e.reverse(), t);
  return [
    n,
    r
  ];
}
function bm(t) {
  const e = [], n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    e.push(n.currentNode);
  return e;
}
function df(t, e) {
  for (const n of t)
    if (!RM(n, {
      upTo: e
    }))
      return n;
}
function RM(t, { upTo: e }) {
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  for (; t; ) {
    if (e !== void 0 && t === e)
      return !1;
    if (getComputedStyle(t).display === "none")
      return !0;
    t = t.parentElement;
  }
  return !1;
}
function AM(t) {
  return t instanceof HTMLInputElement && "select" in t;
}
function On(t, { select: e = !1 } = {}) {
  if (t && t.focus) {
    const n = document.activeElement;
    t.focus({
      preventScroll: !0
    }), t !== n && AM(t) && e && t.select();
  }
}
const ff = LM();
function LM() {
  let t = [];
  return {
    add(e) {
      const n = t[0];
      e !== n && (n == null || n.pause()), t = hf(t, e), t.unshift(e);
    },
    remove(e) {
      var n;
      t = hf(t, e), (n = t[0]) === null || n === void 0 || n.resume();
    }
  };
}
function hf(t, e) {
  const n = [
    ...t
  ], r = n.indexOf(e);
  return r !== -1 && n.splice(r, 1), n;
}
function FM(t) {
  return t.filter(
    (e) => e.tagName !== "A"
  );
}
const ym = "Popper", [wm, xm] = an(ym), [VM, _m] = wm(ym), WM = (t) => {
  const { __scopePopper: e, children: n } = t, [r, o] = ye(null);
  return /* @__PURE__ */ L(VM, {
    scope: e,
    anchor: r,
    onAnchorChange: o
  }, n);
}, HM = "PopperAnchor", BM = /* @__PURE__ */ de((t, e) => {
  const { __scopePopper: n, virtualRef: r, ...o } = t, i = _m(HM, n), s = ae(null), a = et(e, s);
  return ue(() => {
    i.onAnchorChange((r == null ? void 0 : r.current) || s.current);
  }), r ? null : /* @__PURE__ */ L(je.div, ne({}, o, {
    ref: a
  }));
}), Cm = "PopperContent", [jM, o8] = wm(Cm), zM = /* @__PURE__ */ de((t, e) => {
  var n, r, o, i, s, a, l, c;
  const { __scopePopper: u, side: d = "bottom", sideOffset: f = 0, align: h = "center", alignOffset: p = 0, arrowPadding: g = 0, avoidCollisions: m = !0, collisionBoundary: b = [], collisionPadding: v = 0, sticky: _ = "partial", hideWhenDetached: x = !1, updatePositionStrategy: y = "optimized", onPlaced: M, ...k } = t, O = _m(Cm, u), [S, D] = ye(null), P = et(
    e,
    (Re) => D(Re)
  ), [N, T] = ye(null), U = ll(N), R = (n = U == null ? void 0 : U.width) !== null && n !== void 0 ? n : 0, Y = (r = U == null ? void 0 : U.height) !== null && r !== void 0 ? r : 0, V = d + (h !== "center" ? "-" + h : ""), z = typeof v == "number" ? v : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...v
  }, ee = Array.isArray(b) ? b : [
    b
  ], $ = ee.length > 0, F = {
    padding: z,
    boundary: ee.filter(UM),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: $
  }, { refs: te, floatingStyles: J, placement: re, isPositioned: j, middlewareData: A } = al({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: V,
    whileElementsMounted: (...Re) => sl(...Re, {
      animationFrame: y === "always"
    }),
    elements: {
      reference: O.anchor
    },
    middleware: [
      el({
        mainAxis: f + Y,
        alignmentAxis: p
      }),
      m && tl({
        mainAxis: !0,
        crossAxis: !1,
        limiter: _ === "partial" ? Tf() : void 0,
        ...F
      }),
      m && Ja({
        ...F
      }),
      nl({
        ...F,
        apply: ({ elements: Re, rects: ct, availableWidth: ut, availableHeight: Gt }) => {
          const { width: gt, height: xt } = ct.reference, at = Re.floating.style;
          at.setProperty("--radix-popper-available-width", `${ut}px`), at.setProperty("--radix-popper-available-height", `${Gt}px`), at.setProperty("--radix-popper-anchor-width", `${gt}px`), at.setProperty("--radix-popper-anchor-height", `${xt}px`);
        }
      }),
      N && Vf({
        element: N,
        padding: g
      }),
      YM({
        arrowWidth: R,
        arrowHeight: Y
      }),
      x && If({
        strategy: "referenceHidden",
        ...F
      })
    ]
  }), [W, H] = Em(re), q = pt(M);
  An(() => {
    j && (q == null || q());
  }, [
    j,
    q
  ]);
  const oe = (o = A.arrow) === null || o === void 0 ? void 0 : o.x, Z = (i = A.arrow) === null || i === void 0 ? void 0 : i.y, G = ((s = A.arrow) === null || s === void 0 ? void 0 : s.centerOffset) !== 0, [we, Pe] = ye();
  return An(() => {
    S && Pe(window.getComputedStyle(S).zIndex);
  }, [
    S
  ]), /* @__PURE__ */ L("div", {
    ref: te.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...J,
      transform: j ? J.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: we,
      "--radix-popper-transform-origin": [
        (a = A.transformOrigin) === null || a === void 0 ? void 0 : a.x,
        (l = A.transformOrigin) === null || l === void 0 ? void 0 : l.y
      ].join(" ")
    },
    dir: t.dir
  }, /* @__PURE__ */ L(jM, {
    scope: u,
    placedSide: W,
    onArrowChange: T,
    arrowX: oe,
    arrowY: Z,
    shouldHideArrow: G
  }, /* @__PURE__ */ L(je.div, ne({
    "data-side": W,
    "data-align": H
  }, k, {
    ref: P,
    style: {
      ...k.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: j ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (c = A.hide) !== null && c !== void 0 && c.referenceHidden ? 0 : void 0
    }
  }))));
});
function UM(t) {
  return t !== null;
}
const YM = (t) => ({
  name: "transformOrigin",
  options: t,
  fn(e) {
    var n, r, o, i, s;
    const { placement: a, rects: l, middlewareData: c } = e, d = ((n = c.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, f = d ? 0 : t.arrowWidth, h = d ? 0 : t.arrowHeight, [p, g] = Em(a), m = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[g], b = ((r = (o = c.arrow) === null || o === void 0 ? void 0 : o.x) !== null && r !== void 0 ? r : 0) + f / 2, v = ((i = (s = c.arrow) === null || s === void 0 ? void 0 : s.y) !== null && i !== void 0 ? i : 0) + h / 2;
    let _ = "", x = "";
    return p === "bottom" ? (_ = d ? m : `${b}px`, x = `${-h}px`) : p === "top" ? (_ = d ? m : `${b}px`, x = `${l.floating.height + h}px`) : p === "right" ? (_ = `${-h}px`, x = d ? m : `${v}px`) : p === "left" && (_ = `${l.floating.width + h}px`, x = d ? m : `${v}px`), {
      data: {
        x: _,
        y: x
      }
    };
  }
});
function Em(t) {
  const [e, n = "center"] = t.split("-");
  return [
    e,
    n
  ];
}
const KM = WM, GM = BM, qM = zM, XM = /* @__PURE__ */ de((t, e) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...o } = t;
  return r ? /* @__PURE__ */ vf.createPortal(/* @__PURE__ */ L(je.div, ne({}, o, {
    ref: e
  })), r) : null;
}), ZM = [
  "Enter",
  " "
], QM = [
  "ArrowDown",
  "PageUp",
  "Home"
], Mm = [
  "ArrowUp",
  "PageDown",
  "End"
], JM = [
  ...QM,
  ...Mm
], bs = "Menu", [Ha, e7, t7] = xp(bs), [dr, km] = an(bs, [
  t7,
  xm,
  fs
]), sc = xm(), Om = fs(), [n7, No] = dr(bs), [r7, ac] = dr(bs), o7 = (t) => {
  const { __scopeMenu: e, open: n = !1, children: r, dir: o, onOpenChange: i, modal: s = !0 } = t, a = sc(e), [l, c] = ye(null), u = ae(!1), d = pt(i), f = Nl(o);
  return ue(() => {
    const h = () => {
      u.current = !0, document.addEventListener("pointerdown", p, {
        capture: !0,
        once: !0
      }), document.addEventListener("pointermove", p, {
        capture: !0,
        once: !0
      });
    }, p = () => u.current = !1;
    return document.addEventListener("keydown", h, {
      capture: !0
    }), () => {
      document.removeEventListener("keydown", h, {
        capture: !0
      }), document.removeEventListener("pointerdown", p, {
        capture: !0
      }), document.removeEventListener("pointermove", p, {
        capture: !0
      });
    };
  }, []), /* @__PURE__ */ L(KM, a, /* @__PURE__ */ L(n7, {
    scope: e,
    open: n,
    onOpenChange: d,
    content: l,
    onContentChange: c
  }, /* @__PURE__ */ L(r7, {
    scope: e,
    onClose: pe(
      () => d(!1),
      [
        d
      ]
    ),
    isUsingKeyboardRef: u,
    dir: f,
    modal: s
  }, r)));
}, i7 = /* @__PURE__ */ de((t, e) => {
  const { __scopeMenu: n, ...r } = t, o = sc(n);
  return /* @__PURE__ */ L(GM, ne({}, o, r, {
    ref: e
  }));
}), Sm = "MenuPortal", [s7, a7] = dr(Sm, {
  forceMount: void 0
}), l7 = (t) => {
  const { __scopeMenu: e, forceMount: n, children: r, container: o } = t, i = No(Sm, e);
  return /* @__PURE__ */ L(s7, {
    scope: e,
    forceMount: n
  }, /* @__PURE__ */ L(cr, {
    present: n || i.open
  }, /* @__PURE__ */ L(XM, {
    asChild: !0,
    container: o
  }, r)));
}, Nn = "MenuContent", [c7, Pm] = dr(Nn), u7 = /* @__PURE__ */ de((t, e) => {
  const n = a7(Nn, t.__scopeMenu), { forceMount: r = n.forceMount, ...o } = t, i = No(Nn, t.__scopeMenu), s = ac(Nn, t.__scopeMenu);
  return /* @__PURE__ */ L(Ha.Provider, {
    scope: t.__scopeMenu
  }, /* @__PURE__ */ L(cr, {
    present: r || i.open
  }, /* @__PURE__ */ L(Ha.Slot, {
    scope: t.__scopeMenu
  }, s.modal ? /* @__PURE__ */ L(d7, ne({}, o, {
    ref: e
  })) : /* @__PURE__ */ L(f7, ne({}, o, {
    ref: e
  })))));
}), d7 = /* @__PURE__ */ de((t, e) => {
  const n = No(Nn, t.__scopeMenu), r = ae(null), o = et(e, r);
  return ue(() => {
    const i = r.current;
    if (i)
      return Qp(i);
  }, []), /* @__PURE__ */ L(Im, ne({}, t, {
    ref: o,
    trapFocus: n.open,
    disableOutsidePointerEvents: n.open,
    disableOutsideScroll: !0,
    onFocusOutside: be(
      t.onFocusOutside,
      (i) => i.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    ),
    onDismiss: () => n.onOpenChange(!1)
  }));
}), f7 = /* @__PURE__ */ de((t, e) => {
  const n = No(Nn, t.__scopeMenu);
  return /* @__PURE__ */ L(Im, ne({}, t, {
    ref: e,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    disableOutsideScroll: !1,
    onDismiss: () => n.onOpenChange(!1)
  }));
}), Im = /* @__PURE__ */ de((t, e) => {
  const { __scopeMenu: n, loop: r = !1, trapFocus: o, onOpenAutoFocus: i, onCloseAutoFocus: s, disableOutsidePointerEvents: a, onEntryFocus: l, onEscapeKeyDown: c, onPointerDownOutside: u, onFocusOutside: d, onInteractOutside: f, onDismiss: h, disableOutsideScroll: p, ...g } = t, m = No(Nn, n), b = ac(Nn, n), v = sc(n), _ = Om(n), x = e7(n), [y, M] = ye(null), k = ae(null), O = et(e, k, m.onContentChange), S = ae(0), D = ae(""), P = ae(0), N = ae(null), T = ae("right"), U = ae(0), R = p ? ag : gf, Y = p ? {
    as: Rt,
    allowPinchZoom: !0
  } : void 0, V = (ee) => {
    var $, F;
    const te = D.current + ee, J = x().filter(
      (q) => !q.disabled
    ), re = document.activeElement, j = ($ = J.find(
      (q) => q.ref.current === re
    )) === null || $ === void 0 ? void 0 : $.textValue, A = J.map(
      (q) => q.textValue
    ), W = E7(A, te, j), H = (F = J.find(
      (q) => q.textValue === W
    )) === null || F === void 0 ? void 0 : F.ref.current;
    (function q(oe) {
      D.current = oe, window.clearTimeout(S.current), oe !== "" && (S.current = window.setTimeout(
        () => q(""),
        1e3
      ));
    })(te), H && setTimeout(
      () => H.focus()
    );
  };
  ue(() => () => window.clearTimeout(S.current), []), qp();
  const z = pe((ee) => {
    var $, F;
    return T.current === (($ = N.current) === null || $ === void 0 ? void 0 : $.side) && k7(ee, (F = N.current) === null || F === void 0 ? void 0 : F.area);
  }, []);
  return /* @__PURE__ */ L(c7, {
    scope: n,
    searchRef: D,
    onItemEnter: pe((ee) => {
      z(ee) && ee.preventDefault();
    }, [
      z
    ]),
    onItemLeave: pe((ee) => {
      var $;
      z(ee) || (($ = k.current) === null || $ === void 0 || $.focus(), M(null));
    }, [
      z
    ]),
    onTriggerLeave: pe((ee) => {
      z(ee) && ee.preventDefault();
    }, [
      z
    ]),
    pointerGraceTimerRef: P,
    onPointerGraceIntentChange: pe((ee) => {
      N.current = ee;
    }, [])
  }, /* @__PURE__ */ L(R, Y, /* @__PURE__ */ L(DM, {
    asChild: !0,
    trapped: o,
    onMountAutoFocus: be(i, (ee) => {
      var $;
      ee.preventDefault(), ($ = k.current) === null || $ === void 0 || $.focus();
    }),
    onUnmountAutoFocus: s
  }, /* @__PURE__ */ L(PM, {
    asChild: !0,
    disableOutsidePointerEvents: a,
    onEscapeKeyDown: c,
    onPointerDownOutside: u,
    onFocusOutside: d,
    onInteractOutside: f,
    onDismiss: h
  }, /* @__PURE__ */ L(Ep, ne({
    asChild: !0
  }, _, {
    dir: b.dir,
    orientation: "vertical",
    loop: r,
    currentTabStopId: y,
    onCurrentTabStopIdChange: M,
    onEntryFocus: be(l, (ee) => {
      b.isUsingKeyboardRef.current || ee.preventDefault();
    })
  }), /* @__PURE__ */ L(qM, ne({
    role: "menu",
    "aria-orientation": "vertical",
    "data-state": x7(m.open),
    "data-radix-menu-content": "",
    dir: b.dir
  }, v, g, {
    ref: O,
    style: {
      outline: "none",
      ...g.style
    },
    onKeyDown: be(g.onKeyDown, (ee) => {
      const F = ee.target.closest("[data-radix-menu-content]") === ee.currentTarget, te = ee.ctrlKey || ee.altKey || ee.metaKey, J = ee.key.length === 1;
      F && (ee.key === "Tab" && ee.preventDefault(), !te && J && V(ee.key));
      const re = k.current;
      if (ee.target !== re || !JM.includes(ee.key))
        return;
      ee.preventDefault();
      const A = x().filter(
        (W) => !W.disabled
      ).map(
        (W) => W.ref.current
      );
      Mm.includes(ee.key) && A.reverse(), _7(A);
    }),
    onBlur: be(t.onBlur, (ee) => {
      ee.currentTarget.contains(ee.target) || (window.clearTimeout(S.current), D.current = "");
    }),
    onPointerMove: be(t.onPointerMove, ja((ee) => {
      const $ = ee.target, F = U.current !== ee.clientX;
      if (ee.currentTarget.contains($) && F) {
        const te = ee.clientX > U.current ? "right" : "left";
        T.current = te, U.current = ee.clientX;
      }
    }))
  })))))));
}), h7 = /* @__PURE__ */ de((t, e) => {
  const { __scopeMenu: n, ...r } = t;
  return /* @__PURE__ */ L(je.div, ne({
    role: "group"
  }, r, {
    ref: e
  }));
}), p7 = /* @__PURE__ */ de((t, e) => {
  const { __scopeMenu: n, ...r } = t;
  return /* @__PURE__ */ L(je.div, ne({}, r, {
    ref: e
  }));
}), Ba = "MenuItem", pf = "menu.itemSelect", g7 = /* @__PURE__ */ de((t, e) => {
  const { disabled: n = !1, onSelect: r, ...o } = t, i = ae(null), s = ac(Ba, t.__scopeMenu), a = Pm(Ba, t.__scopeMenu), l = et(e, i), c = ae(!1), u = () => {
    const d = i.current;
    if (!n && d) {
      const f = new CustomEvent(pf, {
        bubbles: !0,
        cancelable: !0
      });
      d.addEventListener(
        pf,
        (h) => r == null ? void 0 : r(h),
        {
          once: !0
        }
      ), qa(d, f), f.defaultPrevented ? c.current = !1 : s.onClose();
    }
  };
  return /* @__PURE__ */ L(m7, ne({}, o, {
    ref: l,
    disabled: n,
    onClick: be(t.onClick, u),
    onPointerDown: (d) => {
      var f;
      (f = t.onPointerDown) === null || f === void 0 || f.call(t, d), c.current = !0;
    },
    onPointerUp: be(t.onPointerUp, (d) => {
      var f;
      c.current || (f = d.currentTarget) === null || f === void 0 || f.click();
    }),
    onKeyDown: be(t.onKeyDown, (d) => {
      const f = a.searchRef.current !== "";
      n || f && d.key === " " || ZM.includes(d.key) && (d.currentTarget.click(), d.preventDefault());
    })
  }));
}), m7 = /* @__PURE__ */ de((t, e) => {
  const { __scopeMenu: n, disabled: r = !1, textValue: o, ...i } = t, s = Pm(Ba, n), a = Om(n), l = ae(null), c = et(e, l), [u, d] = ye(!1), [f, h] = ye("");
  return ue(() => {
    const p = l.current;
    if (p) {
      var g;
      h(((g = p.textContent) !== null && g !== void 0 ? g : "").trim());
    }
  }, [
    i.children
  ]), /* @__PURE__ */ L(Ha.ItemSlot, {
    scope: n,
    disabled: r,
    textValue: o ?? f
  }, /* @__PURE__ */ L(Mp, ne({
    asChild: !0
  }, a, {
    focusable: !r
  }), /* @__PURE__ */ L(je.div, ne({
    role: "menuitem",
    "data-highlighted": u ? "" : void 0,
    "aria-disabled": r || void 0,
    "data-disabled": r ? "" : void 0
  }, i, {
    ref: c,
    onPointerMove: be(t.onPointerMove, ja((p) => {
      r ? s.onItemLeave(p) : (s.onItemEnter(p), p.defaultPrevented || p.currentTarget.focus());
    })),
    onPointerLeave: be(t.onPointerLeave, ja(
      (p) => s.onItemLeave(p)
    )),
    onFocus: be(
      t.onFocus,
      () => d(!0)
    ),
    onBlur: be(
      t.onBlur,
      () => d(!1)
    )
  }))));
}), v7 = "MenuRadioGroup";
dr(v7, {
  value: void 0,
  onValueChange: () => {
  }
});
const b7 = "MenuItemIndicator";
dr(b7, {
  checked: !1
});
const y7 = /* @__PURE__ */ de((t, e) => {
  const { __scopeMenu: n, ...r } = t;
  return /* @__PURE__ */ L(je.div, ne({
    role: "separator",
    "aria-orientation": "horizontal"
  }, r, {
    ref: e
  }));
}), w7 = "MenuSub";
dr(w7);
function x7(t) {
  return t ? "open" : "closed";
}
function _7(t) {
  const e = document.activeElement;
  for (const n of t)
    if (n === e || (n.focus(), document.activeElement !== e))
      return;
}
function C7(t, e) {
  return t.map(
    (n, r) => t[(e + r) % t.length]
  );
}
function E7(t, e, n) {
  const o = e.length > 1 && Array.from(e).every(
    (c) => c === e[0]
  ) ? e[0] : e, i = n ? t.indexOf(n) : -1;
  let s = C7(t, Math.max(i, 0));
  o.length === 1 && (s = s.filter(
    (c) => c !== n
  ));
  const l = s.find(
    (c) => c.toLowerCase().startsWith(o.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function M7(t, e) {
  const { x: n, y: r } = t;
  let o = !1;
  for (let i = 0, s = e.length - 1; i < e.length; s = i++) {
    const a = e[i].x, l = e[i].y, c = e[s].x, u = e[s].y;
    l > r != u > r && n < (c - a) * (r - l) / (u - l) + a && (o = !o);
  }
  return o;
}
function k7(t, e) {
  if (!e)
    return !1;
  const n = {
    x: t.clientX,
    y: t.clientY
  };
  return M7(n, e);
}
function ja(t) {
  return (e) => e.pointerType === "mouse" ? t(e) : void 0;
}
const O7 = o7, S7 = i7, P7 = l7, I7 = u7, T7 = h7, D7 = p7, $7 = g7, N7 = y7, Tm = "DropdownMenu", [R7, i8] = an(Tm, [
  km
]), zn = km(), [A7, Dm] = R7(Tm), L7 = (t) => {
  const { __scopeDropdownMenu: e, children: n, dir: r, open: o, defaultOpen: i, onOpenChange: s, modal: a = !0 } = t, l = zn(e), c = ae(null), [u = !1, d] = Hn({
    prop: o,
    defaultProp: i,
    onChange: s
  });
  return /* @__PURE__ */ L(A7, {
    scope: e,
    triggerId: fo(),
    triggerRef: c,
    contentId: fo(),
    open: u,
    onOpenChange: d,
    onOpenToggle: pe(
      () => d(
        (f) => !f
      ),
      [
        d
      ]
    ),
    modal: a
  }, /* @__PURE__ */ L(O7, ne({}, l, {
    open: u,
    onOpenChange: d,
    dir: r,
    modal: a
  }), n));
}, F7 = "DropdownMenuTrigger", V7 = /* @__PURE__ */ de((t, e) => {
  const { __scopeDropdownMenu: n, disabled: r = !1, ...o } = t, i = Dm(F7, n), s = zn(n);
  return /* @__PURE__ */ L(S7, ne({
    asChild: !0
  }, s), /* @__PURE__ */ L(je.button, ne({
    type: "button",
    id: i.triggerId,
    "aria-haspopup": "menu",
    "aria-expanded": i.open,
    "aria-controls": i.open ? i.contentId : void 0,
    "data-state": i.open ? "open" : "closed",
    "data-disabled": r ? "" : void 0,
    disabled: r
  }, o, {
    ref: Ka(e, i.triggerRef),
    onPointerDown: be(t.onPointerDown, (a) => {
      !r && a.button === 0 && a.ctrlKey === !1 && (i.onOpenToggle(), i.open || a.preventDefault());
    }),
    onKeyDown: be(t.onKeyDown, (a) => {
      r || ([
        "Enter",
        " "
      ].includes(a.key) && i.onOpenToggle(), a.key === "ArrowDown" && i.onOpenChange(!0), [
        "Enter",
        " ",
        "ArrowDown"
      ].includes(a.key) && a.preventDefault());
    })
  })));
}), W7 = (t) => {
  const { __scopeDropdownMenu: e, ...n } = t, r = zn(e);
  return /* @__PURE__ */ L(P7, ne({}, r, n));
}, H7 = "DropdownMenuContent", B7 = /* @__PURE__ */ de((t, e) => {
  const { __scopeDropdownMenu: n, ...r } = t, o = Dm(H7, n), i = zn(n), s = ae(!1);
  return /* @__PURE__ */ L(I7, ne({
    id: o.contentId,
    "aria-labelledby": o.triggerId
  }, i, r, {
    ref: e,
    onCloseAutoFocus: be(t.onCloseAutoFocus, (a) => {
      var l;
      s.current || (l = o.triggerRef.current) === null || l === void 0 || l.focus(), s.current = !1, a.preventDefault();
    }),
    onInteractOutside: be(t.onInteractOutside, (a) => {
      const l = a.detail.originalEvent, c = l.button === 0 && l.ctrlKey === !0, u = l.button === 2 || c;
      (!o.modal || u) && (s.current = !0);
    }),
    style: {
      ...t.style,
      "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
      "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
      "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }));
}), j7 = /* @__PURE__ */ de((t, e) => {
  const { __scopeDropdownMenu: n, ...r } = t, o = zn(n);
  return /* @__PURE__ */ L(T7, ne({}, o, r, {
    ref: e
  }));
}), z7 = /* @__PURE__ */ de((t, e) => {
  const { __scopeDropdownMenu: n, ...r } = t, o = zn(n);
  return /* @__PURE__ */ L(D7, ne({}, o, r, {
    ref: e
  }));
}), U7 = /* @__PURE__ */ de((t, e) => {
  const { __scopeDropdownMenu: n, ...r } = t, o = zn(n);
  return /* @__PURE__ */ L($7, ne({}, o, r, {
    ref: e
  }));
}), Y7 = /* @__PURE__ */ de((t, e) => {
  const { __scopeDropdownMenu: n, ...r } = t, o = zn(n);
  return /* @__PURE__ */ L(N7, ne({}, o, r, {
    ref: e
  }));
}), K7 = L7, G7 = V7, q7 = W7, X7 = B7, Z7 = j7, Q7 = z7, J7 = U7, ek = Y7, tk = K7;
tk.displayName = "Menu";
const nk = G7;
nk.displayName = "MenuTrigger";
const rk = Z7;
rk.displayName = "MenuGroup";
const ok = C.forwardRef(
  ({
    className: t,
    align: e = "end",
    sideOffset: n = 4,
    collisionPadding: r = 32,
    loop: o = !0,
    disablePortal: i = !1,
    ...s
  }, a) => {
    const l = i ? C.Fragment : q7;
    return /* @__PURE__ */ w(l, { children: /* @__PURE__ */ w(
      X7,
      {
        ref: a,
        sideOffset: n,
        align: e,
        className: he(
          "z-50 max-h-[var(--radix-dropdown-menu-content-available-height)] w-56 overflow-hidden overflow-y-auto rounded-md border border-foundations-subtle bg-foundations-default p-2 text-foundations-bolder shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
          t
        ),
        loop: o,
        collisionPadding: r,
        ...s
      }
    ) });
  }
);
ok.displayName = "MenuContent";
const ik = Kt(
  "relative flex cursor-pointer select-none scroll-m-1 items-center rounded px-4 py-2 text-sm outline-none transition-colors data-[highlighted]:bg-foundations-subtlest data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
  {
    variants: {
      variant: {
        destructive: "text-danger destructive-menu"
      }
    }
  }
), sk = C.forwardRef(({ className: t, variant: e, ...n }, r) => /* @__PURE__ */ w(
  J7,
  {
    ref: r,
    className: he(ik({ variant: e }), t),
    ...n
  }
));
sk.displayName = "MenuItem";
const ak = C.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ w(
  Q7,
  {
    ref: n,
    className: he(
      "px-4 py-2 text-xs font-medium uppercase text-foundations-subtle",
      t
    ),
    ...e
  }
));
ak.displayName = "MenuHeading";
const lk = C.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ w(
  ek,
  {
    ref: n,
    className: he("-mx-2 my-1.5 border-t border-foundations-subtle", t),
    ...e
  }
));
lk.displayName = "MenuSeparator";
const s8 = C.forwardRef(({ Icon: t, className: e, ...n }, r) => /* @__PURE__ */ w(
  t,
  {
    className: he(
      "mr-2 h-5 w-5 text-foundations-subtler [.destructive-menu_&]:text-red-300",
      e
    ),
    ref: r,
    ...n
  }
)), ck = C.forwardRef(
  ({ steps: t, currentStepIndex: e }, n) => {
    const r = (i) => i === e, o = (i) => i < e;
    return /* @__PURE__ */ w("nav", { ref: n, "aria-label": "progress", children: /* @__PURE__ */ w("ol", { className: "flex flex-wrap", children: t.map((i, s) => /* @__PURE__ */ B("li", { className: "flex items-center", children: [
      s > 0 && /* @__PURE__ */ w("hr", { className: "mx-2 h-[1px] w-8" }),
      /* @__PURE__ */ B("div", { className: "flex flex-wrap items-center justify-center gap-2", children: [
        o(s) ? /* @__PURE__ */ w(uk, {}) : /* @__PURE__ */ w(dk, { isActive: r(s) }),
        /* @__PURE__ */ w(
          "span",
          {
            className: he(
              "text-sm font-medium",
              r(s) ? "text-foundations-boldest" : "text-foundations-subtle"
            ),
            children: i
          }
        )
      ] })
    ] }, `${s}-${i}`)) }) });
  }
);
ck.displayName = "Stepper";
const uk = () => /* @__PURE__ */ w("span", { className: "flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-info-subtler p-1", children: /* @__PURE__ */ w(Io, { className: "h-4 w-4 text-info" }) }), dk = ({ isActive: t }) => /* @__PURE__ */ w(
  "span",
  {
    className: he(
      "flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-foundations-subtlest",
      t ? "bg-info-bold" : "bg-foundations-subtlest"
    ),
    children: /* @__PURE__ */ w(
      "span",
      {
        className: he(
          "h-[10px] w-[10px] rounded-full bg-foundations-subtle",
          t ? "bg-white" : "bg-foundations-subtle"
        )
      }
    )
  }
), a8 = I.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ w(
  "div",
  {
    ref: n,
    className: he(
      "pointer-events-none absolute bottom-0 left-0 z-20 h-16 w-full bg-gradient-to-t from-[theme(backgroundColor.foundations-default)] to-transparent",
      t
    ),
    ...e
  }
));
function fk(t, e, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (t == null || t(o), n === !1 || !o.defaultPrevented)
      return e == null ? void 0 : e(o);
  };
}
function hk(t, e = []) {
  let n = [];
  function r(i, s) {
    const a = C.createContext(s), l = n.length;
    n = [...n, s];
    const c = (d) => {
      var b;
      const { scope: f, children: h, ...p } = d, g = ((b = f == null ? void 0 : f[t]) == null ? void 0 : b[l]) || a, m = C.useMemo(() => p, Object.values(p));
      return /* @__PURE__ */ w(g.Provider, { value: m, children: h });
    };
    c.displayName = i + "Provider";
    function u(d, f) {
      var g;
      const h = ((g = f == null ? void 0 : f[t]) == null ? void 0 : g[l]) || a, p = C.useContext(h);
      if (p)
        return p;
      if (s !== void 0)
        return s;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return [c, u];
  }
  const o = () => {
    const i = n.map((s) => C.createContext(s));
    return function(a) {
      const l = (a == null ? void 0 : a[t]) || i;
      return C.useMemo(
        () => ({ [`__scope${t}`]: { ...a, [t]: l } }),
        [a, l]
      );
    };
  };
  return o.scopeName = t, [r, pk(o, ...e)];
}
function pk(...t) {
  const e = t[0];
  if (t.length === 1)
    return e;
  const n = () => {
    const r = t.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const s = r.reduce((a, { useScope: l, scopeName: c }) => {
        const d = l(i)[`__scope${c}`];
        return { ...a, ...d };
      }, {});
      return C.useMemo(() => ({ [`__scope${e.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = e.scopeName, n;
}
function $m(t) {
  const e = C.useRef(t);
  return C.useEffect(() => {
    e.current = t;
  }), C.useMemo(() => (...n) => {
    var r;
    return (r = e.current) == null ? void 0 : r.call(e, ...n);
  }, []);
}
function gk({
  prop: t,
  defaultProp: e,
  onChange: n = () => {
  }
}) {
  const [r, o] = mk({ defaultProp: e, onChange: n }), i = t !== void 0, s = i ? t : r, a = $m(n), l = C.useCallback(
    (c) => {
      if (i) {
        const d = typeof c == "function" ? c(t) : c;
        d !== t && a(d);
      } else
        o(c);
    },
    [i, t, o, a]
  );
  return [s, l];
}
function mk({
  defaultProp: t,
  onChange: e
}) {
  const n = C.useState(t), [r] = n, o = C.useRef(r), i = $m(e);
  return C.useEffect(() => {
    o.current !== r && (i(r), o.current = r);
  }, [r, o, i]), n;
}
var Zi = globalThis != null && globalThis.document ? C.useLayoutEffect : () => {
};
function vk(t, e) {
  typeof t == "function" ? t(e) : t != null && (t.current = e);
}
function Nm(...t) {
  return (e) => t.forEach((n) => vk(n, e));
}
function Rm(...t) {
  return C.useCallback(Nm(...t), t);
}
var Am = C.forwardRef((t, e) => {
  const { children: n, ...r } = t, o = C.Children.toArray(n), i = o.find(yk);
  if (i) {
    const s = i.props.children, a = o.map((l) => l === i ? C.Children.count(s) > 1 ? C.Children.only(null) : C.isValidElement(s) ? s.props.children : null : l);
    return /* @__PURE__ */ w(za, { ...r, ref: e, children: C.isValidElement(s) ? C.cloneElement(s, void 0, a) : null });
  }
  return /* @__PURE__ */ w(za, { ...r, ref: e, children: n });
});
Am.displayName = "Slot";
var za = C.forwardRef((t, e) => {
  const { children: n, ...r } = t;
  if (C.isValidElement(n)) {
    const o = xk(n);
    return C.cloneElement(n, {
      ...wk(r, n.props),
      // @ts-ignore
      ref: e ? Nm(e, o) : o
    });
  }
  return C.Children.count(n) > 1 ? C.Children.only(null) : null;
});
za.displayName = "SlotClone";
var bk = ({ children: t }) => /* @__PURE__ */ w(nt, { children: t });
function yk(t) {
  return C.isValidElement(t) && t.type === bk;
}
function wk(t, e) {
  const n = { ...e };
  for (const r in e) {
    const o = t[r], i = e[r];
    /^on[A-Z]/.test(r) ? o && i ? n[r] = (...a) => {
      i(...a), o(...a);
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...i } : r === "className" && (n[r] = [o, i].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function xk(t) {
  var r, o;
  let e = (r = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (o = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : o.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var _k = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], lc = _k.reduce((t, e) => {
  const n = C.forwardRef((r, o) => {
    const { asChild: i, ...s } = r, a = i ? Am : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ w(a, { ...s, ref: o });
  });
  return n.displayName = `Primitive.${e}`, { ...t, [e]: n };
}, {});
function Ck(t, e) {
  return C.useReducer((n, r) => e[n][r] ?? n, t);
}
var Lm = (t) => {
  const { present: e, children: n } = t, r = Ek(e), o = typeof n == "function" ? n({ present: r.isPresent }) : C.Children.only(n), i = Rm(r.ref, Mk(o));
  return typeof n == "function" || r.isPresent ? C.cloneElement(o, { ref: i }) : null;
};
Lm.displayName = "Presence";
function Ek(t) {
  const [e, n] = C.useState(), r = C.useRef({}), o = C.useRef(t), i = C.useRef("none"), s = t ? "mounted" : "unmounted", [a, l] = Ck(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return C.useEffect(() => {
    const c = ci(r.current);
    i.current = a === "mounted" ? c : "none";
  }, [a]), Zi(() => {
    const c = r.current, u = o.current;
    if (u !== t) {
      const f = i.current, h = ci(c);
      t ? l("MOUNT") : h === "none" || (c == null ? void 0 : c.display) === "none" ? l("UNMOUNT") : l(u && f !== h ? "ANIMATION_OUT" : "UNMOUNT"), o.current = t;
    }
  }, [t, l]), Zi(() => {
    if (e) {
      let c;
      const u = e.ownerDocument.defaultView ?? window, d = (h) => {
        const g = ci(r.current).includes(h.animationName);
        if (h.target === e && g && (l("ANIMATION_END"), !o.current)) {
          const m = e.style.animationFillMode;
          e.style.animationFillMode = "forwards", c = u.setTimeout(() => {
            e.style.animationFillMode === "forwards" && (e.style.animationFillMode = m);
          });
        }
      }, f = (h) => {
        h.target === e && (i.current = ci(r.current));
      };
      return e.addEventListener("animationstart", f), e.addEventListener("animationcancel", d), e.addEventListener("animationend", d), () => {
        u.clearTimeout(c), e.removeEventListener("animationstart", f), e.removeEventListener("animationcancel", d), e.removeEventListener("animationend", d);
      };
    } else
      l("ANIMATION_END");
  }, [e, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(a),
    ref: C.useCallback((c) => {
      c && (r.current = getComputedStyle(c)), n(c);
    }, [])
  };
}
function ci(t) {
  return (t == null ? void 0 : t.animationName) || "none";
}
function Mk(t) {
  var r, o;
  let e = (r = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (o = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : o.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var kk = C["useId".toString()] || (() => {
}), Ok = 0;
function Sk(t) {
  const [e, n] = C.useState(kk());
  return Zi(() => {
    t || n((r) => r ?? String(Ok++));
  }, [t]), t || (e ? `radix-${e}` : "");
}
var cc = "Collapsible", [Pk, l8] = hk(cc), [Ik, uc] = Pk(cc), Fm = C.forwardRef(
  (t, e) => {
    const {
      __scopeCollapsible: n,
      open: r,
      defaultOpen: o,
      disabled: i,
      onOpenChange: s,
      ...a
    } = t, [l = !1, c] = gk({
      prop: r,
      defaultProp: o,
      onChange: s
    });
    return /* @__PURE__ */ w(
      Ik,
      {
        scope: n,
        disabled: i,
        contentId: Sk(),
        open: l,
        onOpenToggle: C.useCallback(() => c((u) => !u), [c]),
        children: /* @__PURE__ */ w(
          lc.div,
          {
            "data-state": fc(l),
            "data-disabled": i ? "" : void 0,
            ...a,
            ref: e
          }
        )
      }
    );
  }
);
Fm.displayName = cc;
var Vm = "CollapsibleTrigger", Wm = C.forwardRef(
  (t, e) => {
    const { __scopeCollapsible: n, ...r } = t, o = uc(Vm, n);
    return /* @__PURE__ */ w(
      lc.button,
      {
        type: "button",
        "aria-controls": o.contentId,
        "aria-expanded": o.open || !1,
        "data-state": fc(o.open),
        "data-disabled": o.disabled ? "" : void 0,
        disabled: o.disabled,
        ...r,
        ref: e,
        onClick: fk(t.onClick, o.onOpenToggle)
      }
    );
  }
);
Wm.displayName = Vm;
var dc = "CollapsibleContent", Hm = C.forwardRef(
  (t, e) => {
    const { forceMount: n, ...r } = t, o = uc(dc, t.__scopeCollapsible);
    return /* @__PURE__ */ w(Lm, { present: n || o.open, children: ({ present: i }) => /* @__PURE__ */ w(Tk, { ...r, ref: e, present: i }) });
  }
);
Hm.displayName = dc;
var Tk = C.forwardRef((t, e) => {
  const { __scopeCollapsible: n, present: r, children: o, ...i } = t, s = uc(dc, n), [a, l] = C.useState(r), c = C.useRef(null), u = Rm(e, c), d = C.useRef(0), f = d.current, h = C.useRef(0), p = h.current, g = s.open || a, m = C.useRef(g), b = C.useRef();
  return C.useEffect(() => {
    const v = requestAnimationFrame(() => m.current = !1);
    return () => cancelAnimationFrame(v);
  }, []), Zi(() => {
    const v = c.current;
    if (v) {
      b.current = b.current || {
        transitionDuration: v.style.transitionDuration,
        animationName: v.style.animationName
      }, v.style.transitionDuration = "0s", v.style.animationName = "none";
      const _ = v.getBoundingClientRect();
      d.current = _.height, h.current = _.width, m.current || (v.style.transitionDuration = b.current.transitionDuration, v.style.animationName = b.current.animationName), l(r);
    }
  }, [s.open, r]), /* @__PURE__ */ w(
    lc.div,
    {
      "data-state": fc(s.open),
      "data-disabled": s.disabled ? "" : void 0,
      id: s.contentId,
      hidden: !g,
      ...i,
      ref: u,
      style: {
        "--radix-collapsible-content-height": f ? `${f}px` : void 0,
        "--radix-collapsible-content-width": p ? `${p}px` : void 0,
        ...t.style
      },
      children: g && o
    }
  );
});
function fc(t) {
  return t ? "open" : "closed";
}
var Dk = Fm, $k = Wm, Nk = Hm;
const Rk = Dk, Ak = ({
  children: t,
  className: e = ""
}) => /* @__PURE__ */ w($k, { asChild: !0, children: /* @__PURE__ */ B(
  "button",
  {
    className: he(
      "group/collapse flex w-full items-center justify-between rounded-lg border-x border-t border-foundations-bold bg-foundations-subtelst-02 p-4 focus:outline-none data-[state=open]:rounded-b-none data-[state=closed]:border-b",
      e
    ),
    children: [
      t,
      /* @__PURE__ */ w(o5, { className: "h-5 w-5 text-foundations-subtler transition duration-300 group-data-[state=closed]/collapse:rotate-180 group-data-[state=open]/collapse:rotate-0" })
    ]
  }
) }), Lk = ({
  children: t,
  className: e = ""
}) => /* @__PURE__ */ w(Nk, { asChild: !0, children: /* @__PURE__ */ w(
  "div",
  {
    className: he(
      "w-full overflow-hidden rounded-b-lg border-x border-b border-foundations-bold bg-foundations-subtelst-02 data-[state=closed]:animate-slideUp data-[state=open]:animate-slideDown",
      e
    ),
    children: /* @__PURE__ */ w("div", { className: "p-4", children: t })
  }
) }), c8 = {
  Root: Rk,
  Trigger: Ak,
  Content: Lk
};
function u8(t) {
  const { fileInputDom: e, accept: n, onSelect: r } = t ?? {}, o = ae(null), [i, s] = ye(null), [a, l] = ye(!1), [c, u] = ye(null), d = pe(() => {
    o.current && (o.current.value = "");
  }, []), f = pe(async () => {
    var g, m;
    const p = (m = (g = o.current) == null ? void 0 : g.files) == null ? void 0 : m[0];
    s(p || null);
    try {
      l(!0), p && await (r == null ? void 0 : r(p, d));
    } catch (b) {
      u(b);
    } finally {
      l(!1);
    }
  }, [r]);
  return ue(() => {
    o.current || (o.current = e ?? document.createElement("input"), o.current.type = "file", o.current.accept = n ?? "*/*", o.current.disabled = (t == null ? void 0 : t.disabled) ?? !1, o.current.addEventListener("change", f));
  }, [e, f]), { file: i, isLoading: a, error: c, selectFile: () => {
    o.current && o.current.click();
  } };
}
function d8({
  currency: t,
  amount: e,
  compact: n = !1
}) {
  const r = new Intl.NumberFormat(void 0, {
    style: "currency",
    currency: t,
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
    notation: n ? "compact" : "standard"
  });
  return n ? r.format(e) : r.format(e).replace(/^(\D+)\s*(.+)$/, "$2$1").trim();
}
function f8({
  value: t,
  compact: e = !1
}) {
  return new Intl.NumberFormat(void 0, {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
    notation: e ? "compact" : "standard"
  }).format(t);
}
export {
  Zk as AccessDeniedIllustration,
  C5 as Alert,
  u5 as Badge,
  Mi as Button,
  Wv as ButtonGroup,
  Hp as Calendar,
  M5 as Card,
  QC as Chart,
  kl as ChartJS,
  bp as Checkbox,
  s5 as CircleChart,
  c8 as Collapsible,
  XE as DateInput,
  KE as DatePicker,
  Yk as DiffPercentageBadge,
  r8 as DropdownSearch,
  Kk as EmptyStateIllustration,
  Gk as EmptyStateIllustration2,
  qk as EmptyStateIllustration3,
  Xk as EmptyStateIllustration4,
  l5 as HorizontalBarsChart,
  ua as IconButton,
  mp as Input,
  K5 as Link,
  k5 as LinkBox,
  O5 as LinkOverlay,
  tk as Menu,
  ok as MenuContent,
  rk as MenuGroup,
  ak as MenuHeading,
  s8 as MenuIcon,
  sk as MenuItem,
  lk as MenuSeparator,
  nk as MenuTrigger,
  gp as NoMatchingResultIllustration,
  b6 as Option,
  v6 as OptionsGroup,
  a8 as OverflowIndicator,
  yb as OverflowText,
  ZE as Popover,
  n8 as PopoverArrow,
  JE as PopoverClose,
  e4 as PopoverContent,
  QE as PopoverTrigger,
  cp as Portal,
  dp as ProgressRadial,
  U5 as Radio,
  S5 as SearchIllustration,
  CM as Select,
  wb as Skeleton,
  Rt as Slot,
  ck as Stepper,
  Jk as Switch,
  rr as Tooltip,
  ga as TooltipProvider,
  MM as UploadArea,
  _5 as alertVariants,
  c5 as badgeVariants,
  Ei as buttonVariants,
  he as cn,
  Uk as createScale,
  Kt as cva,
  d8 as formatCurrency,
  f8 as formatNumber,
  Dn as getColorFromCssVariable,
  Oc as iconButtonVariants,
  Y5 as linkVariants,
  ot as useCombobox,
  $5 as useCopyToClipboard,
  It as useDateInput,
  u8 as useUploadFile
};
